import React, {createRef, Suspense, unstable_Profiler as Profiler, useRef} from 'react';
import PropTypes from 'prop-types';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {Button, IconButton, MenuItem} from "@material-ui/core";
import {baseStyles, BORDER_RADIUS, changeNavColor, IMAGE_BORDER_RADIUS, withMultipleStyles} from "src/styles/Styles";
import ValueHelper from "../../utils/ValueHelper";
import {history} from "../../store/configureStore";
import {cloneDeep} from "lodash";
import {
  ColorAccent,
  ColorActivityBackground,
  ColorBackground,
  ColorBlack, ColorBorder,
  ColorClear,
  ColorEarning,
  ColorGold,
  ColorGreen,
  ColorNegative,
  ColorOrange,
  ColorOtherTitle,
  ColorSecondary,
  ColorSubTitle,
  ColorTheme,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import utils from "../../utils/utils";
import zIndex from "@material-ui/core/styles/zIndex";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DialogView from "../commons/DialogView";
import {logDebug, logInfo} from "../../utils/AppLog";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import 'regenerator-runtime/runtime';
import tinycolor from "tinycolor2";

import {HeightElementMinimum, SpaceNormal, SpaceSmall, SpaceXSmall, SpaceXXSmall} from 'src/res/Spacing';
import {FontSizeLarge, FontSizeNormal, FontSizeSmall, FontSizeXLarge} from 'src/res/FontSize';
import {FontWeightBold, FontWeightMedium, FontWeightRegular} from 'src/res/FontWeight';
import {
  ACTIVITY_CTA2_ACTION,
  ACTIVITY_CTA2_VIEW,
  ACTIVITY_TYPE_BETTING_PIC,
  ACTIVITY_TYPE_BRAND_RACE,
  ACTIVITY_TYPE_CHALLENGE,
  ACTIVITY_TYPE_COLLECT_STARS,
  ACTIVITY_TYPE_CONTENT_WRITING,
  ACTIVITY_TYPE_DISCOUNT,
  ACTIVITY_TYPE_EVENT,
  ACTIVITY_TYPE_EXTERNAL_GAMES,
  ACTIVITY_TYPE_FIND_HIDDEN,
  ACTIVITY_TYPE_FLIP_CARD,
  ACTIVITY_TYPE_GAME_ROULETTE,
  ACTIVITY_TYPE_GREEDY_SPIN,
  ACTIVITY_TYPE_GUESS,
  ACTIVITY_TYPE_IDENTIFY_LOCATION,
  ACTIVITY_TYPE_MATCH_THREE,
  ACTIVITY_TYPE_MATCHING_PIC,
  ACTIVITY_TYPE_OFFER,
  ACTIVITY_TYPE_OPINION,
  ACTIVITY_TYPE_POKER,
  ACTIVITY_TYPE_PREDICTION,
  ACTIVITY_TYPE_PUZZLE,
  ACTIVITY_TYPE_PUZZLE_SLIDE,
  ACTIVITY_TYPE_QUESTION,
  ACTIVITY_TYPE_QUESTIONNAIRE,
  ACTIVITY_TYPE_SHARE_N_LIKE, ACTIVITY_TYPE_SHOWCASE_MENU, ACTIVITY_TYPE_SLIDES,
  ACTIVITY_TYPE_SLOT,
  ACTIVITY_TYPE_SMART_AD,
  ACTIVITY_TYPE_SPIN_DISCOVER,
  ACTIVITY_TYPE_SURVEY,
  ACTIVITY_TYPE_TIC_TAC_TOE,
  ACTIVITY_TYPE_VISITOR_OPINION,
  ACTIVITY_TYPE_VOTE,
  ACTIVITY_TYPE_WHAC_A_MOLE,
  ACTIVITY_UPDATE_STATE_ACTION,
  ACTIVITY_UPDATE_STATE_RATE,
  ACTIVITY_UPDATE_STATE_RESET,
  ACTIVITY_UPDATE_STATE_SHARE,
  CREATED_TYPE_ME,
  FEED_TYPE_POST,
  POST_TYPE_CHALLENGE,
  STATE_ENABLED,
  STATE_USER_REQUEST_COMPLETED,
} from 'src/js/constants/ApiConstants';
import {
  NAVIGATION_NAME_ACTIVITY_RATINGS,
  NAVIGATION_NAME_DETAIL,
  NAVIGATION_NAME_GIFT_DETAIL,
  NAVIGATION_NAME_GIFT_ELIGIBLE,
  NAVIGATION_NAME_MAP,
  NAVIGATION_NAME_SYSTEM_GIFT_WINNERS,
  NAVIGATION_NAME_TRANSFER_OFFER,
} from 'src/js/constants/NavigationHelper';
import AppImage from 'src/js/components/commons/AppImage';
import {RadiusIcon, RadiusOverlay, RadiusView, RadiusViewCard, RadiusViewList} from 'src/res/Radius';
import AppIcon, {
  IconArrowLeftLong,
  IconArrowRightLong,
  IconCheckCircle,
  IconChevronDown,
  IconChevronUp,
  IconClock,
  IconCopy,
  IconCross,
  IconGifts,
  IconLongArrowRight,
  IconMoreGame,
  IconPoints,
  IconQuestion, IconShare, IconShow,
  IconStar,
  IconSuccess,
  IconWallet,
} from 'src/js/components/commons/AppIcon';
import DateTimeHelper from 'src/js/utils/DateTimeHelper';
// import NotificationUtils from 'app/src/utils/NotificationUtils';
// import LinkHelper from 'src/js/components/commons/LinkHelper';
import AppText from 'src/js/components/commons/AppText';
// import ReportPostScreen from 'app/src/ui/screens/post/ReportPostScreen';
// import ActivityReviewsScreen from 'app/src/ui/screens/activity/ActivityReviewsScreen';
import AppTextWrapper from 'src/js/components/commons/AppTextWrapper';
// import ProductsInOfferScreen from 'app/src/ui/screens/order/ProductsInOfferScreen';
// import AddChallengeScreen from 'app/src/ui/screens/challenge/AddChallengeScreen';
// import VideoPlayer from 'app/src/data/VideoPlayer';
// import VideoPlayerScreen from 'app/src/ui/screens/common/VideoPlayerScreen';
// import FlipTileGameView from 'app/src/ui/components/FlipTileGameView';
// import ActivityReviewDetailScreen from 'app/src/ui/screens/activity/ActivityReviewDetailScreen';
import ActivityHelper, {
  GetActionButton,
  GetImageActionButton,
  GetLanguageSelectorView,
  GetMoreDetailsView,
  GetRewardsView
} from 'src/js/utils/ActivityHelper';
// import CipherHelper from 'app/src/utils/CipherHelper';
import {GAME_BG_AUDIO, GAME_LOSE_AUDIO, GAME_TIMER_LOW_AUDIO, GAME_WIN_AUDIO} from 'src/js/utils/GameAudioPlayer';
import AppImageButtonEx from 'src/js/components/commons/AppImageButtonEx';
// import PickMapScreen from 'app/src/ui/screens/common/PickMapScreen';
import ScrollView from "../commons/ScrollView";
import ImageBackground from "../commons/ImageBackground";
import {
  ImageIcon,
  locHtmlString,
  locString,
  locStringA, NavActionView, NavBackActionView,
  SNACKBAR_AUTO_HIDE_DURATION,
  VideoPlayerView
} from "../commons/ViewHelper";
import TextView from "../commons/TextView";
import Menu from "@material-ui/core/Menu";
import {Transition} from 'react-transition-group';
import LinkHelper from "../../utils/LinkHelper";
import ApiHelper from "../../utils/ApiHelper";
import {APP_GAME_AUDIO_URI} from "../../utils/services";
import GameAudio from "../commons/GameAudio";
import HeaderTitleView from "../commons/HeaderTitleView";
import constants from "../../constants";
import Space from "../commons/Space";
import Paper from "@material-ui/core/Paper";
import Loader from "../commons/Loader";
import ImageBackground1 from "../commons/ImageBackground1";
import FullWidthDummyView from "../commons/FullWidthDummyView";
import {socket} from "../../socket";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils, {colorWithAlpha} from "../../utils/AppUtils";
import {GetPredictionActionView, GetPredictWinnerActionView} from "./ActivityViewHelper";
import MapField, {MAP_EXTRA_HEIGHT, ZOOM_COARSE_LOCATION} from "../commons/MapField";
import {clearAllBodyScrollLocks} from "body-scroll-lock";
import {v4 as uuidv4} from 'uuid';
import {getPathForActivity, getRedirectSearch, getURLParameters, PathJoin} from "src/js/components/routes/NavHelper";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {GameTapTapShots} from "src/gameTapTapShots/GameTapTapShots";
import {GameFreeKicks} from "src/gameFreeKicks/GameFreeKicks";
import {GamePacManRush} from "src/gamePacManRush/GamePacManRush";
import {GameTrafficGo} from "src/gameTrafficGo/GameTrafficGo";
import JoinNow from "src/js/components/JoinNow";
import {GameCannonCraze} from "src/gameCannonCraze/GameCannonCraze";
import {GameSnakeUp} from "src/gameSnakeUp/GameSnakeUp";
import {GameArcHunter} from "src/gameArcHunter/GameArcHunter";
import {Skeleton} from "@material-ui/lab";

import QRCode from 'react-qr-code';
import ActivityReelsView from './ActivityReelsView';
import JackpotGameView from '../game/JackpotGameView';
import GameSpinDiscoverView from '../game/GameSpinDiscoverView';
import GameGreedySpinView from '../game/GameGreedySpinView';
import FlipTileGameView from '../game/FlipTileGameView';
import RouletteGameView from '../game/RouletteGameView';
import GameBettingPicView from '../game/GameBettingPicView';
import GameWhacAMoleView from '../game/GameWhacAMoleView';
import GameMatchThreeView from '../game/GameMatchThreeView';
import GamePuzzleTapSelectView from '../game/GamePuzzleTapSelectView';
import GamePuzzleSlideView from '../game/GamePuzzleSlideView';
import GamePokerView from '../game/GamePokerView';
import TicTacToeGameView from '../game/TicTacToeGameView';
import QuestionOptionItem from '../game/QuestionOptionItem';
import ActivityPlayerStats from "src/js/components/activity/ActivityPlayerStats";
import UpdateMobileInline from "src/js/components/UpdateMobileInline";
import {GameRoshambo} from "src/gameRoshambo/GameRoshambo";
import UpdateNameInline from "src/js/components/UpdateNameInline";
import {GamePonk} from "src/gamePonk/GamePonk";
import ActivitySlides from "src/js/components/activityComponent/ActivitySlides";

// const QRCode = React.lazy(() => import('react-qr-code'));
// const ActivityReelsView = React.lazy(() => import('./ActivityReelsView'));
// const JackpotGameView = React.lazy(() => import('../game/JackpotGameView'));
// const GameSpinDiscoverView = React.lazy(() => import('../game/GameSpinDiscoverView'));
// const GameGreedySpinView = React.lazy(() => import('../game/GameGreedySpinView'));
// const FlipTileGameView = React.lazy(() => import('../game/FlipTileGameView'));
// const RouletteGameView = React.lazy(() => import('../game/RouletteGameView'));
// const GameBettingPicView = React.lazy(() => import('../game/GameBettingPicView'));
// const GameWhacAMoleView = React.lazy(() => import('../game/GameWhacAMoleView'));
// const GameMatchThreeView = React.lazy(() => import('../game/GameMatchThreeView'));
// const GamePuzzleTapSelectView = React.lazy(() => import('../game/GamePuzzleTapSelectView'));
// const GamePuzzleSlideView = React.lazy(() => import('../game/GamePuzzleSlideView'));
// const GamePokerView = React.lazy(() => import('../game/GamePokerView'));
// const TicTacToeGameView = React.lazy(() => import('../game/TicTacToeGameView'));
// const QuestionOptionItem = React.lazy(() => import('../game/QuestionOptionItem'));


const ApiTask = () => {
  return {};
};

const BaseScreen = {};

const BaseStyle = {};

const ELEVATION = {};

const ImageTypeConfirmation = 100;
const ImageTypeSuccess = 101;
const HIDE_VIEWS_FOR_CTA1_OPACITY = 0.3;

const HASH_IMAGE_FS = 'olI';
const HASH_OVERLAY = 'ol';
const HASH_QUESTIONNAIRE = 'olP';

const useStyles = (theme) => ({
  gameContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
    // overflowY: 'scroll',
    position: 'relative',
  },
  menuItemBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 28
  },
  backButtonAV: {
    position: 'absolute', top: 0, left: SpaceNormal
  },
  moreButtonAV: {
    position: 'absolute', top: 0, right: SpaceNormal
  },
  viewOverlayContent: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  actionView: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200
  },
  actionViewSlides: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200
  }
});

const ViewSnackBar = (props) => {
  const {showSnackbar, snackbarInfo, onClose} = props;
  if (showSnackbar) {
    const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
    return (
      <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled" style={{borderRadius: BORDER_RADIUS}}>
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId}/> : null}
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    );
  }
  return null;
}

const ViewDialog = (props) => {
  const {classes, showDialog, dialogInfo} = props;
  if (!showDialog) {
    return null;
  }

  const {title, message, positiveText, onPositiveClicked, neutralText, onNeutralClicked} = dialogInfo;
  return (
    <DialogView
      classes={classes}
      show={showDialog}
      title={title}
      message={message}
      positiveText={positiveText}
      onPositiveClicked={onPositiveClicked}
      neutralText={neutralText}
      onNeutralClicked={onNeutralClicked}
    />
  );
};

const ViewOverlay = (props) => {
    const {height, show} = props;
    let {backgroundColor} = props;
    if (!backgroundColor) {
      backgroundColor = 'rgba(0,0,0,0.8)';
    }

    const duration = 300;
    const defaultStyle = {
      transition: `all ${duration}ms ease-in-out`,
      opacity: 0,
    }
    const transitionStyles = {
      entering: {opacity: 1},
      entered: {opacity: 1},
      exiting: {opacity: 0},
      exited: {opacity: 0},
    };
    const nodeRef = useRef(null);

    return (
      <Transition
        nodeRef={nodeRef}
        in={show}
        timeout={duration}
        appear={true}
        mountOnEnter={true}
        unmountOnExit={true}>
        {state => (
          <div ref={nodeRef} style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}>
            <View style={{flex: 'display', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, backgroundColor: backgroundColor, zIndex: zIndex.appBar+1}}>
              <View style={{flex: 'display', position: 'absolute', top: 0, left: 0, height: height, right: 0}}>
                {props.children}
              </View>
            </View>
        </div>
        )}
      </Transition>
    );
};

const GetTopView = (props) => {
  const {isLTR, classes, uiConfigs, contentWidth, sizeFactor, activityType, activitySubType, nextType, questionnaireNumber, showCta1, showCta2,
    businessImageUrl, businessName, businessLink, onBusinessClicked, disableBack, disableMore,
    onBackClicked, openMenu, menuView} = props;

  const onOpenMenu = (event) => {
    if (!disableMore) {
      openMenu(event.target);
    }
  };

  const onBackClickedL = (event) => {
    if (!disableBack) {
      onBackClicked(event.target);
    }
  };

  const topIconWidth = (questionnaireNumber ? 68 : uiConfigs.topIconWidth) * sizeFactor;
  const topIconHeight = (questionnaireNumber ? 68 : uiConfigs.topIconWidth) * sizeFactor;
  const height = (questionnaireNumber ? uiConfigs.topViewSmallHeight : uiConfigs.topViewHeight) * sizeFactor;
  const marginH = (questionnaireNumber ? -14 : -20) * sizeFactor;
  const marginTop = (questionnaireNumber ? -14 : -20) * sizeFactor;

  const styleButtonLeft = {position: 'absolute', top: 0, left: marginH, width: topIconWidth, opacity: showCta1 || showCta2 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1};
  const styleButtonRight = {position: 'absolute', top: 0, right: marginH, width: topIconWidth, opacity: showCta1 && !showCta2 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1};

  return (
    <View className={classes.viewColumnFullWidth} style={{height: height, position: 'relative', zIndex: 1}}>
      <GetTopCenterView
        showCta1={showCta1}
        showCta2={showCta2}
        classes={classes}
        uiConfigs={uiConfigs}
        contentWidth={contentWidth}
        sizeFactor={uiConfigs.sizeFactor}
        questionnaireNumber={questionnaireNumber}
        activityType={activityType}
        activitySubType={activitySubType}
        nextType={nextType}
        businessLink={businessLink}
        businessImageUrl={businessImageUrl}
        businessName={businessName}
        onBusinessClicked={onBusinessClicked}/>
        <View style={isLTR ? styleButtonLeft : styleButtonRight}>
          {uiConfigs.backImage ?
            <AppImageButtonEx
              disabled={!!disableBack}
              imageStyle={{width: topIconWidth, height: topIconHeight}}
              onClick={onBackClickedL}
              imageSource={!disableBack ? uiConfigs.backImage : null} />
            : <TouchableOpacity disabled={!!disableBack} onClick={onBackClickedL} style={{width: topIconWidth, height: topIconHeight, borderRadius: topIconWidth/2, overflow: 'hidden', display: 'flex', flexDirection: 'column', opacity: 1, margin: -2, padding: 2}}>
              <Paper elevation={2} className={classes.flexColumn} style={{borderRadius: topIconWidth/2, borderWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, justifyContent: 'center', background: 'radial-gradient('+ colorWithAlpha(uiConfigs.themeColor, 1) +','+ colorWithAlpha(uiConfigs.themeColorDark, 1) +')'}}>
                {!disableBack ? <AppIcon icon={isLTR ? IconArrowLeftLong : IconArrowRightLong} color={uiConfigs.iconColor} style={{width: 22*sizeFactor, height: 22*sizeFactor, marginLeft: isLTR ? 6 : 0, marginRight: !isLTR ? 6 : 0}}/> : null}
              </Paper>
            </TouchableOpacity>
          }
        </View>
      {!questionnaireNumber ?
        <View style={isLTR ? styleButtonRight : styleButtonLeft}>
          {uiConfigs.moreImage ?
            <AppImageButtonEx
              disabled={!!disableMore}
              imageStyle={{width: topIconWidth, height: topIconHeight}}
              onClick={onOpenMenu}
              imageSource={!disableMore ? uiConfigs.moreImage : null} />
              : <TouchableOpacity disabled={!!disableMore} onClick={onOpenMenu} style={{width: topIconWidth, height: topIconHeight, borderRadius: topIconWidth/2, overflow: 'hidden', display: 'flex', flexDirection: 'column', opacity: 1, margin: -2, padding: 2}}>
              <Paper elevation={2} className={classes.flexColumn} style={{borderRadius: topIconWidth/2, borderWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, justifyContent: 'center', background: 'radial-gradient('+ colorWithAlpha(uiConfigs.themeColor, 1) +','+ colorWithAlpha(uiConfigs.themeColorDark, 1) +')'}}>
                {!disableMore ? <AppIcon icon={IconMoreGame} color={uiConfigs.iconColor} transform={{flipX: isLTR ? 0 : 1}} style={{width: 22*sizeFactor, height: 22*sizeFactor, marginLeft: !isLTR ? 6 : 0, marginRight: isLTR ? 6 : 0}}/> : null}
              </Paper>
            </TouchableOpacity>
          }
        </View>
        : null
      }
    </View>
  );
};

const GetTopCenterView = (props) => {
  const {classes, uiConfigs, contentWidth, sizeFactor, activityType, activitySubType, nextType, questionnaireNumber,
    businessImageUrl, businessName, businessLink, onBusinessClicked, showCta1, showCta2} = props;

  // if (activityType === ACTIVITY_TYPE_QUESTION) {
  //   return (
  //     <View style={{flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
  //       <ImageBackground source={uiConfigs.topCenterImage} style={{flex: 1, marginTop: 28 * sizeFactor, paddingBottom: 34 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
  //         <AppTextWrapper fontSizeN={uiConfigs.fontSize} variant={'body2'} align={'center'} style={{fontWeight: FontWeightBold, color: uiConfigs.overlayHeadingColor}}>
  //           {locString('survey')}
  //         </AppTextWrapper>
  //       </ImageBackground>
  //     </View>
  //   );
  // } else
  if (questionnaireNumber) {
    const businessIconBgSize = 48 * sizeFactor;
    const businessIconSpace = 4 * sizeFactor;
    const businessIconSize = businessIconBgSize - businessIconSpace;
    const businessIconBorderRadius = uiConfigs.businessIconBorderRadius || RadiusView;
    const viewBusiness = (
      <TouchableOpacity disabled={true} onClick={onBusinessClicked} style={{display: 'flex', flex: 1, flexDirection: 'row', opacity: 1}}>
        <View style={{flex: 1, flexDirection: 'row'}}>
          {uiConfigs.businessBgImage ?
            <ImageBackground1 source={uiConfigs.businessBgImage} style={{marginTop: -(businessIconSpace/2), width: businessIconBgSize, height: businessIconBgSize}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, margin: businessIconSpace/2, borderRadius: businessIconBorderRadius}} />
            </ImageBackground1>
            : <div style={{width: businessIconBgSize, height: businessIconBgSize}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, margin: businessIconSpace/2, borderRadius: businessIconBorderRadius}} />
            </div>
          }
          <View style={{flex: 1, marginTop: 8, marginBottom: 16, marginLeft: 4, marginRight: 6, justifyContent: 'center', alignItems: 'center'}}>
            <AppText fontSizeN={uiConfigs.fontSize} variant={'body2'} align={'center'} numberOfLines={1} style={{color: uiConfigs.titleColor, fontWeight: FontWeightBold}}>
              {businessName}
            </AppText>
          </View>
        </View>
      </TouchableOpacity>
    );
    return (
      <View style={{flex: 1, paddingLeft: 40 * sizeFactor, paddingRight: 40 * sizeFactor, marginTop: 8 * sizeFactor, width: '100%', opacity: showCta2 && !showCta1 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}>
        <View style={{flex: 1, flexDirection: 'row', justifyContent: 'center'}}>
          {uiConfigs.topCenterImage1 ?
            <View style={{flex: 0.8, height: businessIconSize}}>
            <ImageBackground source={uiConfigs.topCenterImage1} style={{display: 'flex', flex: 1, height: businessIconSize, paddingLeft: 16 * sizeFactor, paddingRight: 16 * sizeFactor}}>
              {viewBusiness}
            </ImageBackground>
            </View>
            : <div style={{flex: 1, flexDirection: 'row', marginTop: -(businessIconSpace), display: 'flex', height: businessIconSize + 2*businessIconSpace, borderRadius: uiConfigs.businessIconBorderRadius, borderWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColorDark, 0.9) +','+ colorWithAlpha(uiConfigs.themeColorDark, 0.1)}}>
              <div style={{flex: 0.58, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                {viewBusiness}
              </div>
            </div>
          }
        </View>
      </View>
    );
  } else
    // if ((activityType === constants.activity.types.PREDICTION && !activitySubType)
    // || activityType === constants.activity.types.EXTERNAL_GAMES
    // || nextType === constants.activity.types.EXTERNAL_GAMES)
    {
    const businessIconBgSize = 52 * sizeFactor;
    const businessIconSpace = 8 * sizeFactor;
    const businessIconSize = businessIconBgSize - businessIconSpace;
    const viewBusiness = (
      <TouchableOpacity disabled={true} onClick={onBusinessClicked} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', opacity: 1}}>
        <View style={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
          {uiConfigs.businessBgImage ?
            <ImageBackground1 source={uiConfigs.businessBgImage} style={{marginTop: -(businessIconSpace/2), width: businessIconBgSize, height: businessIconBgSize}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, margin: businessIconSpace/2, borderRadius: RadiusView}} />
            </ImageBackground1>
            : <div style={{width: businessIconBgSize, height: businessIconBgSize}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, margin: businessIconSpace/2, borderRadius: RadiusView}} />
            </div>
          }
          <View style={{marginTop: 8, marginBottom: 8, marginLeft: 4, marginRight: 6, justifyContent: 'center', alignItems: 'center'}}>
            <AppText fontSizeN={uiConfigs.fontSize} variant={'body2'} align={'center'} numberOfLines={2} style={{color: uiConfigs.titleColor, fontWeight: FontWeightBold}}>
              {businessName}
            </AppText>
          </View>
        </View>
      </TouchableOpacity>
    );
    return (
      <View style={{flex: 1, width: '100%', opacity: showCta2 && !showCta1 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, height: 12 * sizeFactor, backgroundColor: uiConfigs.safeAreaColor}}></div>
        <View style={{flex: 1, flexDirection: 'row', justifyContent: 'center', marginTop: 10 * sizeFactor}}>
          {uiConfigs.topCenterImage1 ?
            <View style={{flex: 0.8, height: businessIconSize}}>
              <ImageBackground source={uiConfigs.topCenterImage1} style={{display: 'flex', flex: 1, height: businessIconSize, paddingLeft: 16 * sizeFactor, paddingRight: 16 * sizeFactor}}>
                {viewBusiness}
              </ImageBackground>
            </View>
            : <Paper elevation={2} style={{flex: 1, flexDirection: 'row', justifyContent: 'center', marginTop: 0, display: 'flex', height: businessIconSize + businessIconSpace, paddingLeft: 64*sizeFactor, paddingRight: 64*sizeFactor, borderRadius: 0, borderWidth: 0, borderBottomWidth: 0, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColor, 1) +','+ colorWithAlpha(uiConfigs.themeColorDark, 1)}}>
              {/*<div style={{flex: 0.58, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>*/}
                {viewBusiness}
              {/*</div>*/}
            </Paper>
          }
        </View>
      </View>
    );
  }
  const businessViewMarginTop = 8 * sizeFactor;
  const businessIconBgSize = 70 * sizeFactor;
  const businessIconSpace = 6 * 2 * sizeFactor;
  const businessIconSize = businessIconBgSize - businessIconSpace;
  const businessIconBorderRadius = uiConfigs.businessIconBorderRadius || RadiusView;
  const viewBusiness = (
    <TouchableOpacity disabled={!businessLink} onClick={onBusinessClicked} style={{flex: 1, display: 'flex', opacity: 1}}>
      <View className={classes.flexRow}>
        {uiConfigs.businessBgImage ?
          <ImageBackground source={uiConfigs.businessBgImage} style={{marginTop: -(businessIconSpace/2), width: businessIconBgSize, height: businessIconBgSize, zIndex: 0}}>
            <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, margin: businessIconSpace/2, borderRadius: businessIconBorderRadius}} />
            </View>
          </ImageBackground>
          : <div style={{marginTop: uiConfigs.themeColor ? 0 : -(businessIconSpace/2), width: businessIconBgSize, height: businessIconBgSize, zIndex: 0, position: 'relative'}}>
            <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <AppImage imageUrl={businessImageUrl} style={{width: businessIconSize, height: businessIconSize, borderRadius: businessIconBorderRadius}} />
            </View>
          </div>
        }
        <View style={{display: 'flex', flex: 1, marginTop: 12, marginBottom: 12, marginLeft: 4, marginRight: 6, justifyContent: 'center', alignItems: 'center'}}>
          <AppTextWrapper fontSizeN={uiConfigs.fontSize} variant={'body2'} numberOfLines={contentWidth <= 380 ? 2 : 3} style={{color: uiConfigs.businessTitleColor, fontWeight: FontWeightMedium}}>
            {businessName}
          </AppTextWrapper>
        </View>
      </View>
    </TouchableOpacity>
  );
  const viewBusinessWrapper = (
    <View style={{display: 'flex', flex: 0.58, marginTop: businessViewMarginTop, height: businessIconSize}}>
      {uiConfigs.businessViewBgImage ?
        <ImageBackground source={uiConfigs.businessViewBgImage} style={{display: 'flex', flex: 1, height: businessIconSize}}>
          {viewBusiness}
        </ImageBackground>
        : uiConfigs.themeColor ?
          <div style={{marginTop: -(businessIconSpace/2), display: 'flex', flex: 1, height: businessIconSize + businessIconSpace, borderRadius: uiConfigs.businessIconBorderRadius, borderWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColorDark, 0.9) +','+ colorWithAlpha(uiConfigs.themeColorDark, 0.1)}}>
            {viewBusiness}
          </div>
          : viewBusiness
      }
    </View>
  );
  return (
    <View className={classes.flexColumn} style={{paddingLeft: 24 * sizeFactor, paddingRight: 24 * sizeFactor, opacity: showCta2 && !showCta1 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}>
      {uiConfigs.topCenterImage ?
        <ImageBackground className={classes.flexRow} source={uiConfigs.topCenterImage} style={{justifyContent: 'center'}}>
          {viewBusinessWrapper}
        </ImageBackground>
        : <Paper className={classes.flexRow} style={{width: '100%', height: '100%', borderRadius: 20, backgroundColor: colorWithAlpha(uiConfigs.themeColor, 0.9), borderWidth: 2, borderStyle: 'solid', borderColor: uiConfigs.themeColor, justifyContent: 'center'}}>
          {viewBusinessWrapper}
        </Paper>
      }
    </View>
  );
};

const GetTopMenuItem = (props) => {
  const {classes, uiConfigs, title, onClose, clickCallback} = props;
  const onClick = () => {
    onClose(clickCallback);
  };
  return (
    <MenuItem dense onClick={onClick} /* style={{backgroundColor: uiConfigs.messageBgColor}} */>
      <div className={classes.menuItemBox}>
        <TextView fontWeight={FontWeightRegular} color={ColorTitle} variant={'body2'}>
          {title}
        </TextView>
      </div>
    </MenuItem>
  );
};

const GetBottomMenuItem = (props) => {
  const {classes, imageBg, imageBgColor, image, title, onClick, uiConfigs, sizeSmall, sizeFactor} = props;

  const size = (sizeSmall ? 36 : uiConfigs.bottomIconViewSize || 48) * sizeFactor;
  const iconSize = (sizeSmall ? 20 : uiConfigs.bottomIconSize || 24) * sizeFactor;
  return (
    <View style={{marginLeft: 6*sizeFactor, marginRight: 6*sizeFactor, marginTop: -8, marginBottom: SpaceNormal, minWidth: 50*sizeFactor}}>
      <TouchableOpacity classes={classes} onClick={onClick}>
        <View className={classes.flexColumn}>
          {imageBg ? <ImageBackground source={imageBg} style={{display: 'flex', width: size, height: size, alignItems: 'center', justifyContent: 'center', paddingBottom: 4}} >
              <ImageBackground source={image} style={{width: iconSize, height: iconSize}} />
            </ImageBackground>
            : <Paper style={{display: 'flex', width: size, height: size, borderRadius: imageBg ? 0 : size/2, alignItems: 'center', justifyContent: 'center', paddingBottom: 4, backgroundColor: imageBgColor}} >
              <ImageBackground source={image} style={{width: iconSize, height: iconSize}} />
            </Paper>
          }
          <TextView fontSizeN={uiConfigs.fontSize * (sizeSmall ? 0.9 : 1)} variant={sizeSmall ? 'body2' : 'body2'} style={{color: uiConfigs.bottomMenuTitleColor, fontWeight: sizeSmall ? FontWeightRegular : FontWeightMedium}}>
            {title}
          </TextView>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const GetBottomView = (props) => {
  const {sizeFactor, uiConfigs, showSmall, classes, showPlayers, showGuide, showRewards, showCta1, showCta2, showShare, mute,
    onWinEligibleMenuClicked, onRewardsClicked, onGuideClicked, onShareClicked, onMuteToggle} = props;

  const bottomViewMarginBottomN = uiConfigs.bottomViewMarginBottomN || 0;
  const effHeight = (showSmall ? uiConfigs.bottomViewSmallHeight : uiConfigs.bottomViewHeight) * uiConfigs.sizeFactor + bottomViewMarginBottomN;
  const imageBg = uiConfigs.menuItemBgImage;
  const imageBgColor = uiConfigs.accentColor;

  const view = (
    <React.Fragment>
      {showPlayers ?
        <GetBottomMenuItem
          sizeSmall={showSmall}
          imageBg={imageBg}
          imageBgColor={imageBgColor}
          image={require('src/images/activity/0-img_players.png')}
          title={locString('players')}
          onClick={onWinEligibleMenuClicked}
          classes={classes}
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
        />
        : null
      }
      {showRewards ?
        <GetBottomMenuItem
          sizeSmall={showSmall}
          imageBg={imageBg}
          imageBgColor={imageBgColor}
          image={require('src/images/activity/0-img_prize.png')}
          title={locString('rewards')}
          onClick={onRewardsClicked}
          classes={classes}
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
        />
        : null
      }
      {showGuide ?
        <GetBottomMenuItem
          sizeSmall={showSmall}
          imageBg={imageBg}
          imageBgColor={imageBgColor}
          image={require('src/images/activity/0-img_guide.png')}
          title={locString('guide')}
          onClick={onGuideClicked}
          classes={classes}
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
        />
        : null
      }
      {showShare ?
        <GetBottomMenuItem
          sizeSmall={showSmall}
          imageBg={imageBg}
          imageBgColor={imageBgColor}
          image={require('src/images/activity/0-img_share.png')}
          title={locString('share')}
          onClick={onShareClicked}
          classes={classes}
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
        />
        : null
      }
      <GetBottomMenuItem
        sizeSmall={showSmall}
        imageBg={imageBg}
        imageBgColor={imageBgColor}
        image={mute ? require('src/images/activity/0-img_mute.png') : require('src/images/activity/0-img_unmute.png')}
        title={locString(mute ? 'activity.unmute' : 'activity.mute')}
        onClick={onMuteToggle}
        classes={classes}
        uiConfigs={uiConfigs}
        sizeFactor={sizeFactor}
      />
    </React.Fragment>
  );
  return (
    <View className={classes.viewColumnFullWidth} style={{flexDirection: 'row', alignSelf: 'center', height: effHeight, marginBottom: -bottomViewMarginBottomN, opacity: showCta1 || showCta2 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}>
      {uiConfigs.bottomImage ?
        <ImageBackground className={classes.flexRow} source={uiConfigs.bottomImage} style={{justifyContent: 'center', paddingBottom: bottomViewMarginBottomN}}>
          {view}
        </ImageBackground>
        : <Paper elevation={3} className={classes.flexRow} style={{borderRadius: 0, height: effHeight, justifyContent: 'center', paddingBottom: bottomViewMarginBottomN, borderWidth: 0, borderTopWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, background: 'linear-gradient(0deg, '+ uiConfigs.themeColorDark +','+ uiConfigs.themeColor +')'}}>
          {view}
        </Paper>
      }
    </View>
  );
};

const GetQuestionnaireBottomView = (props) => {
  const {inPreview, uiConfigs, classes, contentWidth, enablePrevious, enableNext, nextTitleId, showRewards, mute,
    onPreviousClicked, onNextClicked, onRewardsClicked, onMuteToggle} = props;
  const sizeFactor = uiConfigs.sizeFactor;
  const bottomViewMarginBottomN = uiConfigs.bottomViewMarginBottomN || 0;
  const height = 44 * sizeFactor + bottomViewMarginBottomN;

  const imageBg = uiConfigs.menuItemBgImage;
  const imageBgColor = uiConfigs.accentColor;

  const getBottomMenuItem = (image, imageFirst, title, disabled, onClick) => {
    return (
      <View>
        <TouchableOpacity disabled={disabled} onClick={onClick} style={{opacity: disabled ? 0.4 : 1}}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            {imageFirst ?
              <ImageBackground source={image} style={{width: 24 * sizeFactor, height: 20 * sizeFactor}} />
              : null
            }
            <AppTextWrapper fontSizeN={uiConfigs.fontSize} style={{color: uiConfigs.bottomMenuTitleColor, fontWeight: FontWeightMedium, marginLeft: 4 * sizeFactor, marginRight: 4 * sizeFactor}}>
              {title}
            </AppTextWrapper>
            {!imageFirst ?
              <ImageBackground source={image} style={{width: 24 * sizeFactor, height: 20 * sizeFactor}} />
              : null
            }
          </View>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <View style={{width: '100%', maxWidth: contentWidth, flexDirection: 'row', alignSelf: 'center', height: height, marginBottom: -bottomViewMarginBottomN}}>
      <ImageBackground source={uiConfigs.bottomImage} style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingBottom: bottomViewMarginBottomN, paddingLeft: 12 * sizeFactor, paddingRight: 12 * sizeFactor}}>
        {getBottomMenuItem(uiConfigs.prevImage, true, locString('previous'), !enablePrevious, onPreviousClicked)}
        <View style={{flex: 1}} />
        {showRewards ?
          <GetBottomMenuItem
            imageBg={imageBg}
            imageBgColor={imageBgColor}
            image={require('src/images/activity/0-img_prize.png')}
            sizeSmall
            title={locString('rewards')}
            onClick={onRewardsClicked}
            classes={classes}
            uiConfigs={uiConfigs}
            sizeFactor={sizeFactor}
          />
          : null
        }
        <GetBottomMenuItem
          imageBg={imageBg}
          imageBgColor={imageBgColor}
          image={mute ? require('src/images/activity/0-img_mute.png') : require('src/images/activity/0-img_unmute.png')}
          sizeSmall
          title={locString(mute ? 'activity.unmute' : 'activity.mute')}
          onClick={onMuteToggle}
          classes={classes}
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
        />
        <View style={{flex: 1}} />
        {getBottomMenuItem(uiConfigs.nextImage, false, locString(nextTitleId), !enableNext, onNextClicked)}
      </ImageBackground>
    </View>
  );
};

const GetQuestionnaireInitialView = (props) => {
  const {uiConfigs, activityType, answerCount, answeredCount, correctAnswerCount, winnersBy, winnersByValue, gameTimeText, title, isUserActionable, showGameAction, showGameInitial, isGameEnded,
    imageUrl, imageWidth, onImageFSClicked, onActionClicked} = props;
  const sizeFactor = uiConfigs.sizeFactor;

  const onImageFSClickedL = () => {
    onImageFSClicked(imageUrl);
  };

  return (
    <View>
      {showGameInitial ?
        <View style={{alignItems: 'center', marginBottom: 6 * sizeFactor}}>
          <View style={{flexDirection: 'row', marginBottom: -4 * sizeFactor}}>
            <ImageBackground1 source={uiConfigs.gameBgTopImage} style={{minWidth: 110 * sizeFactor, maxWidth: 140 * sizeFactor, minHeight: 40 * sizeFactor, alignItems: 'center', marginLeft: 2 * sizeFactor, marginRight: 2 * sizeFactor, padding: 6 * sizeFactor, paddingLeft: 18 * sizeFactor, paddingRight: 18 * sizeFactor}}>
              <AppText variant={'caption'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{locString('totalQuestions')}</AppText>
              <AppText variant={'subtitle2'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{answerCount}</AppText>
            </ImageBackground1>
            {winnersByValue > 0 ?
              <ImageBackground1 source={uiConfigs.gameBgTopImage} style={{minWidth: 110 * sizeFactor, maxWidth: 140 * sizeFactor, minHeight: 40 * sizeFactor, marginLeft: 2 * sizeFactor, marginRight: 2 * sizeFactor, padding: 6 * sizeFactor, paddingLeft: 18 * sizeFactor, paddingRight: 18 * sizeFactor}}>
                <AppText variant={'caption'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{locString('activity.percentCorrectAnswer')}</AppText>
                <AppText variant={'subtitle2'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{Math.ceil(winnersByValue/answerCount*100) + '%'}</AppText>
              </ImageBackground1>
              : null
            }
            {gameTimeText ?
              <ImageBackground1 source={uiConfigs.gameBgTopImage} style={{minWidth: 110 * sizeFactor, maxWidth: 140 * sizeFactor, minHeight: 40 * sizeFactor, alignItems: 'center', padding: 6 * sizeFactor, paddingLeft: 18 * sizeFactor, paddingRight: 18 * sizeFactor, marginLeft: 2 * sizeFactor, marginRight: 2 * sizeFactor}}>
                <AppText variant={'caption'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{locString('totalTime')}</AppText>
                <AppText variant={'subtitle2'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>{gameTimeText}</AppText>
              </ImageBackground1>
              : null
            }
          </View>
          {imageUrl ?
            <ImageBackground source={uiConfigs.mediaBgImage} style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: (isGameEnded ? 20 : 30) * sizeFactor, paddingTop:(isGameEnded ? 16 :  26) * sizeFactor, paddingBottom: (isGameEnded ? 30 : 50) * sizeFactor, marginLeft: 2, marginRight: 2}}>
              <TouchableOpacity onClick={onImageFSClickedL}>
                <AppImage imageUrl={imageUrl} style={{height: imageWidth/16*9, width: imageWidth, borderRadius: RadiusView, borderWidth: 1, borderColor: uiConfigs.titleColor}} />
              </TouchableOpacity>
            </ImageBackground>
            : null
          }
          <View style={{width: imageWidth + 40 * sizeFactor, marginLeft: 2, marginRight: 2, marginTop: -4 * sizeFactor, position: 'relative'}}>
            <ImageBackground1 source={uiConfigs.gameBgQMiddleImage} style={{position: 'absolute', top: 0, bottom: 10 * sizeFactor, left: 0, right: 0}}>
              <View style={{position: 'relative', minHeight: 20, marginTop: 12 * sizeFactor, marginLeft: 30 * sizeFactor, marginRight: 30 * sizeFactor, marginBottom: 6 * sizeFactor, justifyContent: 'center'}}>
                <AppText fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.titleColor, textAlign: 'center'}}>{title}</AppText>
              </View>
            </ImageBackground1>
            <ImageBackground source={uiConfigs.gameBgQBottomImage} style={{position: 'absolute', bottom: 0, left: 0, right: 0, height: 10 * sizeFactor}}/>
          </View>
        </View>
        : null
      }
      {showGameAction ?
        <View style={{alignItems: 'center', marginTop: 16, marginBottom: 8}}>
          <GetImageActionButton
            uiConfigs={uiConfigs}
            sizeFactor={sizeFactor}
            onClick={onActionClicked}
            title={answeredCount > 0 ? locString('resume') : locString('start')}
            width={200}
            image={uiConfigs.otherActionImage}
            disabled={!isUserActionable}
          />
        </View>
        : null
      }
      {isGameEnded && activityType === constants.activity.types.QUESTIONNAIRE ?
        <View style={{alignItems: 'center', justifyContent: 'center', marginTop: 20 * sizeFactor}}>
          <ImageBackground1 source={uiConfigs.gameBgEndImage} style={{alignItems: 'center', padding: 40 * sizeFactor, paddingTop: 20 * sizeFactor, paddingBottom: 32 * sizeFactor, marginLeft: 12 * sizeFactor, marginRight: 12 * sizeFactor, marginBottom: 4 * sizeFactor}}>
            <AppText fontSizeN={uiConfigs.fontSize} style={{fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: uiConfigs.titleColor, textAlign: 'center'}}>{locString('correctAnswers')}</AppText>
            <AppText variant={'h6'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.messageBgColor, textAlign: 'center', marginTop: 16 * sizeFactor}}>{locString('correctAnswersValue', {value1: correctAnswerCount, value2: answerCount, value3: Math.ceil(correctAnswerCount/answerCount*100)})}</AppText>
          </ImageBackground1>
        </View>
        : null
      }
    </View>
  );
};

const GetQuestionnaireView = (props) => {
  const {uiConfigs, isLTR, question, answerCount, questionnaireNumber, timeLeftText, selectedOption, gameTimeText, isUserActionable,
    width, imageWidth, onImageFSClicked, onQuestionnaireQuestionOptionSelected} = props;
  const sizeFactor = uiConfigs.sizeFactor;

  const onImageFSClickedL = () => {
    onImageFSClicked(question.imageUrl);
  };
  const qOptions = question.qOptions || question.options;

  return (
    <View style={{alignItems: 'center', marginTop: 8, width: '100%'}}>
      <View style={{flexDirection: 'row', width: '100%', marginBottom: -4 * sizeFactor}}>
        <View style={{marginLeft: (isLTR ? 42 : 12) * sizeFactor, marginRight: (isLTR ? 12 : 42) * sizeFactor, backgroundColor: uiConfigs.messageBorderColor, borderWidth: 1, borderColor: 'rgb(66,66,66)', borderTopStartRadius: RadiusView, borderTopEndRadius: RadiusView, padding: 4, paddingBottom: 6, paddingLeft: 12, paddingRight: 12, borderTopLeftRadius: 4, borderTopRightRadius: 4}}>
          <AppText variant={'subtitle2'} fontSizeN={uiConfigs.fontSize} style={{color: uiConfigs.gameValueTextColor, fontSize: FontSizeLarge, fontWeight: FontWeightMedium, textAlign: 'center'}}>
            {locString('questionValue', {value1: questionnaireNumber, value2: answerCount})}
          </AppText>
        </View>
        <View style={{flex: 1}}/>
        {gameTimeText ?
          <View style={{marginLeft: (isLTR ? 12 : 42) * sizeFactor, marginRight: (isLTR ? 42 : 12) * sizeFactor, backgroundColor: uiConfigs.messageBorderColor, borderWidth: 1, borderColor: 'rgb(66,66,66)', borderTopStartRadius: RadiusView, borderTopEndRadius: RadiusView, padding: 4, paddingBottom: 6, paddingLeft: 12, paddingRight: 12, borderTopLeftRadius: 4, borderTopRightRadius: 4}}>
            <AppText variant={'subtitle2'} fontSizeN={uiConfigs.fontSize} style={{color: uiConfigs.gameValueTextColor, fontSize: FontSizeLarge, fontWeight: FontWeightMedium, textAlign: 'center'}}>
              {locString('timeValue', {value1: timeLeftText})}
            </AppText>
          </View>
          : null
        }
      </View>
      <View style={{position: 'relative', marginLeft: 2, marginRight: 2}}>
        <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
          <AppImage source={uiConfigs.gameBgQTopImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, left: 0, right: 0, width: '100%', height: 40 * sizeFactor}}/>
          <AppImage source={uiConfigs.gameBgQMiddleImage} resizeMode={'fill'} style={{position: 'absolute', paddingTop: 40 * sizeFactor, paddingBottom: 10 * sizeFactor, left: 0, right: 0, width: '100%', height: '100%'}}/>
          <AppImage source={uiConfigs.gameBgQBottomImage} resizeMode={'fill'} style={{position: 'absolute', bottom: 0, left: 0, right: 0, width: '100%', height: 10 * sizeFactor}}/>
        </View>
        <FullWidthDummyView />
        <View style={{position: 'relative', marginTop: 12 * sizeFactor, marginLeft: 30 * sizeFactor, marginRight: 30 * sizeFactor, marginBottom: 10 * sizeFactor, minHeight: 20 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
          {question.imageUrl ?
            <TouchableOpacity style={{marginBottom: 6}} onClick={onImageFSClickedL}>
              <AppImage imageUrl={question.imageUrl} style={{height: imageWidth/16*9, width: imageWidth, borderRadius: RadiusView, borderWidth: 1, borderColor: uiConfigs.titleColor}} />
            </TouchableOpacity>
            : null
          }
          <AppText variant={'subtitle1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.titleColor, align: 'center'}}>{question.name}</AppText>
        </View>
      </View>
      <View style={{marginTop: 2 * sizeFactor, marginLeft: 16 * sizeFactor, marginRight: 16 * sizeFactor, marginBottom: 12 * sizeFactor, flexDirection: 'row', flexWrap: 'wrap'}}>
        {qOptions.map((item, index) => {
          return (
            <View key={''+ index} style={{width: Math.floor(width - 32 * sizeFactor) - 1, marginTop: 2 * sizeFactor}}>
              <QuestionOptionItem
                uiConfigs={uiConfigs}
                styleWrapper={{marginLeft: isLTR ? 12 : 6, marginRight: isLTR ? 6 : 12, marginTop: 6, marginBottom: 8}}
                bgImage={uiConfigs.cardBgImage}
                selectorColor={uiConfigs.gameValueTextColor}
                titleColor={uiConfigs.gameValueTextColor}
                id={index}
                disabled={!isUserActionable}
                onClick={() => {
                  onQuestionnaireQuestionOptionSelected(question.id, item.id);
                }}
                name={item.name}
                selected={selectedOption === item.id}/>
            </View>
          );
        })}
      </View>
    </View>
  );
};

const GetRewardsWonView = (props) => {
  const {isGuestUser, topView, topViewHeight, uiConfigs, contentWidth, classes, sizeFactor, activity, rewardUnavailableMessage, viewMaxHeight, onActivityClicked, onImageClicked} = props;

  const type = activity.userWinType == 1 ? 3 : 2;
  let view = ActivityHelper.getPointsNFunView(uiConfigs, contentWidth, activity.userValue1, 0, activity.userValueObjs, type, null, onActivityClicked, onImageClicked);
  if (!view) {
    const message = activity.userValue1 === -1 ? <FormattedMessage id={'activity.youWonGame'} /> : rewardUnavailableMessage;
    if (message) {
      let titleColor = uiConfigs.overlayTitleColor;
      if (type === 2 || type === 3) {
        titleColor = uiConfigs.rewardTitleColor;
      }
      view = (
        <View style={{minHeight: isGuestUser ? 0 : 60, alignItems: 'center', justifyContent: 'center'}}>
          <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'}
                   style={{textAlign: 'center', color: titleColor, fontWeight: FontWeightMedium, marginBottom: 12}}>
            {message}
          </AppText>
        </View>
      );
    }
  }
  if (!view) {
    return null;
  }

  const rewardViewMinHeight = (uiConfigs.rewardViewTopHeight + uiConfigs.rewardViewBottomHeight) * sizeFactor;
  const rewardViewMarginHorizontal = uiConfigs.rewardViewMarginHorizontal !== undefined ? uiConfigs.rewardViewMarginHorizontal : 4;
  return (
    <View className={classes.viewRowFullWidth} style={{padding: 8, paddingTop: 12, paddingLeft: rewardViewMarginHorizontal, paddingRight: rewardViewMarginHorizontal}}>
      <View className={classes.flexColumn} style={{position: 'relative', minHeight: rewardViewMinHeight, paddingTop: uiConfigs.rewardViewMarginTop * sizeFactor, paddingBottom: uiConfigs.rewardViewMarginBottom * sizeFactor}}>
        <FullWidthDummyView/>
        <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}>
          {uiConfigs.rewardTopImage == null && uiConfigs.rewardBottomImage == null && uiConfigs.rewardMiddleImage == null && !uiConfigs.themeColor ?
            <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, borderRadius: RadiusViewCard, borderWidth: 1, backgroundColor: uiConfigs.messageBgColor, borderColor: uiConfigs.messageBorderColor}}/>
            : null
          }
          {uiConfigs.rewardTopImage ? <AppImage resizeMode={'fill'} source={uiConfigs.rewardTopImage} style={{position: 'absolute', top: 0, left: 0, right: 0, height: uiConfigs.rewardViewTopHeight * sizeFactor, width: '100%'}} /> : null}
          {uiConfigs.rewardBottomImage ? <AppImage resizeMode={'fill'} source={uiConfigs.rewardBottomImage} style={{position: 'absolute', bottom: 0, left: 0, right: 0, height: uiConfigs.rewardViewBottomHeight * sizeFactor, width: '100%'}} /> : null}
          {uiConfigs.rewardMiddleImage ?
            <View style={{position: 'absolute', left: 0, right: 0, top: uiConfigs.rewardViewTopHeight * sizeFactor - 2, bottom: uiConfigs.rewardViewBottomHeight * sizeFactor - 2}}>
              <AppImage resizeMode={'fill'} source={uiConfigs.rewardMiddleImage} style={{width: '100%', height: '100%'}} />
            </View>
            : null
          }
        </View>
        <View className={classes.flexColumn} style={{position: 'relative', width: '100%'}}>
          <View style={{minHeight: uiConfigs.rewardViewTitleHeight * sizeFactor, alignItems: 'center', justifyContent: 'center', marginBottom: uiConfigs.rewardViewTitleMarginBottom, borderRadius: 2, backgroundColor: uiConfigs.themeColor || ColorClear, padding: uiConfigs.themeColor ? 16*sizeFactor : 0, paddingTop: uiConfigs.themeColor ? 6*sizeFactor : 0, paddingBottom: uiConfigs.themeColor ? 6*sizeFactor : 0, marginTop: uiConfigs.themeColor ? -12*sizeFactor : 0}}>
            <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.rewardHeadingColor, fontSize: FontSizeXLarge, fontWeight: FontWeightMedium}}>{locString('congratulations')}</AppText>
          </View>
          <View style={{maxHeight: viewMaxHeight, paddingLeft: uiConfigs.rewardViewContentMarginHorizontal * sizeFactor, paddingRight: uiConfigs.rewardViewContentMarginHorizontal * sizeFactor, width: '100%'}}>
            {/*<ScrollView contentContainerStyle={{paddingTop: 12}}>*/}
              <div style={{paddingTop: 12}}>
                <View style={{width: '100%', minHeight: isGuestUser ? 40 : 100, justifyContent: 'center', alignItems: 'center'}}>
                  <div style={topViewHeight ? {minHeight: topViewHeight} : {}}>
                    {topView}
                  </div>
                  {view}
                </View>
              </div>
            {/*</ScrollView>*/}
          </View>
        </View>
      </View>
    </View>
  );
};

const ExternalGameComponentView = (props) => {
  const {width, height, gameOptions, refHandler, gameId} = props;
  // gameOptions.onStart = null;
  // gameOptions.onEnd = null;
  if (gameId === 1) {
    return (
      <GameTapTapShots bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 2) {
    return (
      <GameFreeKicks bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 3) {
    return (
      <GamePacManRush bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 4) {
    return (
      <GameTrafficGo bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 5) {
    return (
      <GameCannonCraze bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 6) {
    return (
      <GameSnakeUp bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 7) {
    return (
      <GameArcHunter bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 8) {
    return (
      <GameRoshambo bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }
  if (gameId === 9) {
    return (
      <GamePonk bounceLoopSide={true} ref={refHandler} width={width} height={height} options={gameOptions}/>
    );
  }

  return null;
};

export const GetTextView = (props) => {
  const {title, isXS, uiConfigs, numberOfLines} = props;
  const extraSpacing = uiConfigs.textViewExtraSpacing || 0;
  return (
    <View style={{marginTop: 8, marginBottom: 8, marginLeft: 12, marginRight: 12, flexDirection: 'row', justifyContent: 'center'}}>
      <View style={{backgroundColor: uiConfigs.messageBgColor, border: '1px solid '+ uiConfigs.messageBorderColor, borderRadius: 8, padding: 8 + extraSpacing, paddingLeft: 12 + extraSpacing, paddingRight: 12 + extraSpacing}}>
        <AppText
          numberOfLines={numberOfLines}
          fontSizeN={uiConfigs.fontSize}
          variant={'body1'}
          style={{
            color: uiConfigs.titleColor,
            fontWeight: FontWeightMedium,
            textAlign: 'center'}}>
          {title}
        </AppText>
      </View>
    </View>
  );
};

const GetNoActionMessageView = (props) => {
  const {noActionMessage, showCollectMorePoints, onCollectMoreClicked} = props;
  return (
    <View style={{alignItems: 'center', marginLeft: 12, marginRight: 12}}>
      <AppText style={{
        marginTop: 6,
        marginBottom: SpaceXSmall,
        color: ColorOrange,
        fontSize: FontSizeNormal,
        fontWeight: FontWeightMedium,
        textAlign: 'center'}}>
        {noActionMessage}
      </AppText>
      {showCollectMorePoints ?
        <Button
          elevation={false}
          titleColor={ColorTheme}
          style={{marginTop: -SpaceSmall}}
          onClick={onCollectMoreClicked}
        >{locString('collectMorePoints')}</Button>
        : null
      }
    </View>
  );
};

const SOCKET_STATE_NONE = 0;
const SOCKET_STATE_CONNECTING = 1;
const SOCKET_STATE_DISCONNECTING = 2;
const SOCKET_STATE_CONNECTED = 3;
const SOCKET_STATE_EMITTING = 4;
const SOCKET_STATE_ERROR = 5;

class ActivityView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.refExGame = createRef();
    this.refBgAudio = createRef();
    this.refAudioWin = createRef();
    this.refAudioAction = createRef();
    this.refAudioNeutral = createRef();
    this.refAudioTimer = createRef();

    // this.oldActivity = props.activity;
    this.activity = cloneDeep(props.activity);

    this.activityType = this.activity.type;
    this.sizeFactor = this.getSizeFactor();
    this.sizeVFactor = this.getSizeVFactor();
    this.showCtaNumber = this.props.showCtaNumber;
    if (!this.activity.configs) {
      this.activity.configs = {};
    }
    if (props.inPreview && !props.simulation) {
      this.processPreview(this.activity);
    }

    this.state = {
      activityId: this.activity.id,
      reload: false,
      isBlockedLoading: false,
      questionnaireTimer: 0,
      showSnackbar: false,
      showDialog: false,
      showMenu: false,
      showImageFS: false,
      showOverlay: false,
      showSimpleOverlay: false,
      showEnd: false,
      mute: true,
      userMute: true,
      socketState: SOCKET_STATE_NONE,
      showAction: true,
    };
    this.iframeLoadCount = 0;
    this.socketTries = 0;

    // this.gameAudioPlayer = new GameAudioPlayer();
    // this.gameAudioPlayer.unmute();
    this.isHavingFocus = true;

    const params = {};

    // this.influencerFollowerActivityId = params.ifId;
    // this.transaction = params.transaction;
    // this.business = params.business;
    // this.branch = params.branch;
    // this.displayAsModel = params.displayAsModel;
    this.displayAsModel = false;
    this.enableScroll = true;
    this.autoPlayVideo = true;
    // this.inExperience = params.inExperience;
    // this.inProfile = params.inProfile;
    // this.inAck = params.inAck;
    // this.cType = params.cType;
    // this.hasNext = false;
    this.onResultDelete = params.onResultDelete;
    this.onResultUpdate = params.onResultUpdate;

    this.selectedOptionIndexes = new Set();
    this.oldGuess1 = null;
    this.oldGuess2 = null;
    this.guess1 = null;
    this.guess2 = null;
    this.oldGuessText = null;
    this.guessText = null;
    this.selectedGuesses = null;
    this.showBranches = false;
    this.recordAsset = null;
    this.rating = 0;
    this.disabledBodyScroll = false;

    this.renderWidth = 0;
    this.renderHeight = 0;
    this.statusBarHeight = 0;
    this.bottomSpacing = 0;

    this.videoAsset = null;
    this.invokeReelsDirectly = true;
    this.questionnaireNumber = 0;
    this.questionnaireMap = null;
    this.wasQuestionnaireTimerRunning = false;
    this.intervalHandle = null;
    this.processEndViewPending = false;
    this.isInFullscreen = false;
    this.hashHistory = [];


    this.processPreviewConfigs();
  }

  processPreviewConfigs() {
    if (this.props.inPreview) {
      this.activity.maxCards = 6;
      this.activity.isUserActionable = true;
      this.activity.showWinners = this.activity.type !== constants.activity.types.SLIDES && this.activity.type !== constants.activity.types.SHOWCASE_MENU;
      this.activity.showPlayers = true;
      this.activity.userConsumedCount = 0;
      this.activity.winGLimit = 100;
      this.activity.answerLimit = 100;
      this.activity.winGCount = 0;
      this.activity.answeredCount = 0;
      this.activity.userAnswer = 0;

      // const cardsCount = this.activity.slotValues ? this.activity.slotValues.length : 0;
      // const maxCards = this.activity.activityConfigs.slotTotalImages;
      // if (!this.activity.slotValues || cardsCount < maxCards) {
      //   if (!this.activity.slotValues) {
      //     this.activity.slotValues = [];
      //   }
      //   for (let i = cardsCount; i < this.activity.maxCards; i++) {
      //     const id = - (100 + i + 1);
      //     const imageUrl = APP_GAME_DEFAULT_IMAGES_URI + 'ic_slot'+ id +'.png';
      //     this.activity.slotValues.push({
      //       id: id,
      //       imageUrl: imageUrl,
      //       offers: [],
      //       points: '0',
      //       value1: '0',
      //       winLimit: '0',
      //       winILimit: '0',
      //     });
      //   }
      // }
    }
  }

  pushHashHistory(hash) {
    if (!this.props.inPreview) {
      if (!this.hashHistory.length || this.hashHistory[this.hashHistory.length - 1] !== hash) {
        this.hashHistory.push(hash);
        const {history} = this.props;
        const newPath = history.location.pathname + history.location.search + '#' + hash;
        history.push(newPath);
      }
    }
  }

  popHashHistory(hash) {
    if (!this.props.inPreview) {
      if (this.hashHistory.length > 0 && this.hashHistory[this.hashHistory.length - 1] === hash) {
        this.hashHistory.splice(this.hashHistory.length - 1, 1);
        this.props.history.goBack();
      }
    }
  }

  popHashHistoryOnly(hash) {
    if (!this.props.inPreview) {
      if (this.hashHistory.length > 0 && this.hashHistory[this.hashHistory.length - 1] === hash) {
        this.hashHistory.splice(this.hashHistory.length - 1, 1);
      }
    }
  }

  componentDidMount() {
    // window.addEventListener('click', () => {
    //   this.refBgAudio1.play();
    // }, {once: true});

    window.addEventListener('hashchange', this.onWindowHasChange);
    window.addEventListener('onAppDidFocus', this.onAppDidFocus);
    window.addEventListener('onAppDidBlur', this.onAppDidBlur);

    this.statusBarHeight = 0;
    this.bottomSpacing = 0;

    this.updateAndReload();
    this.timeoutHandlerShowAction = setTimeout(() => {
      this.setState({showAction: true});
    }, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.onWindowHasChange);
    window.removeEventListener('onAppDidFocus', this.onAppDidFocus);
    window.removeEventListener('onAppDidBlur', this.onAppDidBlur);
    window.removeEventListener('message', this.onMessage);

    this.onAppDidBlur();

    if (this.onResultUpdate) {
      this.onResultUpdate(this.activity);
    }
    if (this.showGameUIVideoHandler) {
      clearTimeout(this.showGameUIVideoHandler);
      this.showGameUIVideoHandler = null;
    }
    if (this.showEndViewHandler) {
      clearTimeout(this.showEndViewHandler);
      this.showEndViewHandler = null;
    }
    if (this.timerShowShare) {
      clearTimeout(this.timerShowShare);
      this.timerShowShare = null;
    }
    if (this.showDelayViewHandler) {
      clearTimeout(this.showDelayViewHandler);
      this.showDelayViewHandler = null;
    }
    if (this.autoCloseIntervalHandler) {
      clearInterval(this.autoCloseIntervalHandler);
      this.autoCloseIntervalHandler = null;
    }
    if (this.timeoutHandlerShowAction) {
      clearTimeout(this.timeoutHandlerShowAction);
      this.timeoutHandlerShowAction = null;
    }
    if (this.timeoutRefAutoSimulationEnd) {
      clearTimeout(this.timeoutRefAutoSimulationEnd);
      this.timeoutRefAutoSimulationEnd = null;
    }
    this.stopQuestionnaireTimer();
    logDebug('Socket-Release-componentWillUnmount');
    this.releaseSocket();
    clearAllBodyScrollLocks();

    this.refExGame.current = null;
    this.refBgAudio.current = null;
    this.refAudioWin.current = null;
    this.refAudioAction.current = null;
    this.refAudioNeutral.current = null;
    this.refAudioTimer.current = null;
    this.refIframeGame = null;
    this.refDiv = null;
    this.refFlipTileGameView = null;
    this.refJackpotGameView = null;
    this.refScrollView = null;
    this.refVideoView = null;
    this.refMultiInputView = null;
    this.refBranch = null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.width !== prevProps.width || this.props.height !== prevProps.height) {
      this.sizeFactor = this.getSizeFactor();
      this.sizeVFactor = this.getSizeVFactor();
      this.uiConfigs = null;
      this.getUIConfigs();
      this.reloadView();
    }
    if (this.props.autoSimulation && this.props.autoSimulation !== prevProps.autoSimulation) {
      this.updateAndReload();
    }
  }

  onAppDidFocus = () => {
    if (this.wasQuestionnaireTimerRunning) {
      this.startQuestionnaireTimer();
    }
    this.playGameBgAudio();
    if (this.processEndViewPending) {
      this.processGameEndView();
    }

    this.setupSocket(true);

    if (this.wasBodyScrollDisabled) {
      this.wasBodyScrollDisabled = false;
      this.disableBodyScroll();
    }
  };

  onAppDidBlur = () => {
    this.wasQuestionnaireTimerRunning = false;
    if (this.intervalHandle) {
      this.wasQuestionnaireTimerRunning = true;
      this.stopQuestionnaireTimer();
    }
    this.stopGameBgAudio();

    this.releaseSocket();

    this.wasBodyScrollDisabled = this.disabledBodyScroll;
    this.enableBodyScroll();
  };

  onWindowHasChange = (event) => {
    const oldUrl = event.oldURL;
    const newUrl = event.newURL;
    const oldHash = utils.getHashFromUrl(oldUrl);
    const newHash = utils.getHashFromUrl(newUrl);
    if (oldHash && oldHash !== newHash) {
      if (oldHash === HASH_IMAGE_FS && (!newHash || newHash === HASH_OVERLAY || newHash === HASH_QUESTIONNAIRE)) {
        this.popHashHistoryOnly(HASH_IMAGE_FS);
        this.closeImageFS();
      }
      else if (oldHash === HASH_OVERLAY && (!newHash || newHash === HASH_QUESTIONNAIRE)) {
        if (this.state.showEnd) {
          this.popHashHistoryOnly(HASH_OVERLAY);
          this.hideEndView();
        } else if (this.state.showSponsor) {
          this.popHashHistoryOnly(HASH_OVERLAY);
          this.hideSponsorView();
        } else if (this.state.showSimpleOverlay) {
          this.popHashHistoryOnly(HASH_OVERLAY);
          this.dismissSimpleOverlayNHandleCallback();
        }
      }
      else if (oldHash === HASH_QUESTIONNAIRE && !newHash) {
        if (this.questionnaireNumber > 0 || this.isPlaying) {
          this.popHashHistoryOnly(HASH_QUESTIONNAIRE);
          this.onBackClicked();
        }
      }
    }
  };

  changeNavigationColor(color) {
    if (!this.props.inPreview && !this.props.onPreFunDone) {
      if (!color) {
        color = this.getUIConfigs().safeAreaColor;
      }
      changeNavColor(color);
    }
  }

  disableBodyScroll() {
    // if (/*!this.props.inPreview && */this.activity && this.activity.type === ACTIVITY_TYPE_MATCH_THREE) {
    //   if (this.activity.isUserActionable) {
    //     if (!this.disabledBodyScroll) {
    //       this.disabledBodyScroll = true;
    //       disableBodyScroll(this.refDiv);
    //     }
    //   } else {
    //     this.enableBodyScroll();
    //   }
    // }
  }

  enableBodyScroll() {
    // if (/*!this.props.inPreview && */this.activity && this.activity.type === ACTIVITY_TYPE_MATCH_THREE && this.disabledBodyScroll) {
    //   this.disabledBodyScroll = false;
    //   enableBodyScroll(this.refDiv);
    // }
  }

  isSocketApplicable() {
    // const {inPreview, noActionMode, readOnly} = this.props;
    // return this.activity &&
    //   this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE
    //   && !inPreview
    //   && !noActionMode
    //   && !readOnly
    //   && this.activity.isUserActionable;
    return false;
  }

  setupSocket(fromAppInForeground = false) {
    const {socketState} = this.state;
    if (this.isSocketApplicable()) {
      let canStartSocket = socketState === SOCKET_STATE_NONE;
      if (!canStartSocket && !fromAppInForeground) {
        canStartSocket = socketState === SOCKET_STATE_ERROR;
      }
      if (canStartSocket) {
        this.attachSocketEvents();
        this.socketTries = 0;
        this.setState({socketState: SOCKET_STATE_CONNECTING});
        logDebug('Socket-Connecting');
        socket.connect();
      }
    } else {
      this.releaseSocket();
    }
  }

  releaseSocket() {
    const {socketState} = this.state;
    const isSocketOn = socketState === SOCKET_STATE_CONNECTED || socketState === SOCKET_STATE_EMITTING;
    if (isSocketOn) {
      logDebug('Socket-Disconnecting');
      this.setState({socketState: SOCKET_STATE_DISCONNECTING});
      socket.disconnect();
    }
  }

  attachSocketEvents() {
    this.detachSocketEvents();
    socket.on('connect', this.onSocketConnect);
    socket.on('disconnect', this.onSocketDisconnect);
    socket.on('connect_error', this.onSocketError);
  }

  detachSocketEvents() {
    socket.off('connect', this.onSocketConnect);
    socket.off('disconnect', this.onSocketDisconnect);
    socket.off('connect_error', this.onSocketError);
  }

  onSocketConnect = () => {
    logDebug('Socket-Connected');
    this.setState({socketState: SOCKET_STATE_CONNECTED}, () => {
      if (this.isSocketApplicable()) {
        this.sendSocketData();
      } else {
        logDebug('Socket-Release-onSocketConnect');
        this.releaseSocket();
      }
    });
  };

  onSocketDisconnect = () => {
    logDebug('Socket-Disconnected');
    this.detachSocketEvents();
    this.setState({socketState: SOCKET_STATE_NONE});
  };

  onSocketError = () => {
    this.socketTries++;
    if (this.socketTries > 2) {
      logDebug('Socket-Error');
      socket.disconnect();
      this.detachSocketEvents();
      this.setState({socketState: SOCKET_STATE_ERROR, socketError: this.context.intl.formatMessage({id: 'activity.errorGameLoading'})});
    }
  };

  sendSocketData(gameRequest, onDone) {
    gameRequest = this.processGameRequestForSocket(gameRequest);

    const onSocketSendError = (error) => {
      socket.disconnect();
      this.detachSocketEvents();
      this.setState({socketState: SOCKET_STATE_ERROR, socketError: error});

      const gameData = this.lastSocketData ? this.lastSocketData.gameData : gameRequest.gameData;
      if (onDone) {
        onDone(gameData);
      } else {
        this.onSocketGameResponseNonHandled(gameData);
      }
    }

    socket.timeout(10000).emitWithAck('gameAction', gameRequest).then((gameResponse) => {
      if (gameResponse.error) {
        onSocketSendError(gameResponse.error);
      } else {
        this.lastSocketData = cloneDeep(gameResponse);
        this.setState({socketState: SOCKET_STATE_CONNECTED});
        if (onDone) {
          onDone(gameResponse.gameData);
        } else {
          this.onSocketGameResponseNonHandled(gameResponse.gameData);
        }
      }
    }).catch((error) => {
      onSocketSendError(this.context.intl.formatMessage({id: 'activity.socketTimeout'}));
    });
    this.setState({socketState: SOCKET_STATE_EMITTING});
  }

  onSocketRetryClicked = () => {
    this.setupSocket();
  };

  fetchSocketResponse = (gameRequest, onDone) => {
    this.sendSocketData(gameRequest, onDone);
  };

  onSocketGameResponseNonHandled = (gameData) => {
    if (this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
      if (this.refFlipTileGameView) {
        this.refFlipTileGameView.refreshGame(gameData);
      }
    }
  };

  processGameRequestForSocket(gameRequest) {
    if (!gameRequest) {
      gameRequest = {};
    }
    gameRequest.userId = this.props.userId;
    gameRequest.activityId = this.activity.id;
    gameRequest.activityType = this.activity.type;

    if (!gameRequest.gameData) {
      if (this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
        const slotCount = this.activity.slotValues ? this.activity.slotValues.length : 0;
        for (let i = slotCount; i < 2; i++) {
          this.activity.slotValues.push({id: i === 0 ? -10 : -i});
        }
        gameRequest.gameData = {
          input: this.getInputSlotsWithFields(['id']),
          state: Array(9).fill(null),
        };
      }
    }
    return gameRequest;
  }

  getInputSlotsWithFields(fields) {
    if (!fields) {
      fields = ['id'];
    }
    let slots = [];
    if (this.activity.slotValues) {
      this.activity.slotValues.forEach((slotValue) => {
        const slot = {};
        fields.forEach((field) => {
          slot[field] = slotValue[field];
        });
        slots.push(slot);
      });
    }
    return slots;
  }

  updateAndReload() {
    this.updateActivityData().then(() => {
      if (this.state.showAction) {
        this.reloadView();
      }
    });
  }

  reloadView() {
    if (this.state) {
      this.setState({reload: !this.state.reload});
    }
  }

  reloadPreview(configData, showCtaNumber) {
    this.showCtaNumber = showCtaNumber;
    this.processPreview(configData);
    // if (!this.activity.configs.playAudioBg) {
    //   this.setState({mute: true});
    // } else if (!this.state.userMute) {
    //   this.setState({mute: false});
    // }
    this.reloadView();
  }

  processPreview(configData) {
    // game easy default configs
    this.activity.withDetails = true;
    if (this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
      this.activity.gameEasy = 10; // 10% randomise use of minmax or random algo
    } else if (this.activity.type === constants.activity.types.GAME_WHAC_A_MOLE) {
      this.activity.gameEasy = 200; // time upto which mole is displayed in ms
      this.activity.gameEasy1 = 200; // random time on top of above time upto which mole is displayed in ms
    } else if (this.activity.type === constants.activity.types.IDENTIFY_LOCATION) {
      this.activity.startLocation = {
        latitude: 24.7136,
        longitude: 46.6753
      };
    }

    let isBgAudioChanged = false;
    const {previewBasics, previewBgAudio, previewCta1, previewCta2,
      previewCards, previewReferral, previewGamePlay, previewInQuestion, previewInQuestionEnd,
      previewPrediction, previewLocation, previewQuestion, previewQuestions,
      previewSubPosts, previewOpinion, previewBusiness} = configData;
    if (previewBasics && (previewBasics.final || previewBasics.start)) {
      this.activity = this.processPreviewGameReset();
    }

    this.activity.showReward = false;
    if (previewBasics) {
      this.activity.showReward = previewBasics.showReward;
      const oldThemeColor = this.activity.themeColor;
      if (oldThemeColor != previewBasics.themeColor) {
        this.activity.themeColor = previewBasics.themeColor;
        this.uiConfigs = null;
        if (this.activity.type === ACTIVITY_TYPE_EXTERNAL_GAMES && this.activity.gameInfo && this.activity.gameInfo.configs && this.activity.gameInfo.configs.themeBg) {
          this.gameOptions = null;
        }
      }
    }
    if (previewBgAudio) {
      isBgAudioChanged = this.activity.bgAudioUrl !== previewBgAudio.audioUrl;
      this.activity.bgAudioUrl = previewBgAudio.audioUrl;
      this.activity.configs.playAudioBg = previewBgAudio.play;
    }

    let isBusinessInfoChanged = false;
    if (previewBusiness) {
      isBusinessInfoChanged = this.activity.business.name != previewBusiness.name || this.activity.business.imageUrl != previewBusiness.imageUrl;
      this.activity.business.name = previewBusiness.name;
      this.activity.business.imageUrl = previewBusiness.imageUrl;
    }

    // if (previewCta1) {
    //   this.activity.business.name = previewCta1.title;
    //   this.activity.business.link = previewCta1.link;
    //   this.activity.business.imageUrl = previewCta1.imageUrl;
    //   this.activity.showCta1 = previewCta1.show;
    //   if (this.showCtaNumber) {
    //     this.activity.showCta1 = this.showCtaNumber === 1;
    //   }
    // }

    if (previewCta2) {
      this.activity.s2LinkText = previewCta2.linkText;
      this.activity.s2Link = previewCta2.link;
      this.activity.s2ImageUrl = previewCta2.imageUrl;
      this.activity.videoUrl = previewCta2.videoUrl;
      this.activity.videoStreamUrl = previewCta2.videoStreamUrl;
      this.activity.showCta2 = previewCta2.show;
      this.activity.showEnd = previewCta2.show;
      if (this.showCtaNumber) {
        this.activity.showCta2 = this.showCtaNumber === 2;
        this.activity.showEnd = this.showCtaNumber === 2;
      }
      if (this.activity.type === constants.activity.types.CHALLENGE || this.activity.type === constants.activity.types.SOCIAL_CONTENT) {
        this.activity.description = previewCta2.description;
      }
    }

    if (this.activity.type === constants.activity.types.PREDICTION) {
      if (previewPrediction) {
        // let isAnswerAttempted = false;
        // if (this.activity.type === constants.activity.types.PREDICTION) {
        //   isAnswerAttempted = this.activity.userValueText != null;
        // }
        this.activity.qTitle = previewPrediction.name;
        this.activity.value1Placeholder = null;
        this.activity.imageUrl1 = null;
        this.activity.rightOptionHint = null;
        this.activity.value2Placeholder = null;
        this.activity.imageUrl2 = null;
        this.activity.rightOptionHintAr = null;
        if (previewPrediction.option1) {
          this.activity.value1Placeholder = previewPrediction.option1.name;
          this.activity.imageUrl1 = previewPrediction.option1.imageUrl;
          this.activity.rightOptionHint = previewPrediction.option1.answer;
        } else {
          this.guess1 = null;
        }
        if (previewPrediction.option2) {
          this.activity.value2Placeholder = previewPrediction.option2.name;
          this.activity.imageUrl2 = previewPrediction.option2.imageUrl;
          this.activity.rightOptionHintAr = previewPrediction.option2.answer;
        } else {
          this.guess2 = null;
        }
        if (!this.guess1 && !this.guess2) {
          this.activity.isUserActionable = true;
          this.activity.isUserActionableA = false;
        }
      }
    }
    else if (this.activity.type === constants.activity.types.VISITOR_OPINION) {
      if (previewOpinion) {
        this.activity.qTitle = previewOpinion.name;
        this.activity.imageUrl1 = previewOpinion.imageUrl;
        this.activity.contentTypes = previewOpinion.contentTypes;
        this.activity.value1Placeholder = previewOpinion.ratingMinTitle;
        this.activity.value2Placeholder = previewOpinion.ratingMaxTitle;
      }
    }
    else if (this.activity.type === constants.activity.types.IDENTIFY_LOCATION) {
      if (previewLocation) {
        this.activity.qTitle = previewLocation.name;
        this.activity.imageUrl1 = previewLocation.imageUrl;
      }
    }
    else if (this.activity.type === constants.activity.types.QUESTION
      || this.activity.type === constants.activity.types.GUESS) {
      if (previewQuestion) {
        this.activity.imageUrl2 = previewQuestion.imageUrl;
        let isAnswerAttempted = false;
        if (this.activity.type === constants.activity.types.QUESTION) {
          isAnswerAttempted = this.activity.userAnswer != 0;
          this.activity.showAnswers = previewQuestion.showAnswers;
        } else if (this.activity.type === constants.activity.types.GUESS) {
          isAnswerAttempted = this.activity.userValueText != null;
          this.activity.rightOptionId = previewQuestion.rightOptionId;
          this.activity.correction = previewQuestion.correction;
        }
        this.activity.qTitle = previewQuestion.name;
        this.activity.qOptions = previewQuestion.options;
        if (isAnswerAttempted) {
          let isFound = false;
          this.activity.qOptions.forEach((option) => {
            let isThisOptionAnswered = false;
            if (this.activity.type === constants.activity.types.QUESTION) {
              isThisOptionAnswered = option.id === this.activity.userAnswer;
            } else if (this.activity.type === constants.activity.types.GUESS) {
              isThisOptionAnswered = option.id === this.activity.userValueText;
            }
            if (isThisOptionAnswered) {
              isFound = true;
            }
          });
          if (!isFound) {
            this.processPreviewGameResetForQuestionNGuessNPrediction(this.activity);
          }
        }
      }
    }
    else if (this.activity.type === constants.activity.types.QUESTIONNAIRE || this.activity.type === constants.activity.types.SURVEY) {
      if (previewQuestions) {
        this.activity.qTitle = previewQuestions.name;
        this.activity.imageUrl2 = previewQuestions.imageUrl;
        const oldQuestions = this.activity.questionnaire;
        const oldGameTime = this.activity.gameTime;
        // this.activity.questionnaire = cloneDeep(previewQuestions.questions);
        this.activity.questionnaire = previewQuestions.questions;
        // const questionIds = previewQuestions.questionIds;
        this.activity.gameTime = previewQuestions.gameTime;
        this.activity.winnersBy = previewQuestions.minCorrectAnswers > 0 ? 1 : 0;
        this.activity.winnersByValue = previewQuestions.minCorrectAnswers;
        this.activity.correction = previewQuestions.correction;
        this.activity.consumeLimitPerUser = this.activity.questionnaire ? this.activity.questionnaire.length : 0;
        if (this.questionnaireNumber > 0) {
          let isChanged = oldGameTime !== this.activity.gameTime;
          if (!isChanged) {
            isChanged = (!oldQuestions || oldQuestions.length === 0)
              || (!this.activity.questionnaire || this.activity.questionnaire.length === 0)
              || (oldQuestions.length !== this.activity.questionnaire.length);
            if (!isChanged) {
              for (let i = 0; i < oldQuestions.length; i++) {
                const oldQuestion = oldQuestions[i];
                const question = this.activity.questionnaire[i];
                isChanged = (oldQuestion.id !== question.id)
                  || (!oldQuestion.options || oldQuestion.options.length === 0)
                  || (!question.options || question.options.length === 0)
                  || (oldQuestion.options.length !== question.options.length);
                if (!isChanged) {
                  for (let j = 0; j < oldQuestion.options; j++) {
                    isChanged = oldQuestion.options[j].id !== question.options[j].id;
                  }
                }
              }
            }
          }
          if (isChanged) {
            this.questionnaireNumber = 0;
            this.questionnaireMap = {};
            this.stopQuestionnaireTimer();
            this.processPreviewGameResetForQuestionnaire(this.activity);
          }
        }
      }
    }

    if (previewGamePlay) {
      if (this.activity.type !== constants.activity.types.QUESTIONNAIRE && this.activity.type !== constants.activity.types.SURVEY
        && this.activity.type !== constants.activity.types.GAME_FLIP_CARD) {
        this.activity.consumeLimitPerUser = previewGamePlay.tries;
      }
      if (this.activity.type === constants.activity.types.GAME_FLIP_CARD) {
        this.activity.flipsNeeded = previewGamePlay.tries;
      }
      if (this.activity.type !== constants.activity.types.PREDICTION
        && this.activity.type !== constants.activity.types.QUESTIONNAIRE
        && this.activity.type !== constants.activity.types.SURVEY
        && this.activity.type !== constants.activity.types.QUESTION
        && this.activity.type !== constants.activity.types.GUESS
        && this.activity.type !== constants.activity.types.IDENTIFY_LOCATION
        && this.activity.type !== constants.activity.types.VISITOR_OPINION) {
        this.activity.imageUrl1 = previewGamePlay.cardImageUrl;
        this.activity.imageUrl2 = previewGamePlay.cardRevealImageUrl;
      }
      this.activity.consumeLimit = previewGamePlay.plays;
      if (previewGamePlay.showCards) {
        if (this.activity.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
          const exValue = this.activity.userValueText ? this.activity.userValueText : 0;
          this.activity.userValueText = Math.max(previewGamePlay.showCards, exValue);
        }
      }
    }

    if (previewCards && this.activity.slotValues) {
      const previewCardsShow = previewGamePlay.showCards;
      const previewCardsKeyShow = previewGamePlay.showKeyCards;
      let isCardImagesChanged = (previewCardsShow && this.activity.previewCardsShow !== previewCardsShow)
        || (previewCards.length !== this.activity.slotValues.length);
      this.activity.previewCardsShow = previewCardsShow;
      this.activity.previewCardsKeyShow = previewCardsKeyShow;
      if (!isCardImagesChanged) {
        let index = 0;
        previewCards.forEach((card) => {
          if (index < this.activity.slotValues.length) {
            const slot = this.activity.slotValues[index];
            slot.id = card.id;
            slot.points = card.points;
            slot.offers = card.offers;

            if (card.imageUrl !== slot.imageUrl || card.name !== slot.name || card.value1 !== slot.value1) {
              slot.imageUrl = card.imageUrl;
              slot.name = card.name;
              slot.value1 = card.value1;
              isCardImagesChanged = true;
            }
          }
          index++;
        });
      }
      if (isCardImagesChanged) {
        this.activity.slotValues = cloneDeep(this.activity.slotValues);
        if (this.refJackpotGameView) {
          this.refJackpotGameView.resetItems(this.activity.slotValues);
        } else if (this.refFlipTileGameView) {
          this.refFlipTileGameView.resetForPreview(this.activity.slotValues, previewCardsShow, previewCardsKeyShow);
        }
        this.gameOptions = null;
        this.iframeLoadCount++;
      }
    }

    if ((this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU)) {
      let isChanged = previewSubPosts && !this.activity.subPosts
        || !previewSubPosts && this.activity.subPosts
        || previewSubPosts.length !== this.activity.subPosts.length;
      if (!isChanged) {
        let index = 0;
        previewSubPosts.forEach((card) => {
          if (index < this.activity.subPosts.length) {
            const slot = this.activity.subPosts[index];
            if (card.imageUrl !== slot.imageUrl || card.title !== slot.title || card.duration !== slot.duration) {
              isChanged = true;
            }
          }
          index++;
        });
      }
      if (isChanged) {
        this.activity.subPosts = previewSubPosts ? cloneDeep(previewSubPosts) : [];
        if (this.refSlides) {
          this.refSlides.resetForPreview(this.activity.subPosts, 0);
        }
      }
    }

    this.activity.previewInQuestion = null;
    if (previewInQuestion) {
      const oldIsUserActionable = this.activity.previewInQuestion ? this.activity.previewInQuestion.isUserActionable : false;
      previewInQuestion.isUserActionable = previewInQuestion.show;
      previewInQuestion.isInternal = true;
      previewInQuestion.showAnswers = false;
      previewInQuestion.type = constants.activity.types.QUESTION;
      previewInQuestion.nextId = this.activity.id || -1;
      this.activity.previewInQuestion = previewInQuestion;

      const isUserActionableChanged = this.activity.type === constants.activity.types.CHALLENGE
        && oldIsUserActionable !== previewInQuestion.isUserActionable;
      if (isUserActionableChanged && this.uiConfigs) {
        this.uiConfigs = null;
        this.getUIConfigs();
      }
    }

    this.activity.inQuestion = null;
    if (previewInQuestionEnd) {
      previewInQuestionEnd.isUserActionable = previewInQuestionEnd.show;
      previewInQuestionEnd.isInternal = true;
      previewInQuestionEnd.showAnswers = false;
      previewInQuestionEnd.type = constants.activity.types.QUESTION;
      this.activity.inQuestion = previewInQuestionEnd;

      if (previewInQuestionEnd.isUserActionable) {
        this.activity.wasUserActionable = this.activity.isUserActionable;
        this.activity.isUserActionable = false;
      }
    }

    this.activity.referralWinFun = null;
    this.activity.referralWinPoints = 0;
    if (previewReferral) {
      this.activity.referralWinFun = previewReferral.offer;
      this.activity.referralWinPoints = previewReferral.points;
    }

    if (this.activity.type === constants.activity.types.CHALLENGE || this.activity.type === constants.activity.types.SOCIAL_CONTENT) {
      let imageUrl = null;
      if (previewBasics) {
        this.activity.title = previewBasics.title;
        imageUrl = previewBasics.imageUrl;
      }

      if (!this.activity.reelsPreviewData) {
        this.activity.reelsPreviewData = {
          data: [],
          page: 1,
          perPage: 20,
        }
      }
      // const isImageDefault = this.props.inPreview
      //   && (ActivityHelper.isActivityImageDefault(this.activity.s2ImageUrl, constants.activity.types.CHALLENGE)
      //     || (!this.activity.s2ImageUrl && ActivityHelper.isActivityImageDefault(imageUrl, constants.activity.types.CHALLENGE)));
      const isImageDefault = false;
      const effImageUrl = isImageDefault ? require('src/images/ic_add_media_banner.png') : (this.activity ? this.activity.s2ImageUrl || imageUrl : null);
      const effDetails = this.activity && this.activity.description ? this.activity.description : this.activity.title;
      const front = {
        id: 0,
        feedType: FEED_TYPE_POST,
        type: POST_TYPE_CHALLENGE,
        details: effDetails,
        imageUrls: effImageUrl ? [effImageUrl] : null,
        videoUrl: this.activity.videoUrl,
        videoStreamUrl: this.activity.videoStreamUrl,
        audioUrl: this.activity.bgAudioUrl,
        activity: this.activity,
        business: this.activity.business,
        isDummy: true,
        showHelp: true
      }
      if (this.activity.reelsPreviewData.data.length > 0) {
        const oldFront = this.activity.reelsPreviewData.data[0];
        const oldImageUrl = oldFront.imageUrls && oldFront.imageUrls.length > 0 ? oldFront.imageUrls[0] : null;
        if (oldFront.details !== effDetails || oldFront.videoUrl !== this.activity.videoUrl || oldFront.audioUrl !== this.activity.bgAudioUrl || oldImageUrl !== effImageUrl) {
          this.activity.reelsPreviewData = {
            data: [front],
            page: 1,
            perPage: 20,
          }
        } else {
          this.activity.reelsPreviewData.data.splice(0, 1, front);
        }
      } else {
        this.activity.reelsPreviewData.data.push(front);
      }
      const countToRemove = this.activity.reelsPreviewData.data.length - 1;
      for (let i = 0; i < countToRemove; i++) {
        this.activity.reelsPreviewData.data.splice(1, 1);
      }
      if (previewSubPosts && previewSubPosts.length > 0) {
        previewSubPosts.forEach((previewSubPost) => {
          previewSubPost.isDefaultPost = true;
          previewSubPost.activity = this.activity;
          previewSubPost.business = this.activity.business;
          this.activity.reelsPreviewData.data.push(previewSubPost);
        });
      }
      if (this.activity.previewAddedPosts && this.activity.previewAddedPosts.length > 0) {
        this.activity.previewAddedPosts.forEach((post) => {
          this.activity.reelsPreviewData.data.push(post);
        });
      }
    }

    if (this.activity.showReward) {
      this.onRewardsMenuClicked();
    } else if (this.state && this.state.showSimpleOverlay) {
      this.dismissSimpleOverlayNHandleCallback();
    }
    if (this.activity.showEnd) {
      this.processGameEndView();
      this.activity.showEnd = false;
    } else {
      this.hideEndView();
    }

    if (isBgAudioChanged) {
      if (previewBgAudio.audioUrl) {
        this.gameOptions = null;
        this.iframeLoadCount++;
      }
      this.setState({mute: true});
    }
    if (this.activity.configs.playAudioBg) {
      this.playGameBgAudio();
    } else {
      this.stopGameBgAudio();
    }

    if (this.activity.type === constants.activity.types.CHALLENGE && previewBasics && this.reelPlayPauseCallback) {
      if (previewBasics.reelInFocus) {
        this.reelPlayPauseCallback.onAppDidFocus();
      } else {
        this.reelPlayPauseCallback.onAppDidBlur();
      }
    }

    if (isBusinessInfoChanged || (previewInQuestion && previewInQuestion.isUserActionable)) {
      this.reloadView();
    }
  }

  getPreviewInQuestion = () => {
    return this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable ? this.activity.previewInQuestion : null;
  };

  isHeaderBackGestureEnabled() {
    return false;
  }

  shouldHeaderShown() {
    if (this.isGameUI()) {
      return this.getUIConfigs().showSimpleHeader === true;
    }
    if (this.activity) {
      return super.shouldHeaderShown();
    }
    return false;
  }

  getSafeAreaColor() {
    if (this.isInFullscreen) {
      return ColorBlack;
    }
    return this.getUIConfigs().safeAreaColor;
  }

  isActivitySupported() {
    if (this.activity) {
      return this.activity.type === ACTIVITY_TYPE_OFFER
        || this.activity.type === ACTIVITY_TYPE_CHALLENGE
        || this.activity.type === ACTIVITY_TYPE_SLOT
        || this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE
        || this.activity.type === ACTIVITY_TYPE_BETTING_PIC
        || this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER
        || this.activity.type === ACTIVITY_TYPE_BRAND_RACE
        || this.activity.type === ACTIVITY_TYPE_POKER
        || this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE
        || this.activity.type === ACTIVITY_TYPE_FLIP_CARD
        || this.activity.type === ACTIVITY_TYPE_MATCHING_PIC
        || this.activity.type === ACTIVITY_TYPE_MATCH_THREE
        || this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE
        || this.activity.type === ACTIVITY_TYPE_PUZZLE
        || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE
        || this.activity.type === ACTIVITY_TYPE_PREDICTION
        || this.activity.type === ACTIVITY_TYPE_GUESS
        || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION
        || this.activity.type === ACTIVITY_TYPE_QUESTION
        || this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE
        || this.activity.type === ACTIVITY_TYPE_SURVEY
        || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION
        || this.activity.type === ACTIVITY_TYPE_SLIDES
        || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU
        || this.activity.type === ACTIVITY_TYPE_EXTERNAL_GAMES;
    }
    return false;
  }

  isGameUI() {
    if (this.activity) {
      return this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION
        || this.activity.type === ACTIVITY_TYPE_QUESTION
        || this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE
        || this.activity.type === ACTIVITY_TYPE_SURVEY
        || this.activity.type === ACTIVITY_TYPE_PREDICTION
        || this.activity.type === ACTIVITY_TYPE_GUESS
        || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION
        || this.activity.type === ACTIVITY_TYPE_SLIDES
        || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU
        || this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE
        || this.activity.type === ACTIVITY_TYPE_COLLECT_STARS
        || this.activity.type === ACTIVITY_TYPE_SLOT
        || this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN
        || this.activity.type === ACTIVITY_TYPE_BETTING_PIC
        || this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE
        || this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER
        || this.activity.type === ACTIVITY_TYPE_BRAND_RACE
        || this.activity.type === ACTIVITY_TYPE_FLIP_CARD
        || this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN
        || this.activity.type === ACTIVITY_TYPE_MATCHING_PIC
        || this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE
        || this.activity.type === ACTIVITY_TYPE_POKER
        || this.activity.type === ACTIVITY_TYPE_MATCH_THREE
        || this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE
        || this.activity.type === ACTIVITY_TYPE_PUZZLE
        || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE
        || this.activity.type === ACTIVITY_TYPE_EXTERNAL_GAMES;
    }
    return false;
  }

  onGameAudioLoaded = (gameAudioId) => {
    this.gameAudioId = gameAudioId
  };

  getSizeFactor() {
    if (this.activity.type === constants.activity.types.OFFER
      || this.activity.type === constants.activity.types.VOUCHER
      || this.activity.type === constants.activity.types.DISCOUNT) {
      return 1;
    }

    const widthDesign = 400;
    const effWidth = this.props.width;
    return Math.min(1.3, effWidth / widthDesign);
  }

  getSizeVFactor() {
    let heightFactor = 1;
    const thHeight = 700;
    const effHeight = this.props.height;
    if (effHeight < thHeight) {
      heightFactor = 0.5;
    }
    return Math.min(1.5, thHeight / 840 * heightFactor);
  }

  // shouldComponentUpdate(nextProps, nextState, nextContext) {
  //   ViewHelper.logStatePropsChange(this.state, nextState, this.props, nextProps, 'AV');
  //   return true;
  // }

  render() {
    const {classes} = this.props;
    const {showDialog, dialogInfo, showSnackbar, snackbarInfo, showImageFS, showOverlay, isBlockedLoading} = this.state;
    const {gameAudio, fromResources} = this.getGameBgAudio();

    return (
      <div style={{position: 'relative', display: 'flex', flex: 1, width: '100%', height: '100%'}}>
        <div style={{display: 'flex', flex: 1, width: '100%', height: '100%'}}>
        {gameAudio && !this.props.disableAudio ?
          <GameAudio ref={this.refBgAudio} source={gameAudio} autoPlay={this.activity.configs.playAudioBg} loop={true} hasUserInteraction={false} mute={this.state.mute} />
          :null
        }
        <Profiler id="MainViewW" onRender={this.onProfilerCallback}>
          <div className={classes.gameContainer}>
            <Profiler id="MainView" onRender={this.onProfilerCallback}>
              {this.renderView()}
            </Profiler>
            <ViewDialog classes={classes} showDialog={showDialog} dialogInfo={dialogInfo} />
            <ViewSnackBar classes={classes} showSnackbar={showSnackbar} snackbarInfo={snackbarInfo} onClose={this.onCloseSnackbar} />
            <ViewOverlay key={'showOverlay'} height={this.props.height} show={showOverlay} >
              {this.renderSimpleOverlayView()}
              {this.getEndView()}
              {this.renderSponsorView()}
            </ViewOverlay>
            <ViewOverlay key={'showImageFS'} height={this.props.height} show={showImageFS} >
              {this.renderImageFullScreen()}
            </ViewOverlay>
            {this.getTopMoreMenu()}
          </div>
        </Profiler>
        {this.renderDialogView()}
        {isBlockedLoading && <Loader />}
        </div>
      </div>
    )
  }

  handleRefDiv = (ref) => {
    this.refDiv = ref;
  }

  onProfilerCallback = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
    logInfo('Rendered: '+ id, actualDuration);
  };

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    this.setState({showDialog: false, dialogInfo: null});
  };

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      return (
        <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.onCloseSnackbar}>
          <MuiAlert severity={snackbarType || "success"} onClose={this.onCloseSnackbar} elevation={6} variant="filled" style={{borderRadius: BORDER_RADIUS}}>
            {snackbarMessageId ? <FormattedMessage id={snackbarMessageId}/> : null}
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  onCloseSnackbar = () => {
    this.setState({showSnackbar: false, snackbarInfo: null});
  }

  renderImageFullScreen() {
    const {classes} = this.props;
    const {showImageFS, imageFSUrl} = this.state;
    if (showImageFS) {
      const uiConfigs = this.getUIConfigs();
      return (
        <View style={{flex: 'display', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0}}>
          <AppImage resizeMode={'contain'} source={imageFSUrl} style={{width: '100%', height: '100%', marginBottom: 80}} />

          <View style={{position: 'absolute', bottom: 0, left: 0, right: 0}}>
            <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: SpaceNormal, marginBottom: SpaceNormal}}>
              <View style={{display: 'flex', width: 50, borderRadius: 25, backgroundColor: uiConfigs.messageBgColor, border: '2px solid '+ uiConfigs.messageBorderColor}}>
                <IconButton
                  size={'medium'}
                  variant={'outlined'}
                  onClick={this.closeImageFS}>
                  <AppIcon color={uiConfigs.titleColor} icon={IconCross} />
                </IconButton>
              </View>
            </View>
          </View>
        </View>
      );
    }
  }

  onImageFSClicked = (imageUrl) => {
    this.showImageFS(imageUrl);
  };

  showImageFS(imageFSUrl) {
    if (imageFSUrl) {
      this.setState({showImageFS: true, imageFSUrl}, () => {
        this.changeNavigationColor(this.getDialogAddressBarColor());

        this.pushHashHistory(HASH_IMAGE_FS);
      });
    }
  }

  closeImageFS = () => {
    this.setState({showImageFS: false, imageFSUrl: null}, () => {
      this.changeNavigationColor();

      this.popHashHistory(HASH_IMAGE_FS);
    });
  }

  renderSimpleOverlayView() {
    const {showSimpleOverlay, simpleOverlayView} = this.state;
    if (showSimpleOverlay) {
      const moreStyle = this.showSimpleOverlayCenter ? {top: 0, alignItems: 'center', justifyContent: 'center'} : {};
      return (
        <View style={{flex: 'display', position: 'absolute', left: 0, bottom: 0, right: 0, ...moreStyle}}>
          {simpleOverlayView}
          {/*<View style={{position: 'absolute', top: 4, left: 4}}>*/}
          {/*  <IconButton*/}
          {/*    variant={'outlined'}*/}
          {/*    onClick={this.onCloseImageFS}>*/}
          {/*    <AppIcon color={ColorWhite} icon={IconCross} />*/}
          {/*  </IconButton>*/}
          {/*</View>*/}
        </View>
      );
    }
  }

  showToastError(message = null) {
    this.showSnackbar({
      snackbarMessage: message,
      snackbarMessageId: !message ? 'somethingWentWrong' : null,
      snackbarType: "error",
    });
  }

  showToastInfo(message) {
    this.showSnackbar({
      snackbarMessage: message,
      snackbarType: "info",
    });
  }

  showToast(message) {
    this.showSnackbar({
      snackbarMessage: message,
      snackbarType: "success",
    });
  }

  renderView() {
    if (!this.activity) {
      return null;
    }

    const {classes, isLTR, isXS, isDrawerHidden} = this.props;
    if (!this.isActivitySupported()) {
      return <View style={{alignItems: 'center', justifyContent: 'center', backgroundColor: ColorActivityBackground, minHeight: 300, padding: 16}}>
        <TextView variant={'h6'}>{"Campaign is not yet supported, please check back later."}</TextView>
        <Space horizontalSpace={3} />
        <Button variant={"contained"} color={"primary"} onClick={this.onBackClicked} >{'Go Back'}</Button>
      </View>;
    }

    const isGameUI = this.isGameUI()
      || (this.props.inPreview && this.activity && this.activity.type === ACTIVITY_TYPE_CHALLENGE && this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable);
    if (isGameUI) {
      return this.renderGameUIView();
    }
    if (this.activity && this.activity.type === ACTIVITY_TYPE_CHALLENGE) {
      return this.renderReelUIView();
    }

    let priceText = null;
    if (this.activity) {
      if (this.activity.type == ACTIVITY_TYPE_OFFER && this.activity.productId == 0 && this.activity.price > 0) {
        priceText = this.activity.price;
      }
    }
    const showMediaNTitle = this.activity.type == ACTIVITY_TYPE_SMART_AD
      || this.activity.type == ACTIVITY_TYPE_EVENT
      || this.activity.type == ACTIVITY_TYPE_OFFER
      || this.activity.type == ACTIVITY_TYPE_DISCOUNT
      || this.activity.type == ACTIVITY_TYPE_OPINION
      || this.activity.type == ACTIVITY_TYPE_VISITOR_OPINION
      || this.activity.type == ACTIVITY_TYPE_CHALLENGE
      || this.activity.type == ACTIVITY_TYPE_CONTENT_WRITING
      || this.activity.type == ACTIVITY_TYPE_PREDICTION
      || this.activity.type == ACTIVITY_TYPE_GREEDY_SPIN
      || this.activity.type == ACTIVITY_TYPE_BETTING_PIC
      || this.activity.type == ACTIVITY_TYPE_GAME_ROULETTE
      || this.activity.type == ACTIVITY_TYPE_SPIN_DISCOVER
      || this.activity.type == ACTIVITY_TYPE_FLIP_CARD
      || this.activity.type == ACTIVITY_TYPE_FIND_HIDDEN
      || this.activity.type == ACTIVITY_TYPE_MATCHING_PIC
      || this.activity.type == ACTIVITY_TYPE_GUESS
      || this.activity.type == ACTIVITY_TYPE_SHARE_N_LIKE
      || this.activity.type == ACTIVITY_TYPE_COLLECT_STARS;

    const spacing = isDrawerHidden ? 16 : 24;
    this.mediaWidth = this.props.width - 4 * spacing;

    const mediaMaxWidth = this.mediaWidth;
    const mediaMaxHeight = mediaMaxWidth;
    let videoWidth = this.mediaWidth;
    let videoHeight = null;
    if (this.activity.videoUrl) {
      let videoInfo = null;
      if (this.activity.videoStreamUrl) {
        videoInfo = ApiHelper.getInfoForVideoUrl(this.activity.videoStreamUrl);
      } else {
        videoInfo = ApiHelper.getInfoForVideoUrl(this.activity.videoUrl);
      }
      if (videoInfo) {
        videoHeight = Math.min(videoWidth * videoInfo.height / videoInfo.width, mediaMaxHeight);
      }
    }

    return (
      <View className={classes.viewColumnFullWidth} style={{marginTop: isXS ? 12 : 16}}>
        <HeaderTitleView isLTR={isLTR} isXS={isXS} titleId={this.getHeaderTitleId()}/>

        <View className={classes.viewColumnFullWidth} style={{padding: spacing, paddingTop: 0}}>
          {this.activity.videoUrl ?
            <React.Fragment>
              <Paper className={classes.viewColumnFullWidth} style={{borderRadius: BORDER_RADIUS, overflow: 'hidden', backgroundColor: ColorBlack}}>
                <VideoPlayerView
                  autoplay={true}
                  videoUrl={this.activity.videoStreamUrl || this.activity.videoUrl}
                  maxWidth={this.mediaWidth}
                  borderRadius={BORDER_RADIUS}/>
              </Paper>
              <FieldSpace />
            </React.Fragment>
            : null
          }
          {showMediaNTitle ?
            <Paper elevation={0} className={classes.viewColumnFullWidthNoCenter} style={{padding: spacing, paddingBottom: 0}}>
              {this.getMediaViewEx(this.mediaWidth, IMAGE_BORDER_RADIUS)}
              <View className={classes.viewColumnFullWidthNoCenter} style={{padding: SpaceXSmall}}>
                <AppText
                  textAlign={'left'}
                  variant={'h6'}
                  onLinkClick={this.onTextLinkClicked}
                  style={{
                    color: ColorTitle,
                    fontWeight: FontWeightMedium}}>
                  {this.activity.title}
                </AppText>
                {priceText ?
                  <View style={{flexDirection: 'row', marginTop: 6}}>
                    <AppTextWrapper style={{color: ColorSubTitle, fontSize: FontSizeNormal, fontWeight: FontWeightMedium}}>
                      {locString('offerPrice')}
                    </AppTextWrapper>
                    <AppText style={{marginLeft: SpaceXSmall, color: ColorSubTitle, fontSize: FontSizeNormal, fontWeight: FontWeightMedium}}>
                      {priceText}
                    </AppText>
                  </View>
                  : null
                }
                {this.getDurationView()}
                {/*{this.getRatingView()}*/}
                {/*{this.getCommentsView()}*/}
                {/*<View style={{flex: 1, marginTop: 8, borderColor: 'rgba(0,0,0,0.1)', borderWidth: 0, borderTopWidth: 1, borderStyle: 'solid'}}>*/}
                {/*  <View style={{marginLeft: -8, marginRight: -8, marginBottom: -4}}>*/}
                {/*    {this.getBusinessView()}*/}
                {/*  </View>*/}
                {/*</View>*/}
              </View>
            </Paper> : null
          }
          <View style={{marginTop: isXS ? 16 : 24, marginBottom: isXS ? 16 : 24}}>
            <Suspense fallback={this.handleSuspenseFallback}>
              {this.getActionView()}
            </Suspense>
          </View>
          <View style={{flex: 1, padding: SpaceNormal, paddingTop: 0, borderTopStartRadius: SpaceNormal, borderTopEndRadius: SpaceNormal}}>
            {this.getBottomOtherActionsView()}
          </View>
          <Space horizontalSpace={1} />
        </View>
      </View>
    );
  }

  handleSuspenseFallback = () => {}

  getHeaderTitleId() {
    if (this.activity.type === constants.activity.types.OFFER) {
      if (this.activity.isVoucher) {
        return 'activity.type.voucher';
      }
      return 'activity.type.offer';
    }
    return `activity.manage.${this.activity.type}.title`;
  }

  renderReelUIView() {
    const {isLTR, isXS, isDrawerHidden, noActionMode, history, canGoBack, userId, userBId, userMeType, readOnly, onActionClickedInNoActionMode, makeActionInActivity, fetchActivityReviews, classes} = this.props;
    return (
      <div style={{width: '100%', height: '100%'}}>
        <ActivityReelsView
          playPauseCallback={this.onReelPlayPauseCallback}
          activity={this.activity}
          postId={this.props.postId}
          showcaseId={this.props.showcaseId}
          autoSimulation={this.props.autoSimulation}
          inPreview={this.props.inPreview}
          playInShowcase={this.props.playInShowcase}
          hideTop={this.props.hideTop}
          hideActions={this.props.hideActions}
          previewPaginated={this.activity.reelsPreviewData}
          key={!this.props.inPreview ? 0 : ''+ this.activity.reelsPreviewData.data.length + this.activity.reelsPreviewData.data[0].videoUrl}
          uiConfigs={this.getUIConfigs()}
          isLTR={isLTR}
          isXS={isXS}
          isDrawerHidden={isDrawerHidden}
          windowHeight={this.props.windowHeight}
          windowWidth={this.props.windowWidth}
          height={this.props.height}
          width={this.props.width}
          userId={userId}
          userBId={userBId}
          isGuestUser={this.props.isGuestUser}
          // width={this.props.width}
          noActionMode={this.props.noActionMode || this.props.readOnly}
          onActionClickedInNoActionMode={onActionClickedInNoActionMode}
          // classes={classes}
          history={history}
          canGoBack={canGoBack}
          hasUserInteraction={canGoBack}
          ctaTitles={this.props.ctaTitles}
          onBackClicked={this.onBackClicked}
          onBusinessClicked={this.onReelBusinessClicked}
          onAddClicked={this.onAddReelClicked}
          onReportClicked={this.onReelPostReportClicked}
          onShareClicked={this.onReelShareClicked}
          onMoreDetailsClicked={this.onReelMoreDetailsClicked}
          onWinnersClicked={this.onReelWinnersClicked}
          onSponsorClicked={this.onReelSponsorClicked}
          onRewardsClicked={this.onReelRewardsClicked}
          onRewardsWonClicked={this.onReelRewardsWonClicked}
          openActivity={this.onActivityClicked}
          onPromotedLinkClicked={this.onReelPromotedLinkClicked}
          onJoinRab7Clicked={this.onPlayJoinClicked}
          onUpdateMobileClicked={this.onUpdateMobileClicked}
          makeActionInActivity={makeActionInActivity}
          fetchData={fetchActivityReviews}
          fetchActivity={this.props.fetchActivity}
        />
      </div>
    );
  }

  onReelPlayPauseCallback = (callback) => {
    this.reelPlayPauseCallback = callback;
  };

  onReelBusinessClicked = (item) => {
    if (item.business && item.business.link) {
      // this.makeCtaActionsInActivity(ACTIVITY_CTA1_ACTION);
      LinkHelper.openLink(item.business.link);
    } else {
      this.onReelSponsorClicked(item);
    }
  }

  onReelPromotedLinkClicked = (item) => {
    if (item.link) {
      this.makeCtaActionsInActivity(ACTIVITY_CTA2_ACTION);
      LinkHelper.openLink(item.link);
    }
  }

  onReelMoreDetailsClicked = (activity) => {
    this.onMoreDetailsMenuClicked(null, activity);
  }

  onReelWinnersClicked = (activity) => {
    this.onWinnerMenuClicked(null, activity);
  }

  onReelSponsorClicked = (item) => {
    this.showSponsorView(null, item);
  }

  onReelRewardsClicked = (activity) => {
    this.onRewardsMenuClicked(null, activity);
  }

  onReelShareClicked = (activity, postId) => {this.onShareClicked(null, activity, postId)};

  onReelPostReportClicked = (activity, postId) => {
    if (postId > 0) {
      this.showSimpleOverlayView({
        title: locString('activity.reportPost'),
        subTitle: locString('activity.reportPostMessage'),
        positiveActionText: locString('close'),
        hideActions: true,
        showInCenter: !this.props.isXS && (activity.type === constants.activity.types.CHALLENGE || activity.type === constants.activity.types.SOCIAL_CONTENT),
        subView: ActivityHelper.getReportPostView(postId, this.getUIConfigs(), 500, this.props.width, (isSuccess) => {
          if (isSuccess) {
            this.showToast(this.context.intl.formatMessage({id: 'reportedMessage'}));
          }
          this.dismissSimpleOverlayNHandleCallback();
        }),
      });
    } else {
      this.onReportClicked(null, activity);
    }
  };

  onAddReelClicked = (activity, onDone) => {
    this.showSimpleOverlayView({
      title: locString('activity.addPost'),
      positiveActionText: locString('close'),
      hideActions: true,
      showInCenter: !this.props.isXS && (activity.type === constants.activity.types.CHALLENGE || activity.type === constants.activity.types.SOCIAL_CONTENT),
      paddingH: SpaceNormal,
      subView: ActivityHelper.getAddPostView(activity, this.props.showcaseId, this.getUIConfigs(), 500, this.props.width, this.props.inPreview, this.props.isXS,null, this.activity.contentTypes, (data) => {
        this.dismissSimpleOverlayNHandleCallback();
        if (data) {
          if (this.props.inPreview) {
            if (!this.activity.previewAddedPosts) {
              this.activity.previewAddedPosts = [];
            }
            data.post.activity = this.activity;
            data.post.business = this.activity.business;
            this.activity.previewAddedPosts.push(data.post);
            this.activity.reelsPreviewData.data.splice(1, 0, data.post);
            this.reloadView();
          } else {
            onDone(data);
          }
          this.showToast(this.context.intl.formatMessage({id: 'activity.postAdded'}));
        }
      })
    });
  }

  onReelRewardsWonClicked = (activity) => {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const rewardWonView = this.getRewardsWonView(activity, null, 0, locString('activity.postDownloadedByCampaigner'));
    this.showSimpleOverlayView({
      image: require('src/images/activity/0_ic_congratulations.png'),
      title: null,
      positiveActionText: locString('generic.ok'),
      subView: <div>
        {rewardWonView}
        {activity.needContactNumber ?
          <View className={classes.viewColumn} style={{backgroundColor: tinycolor(ColorBackground).setAlpha(0.9), border: '1px solid '+ ColorBackground, borderRadius: 8, padding: 8, paddingLeft: 12, paddingRight: 12}}>
            <AppText
              fontSizeN={uiConfigs.fontSize}
              variant={'body1'}
              style={{
                color: ColorSubTitle,
                fontWeight: FontWeightMedium,
                textAlign: 'center'
              }}>{locString('activity.needCustomerContactWon')}
            </AppText>
            <GetActionButton
              size={'large'}
              uiConfigs={uiConfigs}
              onClick={this.moveToUpdateMobile}
              title={locStringA(this.context.intl, 'proceed')}
            />
          </View>
          : null
        }
      </div>,
      showInCenter: this.shouldShowInCenter(),
    });
  };

  renderGameUIView() {
    if (!this.activity) {
      return null;
    }
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const sizeVFactor = uiConfigs.sizeVFactor;

    let showTopView = !this.activity.nextId && !this.props.gameValidationCallbacks && !this.props.hideTop && !uiConfigs.showSimpleHeader;
    if (this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable) {
      showTopView = false;
    }
    if (this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU) {
      showTopView = false;
    }
    let showBottomView = !this.props.gameValidationCallbacks && !this.props.hideActions && !this.props.onPreFunDone;
    if (this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU) {
      showBottomView = false;
    }
    const showShortGuide = !showBottomView && this.props.guideShort;

    const contentMarginTop = uiConfigs.contentViewMarginTop * sizeVFactor;
    const extraSpaceBottom = -utils.getBottomSpace();

    const topViewHeight = !showTopView ? 0 : (this.questionnaireNumber ? uiConfigs.topViewSmallHeight : uiConfigs.topViewHeight) * sizeFactor;
    const bottomViewMarginBottomN = uiConfigs.bottomViewMarginBottomN || 0;
    const bottomHeight = showShortGuide ? 60 : (showBottomView ? (this.questionnaireNumber ? uiConfigs.bottomViewSmallHeight : uiConfigs.bottomViewHeight) : 0);
    const bottomViewHeight = bottomHeight * sizeFactor + bottomViewMarginBottomN;
    const contentViewHeight = this.props.height - topViewHeight - bottomViewHeight;

    this.contentY = topViewHeight + contentMarginTop + utils.getStatusBarHeight();
    this.contentHeight = contentViewHeight - contentMarginTop - 24;

    let actionAudio = null;
    let winAudio = null;
    let neutralAudio = null;
    let timerAudio = null;
    if (this.activity.type === constants.activity.types.QUESTIONNAIRE || this.activity.type === constants.activity.types.SURVEY || this.activity.type === constants.activity.types.EXTERNAL_GAMES) {
      // actionAudio = this.activity.gamePlayAudioLocalUrl;
      winAudio = this.activity.gameWinAudioLocalUrl || GAME_WIN_AUDIO;
      neutralAudio = GAME_LOSE_AUDIO;
      timerAudio = this.activity.gamePlayAudioLocalUrl || GAME_TIMER_LOW_AUDIO;
    }
    const hasPreviewQuestion = this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable;
    const hasExtGames = !hasPreviewQuestion && this.activity.type === constants.activity.types.EXTERNAL_GAMES;
    const actionViewMarginTop = !this.props.hideTop ? (hasExtGames ? 12 * uiConfigs.sizeFactor : 0) : 0;
    const paddingBottom = this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU ? 0 : 24;
    const view = (
      <View style={{display: 'flex', flex: 1, flexDirection: 'column', overflow: 'hidden', position: 'relative'}}>
        {showTopView ?
          <Profiler id="TopView" onRender={this.onProfilerCallback}>
            <GetTopView
              isLTR={this.props.isLTR}
              disableBack={this.props.hideActions || this.props.inPreview}
              disableMore={this.props.playInShowcase || this.props.autoSimulation}
              showCta1={this.activity.showCta1}
              showCta2={this.activity.showCta2}
              classes={classes}
              uiConfigs={uiConfigs}
              contentWidth={this.props.width}
              sizeFactor={sizeFactor}
              questionnaireNumber={this.questionnaireNumber}
              activityType={this.activity.type}
              activitySubType={this.activity.subType}
              nextType={this.activity.isInternal && this.activity.next ? this.activity.next.type : 0}
              businessImageUrl={this.activity.business.imageUrl}
              businessName={this.activity.business.name}
              businessLink={this.activity.business.link}
              onBusinessClicked={this.onBusinessClicked}
              onBackClicked={this.onBackClicked}
              openMenu={this.openMenu}
            />
          </Profiler>
          : null
        }
        <Profiler id="ActionView" onRender={this.onProfilerCallback}>
          {hasExtGames ?
            <View
              style={{position: 'relative', display: 'flex', width: '100%', height: contentViewHeight + actionViewMarginTop, marginTop: -actionViewMarginTop, marginBottom: 0, opacity: this.activity.showCta1 || this.activity.showCta2 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}>
              {winAudio && !this.props.disableAudio ?
                <GameAudio ref={this.refAudioWin} source={winAudio} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.state.mute} />
                : null
              }
              {/*<View className={classes.viewColumnFullWidth}>*/}
                {this.state.showAction ? this.getActionView(this.props.height - topViewHeight - bottomViewHeight + actionViewMarginTop) : this.getLoadingDotsView()}
                {/*<div style={{opacity: 0}} >*/}
                {/*  {this.getTextView('DUMMY')}*/}
                {/*</div>*/}
              {/*</View>*/}
            </View>
            : <ScrollView
              style={{position: 'relative', display: 'flex', width: '100%', height: contentViewHeight, paddingTop: contentMarginTop, paddingBottom: paddingBottom, opacity: this.activity.showCta1 || this.activity.showCta2 ? HIDE_VIEWS_FOR_CTA1_OPACITY : 1}}
              ref={this.handleRefScroll}>
              <View className={classes.viewColumnFullWidth}>
                {actionAudio && !this.props.disableAudio ?
                  <GameAudio ref={this.refAudioAction} source={actionAudio} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.state.mute} />
                  : null
                }
                {winAudio && !this.props.disableAudio ?
                  <GameAudio ref={this.refAudioWin} source={winAudio} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.state.mute} />
                  : null
                }
                {neutralAudio && !this.props.disableAudio ?
                  <GameAudio ref={this.refAudioNeutral} source={neutralAudio} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.state.mute} />
                  : null
                }
                {timerAudio && !this.props.disableAudio ?
                  <GameAudio ref={this.refAudioTimer} source={timerAudio} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.state.mute} />
                  : null
                }
                {this.state.showAction ?
                  <Suspense fallback={this.handleSuspenseFallback}>
                    {this.getActionView()}
                  </Suspense>
                  : this.getLoadingDotsView()
                }
                <div style={{opacity: 0, zIndex: -1}} >
                  {this.getTextView('DUMMY')}
                </div>
              </View>
            </ScrollView>
          }
        </Profiler>

        {showBottomView ?
          <Profiler id="BottomView" onRender={this.onProfilerCallback}>
            {this.getBottomView()}
          </Profiler>
          : null
        }
        {showShortGuide ?
          <Profiler id="GuideShortView" onRender={this.onProfilerCallback}>
            <div className={classes.viewColumnFullWidth} style={{height: bottomViewHeight, justifyContent: 'center'}}>
              <AppText
                numberOfLines={2}
                fontSizeN={uiConfigs.fontSize}
                variant={'body1'}
                style={{
                  paddingLeft: 8,
                  paddingRight: 8,
                  color: tinycolor.mostReadable(uiConfigs.bgColor, [uiConfigs.titleColor, '#000', '#fff']).toString(),
                  fontWeight: FontWeightMedium,
                  textAlign: 'center'}}>
                {this.props.guideShort}
              </AppText>
              {/*{this.getTextView(this.props.guideShort, 2)}*/}
            </div>
          </Profiler>
          : null
        }
      </View>
    );

    if (!this.displayAsModel) {
      if (uiConfigs.bgImage) {
        return (
          <ImageBackground source={uiConfigs.bgImage} style={{display: 'flex', flex: 1, marginBottom: extraSpaceBottom, paddingBottom: -extraSpaceBottom, backgroundColor: uiConfigs.safeAreaColor}}>
            {view}
          </ImageBackground>
        );
      } else if (uiConfigs.bgLImage) {
        return (
          <ImageBackground source={uiConfigs.bgLImage} style={{display: 'flex', flex: 1, marginBottom: extraSpaceBottom, paddingBottom: -extraSpaceBottom, backgroundColor: uiConfigs.safeAreaColor}}>
            <div className={classes.absoluteFill} style={{backgroundColor: uiConfigs.bgColor}}/>
            {view}
          </ImageBackground>
        );
      } else {
        return (
          <div style={{display: 'flex', flex: 1, backgroundColor: '#CCCCCC', marginBottom: extraSpaceBottom, paddingBottom: -extraSpaceBottom}}>
            {view}
          </div>
        );
      }
    }
    return (
      <View style={{display: 'flex', flex: 1, marginBottom: extraSpaceBottom, paddingBottom: -extraSpaceBottom}}>
        {view}
      </View>
    );
  }

  getLoadingDotsView() {
    if (!this.props.gameValidationCallbacks) {
      const {classes} = this.props;
      const sizeFactor = this.getUIConfigs().sizeFactor;
      return (
        <View className={classes.viewColumnFullWidth} style={{minHeight: 300 * sizeFactor, justifyContent: 'center'}}>
          {this.getTextView(locString('activity.loadingDots'))}
        </View>
      );
    }
    return null;
  }

  handleRefScroll = (ref) => {
    this.refScrollView = ref;
  }

  isActionViewScrollEnabled() {
    return this.enableScroll && !this.isInFullscreen && this.activity && (this.activity.type !== ACTIVITY_TYPE_MATCH_THREE || !this.activity.isUserActionable);
  }

  getTopMoreMenu() {
    if (!this.activity) {
      return null;
    }
    const {inPreview} = this.props;

    const getTopMenuItem = (clickCallback, title, type) => {
      const {classes} = this.props;
      const uiConfigs = this.getUIConfigs();
      return (
        <GetTopMenuItem
          classes={classes}
          uiConfigs={uiConfigs}
          title={title}
          onClose={this.closeMenu}
          clickCallback={clickCallback}
        />
      );
    };

    const showCTA2 = !this.props.playInShowcase && (this.props.inPreview
      || this.activity.videoUrl
      || this.activity.s2ImageUrl
      || this.activity.s2LinkText
    );
    const showReport = !this.props.playInShowcase && !inPreview && !this.props.readOnly;
    const showDetails = this.activity.type !== constants.activity.types.OFFER
      && this.activity.type !== constants.activity.types.DISCOUNT;
    const showLanguage = !this.props.playInShowcase && !this.props.inPreview;
    return (
      <Menu
        id="menu"
        anchorEl={this.state.menuElement}
        getContentAnchorEl={null}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
        keepMounted={false}
        open={this.state.showMenu}
        onClose={this.closeMenu}>
        {this.activity.helpUrl ? getTopMenuItem(this.onHelpClicked, locString('help'), 1) : null}
        {this.activity.showWinners ? getTopMenuItem(this.onWinnerMenuClicked, locString('winners'), 1) : null}
        {showDetails ? getTopMenuItem(this.onMoreDetailsMenuClicked, locString('moreDetails'), 0) : null}
        {showCTA2 ? getTopMenuItem(this.showEndView, locString('activity.endCta2'), 0) : null}
        {getTopMenuItem(this.showSponsorView, locString('activity.sponsor'), 0)}
        {showReport ? getTopMenuItem(this.onReportClicked, locString('report'), 0) : null}
        {showLanguage ? <GetLanguageSelectorView uiConfigs={this.getUIConfigs()} /> : null}
      </Menu>
    );
  }

  openMenu = (menuElement) => {
    this.setState({showMenu: true, menuElement: menuElement});
  }

  closeMenu = (callback) => {
    this.setState({showMenu: false, menuElement: null}, () => {
      if (typeof callback === 'function') {
        callback();
      }
    });
  };

  getBottomView() {
    const {classes, isLTR} = this.props;
    const uiConfigs = this.getUIConfigs();

    if (this.questionnaireNumber) {
      const enablePrevious = this.questionnaireNumber > 1;
      const enableNext = this.questionnaireMap[this.activity.questionnaire[this.questionnaireNumber - 1].id] !== undefined;
      const nextTitleId = this.questionnaireNumber === this.activity.consumeLimitPerUser ? 'complete' : 'next';
      return (
        <GetQuestionnaireBottomView
          inPreview={this.props.inPreview}
          uiConfigs={uiConfigs}
          isLTR={isLTR}
          classes={classes}
          contentWidth={this.props.width}
          enablePrevious={enablePrevious}
          enableNext={enableNext}
          nextTitleId={nextTitleId}
          showRewards={this.shouldShowRewards()}
          mute={this.state.mute}
          onPreviousClicked={this.onQuestionnairePreviousClicked}
          onNextClicked={this.onQuestionnaireNextClicked}
          onRewardsClicked={this.onRewardsMenuClicked}
          onMuteToggle={this.onMuteToggle}
        />
      );
    }

    if (!uiConfigs.bottomImage && !uiConfigs.themeColor) {
      return null;
    }
    const sizeFactor = uiConfigs.sizeFactor;
    const showGuide = this.shouldShowGuide();
    const showRewards = this.shouldShowRewards();
    return (
      <GetBottomView
        showCta1={this.activity.showCta1}
        showCta2={this.activity.showCta2}
        sizeFactor={sizeFactor}
        uiConfigs={uiConfigs}
        contentWidth={this.props.width}
        classes={classes}
        activity={this.activity}
        showPlayers={this.activity.showPlayers}
        showGuide={showGuide}
        showRewards={showRewards}
        showShare={!this.props.playInShowcase && (!this.props.inPreview || this.activity.shUrl)} // show in preview only if we have share url
        mute={this.state.mute}
        onWinEligibleMenuClicked={this.onWinEligibleMenuClicked}
        onRewardsClicked={this.onRewardsMenuClicked}
        onGuideClicked={this.onGuideClicked}
        onShareClicked={this.onShareClicked}
        dismissSimpleOverlayNHandleCallback={this.dismissSimpleOverlayNHandleCallback}
        onProfilerCallback={this.onProfilerCallback}
        onImageClicked={this.onImageFSClicked}
        onActivityClicked={this.onActivityClicked}
        onMuteToggle={this.onMuteToggle}
      />
    )
  }

  shouldShowGuide() {
    return this.activity.type !== ACTIVITY_TYPE_OFFER
      && this.activity.type !== ACTIVITY_TYPE_DISCOUNT
      && this.activity.type !== ACTIVITY_TYPE_SLIDES
      && this.activity.type !== ACTIVITY_TYPE_SHOWCASE_MENU
      && (this.activity.type !== ACTIVITY_TYPE_QUESTION || !this.activity.isInternal);
  }

  shouldShowRewards() {
    let showRewards = this.activity.type !== ACTIVITY_TYPE_OFFER
      && this.activity.type !== ACTIVITY_TYPE_DISCOUNT
      && this.activity.type !== ACTIVITY_TYPE_SLIDES
      && this.activity.type !== ACTIVITY_TYPE_SHOWCASE_MENU
      && (this.activity.type !== ACTIVITY_TYPE_QUESTION || !this.activity.isInternal);
    if (showRewards) {
      showRewards = this.props.inPreview
        || this.activity.consumedPoints > 0 || this.activity.rewardedOffer
        || this.activity.referralWinPoints > 0 || this.activity.referralWinFun;
      if (!showRewards) {
        if (this.activity.type === ACTIVITY_TYPE_CHALLENGE
          || this.activity.type === ACTIVITY_TYPE_CONTENT_WRITING
          || this.activity.type === ACTIVITY_TYPE_PREDICTION
          || this.activity.type === ACTIVITY_TYPE_GUESS
          || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION
          || this.activity.type === ACTIVITY_TYPE_SLIDES
          || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU
          || this.activity.type === ACTIVITY_TYPE_SLOT
          || this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN
          || this.activity.type === ACTIVITY_TYPE_BETTING_PIC
          || this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE
          || this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER
          || this.activity.type === ACTIVITY_TYPE_BRAND_RACE
          || this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE
          || this.activity.type === ACTIVITY_TYPE_COLLECT_STARS
          || this.activity.type === ACTIVITY_TYPE_FLIP_CARD
          || this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN
          || this.activity.type === ACTIVITY_TYPE_MATCHING_PIC
          || this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE
          || this.activity.type === ACTIVITY_TYPE_POKER
          || this.activity.type === ACTIVITY_TYPE_MATCH_THREE
          || this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE
          || this.activity.type === ACTIVITY_TYPE_PUZZLE
          || this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE
          || this.activity.type === ACTIVITY_TYPE_SURVEY
          || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION
          || this.activity.type === ACTIVITY_TYPE_EXTERNAL_GAMES) {
          const firstSlot = this.activity.slotValues[0];
          showRewards = firstSlot.points > 0 || (firstSlot.offers && firstSlot.offers.length > 0);
        }
      }
    }
    return showRewards;
  }

  getEndView() {
    if (this.state.showEnd) {
      const {classes} = this.props;
      const uiConfigs = this.getUIConfigs();
      const sizeFactor = uiConfigs.sizeFactor;

      const margin = 8;
      const marginTop = 16;
      const padding = 8;

      const closeButtonSize = SpaceNormal + 50;
      const viewWidth = this.props.width - 2 * margin;
      const viewHeight = this.props.height - marginTop - margin - closeButtonSize;
      const mediaMaxWidth = viewWidth - 2 * padding;
      let mediaMaxHeight = viewHeight - 2 * padding - SpaceNormal;
      // if (this.activity.s2Text) {
      //   mediaMaxHeight -= (SpaceNormal + 40);
      // }
      if (this.activity.s2LinkText || this.activity.s2Link) {
        mediaMaxHeight -= (SpaceNormal + 42 * sizeFactor);
      }

      let videoWidth = mediaMaxWidth;
      let videoHeight = null;
      if (this.activity.videoUrl) {
        let videoInfo = null;
        if (this.activity.videoStreamUrl) {
          videoInfo = ApiHelper.getInfoForVideoUrl(this.activity.videoStreamUrl);
        } else {
          videoInfo = ApiHelper.getInfoForVideoUrl(this.activity.videoUrl);
        }
        if (videoInfo) {
          videoHeight = Math.min(videoWidth * videoInfo.height / videoInfo.width, mediaMaxHeight);
        } else {
          videoHeight = mediaMaxHeight;
        }
      }
      let imageWidth = mediaMaxWidth;
      let imageHeight = null;
      if (this.activity.s2ImageUrl) {
        const imageInfo = ApiHelper.getInfoForImageUrl(this.activity.s2ImageUrl);
        if (imageInfo) {
          imageHeight = Math.min(imageWidth * imageInfo.height / imageInfo.width, mediaMaxHeight);
        }
      }

      let buttonText = null;
      if (this.activity.s2LinkText) {
        let isTitlePresent = false;
        if (this.props.ctaTitles) {
          this.props.ctaTitles.forEach((ctaTitle) => {
            if (ctaTitle.id == this.activity.s2LinkText) {
              buttonText = <FormattedMessage id={ctaTitle.nameId} />;
              isTitlePresent = true;
            }
          });
        }
        if (!isTitlePresent) {
          buttonText = this.activity.s2LinkText;
        }
      }
      if (!buttonText && this.activity.s2Link) {
        buttonText = <FormattedMessage id={'activity.visitLink'} />;
      }

      let background = null;
      if (this.activity.type === constants.activity.types.EXTERNAL_GAMES) {
        background = {background: 'linear-gradient(0deg, '+ uiConfigs.themeColorDark +','+ uiConfigs.themeColor +')'};
      } else {
        background = {backgroundColor: utils.colorWithAlpha(uiConfigs.messageBgColor, 1), border: '1px solid '+ uiConfigs.messageBorderColor};
      }

      return (
        <View style={{display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
          <View className={classes.flexColumn} style={{justifyContent: this.props.inPreview ? 'flex-start' : 'center', padding: margin, paddingTop: marginTop}}>
            <ScrollView className={classes.viewColumnFullWidth} style={{maxHeight: viewHeight, padding: padding, paddingBottom: 0, borderRadius: BORDER_RADIUS, ...background}}>
              <View className={classes.viewColumnFullWidth}>
                <View className={classes.viewColumnFullWidth} style={{minHeight: this.props.inPreview ? 120 : 0}}>
                  {this.activity.videoUrl ?
                    <View style={{display: 'flex', marginBottom: padding, borderRadius: BORDER_RADIUS, overflow: 'hidden'}}>
                      <VideoPlayerView
                        key={this.activity.videoStreamUrl || this.activity.videoUrl}
                        autoplay={true}
                        videoUrl={this.activity.videoStreamUrl || this.activity.videoUrl}
                        width={videoWidth}
                        height={videoHeight}
                        borderRadius={BORDER_RADIUS}/>
                    </View>
                    : null
                  }
                  {this.activity.s2ImageUrl ?
                    <AppImage resizeMode={'contain'} source={this.activity.s2ImageUrl} style={{width: imageWidth, height: imageHeight, marginBottom: padding, borderRadius: BORDER_RADIUS, backgroundColor: '#000', overflow: 'hidden'}} />
                    : null
                  }
                  {/*{this.activity.s2Text ?*/}
                  {/*  <TextView style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, marginBottom: SpaceNormal}} >*/}
                  {/*    {this.activity.s2Text}*/}
                  {/*  </TextView>*/}
                  {/*  : null*/}
                  {/*}*/}
                </View>
                {buttonText ?
                  <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: 4, marginBottom: padding}}>
                    {this.getImageActionButton(this.onEndViewLinkClicked, buttonText, 240, uiConfigs.otherActionImage)}
                  </View>
                  : null
                }
              </View>
            </ScrollView>

            <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: SpaceNormal, marginBottom: SpaceNormal}}>
              <View style={{display: 'flex', width: 50, borderRadius: 25, backgroundColor: uiConfigs.messageBgColor, border: '2px solid '+ uiConfigs.messageBorderColor}}>
                <IconButton
                  size={'medium'}
                  variant={'outlined'}
                  onClick={this.hideEndView}>
                  <AppIcon color={uiConfigs.titleColor} icon={IconCross} />
                </IconButton>
              </View>
            </View>
          </View>
        </View>
      );
    }
    return null;
  }

  showEndView = () => {
    this.stopGameBgAudio();
    this.setState({showOverlay: true, showEnd: true}, () => {
      this.changeNavigationColor(this.getDialogAddressBarColor());
    });
    this.pushHashHistory(HASH_OVERLAY);
    this.makeCtaActionsInActivity(ACTIVITY_CTA2_VIEW);
  }

  hideEndView = () => {
    if (this.state && this.state.showEnd) {
      this.setState({showOverlay: false, showEnd: false}, () => {
        this.changeNavigationColor();
        this.popHashHistory(HASH_OVERLAY);
        this.playGameBgAudio();
        this.activity.hideJoinNow = false;
        // this.processJoinUsNowView(1000);
        this.processShareDialog();

        if (this.props.onPreFunDone) {
          this.props.onPreFunDone(this.activityNext);
        }
      });
    }
  }

  renderSponsorView() {
    if (this.state.showSponsor && this.state.sponsor) {
      const activity = this.state.sponsor;
      const {classes} = this.props;
      const uiConfigs = this.getUIConfigs();
      const sizeFactor = uiConfigs.sizeFactor;

      const margin = 8;
      const marginTop = 16;
      const padding = 8;

      const closeButtonSize = SpaceNormal + 50;
      const viewWidth = this.props.width - 2 * margin;
      const viewHeight = this.props.height - marginTop - margin - closeButtonSize;
      const mediaMaxWidth = viewWidth - 2 * padding;
      let mediaMaxHeight = viewHeight - 2 * padding - SpaceNormal;
      // if (activity.s2Text) {
      //   mediaMaxHeight -= (SpaceNormal + 40);
      // }
      if (activity.s2LinkText || activity.s2Link) {
        mediaMaxHeight -= (SpaceNormal + 42 * sizeFactor);
      }

      let videoWidth = mediaMaxWidth;
      let videoHeight = null;
      if (activity.videoUrl) {
        let videoInfo = null;
        if (activity.videoStreamUrl) {
          videoInfo = ApiHelper.getInfoForVideoUrl(activity.videoStreamUrl);
        } else {
          videoInfo = ApiHelper.getInfoForVideoUrl(activity.videoUrl);
        }
        if (videoInfo) {
          videoHeight = Math.min(videoWidth * videoInfo.height / videoInfo.width, mediaMaxHeight);
        }
      }
      let imageWidth = mediaMaxWidth;
      let imageHeight = null;
      if (activity.s2ImageUrl) {
        const imageInfo = ApiHelper.getInfoForImageUrl(activity.s2ImageUrl);
        if (imageInfo) {
          imageHeight = Math.min(imageWidth * imageInfo.height / imageInfo.width, mediaMaxHeight);
        }
      }

      let buttonText = null;
      if (activity.business.link) {
        buttonText = <FormattedMessage id={'activity.visitLink'} />;
      }

      let background = null;
      if (this.activity.type === constants.activity.types.EXTERNAL_GAMES) {
        background = {background: 'linear-gradient(0deg, '+ uiConfigs.themeColorDark +','+ uiConfigs.themeColor +')'};
      } else {
        background = {backgroundColor: utils.colorWithAlpha(uiConfigs.messageBgColor, 1), border: '1px solid '+ uiConfigs.messageBorderColor};
      }

      return (
        <View style={{display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
          <View className={classes.flexColumn} style={{justifyContent: this.props.inPreview ? 'flex-start' : 'center', padding: margin, paddingTop: marginTop}}>
            <ScrollView className={classes.viewColumnFullWidth} style={{maxHeight: viewHeight, maxWidth: this.props.width, padding: padding, paddingBottom: 0, borderRadius: BORDER_RADIUS, ...background}}>
              <View className={classes.viewColumnFullWidth}>
                <View className={classes.viewColumnFullWidth} style={{minHeight: this.props.inPreview ? 120 : 0}}>
                  <AppImage resizeMode={'contain'} source={activity.business.imageUrl} style={{width: imageWidth, height: imageHeight, marginBottom: padding, borderRadius: BORDER_RADIUS, backgroundColor: '#000', overflow: 'hidden'}} />
                  <TextView fontStyleN={uiConfigs.fontSize} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, marginTop: 4, marginBottom: SpaceNormal}} >
                    {activity.business.name}
                  </TextView>
                </View>
                {buttonText ?
                  <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: 4, marginBottom: padding}}>
                    {uiConfigs.otherActionImage ?
                      <GetImageActionButton
                        uiConfigs={uiConfigs}
                        sizeFactor={sizeFactor}
                        onClick={this.onSponsorViewLinkClicked.bind(this, activity)}
                        title={buttonText}
                        width={240}
                      /> :
                      <GetActionButton
                        uiConfigs={uiConfigs}
                        onClick={this.onSponsorViewLinkClicked.bind(this, activity)}
                        title={buttonText}
                      />
                    }
                  </View>
                  : null
                }
              </View>
            </ScrollView>

            <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: SpaceNormal, marginBottom: SpaceNormal}}>
              <View style={{display: 'flex', width: 50, borderRadius: 25, backgroundColor: uiConfigs.messageBgColor, border: '2px solid '+ uiConfigs.messageBorderColor}}>
                <IconButton
                  size={'medium'}
                  variant={'outlined'}
                  onClick={this.hideSponsorView}>
                  <AppIcon color={uiConfigs.titleColor} icon={IconCross} />
                </IconButton>
              </View>
            </View>
          </View>
        </View>
      );
    }
    return null;
  }

  showSponsorView = (event, activity) => {
    if (!activity) {
      activity = this.activity;
    }
    // this.stopGameBgAudio();
    this.setState({showOverlay: true, showSponsor: true, sponsor: activity}, () => {
      this.changeNavigationColor(this.getDialogAddressBarColor());
    });
    this.pushHashHistory(HASH_OVERLAY);
    // this.makeCtaActionsInActivity(ACTIVITY_CTA1_VIEW);
  }

  hideSponsorView = () => {
    this.setState({showOverlay: false, showSponsor: false}, () => {
      this.changeNavigationColor();
      this.popHashHistory(HASH_OVERLAY);
      // this.playGameBgAudio();
    });
  }

  shouldShowInCenter() {
    return !this.props.isXS;
  }

  onWinnerMenuClicked = (event, activity) => {
    if (!activity) {
      activity = this.activity;
    }
    const showInCenter = this.shouldShowInCenter();
    this.showSimpleOverlayView({
      image: require('src/images/activity/0-img_winner.png'),
      // title: locString('winners'),
      positiveActionText: locString('close'),
      showInCenter: showInCenter,
      subView: ActivityHelper.getWinnersView(activity, this.getUIConfigs(), this.getSimpleOverlayContentHeight(showInCenter), this.props.readOnly, this.props.inPreview)
    });
  };

  onRewardsMenuClicked = (event = null, activity = null) => {
    if (!activity) {
      activity = this.activity;
    }
    const image = require('src/images/activity/0-img_prize.png');
    const uiConfigs = this.getUIConfigs();

    const rewardsView = (
      <Profiler id={'RewardView'} onRender={this.onProfilerCallback}>
        <GetRewardsView
          sizeFactor={uiConfigs.sizeFactor}
          uiConfigs={uiConfigs}
          inPreview={this.props.inPreview}
          contentWidth={this.props.width}
          activity={activity}
          onDismissFunction={this.dismissSimpleOverlayNHandleCallback}
          onActivityClicked={this.onActivityClicked}
          onImageClicked={this.onImageFSClicked}
          onTextLinkClicked={this.onTextLinkClicked}/>
      </Profiler>
    );
    this.showSimpleOverlayView({
      image: image,
      title: locString('rewards'),
      positiveActionText: locString('activity.playChallenge'),
      subView: rewardsView,
      showInCenter: this.shouldShowInCenter(),
      onPositiveClicked: () => {
        if (this.unmuteGameAudioOnClose) {
          this.unmuteGameAudioOnClose = false;
          this.onMuteToggle();
        }
      }
    });
  };

  onMoreDetailsMenuClicked = (event, activity) => {
    this.showSimpleOverlayView({
      title: locString('moreDetails'),
      positiveActionText: locString('close'),
      subView: this.getMoreDetailsView(activity),
      showInCenter: this.shouldShowInCenter(),
    });
  };

  onWinEligibleMenuClicked = () => {
    const showInCenter = !this.props.isXS;
    this.showSimpleOverlayView({
      image: require('src/images/activity/0-img_players.png'),
      title: locString('playersStats'),
      positiveActionText: locString('close'),
      showInCenter: showInCenter,
      subView: (
        <View style={{display: 'flex', flex: 1, flexDirection: 'column', height: this.getSimpleOverlayContentHeight(showInCenter), minHeight: this.getSimpleOverlayContentHeight(showInCenter), width: '100%'}}>
          <ActivityPlayerStats activityId={this.activity.id} uiConfigs={this.getUIConfigs()} readOnly={this.props.readOnly} inPreview={this.props.inPreview} />
        </View>
      )
    });
  };

  onGuideClicked = () => {
    this.showSimpleOverlayView({
      image: require('src/images/activity/0-img_guide.png'),
      title: locString('guide'),
      positiveActionText: locString('close'),
      subView: this.getGuideView(),
      showInCenter: this.shouldShowInCenter(),
      onPositiveClicked: () => {
        if (this.unmuteGameAudioOnClose) {
          this.unmuteGameAudioOnClose = false;
          this.onMuteToggle();
        }
      }
    });
  };

  showShareDialog = () => {
    logDebug('DG:S_showShareDialog');
    // this.showSimpleOverlayView({
    //   image: require('src/images/activity/0-img_share.png'),
    //   title: locString('share'),
    //   subTitle: locString('activity.sharePrompt'),
    //   positiveActionText: locString('share'),
    //   negativeActionText: locString('close'),
    //   showInCenter: true,
    //   onPositiveClicked: this.onShareClicked,
    // });
  };

  processShareDialog = () => {
    this.activity.showShare = false;
    logDebug('DG:S_processShareDialog0');
    if (!this.props.isGuestUser && !this.props.inPreview  && !this.props.playInShowcase
      && (!this.activity.inQuestion || !this.activity.inQuestion.isUserActionable)
      && !this.activity.isUserActionable && !this.activity.isUserResetable
      && DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) > 0
      && DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) < 0) {
      logDebug('DG:S_processShareDialog1');
      if (this.timerShowShare) {
        clearTimeout(this.timerShowShare);
      }
      this.timerShowShare = setTimeout(this.showShareDialog, 3000);
    }
  }

  showSimpleOverlayView(options) {
    const {classes, isLTR} = this.props;

    const image = options.image;
    const icon = options.icon;
    const iconColor = options.iconColor || ColorSecondary;
    const title = options.title;
    const subTitle = options.subTitle;
    const topSubView = options.topSubView;
    const subView = options.subView;
    const positiveButtonText = options.positiveActionText || locString('ok');
    const negativeButtonText = options.negativeActionText;
    const onPositiveClicked = options.onPositiveClicked;
    const onNegativeClicked = options.onNegativeClicked;
    const hideActionsSeparator = true; // options.hideActionsSeparator;
    const hideActions = options.hideActions;
    const paddingH = options.paddingH || 0;
    const showSimpleOverlayCenter = options.showInCenter;

    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    let actionButtonWidth = 200;

    const positiveClicked = this.dismissSimpleOverlayNHandleCallback.bind(this, onPositiveClicked);
    let negativeClicked = null;
    if (negativeButtonText) {
      const effWidth = this.props.width;
      negativeClicked = this.dismissSimpleOverlayNHandleCallback.bind(this, onNegativeClicked);
      actionButtonWidth = (effWidth - 2 * uiConfigs.infoViewContentHorizontalMargin * sizeFactor - 16) / 2;
      actionButtonWidth = Math.min(actionButtonWidth, (this.props.width - 48)/2) / sizeFactor;
    }

    const actionButton = (title, onClick, isNegative, width) => {
      return this.getImageActionButton(onClick, title, width, isNegative ? uiConfigs.otherActionNImage : uiConfigs.otherActionImage, false, isNegative);
    };

    const paddingSide = uiConfigs.infoViewContentHorizontalMargin * sizeFactor - paddingH;
    const borderBottomLeftRadius = showSimpleOverlayCenter || this.activity.type === constants.activity.types.CHALLENGE ? RadiusOverlay : 0;
    const borderBottomRightRadius = showSimpleOverlayCenter || this.activity.type === constants.activity.types.CHALLENGE ? RadiusOverlay : 0;
    const subViewMaxHeight = showSimpleOverlayCenter ? this.getCenterSimpleOverlayContentViewHeight() : this.getBottomSimpleOverlayContentViewHeight(hideActions, title == null);
    const view = (
      <View className={classes.viewRowFullWidth} style={{margin: showSimpleOverlayCenter ? 16 : 0, justifyContent: 'center'}}>
        <View className={classes.viewOverlayContent} style={{position: 'relative', maxWidth: showSimpleOverlayCenter ? this.props.width - 2 * SpaceNormal : this.props.width}}>
          <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}>
            {uiConfigs.infoTopImage == null && uiConfigs.infoBottomImage == null && uiConfigs.infoMiddleImage == null ?
              uiConfigs.themeColor ?
                <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, borderTopLeftRadius: RadiusOverlay, borderTopRightRadius: RadiusOverlay, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius, borderWidth: 0, borderTopWidth: 1, borderStyle: 'solid', borderColor: uiConfigs.themeColorDark, background: 'linear-gradient(0deg, '+ uiConfigs.themeColorDark +','+ uiConfigs.themeColor}}/>
                : <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, borderTopLeftRadius: RadiusOverlay, borderTopRightRadius: RadiusOverlay, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius, borderWidth: 1, backgroundColor: uiConfigs.overlayBgColor, borderColor: uiConfigs.overlayBorderColor}}/>
              : null
            }
            {uiConfigs.infoTopImage ? <AppImage resizeMode={'fill'} source={uiConfigs.infoTopImage} style={{position: 'absolute', top: 0, left: 0, right: 0, height: uiConfigs.infoViewTopHeight * sizeFactor, width: '100%'}} /> : null}
            {uiConfigs.infoBottomImage ? <AppImage resizeMode={'fill'} source={uiConfigs.infoBottomImage} style={{position: 'absolute', bottom: 0, left: 0, right: 0, height: uiConfigs.infoViewBottomHeight * sizeFactor, width: '100%'}} /> : null}
            {uiConfigs.infoMiddleImage ?
              <View style={{position: 'absolute', left: 0, right: 0, top: uiConfigs.infoViewTopHeight * sizeFactor - 2, bottom: uiConfigs.infoViewBottomHeight * sizeFactor - 2}}>
                <AppImage resizeMode={'fill'} source={uiConfigs.infoMiddleImage} style={{width: '100%', height: '100%'}} />
              </View>
              : null
            }
          </View>
          <View className={classes.flexColumn} style={{position: 'relative'}}>
            {topSubView}
            {image ?
              <View style={{alignItems: 'center', marginTop: -36 * sizeFactor, marginBottom: -6 * sizeFactor}}>
                <ImageBackground source={image} style={{width: 68 * sizeFactor, height: 68 * sizeFactor}} />
              </View>
              : null
            }
            {icon ?
              <View style={{height: 68 * sizeFactor, width: 68 * sizeFactor, borderRadius: 34 * sizeFactor, marginTop: -34 * sizeFactor, marginBottom: -6 * sizeFactor, alignSelf: 'center', alignItems: 'center', justifyContent: 'center', backgroundColor: uiConfigs.overlayBgColor, borderWidth: 4, borderColor: iconColor}}>
                <AppIcon icon={icon} color={iconColor} size={sizeFactor < 0.9 ? "1x" : sizeFactor > 1.1 ? "3x" : "2x"} />
              </View>
              : null
            }
            <View className={classes.viewColumnFullWidth} style={{paddingLeft: paddingSide, paddingRight: paddingSide, paddingTop: image ? 8 : uiConfigs.infoViewTitleMarginTop, paddingBottom: 16 * uiConfigs.sizeFactor}}>
              {title != null ?
                <View style={{alignItems: 'center', justifyContent: 'center', marginTop: !image && !icon ? 12*uiConfigs.sizeFactor : 0, marginBottom: 12*uiConfigs.sizeFactor}}>
                  <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{textAlign: 'center', color: uiConfigs.overlayHeadingColor, fontWeight: FontWeightMedium}}>{title}</AppText>
                </View>
                : null
              }
              {subTitle != null || subView != null ?
                <ScrollView style={{maxHeight: subViewMaxHeight}}>
                  <View className={classes.viewColumnFullWidth}>
                    {subTitle ?
                      <AppText fontSizeN={uiConfigs.fontSize} variant={'body2'} style={{textAlign: 'center', color: uiConfigs.overlaySubTitleColor, fontSize: FontSizeSmall, fontWeight: FontWeightRegular, marginBottom: 16}}>
                        {subTitle}
                      </AppText>
                      : null
                    }
                    {subView}
                  </View>
                </ScrollView>
                : null
              }
              {!hideActions ?
                <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: hideActionsSeparator ? 0 : 0, paddingTop: 16, borderWidth: 0, borderTopWidth: hideActionsSeparator ? 0 : 2, borderStyle: 'ridge', borderColor: uiConfigs.messageBorderColor}}>
                  {negativeButtonText ? <View style={{marginRight: isLTR ? 12 : 0, marginLeft: isLTR ? 0 : 12}}>{actionButton(negativeButtonText, negativeClicked, true, actionButtonWidth)}</View> : null}
                  {actionButton(positiveButtonText, positiveClicked, false, actionButtonWidth)}
                </View>
                : null
              }
            </View>
          </View>
        </View>
      </View>
    );

    this.showSimpleOverlayCenter = showSimpleOverlayCenter;
    this.setState({showOverlay: true, showSimpleOverlay: true, simpleOverlayView: view}, () => {
      this.changeNavigationColor(this.getDialogAddressBarColor());
      this.pushHashHistory(HASH_OVERLAY);
      setTimeout(() => {
        if (options.onDisplayed) {
          options.onDisplayed();
        }
      }, 400);
    });
  }

  dismissSimpleOverlayNHandleCallback = (callback) => {
    this.setState({showOverlay: false, showSimpleOverlay: false, simpleOverlayView: null}, () => {
      this.changeNavigationColor();
      this.popHashHistory(HASH_OVERLAY);
      if (callback) {
        callback();
      }
    });
  };

  getCenterSimpleOverlayContentViewHeight() {
    const sizeFactor = this.getUIConfigs().sizeFactor;
    return this.props.height - 230 * sizeFactor;
  }

  getBottomSimpleOverlayContentViewHeight(hideAction = false, hideTitle = false) {
    const sizeFactor = this.getUIConfigs().sizeFactor;
    let height = this.props.height - 240 * sizeFactor;
    if (hideAction) {
      height += 40 + 42 * sizeFactor;
    }
    if (hideTitle) {
      height += 10 + 44 * sizeFactor;
    }
    return height;
  }

  getSimpleOverlayContentHeight(showInCenter, hideAction, hideTitle) {
    if (showInCenter) {
      return this.getCenterSimpleOverlayContentViewHeight();
    }
    return this.getBottomSimpleOverlayContentViewHeight(hideAction, hideTitle);
  }

  getRewardWonViewMaxHeight() {
    const sizeFactor = this.getUIConfigs().sizeFactor;
    return this.contentHeight - 160 * sizeFactor;
  }

  getUIConfigs() {
    let uiConfigs = this.uiConfigs;
    if (!uiConfigs) {
      let effActivity = this.activity;
      if (this.props.inPreview && this.activity.type === ACTIVITY_TYPE_CHALLENGE && this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable) {
        effActivity = this.activity.previewInQuestion;
      }
      uiConfigs = this.props.uiConfigs || ActivityHelper.getUIConfigs(effActivity, this.context.intl, this.props.isLTR, this.props.inPreview);
      uiConfigs.sizeFactor = this.sizeFactor;
      uiConfigs.sizeVFactor = this.sizeVFactor;
      uiConfigs.fontSize = Math.min(1.1, this.sizeFactor) * 16;
      uiConfigs.intl = this.context.intl;
      uiConfigs.isLTR = this.props.isLTR;
    }
    if (this.activity) {
      this.uiConfigs = uiConfigs;
    }
    return uiConfigs;
  }

  getDialogAddressBarColor() {
    if (this.activity && (this.activity.type === constants.activity.types.CHALLENGE || this.activity.type === constants.activity.types.SOCIAL_CONTENT)) {
      return ColorBlack;
    }
    return '#303030';
  }

  static getLocalUiConfigs(activity) {
  }

  showOverlayView(onDisplayed) {
    this.onAlertDisplayed = onDisplayed;
    this.shouldShowOverlayView = true;
    this.reloadView();
  }

  dismissOverlayView(onDismissed) {
    this.onAlertDismissed = onDismissed;
    this.shouldShowOverlayView = false;
    this.reloadView();
  }

  onOverlayPositiveClicked = () => {
    this.dismissOverlayView();
  };

  getOverlayViewTitle() {
    if (this.activity.type === ACTIVITY_TYPE_SLOT) {
      return locString('rewards');
    }
    if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN) {
      return locString('helpGreedySpinTitle');
    }
    if (this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER) {
      return locString('photoPartsCount');
    }
    if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
      return locString('helpCollectStarsTitle');
    }
    return null;
  }

  getOverlayViewSubTitle() {
    if (this.activity.type === ACTIVITY_TYPE_SLOT) {
      return locString('clickToShowJackpotRewardsMessage');
    }
    if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN) {
      return locString('helpGreedySpinSubTitle', {value1: this.getGameValuePlaceholder(), value2: this.activity.gameValue1});
    }
    if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
      return locString('clickToShowCollectStarPointsMessage', {value1: this.getGameValuePlaceholder()});
    }
    return null;
  }

  getOverlayView() {
    if (this.activity.type === ACTIVITY_TYPE_SLOT || this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN
      || this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER || this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
      let showOffers = false;
      if (this.activity.type === ACTIVITY_TYPE_SLOT) {
        this.activity.slotValues.forEach((item) => {
          if (item.offers && item.offers.length > 0) {
            showOffers = true;
          }
        });
      }
      ActivityHelper.getSlotValuesView(this.activity, this.getUIConfigs(), showOffers, this.onImageFSClicked);
    }
    return null;
  }

  getDurationView() {
    const {classes} = this.props;

    let validityColor;
    let validityText;
    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt);
    if (startDateDiff <= 0) {
      const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt);
      const validity = DateTimeHelper.getValidity(this.activity.endAt);
      if (endDateDiff <= 0) {
        if (this.activity.recurAt) {
          validityText = locString('endedRestartingAgain');
          validityColor = ColorOrange;
        } else {
          validityText = locString('ended');
          validityColor = ColorNegative;
        }
      } else {
        validityText = locString('endingInTime', {0: validity});
        validityColor = ColorTitle;
      }
    } else {
      const validity = DateTimeHelper.getValidity(this.activity.startAt);
      validityText = locString('startingInTime', {0: validity});
      validityColor = ColorSubTitle;
    }

    return (
      <View className={this.props.classes.viewColumn} style={{marginTop: -8, marginBottom: -6, paddingTop: 4}}>
        <View className={this.props.classes.flexRow}>
          <TouchableOpacity className={this.props.classes.viewRow} style={{minHeight: 36, justifyContent: 'center'}} onClick={() => {
            this.showCompleteDuration = !this.showCompleteDuration;
            this.reloadView();
          }}>
            <View className={this.props.classes.viewRow} style={{minHeight: 32}}>
              <View style={{opacity: 0.9}}>
                <AppIcon size={12} icon={IconClock} color={validityColor} />
              </View>
              <AppText
                style={{
                  color: validityColor,
                  fontSize: FontSizeSmall,
                  fontWeight: FontWeightRegular,
                  marginLeft: SpaceXSmall,
                  marginRight: SpaceXSmall,
                  textTransform: 'lowercase',
                }}>
                {validityText}
              </AppText>
              <AppIcon size={10} icon={this.showCompleteDuration ? IconChevronUp : IconChevronDown} color={validityColor} />
            </View>
          </TouchableOpacity>
        </View>
        {this.showCompleteDuration ?
          <View style={{marginTop: -4, marginBottom: -4, marginLeft: 0}}>
            <View style={{flex: 1, flexDirection: 'row'}}>
              <View className={classes.viewColumn} style={{marginBottom: SpaceNormal}}>
                <AppText variant={'body2'} style={{textAlign: 'left', color: ColorSubTitle}}>{locString('startingFrom', {value: DateTimeHelper.getDisplayDate(this.activity.startAt)})}</AppText>
                <AppText variant={'body2'} style={{textAlign: 'left', color: ColorSubTitle}}>{locString('validUpto', {value: DateTimeHelper.getDisplayDate(this.activity.endAt)})}</AppText>
                {this.activity.recurAt ?
                  <AppText variant={'body2'} style={{textAlign: 'left', color: ColorSubTitle}}>{locString('restartAgainOn', {value: DateTimeHelper.getDisplayDate(this.activity.recurAt)})}</AppText>
                  : null
                }
              </View>
            </View>
          </View>
          : null
        }
      </View>
    );
  }

  getGameValuePlaceholder() {
    return ActivityHelper.getGameValuePlaceholder(this.activity);
  }

  getGameOtherInfo() {
    let rewardsWonView = null;
    let actionDisabledMessage = null;
    let gamePlayTriesOver = false;
    let gameWinLimitOver = false;
    let showGame = this.activity.isUserActionable || this.activity.isUserActionableA || this.activity.noActionMessage;
    let showScore = true;

    if (!this.activity.isUserActionable) {
      if (this.activity.userWon) {
        rewardsWonView = this.getRewardsWonView();
        showGame = false;
        showScore = false;
      } else if (this.activity.userWinEligible) {
        // actionDisabledMessage = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
        showGame = true;
      } else if (this.activity.userNotWon) {
        if (!this.props.autoSimulation) {
          actionDisabledMessage = this.getNotWinningMessage();
        }
        showGame = true;
      // } else if (!this.activity.noRewards && !this.activity.winAtEnd && (this.activity.winGCount >= this.activity.winGLimit || this.activity.answeredCount >= this.activity.answerLimit)) {
      } else if (!this.activity.noRewards && (this.activity.winGCount >= this.activity.winGLimit || this.activity.answeredCount >= this.activity.answerLimit)) {
        if (DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) <= 0 && !this.activity.recurAt) {
          showGame = true;
          actionDisabledMessage = locString('campaignIsEnded');
        } else {
          actionDisabledMessage = locString('gameWinLimitComplete');
          gameWinLimitOver = true;
        }
      } else {
        const playTriesOver = this.getGamePlayTriesOverInfo();
        if (playTriesOver && playTriesOver.gamePlayTriesOver) {
          actionDisabledMessage = playTriesOver.gamePlayTriesOverMessage;
          gamePlayTriesOver = true;
          showGame = true;
        } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) > 0) {
          actionDisabledMessage = DateTimeHelper.getValidity(this.activity.startAt, 'campaign.startIn');
          showGame = true;
          showScore = false;
        } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) <= 0 && !this.activity.recurAt) {
          showGame = true;
          actionDisabledMessage = locString('campaignIsEnded');
        } else if (this.activity.isCodeNeeded) {
          showGame = true;
          actionDisabledMessage = locString('campaignIsEnded');
        }
      }
    }
    return {
      rewardsWonView: rewardsWonView,
      actionDisabledMessage: actionDisabledMessage,
      showGame: showGame,
      showScore: showScore && this.activity.type === constants.activity.types.QUESTIONNAIRE, // TODO showing score for quiz only
      gamePlayTriesOver: gamePlayTriesOver,
      gameWinLimitOver: gameWinLimitOver,
    };
  }

  getNotWinningMessage() {
    if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
      if (this.activity.rightOptionHint) {
        const rightOption = ''+ this.activity.rightOptionHint + (this.activity.rightOptionHintAr ? ','+ this.activity.rightOptionHintAr : '');
        if (this.guessText != rightOption) {
          return locString('activity.userPredictionWrong');
        }
      }
    } else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
      if (this.activity.isCodeNeeded && this.guessText != this.activity.rightOptionId) {
        return locString('activity.userGuessWrong');
      }
    } else if (this.activity.type === ACTIVITY_TYPE_QUESTION) {
      return locString('youHaveAnswered');
    }
    return locString('notWinningMessage');
  }

  getGamePlayTriesOverInfo() {
    let gamePlayTriesOver = false;
    let gamePlayTriesOverMessage = null;
    if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
      gamePlayTriesOver = this.guess1 != null;
    } else if (this.activity.type === ACTIVITY_TYPE_SLIDES || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU) {
      gamePlayTriesOver = this.activity.userActionsCount > 0;
    } else if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
      gamePlayTriesOver = this.guess1 != null;
      // if (this.activity.rightOptionHint) {
      //   const rightOption = ''+ this.activity.rightOptionHint + (this.activity.rightOptionHintAr ? ','+ this.activity.rightOptionHintAr : '');
      //   if (this.guessText == rightOption) {
      //     gamePlayTriesOverMessage = locString('activity.userPredictionRight');
      //   } else {
      //     gamePlayTriesOverMessage = locString('activity.userPredictionWrong');
      //   }
      // } else {
      //   const canUpdate = !this.props.isGuestUser && this.activity.isUserActionableA;
      //   gamePlayTriesOverMessage = locStringA(this.context.intl, canUpdate ? 'activity.youHavePredicatedNUpdate' : 'activity.youHavePredicated');
      //   if (!this.activity.noRewards && this.activity.winnersAt) {
      //     gamePlayTriesOverMessage += '\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl)
      //   }
      // }
    } else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
      gamePlayTriesOver = this.guessText != null;
      // if (this.activity.rightOptionId) {
      //   if (this.guessText == this.activity.rightOptionId) {
      //     gamePlayTriesOverMessage = locString('activity.userGuessRight');
      //   } else {
      //     gamePlayTriesOverMessage = locString('activity.userGuessWrong');
      //   }
      // } else {
      //   const canUpdate = !this.props.isGuestUser && this.activity.isUserActionableA;
      //   gamePlayTriesOverMessage = locStringA(this.context.intl, canUpdate ? 'activity.youHaveGuessedNUpdate' : 'activity.youHaveGuessed');
      //   if (!this.activity.noRewards && this.activity.winnersAt) {
      //     gamePlayTriesOverMessage += '\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl)
      //   }
      // }
    } else if (this.activity.type === ACTIVITY_TYPE_QUESTION) {
      gamePlayTriesOver = this.activity.userAnswer != 0;
      gamePlayTriesOverMessage = locString('youHaveAnswered', null, this.context.intl);
      if (this.activity.winnersAt) {
        gamePlayTriesOverMessage += '\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl)
      }
    } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
      gamePlayTriesOver = this.activity.userAnswer > 0 || this.activity.userConsumedCount >= this.activity.consumeLimitPerUser || (this.activity.gameTime > 0 && this.activity.userClickedCount >= this.activity.gameTime);
      if (this.activity.type === ACTIVITY_TYPE_SURVEY) {
        // gamePlayTriesOverMessage = locString('surveyCompleted', null, this.context.intl);
        // if (this.activity.winnersAt) {
        //   gamePlayTriesOverMessage += '\n' + locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl)
        // }
      }
    } else if (this.activity.type === ACTIVITY_TYPE_POKER || this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE) {
      let roundsToWin = Math.floor(this.activity.consumeLimitPerUser / 2) + 1;
      const roundsPlayed = this.activity.userConsumedCount;
      const botWonRounds = this.activity.userClickedCount;
      if (this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE) {
        let userWonRounds = 0;
        if (this.activity.userValueText && this.activity.userValueText < 0) {
          userWonRounds = Math.abs(this.activity.userValueText);
        }
        const drawRounds = roundsPlayed - userWonRounds - botWonRounds;
        roundsToWin = Math.floor((this.activity.consumeLimitPerUser - drawRounds) / 2) + 1;
      }
      const isBotWon = botWonRounds >= roundsToWin;
      gamePlayTriesOver = this.activity.userAnswer === 0 && (this.activity.userConsumedCount >= this.activity.consumeLimitPerUser || isBotWon);
      // if (!this.activity.isUserResetable) {
      //   gamePlayTriesOverMessage = locString('notWinningMessage');
      // }
    } else if (this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
      gamePlayTriesOver = this.activity.userRating > 0;
      // if (!this.activity.isUserResetable) {
      //   gamePlayTriesOverMessage = locString('youHaveReviewed', null, this.context.intl);
      //   if (this.activity.winnersAt) {
      //     gamePlayTriesOverMessage += '\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl)
      //   }
      // }
    } else {
      gamePlayTriesOver = this.activity.userAnswer === 0 && this.activity.userConsumedCount >= this.activity.consumeLimitPerUser;
      // if (!this.activity.isUserResetable) {
      //   gamePlayTriesOverMessage = locString('notWinningMessage');
      // }
    }
    return {
      gamePlayTriesOver,
      gamePlayTriesOverMessage
    };
  }

  getRatingView() {
    if (this.activity.type === ACTIVITY_TYPE_SMART_AD || (this.activity.type === ACTIVITY_TYPE_OFFER && !this.activity.isVoucher) || this.activity.type === ACTIVITY_TYPE_DISCOUNT) {
      return (
        <View style={{flexDirection: 'row', marginTop: -2, alignItems: 'flex-end'}}>
          <View style={{marginRight: 6}}>
            <TouchableOpacity onClick={this.onRatingsClicked}>
              <View style={{flexDirection: 'row', paddingTop: 8, marginRight: 6}}>
                <View style={{opacity: 0.8, marginTop: 2}}>
                  <AppIcon size={15} icon={IconStar} color={ColorAccent} />
                </View>
                <AppText
                  style={{
                    color: ColorSubTitle,
                    fontSize: FontSizeNormal,
                    fontWeight: FontWeightRegular,
                    marginLeft: SpaceXSmall,
                  }}>
                  {ValueHelper.getDisplayValue(this.activity.rating, false, 1)}
                </AppText>
              </View>
            </TouchableOpacity>
          </View>
          <TouchableOpacity onClick={this.onActivityReviewsClicked}>
            <View style={{alignItems: 'center', paddingTop: 8, marginRight: 12}}>
              <AppText
                style={{
                  color: ColorSubTitle,
                  fontWeight: FontWeightRegular,
                  fontSize: FontSizeNormal,
                }}>
                {locString('activityReviewsWithValue', {count: this.activity.commentsCount})}
              </AppText>
            </View>
          </TouchableOpacity>
          {this.activity.isUserReviewable ?
            <Button
              elevation={false}
              onClick={this.onReviewCampaignClicked}
              titleColor={ColorSubTitle}
              style={{padding: 0, paddingTop: 8, minHeight: 0, justifyContent: 'flex-end'}}
              titleStyle={{fontSize: FontSizeNormal - 1}}
            >
              {locString('addReview')}
            </Button>
            : null
          }
        </View>
      );
    }
    return null;
  }

  getCommentsView() {
    if (this.activity.type === ACTIVITY_TYPE_EVENT) {
      return (
        <View style={{flexDirection: 'row', alignItems: 'flex-end', borderWidth: 0, borderColor: ColorNegative}}>
          <Button
            elevation={false}
            onClick={() => {
              const post = {
                id: this.activity.postId,
                title: this.activity.title,
                canComment: this.activity.canComment,
                commentsCount: this.activity.commentsCount,
                activityId: this.activity.id,
                activity: this.activity,
              };
              // ActivityReviewDetailScreen.navigateTo(this.props.navigation, post, post.id, null, this.branchId, this.activity ? this.activity.dp : null, (post) => {
              //   this.activity.commentsCount = post.commentsCount;
              //   this.reloadView();
              // });
            }}
            titleColor={ColorSubTitle}
            style={{marginTop: -2, padding: 0, paddingTop: 8, minHeight: 0, justifyContent: 'flex-end'}}
            titleStyle={{fontSize: FontSizeNormal - 1}}
          >
            {<AppText>
              <AppText style={{fontWeight: FontWeightRegular, fontSize: FontSizeNormal}}>
                {locString('commentsCount', {count: this.activity.commentsCount})}
              </AppText>
              <AppText>
                {'   '}
              </AppText>
              <AppText>
                {locString('addComment')}
              </AppText>
            </AppText>}
          </Button>
        </View>
      );
    }
    return null;
  }

  isPullToRefreshEnabled() {
    if (this.activity && (this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE || this.activity.type === ACTIVITY_TYPE_COLLECT_STARS || this.activity.type === ACTIVITY_TYPE_OFFER || this.activity.type === ACTIVITY_TYPE_DISCOUNT)) {
      return true;
    }
    return false;
  }

  getNewHeading(heading) {
    const uiConfigs = this.getUIConfigs();
    return ActivityHelper.getNewHeading(heading, uiConfigs);
  }

  getPointsView() {
    const pointsRequired = Math.max(this.activity.pointsNeeded, this.activity.fee);
    if (pointsRequired > 0) {
      const pointsBalance = this.activity.userEarnedPoints;
      const isShort = pointsBalance < pointsRequired;
      const width = this.props.width - 4 * SpaceXSmall;
      const percent = isShort ? pointsBalance/pointsRequired : 1;
      return (
        <View style={Object.assign(BaseStyle.viewItemNoPadding, {padding: SpaceXSmall})}>
          {isShort ?
            <View style={{flexDirection: 'row', marginBottom: 2}}>
              <AppTextWrapper wrapperStyle={{flex: 1}} style={{color: ColorOrange, fontSize: FontSizeSmall, fontWeight: FontWeightMedium}}>{locString(this.activity.checkRab7Points ? 'moreRab7PointsNeeded' : 'moreStorePointsNeeded')}</AppTextWrapper>
              <View style={{alignItems: 'center', justifyContent: 'flex-end', flexDirection: 'row'}}>
                <AppTextWrapper style={{fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: ColorOrange, marginRight: 4}}>{pointsRequired - pointsBalance}</AppTextWrapper>
                <AppIcon icon={IconLongArrowRight} color={ColorOrange} size={14}/>
                <View style={{width: 2, height: 14, backgroundColor: ColorOrange, borderRadius: 2, marginLeft: 2}}/>
              </View>
            </View>
            : <View style={{flexDirection: 'row', marginBottom: 4}}>
              <AppTextWrapper wrapperStyle={{flex: 1}} style={{color: ColorGreen, fontSize: FontSizeSmall, fontWeight: FontWeightMedium}}>{locString('pointsConditionPassed')}</AppTextWrapper>
              <AppIcon icon={IconCheckCircle} color={ColorGreen} size={14}/>
            </View>
          }
          <View style={{height: 8, width: Math.max(width * percent, 1), backgroundColor: ColorGold, marginTop: 0, marginBottom: 1}} />
          <View style={{backgroundColor: ColorGold, height: 4, opacity: 0.9}} />
          <View style={{flexDirection: 'row', marginTop: 2}}>
            <View style={{alignItems: 'center', flexDirection: 'row'}} >
              <AppIcon icon={IconWallet} color={ColorGold} size={14}/>
              <AppTextWrapper style={{fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: ColorGold, marginLeft: 4}}>{pointsBalance}</AppTextWrapper>
            </View>
            <View style={{flex: 1}} />
            <View style={{alignItems: 'center', flexDirection: 'row', opacity: 0.9}} >
              <AppTextWrapper style={{fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: ColorGold, marginRight: 4}}>{pointsRequired}</AppTextWrapper>
              <AppIcon icon={IconPoints} color={ColorGold} size={14}/>
            </View>
          </View>
        </View>
      );
    }
    return null;
  }

  getPointsConditionsView() {
    const pointsRequired = Math.max(this.activity.pointsNeeded, this.activity.fee);
    if (pointsRequired > 0 || this.activity.fee > 0 || this.activity.consumedPoints > 0 || this.activity.rewardedOffer) {
      return (
        <View style={{marginBottom: SpaceNormal}}>
          {this.getNewHeading(locString('pointsConditionsNRewards'))}
          {this.getDetailsNameValueTemplateView(this.activity.userEarnedPoints, locString(this.activity.checkRab7Points ? 'rab7PointsBalance' : 'storePointsBalance'))}
          {pointsRequired > 0 ? this.getDetailsNameValueTemplateView(pointsRequired, locString(this.activity.checkRab7Points ? 'rab7PointsRequiredToAction' : 'storePointsRequiredToAction')) : null}
          {this.activity.fee > 0 ? this.getDetailsNameValueTemplateView(this.activity.fee, locString(this.activity.checkRab7Points ? 'rab7PointsChargedOnAction' : 'storePointsChargedOnAction')) : null}
          {this.activity.consumedPoints > 0 ? this.getDetailsNameValueTemplateView(this.activity.consumedPoints, locString(this.activity.checkRab7Points ? 'rab7PointsDeductedOnAction' : 'storePointsDeductedOnAction')) : null}
          {this.activity.rewardedOffer ? this.getDetailsNameValueTemplateView(this.activity.rewardedOffer.title, locString('offerRewardedOnAction')) : null}
        </View>
      );
    }
    return null;
  }

  getParticipateConditionsView(showWalletAlways = false) {
    const {classes} = this.props;
    const pointsRequired = Math.max(this.activity.pointsNeeded, this.activity.fee);
    if (showWalletAlways || pointsRequired > 0 || this.activity.fee > 0) {
      const title = pointsRequired > 0 || this.activity.fee > 0 ? locString('participatePointsConditions') : locString('walletBalance');
      return (
        <View className={classes.viewColumnFullWidth} style={{marginBottom: SpaceNormal}}>
          {this.getNewHeading(title)}
          <View className={classes.viewColumnFullWidth} style={{marginTop: 6}}>
            {this.getDetailsNameValueTemplateView(this.activity.userEarnedPoints, locString(this.activity.checkRab7Points ? 'rab7PointsBalance' : 'storePointsBalance'))}
            {pointsRequired > 0 ? this.getDetailsNameValueTemplateView(pointsRequired, locString(this.activity.checkRab7Points ? 'rab7PointsRequiredToAction' : 'storePointsRequiredToAction')) : null}
            {this.activity.fee > 0 ? this.getDetailsNameValueTemplateView(this.activity.fee, locString(this.activity.checkRab7Points ? 'rab7PointsChargedOnAction' : 'storePointsChargedOnAction')) : null}
          </View>
        </View>
      );
    }
    return null;
  }

  getDetailsNameValueTemplateView(points, message) {
    const uiConfigs = this.getUIConfigs();
    return ActivityHelper.getDetailsNameValueTemplateView(message, points, uiConfigs);
  }

  getBusinessView() {
    let actionText = this.activity.linkText ? this.activity.linkText : locString('view');
    let onClick = null;
    if (this.activity.link) {
      onClick = () => {
        this.onLinkClicked();
      };
    }
    if (this.activity.type === ACTIVITY_TYPE_SMART_AD) {
      actionText = locString('view');
    }
    const size = this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE ? 44 : 36;
    const elevation = this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE ? 1 : 0;
    return (
      <Paper elevation={elevation} style={{width: '100%', padding: SpaceXSmall, paddingLeft: SpaceNormal, borderRadius: RadiusViewCard, backgroundColor: ColorWhite}}>
        <View style={{minHeight: size}}>
          <View style={{
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center'}}>
            <AppImage imageUrl={this.activity.business.imageUrl} style={{width: size, height: size, borderRadius: RadiusView}} />
            <Space verticalSpace={1} />
            <AppTextWrapper wrapperStyle={{flex: 1}} style={{color: ColorTitle}} numberOfLines={1}>
              {this.activity.business.name}
            </AppTextWrapper>
            {onClick ?
              <Button
                elevation={false}
                onClick={onClick}
                color={ColorClear}
                titleColor={ColorTitle}
                style={{minHeight: 34, marginLeft: SpaceXXSmall, marginRight: SpaceXXSmall}}>
                {actionText}
              </Button>
              : null
            }
          </View>
        </View>
      </Paper>
    );
  }

  getBottomOtherActionsView() {
    const {isXS} = this.props;
    const actionButton = (image, title, onClick) => {
      const sizeFactor = this.getUIConfigs().sizeFactor;
      return (
        <View style={{marginLeft: 12, marginRight: 12, minWidth: 60, maxWidth: isXS ? 120 : 200}}>
          <TouchableOpacity disabled={!onClick} onClick={onClick} style={{opacity: 1}}>
            <View style={{alignItems: 'center', borderColor: ColorNegative}}>
              <AppImage source={image} resizeMode="contain" width={30 * sizeFactor} height={30 * sizeFactor} borderRadius={RadiusIcon} />
              <AppTextWrapper numberOfLines={2} variant={'body1'} style={{color: ColorTitle, fontSize: FontSizeSmall, fontWeight: FontWeightMedium, marginTop: 6}}>
                {title}
              </AppTextWrapper>
            </View>
          </TouchableOpacity>
        </View>
      )
    };

    const walletView = null; // this.getWalletView();
    let onWalletClicked = null;
    if (walletView != null) {
      onWalletClicked = () => {
        this.showSimpleOverlayView({
          title: locString('walletInfo'),
          positiveActionText: locString('close'),
          subView: walletView
        });
      };
    }

    let showGuide = false;
    let showMoreDetails = true;
    let showWallet = true;
    let showBusiness = false;
    let rewardIcon = null;
    let guideIcon = null;
    let backgroundColor = ColorWhite;
    let elevation = {};
    if (this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE) {
      showGuide = true;
      showMoreDetails = false;
      showWallet = false;
      rewardIcon = require('src/images/activity/0-img_prize.png');
      guideIcon = require('src/images/activity/0-img_guide.png');
      backgroundColor = ColorWhite;
      elevation = ELEVATION;
    } else {
      rewardIcon = require('src/images/activity/0-img_reward.png');
    }
    if (this.activity.type === ACTIVITY_TYPE_OFFER || this.activity.type === ACTIVITY_TYPE_DISCOUNT) {
      showBusiness = true;
    }
    const onBusinessClicked = this.activity.business.link ? this.onBusinessClicked : null;

    return (
      <View style={{flexDirection: 'row', justifyContent: 'center'}}>
        <Paper style={{borderRadius: RadiusViewCard, backgroundColor: backgroundColor, marginTop: SpaceXSmall, marginBottom: SpaceNormal}}>
          <View style={{flexDirection: 'row', justifyContent: 'center', padding: SpaceXSmall, paddingLeft: SpaceNormal, borderRadius: RadiusViewCard}}>
            {showBusiness ? actionButton(this.activity.business.imageUrl, this.activity.business.name, onBusinessClicked) : null}
            {showWallet && onWalletClicked ? actionButton(require('src/images/activity/0-img_wallet.png'), locString('wallet'), onWalletClicked) : null}
            {showMoreDetails ? actionButton(require('src/images/activity/0-img_detail.png'), locString('moreDetails'), this.onMoreDetailsMenuClicked) : null}
            {this.activity.showPlayers ? actionButton(require('src/images/activity/0-img_players.png'), locString('players'), this.onWinEligibleMenuClicked) : null}
            {this.shouldShowRewards() ? actionButton(rewardIcon, locString('rewards'), this.onRewardsMenuClicked) : null}
            {this.shouldShowGuide() ? actionButton(guideIcon, locString('guide'), this.onGuideClicked) : null}
          </View>
        </Paper>
      </View>
    );
  }

  // region Action

  getActionView(height) {
    const gameOtherInfo = this.getGameOtherInfo();
    if (this.activity.previewInQuestion && this.activity.previewInQuestion.isUserActionable) {
      return this.getCampaignQuestionActionView(this.activity.previewInQuestion, gameOtherInfo);
    }
    let view = null;
    if (this.activity.type === ACTIVITY_TYPE_EXTERNAL_GAMES) {
      view = this.getExternalGameActionView(height, gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_QUESTION) {
      view = this.getCampaignQuestionActionView(this.activity, gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_SMART_AD) {
      view = this.getCampaignSmartAdActionView();
    }
    else if (this.activity.type === ACTIVITY_TYPE_OFFER || this.activity.type === ACTIVITY_TYPE_DISCOUNT) {
      view = this.getCampaignOfferActionView();
    }
    else if (this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
      view = this.getCampaignOpinionActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_EVENT) {
      view = this.getCampaignEventActionView();
    }
    else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
      view = this.getCampaignQuestionnaireActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
      view = this.getCampaignGamePredictionActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
      view = this.getCampaignGameIdentifyLocationActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
      view = this.getCampaignGameGuessActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE) {
      view = this.getCampaignGameShareNGetActionView();
    }
    else if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
      view = this.getCampaignGameCollectStarActionView();
    }
    else if (this.activity.type === ACTIVITY_TYPE_SLOT) {
      view = this.getCampaignGameSlotActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN || this.activity.type === ACTIVITY_TYPE_BETTING_PIC) {
      view = this.getCampaignGameGreedySpinNBettingPicActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE) {
      view = this.getCampaignGameRouletteActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER || this.activity.type === ACTIVITY_TYPE_BRAND_RACE) {
      view = this.getCampaignGameSpinDiscoverBrandRaceActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_FLIP_CARD || this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN || this.activity.type === ACTIVITY_TYPE_MATCHING_PIC) {
      view = this.getCampaignGameFlipCardActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_MATCH_THREE) {
      view = this.getCampaignGameMatchThreeActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE) {
      view = this.getCampaignGameWhacAMoleActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE) {
      view = this.getCampaignGameTicTacToeActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_POKER) {
      view = this.getCampaignGamePokerActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_PUZZLE || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE) {
      view = this.getCampaignGamePuzzleActionView(gameOtherInfo);
    }
    else if (this.activity.type === ACTIVITY_TYPE_SLIDES || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU) {
      view = this.getCampaignGameSlidesActionView(gameOtherInfo);
    }
    if (!view) {
      return null;
    }

    return (
      <React.Fragment>
        {view}
        {this.activity.inQuestion && this.activity.inQuestion.isUserActionable ? this.getInternalQuestionView(gameOtherInfo) : null}
      </React.Fragment>
    );
  }

  getPredictionResultSummaryView = () => {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const fontSize = uiConfigs.fontSize;
    let leftValue = this.activity.ratersCount/this.activity.actionsCount*100;
    let rightValue = this.activity.commentsCount/this.activity.actionsCount*100;
    if (this.props.inPreview) {
      leftValue = (this.guess1 > this.guess2 ? 1 : 0) *100;
      rightValue = (this.guess2 > this.guess1 ? 1 : 0) *100;
    }
    const centerValue = 100 - leftValue - rightValue;
    const colorLeft = '#66fcc2';
    const colorRight = 'rgb(255,143,0)';
    const colorCenter = 'rgb(135,148,86)';
    const textShadowStyle = '0px 0px 2px #282828';
    return (
      <div className={classes.viewColumnFullWidth} style={{margin: 8, marginTop: 40, marginBottom: 80}}>
        <div className={classes.viewRowFullWidthNoCenter} style={{alignItems: 'flex-end'}}>
          <div className={classes.viewColumn} style={{marginBottom: 4}}>
            <div className={classes.viewRow} style={{borderRadius: RadiusView, marginBottom: 12}}>
              {this.activity.imageUrl1 ? <AppImage imageUrl={this.activity.imageUrl1} resizeMode={'contain'} style={{width: 40, height: 40, borderRadius: 4}}/> : null}
              <AppText fontSizeN={fontSize} variant={'body1'} color={ColorWhite} align={'left'} style={{paddingLeft: 6, paddingRight: 6}}>{this.activity.value1Placeholder}</AppText>
            </div>
            <AppText fontSizeN={fontSize} variant={'h6'} color={colorLeft} align={'left'} fontWeight={FontWeightMedium} style={{textShadow: textShadowStyle}}><FormattedMessage id={'activity.valuePercent'} values={{value: ValueHelper.getDisplayValue(leftValue, leftValue < 10 ? 1 : 0)}}/></AppText>
          </div>
          {this.activity.value2Placeholder ?
            <React.Fragment>
              <div className={classes.flex1} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8}}>
                <AppText fontSizeN={fontSize} variant={'caption'} color={ColorWhite} align={'center'} fontWeight={FontWeightMedium} style={{backgroundColor: colorCenter, paddingLeft: 4, paddingRight: 4, borderRadius: 4}}><FormattedMessage id={'activity.predictionDrawValue'} values={{value: ValueHelper.getDisplayValue(centerValue, centerValue < 10 ? 1 : 0)}} /></AppText>
              </div>
              <div className={classes.viewColumn} style={{marginBottom: 4}}>
                <div className={classes.viewRow} style={{borderRadius: RadiusView, marginBottom: 12}}>
                  <AppText fontSizeN={fontSize} variant={'body1'} color={ColorWhite} align={'right'} style={{paddingLeft: 6, paddingRight: 6}}>{this.activity.value2Placeholder}</AppText>
                  {this.activity.imageUrl2 ? <AppImage imageUrl={this.activity.imageUrl2} resizeMode={'contain'} style={{width: 40, height: 40, borderRadius: 4}}/> : null}
                </div>
                <AppText fontSizeN={fontSize} variant={'h6'} color={colorRight} align={'right'} fontWeight={FontWeightMedium} style={{textShadow: textShadowStyle}}><FormattedMessage id={'activity.valuePercent'} values={{value: ValueHelper.getDisplayValue(rightValue, rightValue < 10 ? 1 : 0)}}/></AppText>
              </div>
            </React.Fragment>
            : null
          }
        </div>
        <div className={classes.viewRowFullWidth} style={{position: 'relative', overflow: 'hidden', borderRadius: 4, height: 20, borderWidth: 0, borderStyle: 'solid', borderColor: colorWithAlpha(ColorWhite, 0.6)}}>
          <div style={{backgroundColor: colorLeft, width: leftValue+'%', minWidth: 2, height: 18}}/>
          <div className={classes.flex1} style={{backgroundColor: colorCenter, height: 18}}/>
          <div style={{backgroundColor: colorRight, width: rightValue+'%', minWidth: 2, height: 18}}/>
        </div>
      </div>
    );
  }

  getCampaignGamePredictionActionView(gameOtherInfo) {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const isLTR = this.props.isLTR;
    const isUserActionable = this.activity.isUserActionable || this.activity.isUserActionableA;

    let showInline = true;
    if (this.activity.userWon || this.props.isGuestUser) {
      showInline = false;
    }
    gameOtherInfo.showInline = showInline;

    const canShowResults = !this.props.readOnly && this.guess1 && (this.activity.showAnswers || this.props.inPreview);
    const hideGameStatus = this.activity.isUserActionable;
    let viewShowResults = null;
    if (canShowResults) {
      viewShowResults = (
        <View style={{flexDirection: 'row', justifyContent: 'center'}}>
          {this.getImageActionButton(() => {
            this.showSimpleOverlayView({
              title: locString('activity.resultProbability'),
              positiveActionText: locString('close'),
              subView: this.getPredictionResultSummaryView(),
              showInCenter: this.shouldShowInCenter(),
            });
          }, locString('activity.resultProbability'), 280)}
        </View>
      );
    }

    const canEdit = !this.activity.isUserActionable && this.activity.isUserActionableA && !this.state.canEditPrediction;
    const styleBlur = !hideGameStatus && !showInline ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{width: '100%', minHeight: Math.min(600, this.contentHeight)}}>
        <View style={{...styleBlur}}>
          {!this.activity.subType ?
            <GetPredictWinnerActionView
              classes={this.props.classes}
              uiConfigs={uiConfigs}
              isLTR={isLTR}
              intl={this.context.intl}
              contentWidth={this.props.width}
              title={this.activity.qTitle}
              value1Placeholder={this.activity.value1Placeholder}
              value2Placeholder={this.activity.value2Placeholder}
              imageUrl1={this.activity.imageUrl1}
              imageUrl2={this.activity.imageUrl2}
              guess1={this.guess1}
              guess2={this.guess2}
              canMakeAction={isUserActionable}
              onChangePredictionSelector={this.onChangePredictionSelector}
              onImageFSClicked={this.onImageFSClicked}
            /> : <GetPredictionActionView
              uiConfigs={uiConfigs}
              isLTR={isLTR}
              contentWidth={this.props.width}
              title={this.activity.qTitle}
              value1Placeholder={this.activity.value1Placeholder}
              value2Placeholder={this.activity.value2Placeholder}
              imageUrl1={this.activity.imageUrl1}
              imageUrl2={this.activity.imageUrl2}
              guess1={this.guess1}
              guess2={this.guess2}
              canMakeAction={true}
              canEdit={canEdit}
              disableAction={!this.canAnswer() && !canEdit}
              disableField={canEdit || !isUserActionable}
              onChangeGuessTextField={this.onChangeGuessTextField}
              onPredictClicked={this.onPredictClicked}
              onImageFSClicked={this.onImageFSClicked}
            />
          }
        </View>
        {viewShowResults}
        {!hideGameStatus ? showInline ? this.getGameActionOtherView(gameOtherInfo) :
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, null)}
          </div>
          : null
        }
      </View>
    );
  }

  onChangePredictionSelector = (resultValue) => {
    let guess1 = null;
    let guess2 = null;
    if (resultValue) {
      if (resultValue === 3) {
        guess1 = '1';
        guess2 = '2';
      } else if (resultValue === 2) {
        guess1 = '2';
        guess2 = '1';
      } else {
        guess1 = '1';
        guess2 = '1';
      }
    }
    // show dialog to update guess
    this.showSimpleOverlayView({
      showInCenter: true,
      title: locString('activity.confirmPrediction'),
      positiveActionText: locString('yes'),
      negativeActionText: locString('no'),
      onPositiveClicked: () => {
        this.guess1 = guess1;
        this.guess2 = guess2;
        this.onPredictClicked();
      },
    });
  }

  onChangeGuessTextField = (event) => {
    let value = event.target.value;
    if (event.target.name === 'guess1'
      || event.target.name === 'guess2') {
      let valueMax = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = '0';
      } else if (ValueHelper.getEnglishValue(value) > valueMax) {
        value = ''+ valueMax;
      }
    }
    this[event.target.name] = value;
    this.reloadView();
  }

  getCampaignGameIdentifyLocationActionView(gameOtherInfo) {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    let isUserActionable = this.activity.isUserActionable || this.activity.isUserActionableA;

    let showInline = true;
    if (this.props.isGuestUser && !this.activity.userWon) {
      showInline = false;
    }
    gameOtherInfo.showInline = showInline;
    // if (gameOtherInfo.gameWinLimitOver) {
    //   gameOtherInfo.gameWinLimitOver = null;
    //   gameOtherInfo.actionDisabledMessage = null;
    // } else if (gameOtherInfo.gamePlayTriesOver && this.activity.winnersAt) {
    //   gameOtherInfo.actionDisabledMessage = locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
    // }

    let pickedLocation = null;
    if (this.guess1 && this.guess2) {
      pickedLocation = {
        lat: this.guess1,
        lng: this.guess2
      };
    }
    let actualLocation = null;
    if (!this.props.inPreview && this.activity.rightOptionHint && this.activity.rightOptionHint > 0
      && this.activity.rightOptionHintAr && this.activity.rightOptionHintAr > 0) {
      actualLocation = {
        lat: this.activity.rightOptionHint,
        lng: this.activity.rightOptionHintAr
      };
    }

    const title = this.activity.qTitle || locString('identifyLocationForThePlace');
    const gameImagesWidthPercent = 0.75;
    const maxWidth = this.props.width;
    const imageSize = Math.min(400 * sizeFactor, (maxWidth * gameImagesWidthPercent));
    let isLocationPicked = false;
    let viewReadOnlyMap = null;
    if (pickedLocation || actualLocation) {
      isLocationPicked = true;
      const markers = [];
      if (pickedLocation) {
        markers.push({label: locStringA(this.context.intl, 'location.marked'), position: pickedLocation});
      }
      if (actualLocation) {
        markers.push({label: '✓', position: actualLocation});
      }
      viewReadOnlyMap = (
        <View
          style={{position: 'relative', height: 180 * sizeFactor, marginBottom: this.activity.userWon ? 8 * sizeFactor : 0}}>
          <View style={{position: 'relative'}}>
            <MapField
              readOnly={true}
              width={this.props.width}
              height={180 * sizeFactor}
              isLTR={this.props.isLTR}
              classes={this.props.classes}
              center={pickedLocation ? pickedLocation : actualLocation}
              onCenterChanged={() => {}}
              markers={markers}
            />
          </View>
          <TouchableOpacity
            onClick={this.openPickLocationDialog}
            style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}/>
        </View>
      );
    }
    if (gameOtherInfo.rewardsWonView != null && !this.props.isGuestUser && viewReadOnlyMap) {
      gameOtherInfo.rewardsWonView = (
        <View>
          {gameOtherInfo.rewardsWonView}
          {viewReadOnlyMap}
        </View>
      );
    }

    const actionIconWidth = (isLocationPicked ? 60 : 100) * sizeFactor;
    const actionIconHeight = (isLocationPicked ? 80 : 132) * sizeFactor;
    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus && !showInline ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {gameOtherInfo.showGame ?
          <View style={{marginLeft: 0, marginRight: 0, marginBottom: 6, alignItems: 'center', ...styleBlur}}>
            <View style={{width: '100%', maxWidth: maxWidth}}>
              <View style={{alignItems: 'center'}}>
                <FullWidthDummyView/>
                <ImageBackground source={uiConfigs.gameBgImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />
                {this.activity.imageUrl1 ?
                  <ImageBackground source={uiConfigs.mediaBgImage} resizeMode={'fill'} style={{flex: gameImagesWidthPercent, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 2, marginTop: 8, padding: 12 * sizeFactor, paddingTop: 8 * sizeFactor, paddingBottom: 16 * sizeFactor}} >
                    <TouchableOpacity onClick={() => {
                      this.onImageFSClicked(this.activity.imageUrl1);
                    }}>
                      <AppImage imageUrl={this.activity.imageUrl1} style={{width: imageSize, height: imageSize/16*9, borderRadius: RadiusView}}/>
                    </TouchableOpacity>
                  </ImageBackground>
                  : null
                }
                <ImageBackground source={uiConfigs.gameTextBgImage} resizeMode={'fill'} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: 4, marginRight: 4, marginBottom: 4, padding: 8 * sizeFactor, paddingLeft: 12 * sizeFactor, paddingRight: 12 * sizeFactor}} >
                  <AppText
                    fontSizeN={uiConfigs.fontSize}
                    variant={'body2'}
                    style={{
                      position: 'relative',
                      color: uiConfigs.gameValueTextColor,
                      fontWeight: FontWeightMedium,
                      textAlign: 'center'}}>
                    {title}
                  </AppText>
                </ImageBackground>
              </View>

              {viewReadOnlyMap}
              {/*{!this.activity.userNotWon && !actualLocation ?*/}
              {isUserActionable ?
                <View style={{flexDirection: 'row', justifyContent: 'center', marginTop: -4 * sizeFactor}}>
                  <AppImageButtonEx
                    disabled={!isUserActionable}
                    imageStyle={{width: actionIconWidth, height: actionIconHeight}}
                    titleStyle={{color: uiConfigs.actionTitleColor}}
                    onClick={this.openPickLocationDialog}
                    imageSource={uiConfigs.playImage} />
                </View>
                : null
              }
            </View>
          </View>
          : null
        }
        {!hideGameStatus ? showInline ? this.getGameActionOtherView(gameOtherInfo) :
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
              {this.getGameActionOtherView(gameOtherInfo)}
            </div>
          : null
        }
      </View>
    );
  }

  getPickLocationDialogContentView = () => {
    const {classes, isLTR, isXS, windowWidth, windowHeight} = this.props;
    const width = Math.min(500, Math.min(windowWidth - 48, windowHeight - 440));
    const height = width + MAP_EXTRA_HEIGHT;
    let actualLocation = null;
    if (!this.props.inPreview && this.activity.rightOptionHint && this.activity.rightOptionHint > 0
      && this.activity.rightOptionHintAr && this.activity.rightOptionHintAr > 0) {
      actualLocation = {
        lat: this.activity.rightOptionHint,
        lng: this.activity.rightOptionHintAr
      };
    }
    let pickedLocation = null;
    if (this.guess1 && this.guess2) {
      pickedLocation = {
        lat: this.guess1,
        lng: this.guess2
      };
    }
    let center = null;
    if (pickedLocation) {
      center = pickedLocation;
    } else if (actualLocation) {
      center = actualLocation;
    } else if (this.activity.startLocation) {
      center = {
        lat: this.activity.startLocation.latitude,
        lng: this.activity.startLocation.longitude
      };
    }
    let isReadOnly = false;
    let markers = null;
    if (!this.activity.isUserActionable && !this.activity.isUserActionableA) {
      isReadOnly = true;
      markers = [];
      if (pickedLocation) {
        markers.push({label: locStringA(this.context.intl, 'location.marked'), name: this.context.intl.formatMessage({id: 'activity.pickedLocation'}), position: pickedLocation});
      }
      if (actualLocation) {
        markers.push({label: '✓', name: this.context.intl.formatMessage({id: 'activity.correctLocation'}), position: actualLocation});
      }
    }
    let isLocationZoomCorrect = false;
    if (this.pickedLocation) {
      isLocationZoomCorrect = this.pickedLocation.zoom >= ZOOM_COARSE_LOCATION;
    }
    return (
      <div className={classes.viewColumn} style={{minWidth: width, minHeight: height}}>
        {!isReadOnly ?
          <div style={{marginBottom: 4}}>
            <TextView textAlign={'center'} variant={'body2'} color={ColorSubTitle}>{this.context.intl.formatMessage({id: 'activity.manage.hintSelectGeofence'})}</TextView>
          </div>
          : null
        }
        <MapField
          styleMapContainer={{paddingLeft: isXS ? 0 : 8, paddingRight: isXS ? 0 : 8}}
          readOnly={isReadOnly}
          markers={markers}
          isLTR={isLTR}
          classes={classes}
          width={width}
          center={center}
          onCenterChanged={this.onPickLocationMapChanged}
        />
        {!isReadOnly && this.pickedLocation ?
          <div style={{marginBottom: 4, marginLeft: 8, marginRight: 8}}>
            <TextView textAlign={'center'} variant={'body2'} color={isLocationZoomCorrect ? ColorGreen : ColorNegative}>{this.context.intl.formatMessage({id: isLocationZoomCorrect ? 'location.pickLocationGoodToGo' : 'location.zoomInMapToPickLocation'})}</TextView>
          </div>
          : null
        }
      </div>
    );
  }

  onPickLocationMapChanged = (data) => {
    if (data) {
      const latitude = data.center.lat;
      const longitude = data.center.lng;
      const zoom = data.zoom;
      this.pickedLocation = {latitude, longitude, zoom};
    } else {
      this.pickedLocation = null;
    }
    this.reloadView();
  };

  openPickLocationDialog = () => {
    if (this.props.noActionMode || this.props.readOnly) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    const canEdit = this.activity.isUserActionable || this.activity.isUserActionableA;
    const dialogInfo = {
      title: this.context.intl.formatMessage({id: canEdit ? 'activity.selectLocation' : 'activity.location'}),
      renderContent: this.getPickLocationDialogContentView,
      positiveText: this.context.intl.formatMessage({id: canEdit ? 'generic.save' : 'generic.ok'}),
      onPositiveClicked: this.onLocationPicked.bind(this),
      neutralText: canEdit ? this.context.intl.formatMessage({id: 'generic.cancel'}) : null,
      onNeutralClicked: this.hideDialog
    };
    this.showDialog(dialogInfo);
  }

  onLocationPicked = () => {
    const canEdit = this.activity.isUserActionable || this.activity.isUserActionableA;
    if (canEdit) {
      if (this.pickedLocation && this.pickedLocation.zoom < ZOOM_COARSE_LOCATION) {
        this.showSnackbar({
          snackbarMessageId: 'location.zoomInMapToPickLocation',
          snackbarType: 'error'
        });
        return;
      }

      if (this.pickedLocation) {
        this.guess1 = this.pickedLocation.latitude;
        this.guess2 = this.pickedLocation.longitude;
        this.pickedLocation = null;

        if (this.canAnswer()) {
          this.playGamePlayAudioInline();
          this.makeApiForIdentifyLocation();
        } else {
          this.reloadView();
        }
      } else {
        this.guess1 = null;
        this.guess2 = null;
        this.reloadView();
      }
    } else {
      this.pickedLocation = null;
    }
    this.hideDialog();
  }

  onLocationReset = () => {
    this.guess1 = null;
    this.guess2 = null;
    this.pickedLocation = null;
    this.reloadView();
  }

  getCampaignOpinionActionView(gameOtherInfo) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    if (this.activity.userRating > 0 || this.activity.noActionMessage) {
      gameOtherInfo.showGame = false;
    }
    gameOtherInfo.showInline = true;

    const canMakeAction = this.activity.isUserActionable && !this.props.noActionMode && !this.props.readOnly;
    const showQuestion = !this.activity.userWon;
    const imageUrl = this.activity.imageUrl1;
    const effWidth = this.props.width;

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(1px)'} : null;
    // const styleBlur = null;
    return (
      <View className={classes.viewColumnFullWidth} style={{maxWidth: effWidth}}>
        {showQuestion ?
          <View style={{position: 'relative', marginLeft: 2, marginRight: 2, ...styleBlur}}>
            <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
              <AppImage source={uiConfigs.gameBgQTopImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, left: 0, right: 0, width: '100%', height: 38 * sizeFactor}}/>
              <AppImage source={uiConfigs.gameBgQMiddleImage} resizeMode={'fill'} style={{position: 'absolute', paddingTop: 38 * sizeFactor, paddingBottom: 10 * sizeFactor, left: 0, right: 0, width: '100%', height: '100%'}}/>
              {/*<AppImage source={uiConfigs.gameBgQBottomImage} resizeMode={'fill'} style={{position: 'absolute', bottom: 0, left: 0, right: 0, width: '100%', height: 10 * sizeFactor}}/>*/}
            </View>
            <FullWidthDummyView/>
            <View style={{position: 'relative', marginTop: 8 * sizeFactor, marginLeft: 8 * sizeFactor, marginRight: 8 * sizeFactor, marginBottom: 14 * sizeFactor, minHeight: 36 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
              {imageUrl ?
                <View style={{width: '100%', alignSelf: 'center', marginBottom: 6 * sizeFactor, marginTop: -2 * sizeFactor}}>
                  {/*<ImageBackground source={uiConfigs.mediaBgImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />*/}
                  <View style={{padding: 6 * sizeFactor, overflow: 'hidden'}}>
                    <TouchableOpacity
                      onClick={() => {
                        this.onImageFSClicked(imageUrl);
                      }}>
                      <AppImage
                        resizeMode={'contain'}
                        style={{width: '100%', aspectRatio: 16/9, borderRadius: 12, maxHeight: this.props.width/16*9}}
                        imageUrl={imageUrl}
                      />
                    </TouchableOpacity>
                  </View>
                </View>
                : null
              }
              <AppText variant={'subtitle1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.titleColor, align: 'center', marginBottom: 12, marginLeft: 12, marginRight: 12}}>{this.activity.qTitle || <FormattedMessage id={'activity.opinionDefaultQ'}/>}</AppText>
            </View>
          </View>
          : null
        }

        {!hideGameStatus ? this.getGameActionOtherView(gameOtherInfo) : null}
        {gameOtherInfo.showGame ?
          <div className={classes.viewColumnFullWidthNoCenter1} style={{opacity: canMakeAction ? 1 : 0.9, position: 'relative'}}>
            {this.getAddReviewView()}
            {!canMakeAction ?
              this.props.noActionMode || this.props.readOnly ?
              <TouchableOpacity onClick={this.props.onActionClickedInNoActionMode} style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 1}}/>
              : <div style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0}}/>
              : null
            }
          </div>
          : null
        }
      </View>
    );
  }

  getAddReviewView = () => {
    const {classes, isXS} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const subView = ActivityHelper.getAddPostView(this.activity, this.props.showcaseId, this.getUIConfigs(), isXS ? 300 : 340, this.props.width - 4, this.props.inPreview, this.props.isXS,null, this.activity.contentTypes, (data) => {
      if (data) {
        if (this.props.inPreview) {
          this.activity.isUserActionable = false;
          this.activity.isUserResetable = true;
          this.activity.userRating = data.post.rating;
          if (this.activity.videoUrl || this.activity.s2ImageUrl || this.activity.s2Link) {
            this.activity.showEnd = true;
            this.activity.showEndAfter = 1000;
          }
          if (this.activity.inQuestion) {
            this.activity.inQuestion.isUserActionable = true;
          }
        } else {
          this.activity.isUserActionable = data.activity.isUserActionable;
          this.activity.userRating = data.activity.userRating;
          this.activity.showEnd = data.activity.showEnd;
          this.activity.showEndAfter = data.activity.showEndAfter;
          this.activity.inQuestion = data.activity.inQuestion;
          this.activity.inQuestion.isUserActionable = data.activity.inQuestion.isUserActionable;
        }
        this.showToast(this.context.intl.formatMessage({id: 'activity.feedbackPosted'}));
        this.updateAndReload();
      }
    });
    const paddingSide = Math.max(0, uiConfigs.infoViewContentHorizontalMargin * sizeFactor - SpaceNormal);
    return (
      <View className={classes.viewColumnFullWidthNoCenter1} style={{padding: 6 * sizeFactor, paddingLeft: paddingSide, paddingRight: paddingSide}}>
        <View className={classes.viewColumnFullWidth} style={{backgroundColor: uiConfigs.messageBgColor, border: '2px solid '+ uiConfigs.messageBorderColor, borderRadius: 6}}>
          {subView}
        </View>
      </View>
    );
  }

  getCampaignQuestionActionView(activity, gameOtherInfo) {
    const {classes, locale} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    gameOtherInfo.showInline = true;

    const showQuestion = !activity.userWon;
    const questionItems = activity.qOptions ? activity.qOptions : [];
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(activity.endAt);
    const canShowResults = (/*this.props.inPreview || */(!this.props.readOnly && (endDateDiff <= 0 || activity.userAnswer != 0))) && activity.showAnswers;

    const imageUrl = activity.imageUrl2;

    const optionInRow = 1;
    const effWidth = Math.min(this.props.width, this.props.height);
    const imageWidth = this.props.width - 62 * sizeFactor;
    const gameBgQTopImage = !activity.isInternal ? uiConfigs.gameBgQTopImage : null;
    const gameBgQMidImage = !activity.isInternal ? uiConfigs.gameBgQMiddleImage : null;
    const gameBgQBottomImage = !activity.isInternal ? uiConfigs.gameBgQBottomImage : null;
    const hasGameBgImage = gameBgQTopImage && gameBgQMidImage && gameBgQBottomImage;
    const imageExtraPadding = hasGameBgImage ? 8 : 0;
    const gameBgImage = !activity.isInternal ? uiConfigs.gameBgImage : null;
    const gameItemImage = !activity.isInternal ? uiConfigs.cardBgImage : null;
    const gameBgQTopImageHeight = activity.isInternal ? uiConfigs.infoViewTopHeight : 38;
    const gameBgQBottomImageHeight = activity.isInternal ? uiConfigs.infoViewBottomHeight : 10;
    const gameMarginLeft = activity.isInternal ? 8 : 2;
    const gameMarginRight = activity.isInternal ? 8 : 2;
    const gameImageMarginLeft = activity.isInternal ? 12 : 26;
    const gameImageMarginRight = activity.isInternal ? 12 : 26;
    const gameItemMarginLeft = activity.isInternal ? 6 : 22;
    const gameItemMarginRight = activity.isInternal ? 6 : 22;

    let showResultsView = null;
    if (canShowResults) {
      showResultsView = (
        <View style={{flexDirection: 'row', justifyContent: 'center', marginTop: 12 * sizeFactor}}>
          {this.getImageActionButton(() => {
            let previewData = null;
            if (this.props.inPreview) {
              let totalAnswers = 0;
              const options = cloneDeep(activity.qOptions);
              options.forEach((option) => {
                option.answers = 0;
                option.percentage = 0;
                if (option.id === activity.userAnswer) {
                  option.answers = 1;
                  option.percentage = 100;
                  totalAnswers++;
                }
              });
              previewData = {
                totalAnswers: totalAnswers,
                answers: options,
              };
            }
            this.showSimpleOverlayView({
              positiveActionText: locString('close'),
              subView: ActivityHelper.getAnswerDistributionsView(activity, true, uiConfigs, this.getBottomSimpleOverlayContentViewHeight(false, true), this.props.readOnly, previewData)
            });
          }, locString('showResults'))}
        </View>
      );
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(2px)'} : null;
    return (
      <View style={{flexDirection: 'row', justifyContent: 'center'}}>
        <View style={{flex: 1, maxWidth: effWidth}}>
          {activity.nextId ?
            <div style={{display: 'flex', flex: 1, marginBottom: 3*sizeFactor, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColorDark, 0.9) +','+ colorWithAlpha(uiConfigs.themeColorDark, 0.1)}}>
              <div className={classes.viewRowFullWidth} style={{paddingLeft: 8*sizeFactor, paddingRight: 8*sizeFactor}}>
                <TouchableOpacity onClick={this.onSponsorClicked}>
                  <div style={{minWidth: 60 * sizeFactor}}>
                    <AppImage imageUrl={this.activity.business.imageUrl} style={{width: 40 * sizeFactor, height: 40 * sizeFactor, borderRadius: uiConfigs.businessIconBorderRadius}} />
                  </div>
                </TouchableOpacity>
                <div className={classes.viewColumnFullWidth} style={{margin: 2 * sizeFactor}}>
                  {this.getTextView(this.context.intl.formatMessage({id: 'campaign.answerToContinue'}))}
                </div>
                {!this.props.playInShowcase && !this.props.inPreview ?
                  <GetActionButton
                    size={'small'}
                    textVariant={'body2'}
                    uiConfigs={uiConfigs}
                    onClick={this.props.onChangeLocaleClicked}
                    title={locale === 'en' ? 'عربى' : 'ENG'}
                    style={{minWidth: 60 * sizeFactor}}
                  />
                  : <div style={{minWidth: 60 * sizeFactor}}/>
                }
              </div>
            </div>
            : null
          }
          {showQuestion ?
            <View style={{position: 'relative', marginLeft: gameMarginLeft * sizeFactor, marginRight: gameMarginRight * sizeFactor}}>
              {hasGameBgImage ?
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                  <AppImage source={gameBgQTopImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, left: 0, right: 0, width: '100%', height: gameBgQTopImageHeight * sizeFactor}}/>
                  <AppImage source={gameBgQMidImage} resizeMode={'fill'} style={{position: 'absolute', paddingTop: gameBgQTopImageHeight * sizeFactor, paddingBottom: gameBgQBottomImageHeight * sizeFactor, left: 0, right: 0, width: '100%', height: '100%'}}/>
                  <AppImage source={gameBgQBottomImage} resizeMode={'fill'} style={{position: 'absolute', bottom: 0, left: 0, right: 0, width: '100%', height: gameBgQBottomImageHeight * sizeFactor}}/>
                </View>
                : <Paper elevation={1} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: colorWithAlpha(uiConfigs.messageBgColor,0.9), borderRadius: BORDER_RADIUS, borderWidth: 4, borderStyle: 'solid', borderColor: uiConfigs.messageBorderColor}}/>
              }
              <FullWidthDummyView/>
              <View style={{position: 'relative', marginTop: 12 * sizeFactor, marginLeft: gameImageMarginLeft * sizeFactor, marginRight: gameImageMarginRight * sizeFactor, marginBottom: 14 * sizeFactor, minHeight: 36 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
                {imageUrl ?
                  <View style={{width: '100%', alignSelf: 'center', marginBottom: 6 * sizeFactor, marginTop: -2 * sizeFactor}}>
                    {/*<ImageBackground source={uiConfigs.mediaBgImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />*/}
                    <View style={{overflow: 'hidden', marginLeft: imageExtraPadding*sizeFactor, marginRight: imageExtraPadding*sizeFactor}}>
                      <TouchableOpacity
                        onClick={() => {
                          this.onImageFSClicked(imageUrl);
                        }}>
                        <AppImage
                          resizeMode={'contain'}
                          style={{width: '100%', aspectRatio: 16/9, borderRadius: BORDER_RADIUS, maxHeight: this.props.width/16*9}}
                          imageUrl={imageUrl}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                  : null
                }
                <AppText variant={'subtitle1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.titleColor, align: 'center'}}>{activity.qTitle}</AppText>
              </View>
            </View>
            : null
          }

          {gameOtherInfo.showGame ?
            <View style={{marginTop: gameBgImage ? -2 : 4*sizeFactor, marginBottom: 8*sizeFactor, position: 'relative', alignItems: 'center'}}>
              {gameBgImage ?
                <AppImage source={gameBgImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, width: '100%', height: '100%'}} />
                : null
              }
              <View style={{position: 'relative', marginTop: 2 * sizeFactor, marginLeft: gameItemMarginLeft * sizeFactor, marginRight: gameItemMarginRight * sizeFactor, marginBottom: 6 * sizeFactor, justifyContent: 'center', flexDirection: 'row', flexWrap: 'wrap'}}>
                {questionItems.map((item, index) => {
                  const marginRight = optionInRow === 1 ? 0 : (uiConfigs.isLTR ? (index % 2 === 0 ? 6 * sizeFactor : 0) : 0);
                  const marginLeft = optionInRow === 1 ? 0 : (!uiConfigs.isLTR ? (index % 2 === 0 ? 6 * sizeFactor : 0) : 0);
                  return (
                    <View style={{width: Math.floor((effWidth - ((gameMarginLeft+gameItemMarginLeft)*sizeFactor*2 + 6 * (optionInRow - 1)) * sizeFactor) / optionInRow) - 1, marginLeft: marginLeft, marginRight: marginRight, marginTop: 2 * sizeFactor}}>
                      <QuestionOptionItem
                        uiConfigs={uiConfigs}
                        bgImage={gameItemImage}
                        selectorColor={gameItemImage ? uiConfigs.gameValueTextColor : uiConfigs.titleColor}
                        titleColor={gameItemImage ? uiConfigs.gameValueTextColor : uiConfigs.titleColor}
                        id={index}
                        disabled={!activity.isUserActionable}
                        onClick={this.onQuestionItemClicked.bind(this, activity, index)}
                        name={item.name}
                        selected={this.selectedOptionIndexes.has(item.id)}/>
                    </View>
                  );
                })}
              </View>
            </View>
            : null
          }

          {!hideGameStatus && !this.activity.previewInQuestion ? this.getGameActionOtherView(gameOtherInfo, null, showResultsView) : null}
        </View>
      </View>
    );
  }

  getCampaignInnerQuestionView(activity) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const questionItems = activity.qOptions ? activity.qOptions : [];
    const imageUrl = activity.imageUrl2;

    const effWidth = this.props.width - 40 * uiConfigs.sizeFactor - 8;
    return (
      <View className={classes.viewColumn} style={{position: 'relative', backgroundColor: tinycolor(ColorBackground).setAlpha(0.9), border: '1px solid '+ ColorBackground, borderRadius: 8, padding: 6, paddingBottom: 0, paddingLeft: 8, paddingRight: 8}}>
        <FullWidthDummyView/>
        {imageUrl ?
          <TouchableOpacity
            className={classes.viewColumnFullWidth}
            style={{marginBottom: 8}}
            onClick={() => {
              this.onImageFSClicked(imageUrl);
            }}>
            <AppImage
              resizeMode={'contain'}
              style={{width: '100%', aspectRatio: 16/9, borderRadius: BORDER_RADIUS, maxHeight: this.props.width/16*9, overflow: 'hidden'}}
              imageUrl={imageUrl}
            />
          </TouchableOpacity>
          : null
        }
        <AppText variant={'subtitle1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: ColorTitle, align: 'center'}}>{activity.qTitle}</AppText>

        <View style={{marginTop: 4*sizeFactor, marginBottom: 8*sizeFactor, position: 'relative', alignItems: 'center'}}>
          <View style={{position: 'relative', margin: 4, justifyContent: 'center', flexDirection: 'row', flexWrap: 'wrap'}}>
            {questionItems.map((item, index) => {
              return (
                <View style={{width: effWidth, marginTop: 2 * sizeFactor}}>
                  <QuestionOptionItem
                    uiConfigs={uiConfigs}
                    selectorColor={uiConfigs.titleColor}
                    titleColor={uiConfigs.titleColor}
                    id={index}
                    disabled={!activity.isUserActionable}
                    onClick={this.onQuestionItemClicked.bind(this, activity, index, true)}
                    name={item.name}
                    selected={this.selectedOptionIndexes.has(item.id)}/>
                </View>
              );
            })}
          </View>
        </View>
      </View>
    );
  }

  getCampaignQuestionnaireActionView(gameOtherInfo) {
    const {isLTR, classes} = this.props;
    const isGameEnded = !this.activity.isUserActionable && (this.activity.userAnswer > 0 || this.activity.userConsumedCount >= this.activity.consumeLimitPerUser || (this.activity.gameTime > 0 && this.activity.userClickedCount >= this.activity.gameTime));
    const uiConfigs= this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const width = this.props.width;
    const otherUiHeight = (isGameEnded ? 260 : 0) * sizeFactor;
    const imageWidth = Math.min(width - 68 * sizeFactor, this.contentHeight - otherUiHeight);
    let gameTimeText = null;
    let timeLeftText = null;
    if (this.activity.gameTime > 0 && !isGameEnded) {
      gameTimeText = ActivityHelper.getGameTimeText(this.activity.gameTime);
      timeLeftText = ActivityHelper.getGameTimeText(this.activity.gameTime - this.state.questionnaireTimer);
    }

    if (this.questionnaireNumber) {
      const question = this.activity.questionnaire[this.questionnaireNumber - 1];
      return (
        <GetQuestionnaireView
          uiConfigs={uiConfigs}
          isLTR={isLTR}
          questionnaireNumber={this.questionnaireNumber}
          answerCount={this.activity.consumeLimitPerUser}
          timeLeftText={timeLeftText}
          gameTimeText={gameTimeText}
          question={question}
          selectedOption={this.questionnaireMap[question.id]}
          isUserActionable={this.activity.isUserActionable}
          width={width}
          imageWidth={imageWidth}
          onImageFSClicked={this.onImageFSClicked}
          onQuestionnaireQuestionOptionSelected={this.onQuestionnaireQuestionOptionSelected}
        />
      );
    }

    let showGame = this.activity.isUserActionable || this.activity.noActionMessage;
    let showGameInitial = false;
    let rewardsWonView = null;
    let actionDisabledMessage = null;
    let gameWinLimitOver = false;
    let gamePlayTriesOver = false;

    if (!this.activity.isUserActionable) {
      if (this.activity.userWon) {
        rewardsWonView = this.getRewardsWonView();
        showGame = false;
      } else if (this.activity.userWinEligible) {
        actionDisabledMessage = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
        showGameInitial = true;
      } else if (this.activity.userNotWon) {
        showGameInitial = true;
        actionDisabledMessage = locString('notWinningMessage');
      } else if (!this.activity.noRewards && !this.activity.winAtEnd && (this.activity.winGCount >= this.activity.winGLimit || this.activity.answeredCount >= this.activity.answerLimit)) {
        actionDisabledMessage = locString('gameWinLimitComplete');
        gameWinLimitOver = true;
      } else {
        const playTriesOver = this.getGamePlayTriesOverInfo();
        if (playTriesOver && playTriesOver.gamePlayTriesOver) {
          actionDisabledMessage = playTriesOver.gamePlayTriesOverMessage;
          gamePlayTriesOver = true;
          // showGame = true;
          showGameInitial = true;
        } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) > 0) {
          actionDisabledMessage = DateTimeHelper.getValidity(this.activity.startAt, 'campaign.startIn');
          // showGame = true;
          showGameInitial = true;
        } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) <= 0 && !this.activity.recurAt) {
          // showGame = true;
          showGameInitial = true;
          actionDisabledMessage = locString('campaignIsEnded');
        } else if (this.activity.isCodeNeeded) {
          // showGame = true;
          showGameInitial = true;
          if (!this.activity.recurAt) {
            actionDisabledMessage = locString('campaignIsEnded');
          }
        }
      }
    } else {
      showGame = true;
      showGameInitial = true;
    }
    const answerCount = this.activity.consumeLimitPerUser;
    const answeredCount = this.activity.questionnaireAnswers ? 1 : 0;
    const correctAnswerCount = ''+ this.activity.userAnswer;

    if (!this.activity.userWon && this.activity.type === constants.activity.types.SURVEY) {
      gameOtherInfo.showInline = true;
    }

    let scoreView = null;
    if (this.activity.type === constants.activity.types.QUESTIONNAIRE && gameOtherInfo.showScore) {
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 12}}>
          <AppText variant={'body1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.titleColor, textAlign: 'center'}}>{locString('correctAnswers')}</AppText>
          <AppText variant={'body1'} fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightBold, color: uiConfigs.subTitle, textAlign: 'center', marginTop: 2 * sizeFactor}}>{locString('correctAnswersValue', {value1: correctAnswerCount, value2: answerCount, value3: Math.ceil(correctAnswerCount/answerCount*100)})}</AppText>
        </div>
      )
    }

    const hideGameStatus = this.activity.isUserActionable;
    let styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    if (this.activity.type === constants.activity.types.SURVEY) {
      styleBlur = null;
    }
    const hideView = this.activity.type === constants.activity.types.SURVEY && this.activity.userWon;
    return (
      <View style={{minHeight: this.contentHeight - 160 * sizeFactor}}>
        {!hideView ?
          <View style={styleBlur}>
            <GetQuestionnaireInitialView
              activityType={this.activity.type}
              uiConfigs={uiConfigs}
              answerCount={answerCount}
              answeredCount={answeredCount}
              correctAnswerCount={correctAnswerCount}
              winnersBy={this.activity.winnersBy}
              winnersByValue={this.activity.winnersByValue}
              gameTimeText={gameTimeText}
              imageUrl={this.activity.imageUrl2}
              imageWidth={imageWidth}
              onImageFSClicked={this.onImageFSClicked}
              onActionClicked={this.startQuestionnaire}
              isGameEnded={isGameEnded}
              title={this.activity.qTitle}
              showGameInitial={true}
              showGameAction={showGame}
              isUserActionable={this.activity.isUserActionable && this.activity.questionnaire && this.activity.questionnaire.length > 0}
            />
          </View>
          : null
        }
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, scoreView)}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignOfferActionView() {
    const {classes} = this.props;

    let voucher = null;
    if (this.activity.isVoucher && this.activity.userAnswer > 0 && this.activity.userValue2 > 0 && this.activity.userValueObjs && this.activity.userValueObjs.length > 0) {
      voucher = this.activity.userValueObjs[0];
    }

    let validity = null;
    let validityMessage = null;
    let consumeMessage = null;
    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt);
    if (startDateDiff <= 0) {
      const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt);
      validity = DateTimeHelper.getValidity(this.activity.endAt);
      if (endDateDiff <= 0) {
        validityMessage = locString('offerExpired');
        consumeMessage = validityMessage;
      } else {
        validityMessage = locString('validityMessage', null, this.context.intl);
        consumeMessage = validityMessage +" "+ validity;
      }
    } else {
      validity = DateTimeHelper.getValidity(this.activity.startAt);
      validityMessage = locString('validityFutureMessage', null, this.context.intl);
      consumeMessage = validityMessage +" "+ validity;
    }
    if (!this.activity.isUserLConsumable) {
      consumeMessage = locString('consumedOfferAllLimit');
    }

    let actionTitle = null;
    if (this.activity.isVoucher) {
      if (this.activity.userAnswer > 0) {
        actionTitle = locString('generateNewVoucherCode');
      } else {
        actionTitle = locString('generateVoucherCode');
      }
    } else {
      actionTitle = locString('promptGenerateOfferCode')
    }
    return (
      <View className={classes.viewColumnFullWidth} >
        {voucher ? this.getVoucherCodeView(voucher.imageUrl, null, voucher.code, voucher.pin, locString('pin'), locString('generatedVoucherCode')) : null}
        {this.activity.isUserSConsumable /*|| this.activity.isUserOConsumable*/ ?
          <View className={classes.viewColumnFullWidth}>
            {this.activity.isUserSConsumable ?
              this.activity.userValueText ?
                this.getVoucherCodeView(null, this.activity.offerRedeemQRData, this.activity.userValueText, this.props.userRab7Number, locString('rab7Number'), locString('generatedOfferCode'), locString('shareGenerateOfferCodeMessage'), false)
                : <View style={{flexDirection: 'row', margin: SpaceSmall}}>
                  <View style={{flex: 1, marginRight: this.activity.isUserOConsumable ? SpaceXSmall : 0}}>
                    <Button
                      variant={"contained"}
                      size={"large"}
                      color={'primary'}
                      disabled={!this.activity.isUserConsumable}
                      onClick={this.onConsumeInStoreClicked}>
                      {actionTitle}
                    </Button>
                  </View>
                </View>
              : null
            }
            {/*{this.activity.isUserOConsumable ?*/}
            {/*    <View style={{flex: 1}}>*/}
            {/*        <AppButtonEx*/}
            {/*            disabled={!this.activity.isUserConsumable}*/}
            {/*            style={{borderRadius: HeightElementMinimum / 2}}*/}
            {/*            color={ColorSecondary}*/}
            {/*            titleColor={ColorWhite}*/}
            {/*            title={this.activity.type == ACTIVITY_TYPE_OFFER ? locString('addToBasket') : locString('applyToBasket')}*/}
            {/*            onClick={this.onConsumeInCartClicked}/>*/}
            {/*    </View>*/}
            {/*    : null*/}
            {/*}*/}
            {this.activity.noActionMessage ? this.getNoActionMessageViewEx() : null}
          </View>
          : null
        }
        {!voucher ?
          !this.activity.isUserConsumable && (this.activity.userConsumedCount === this.activity.consumeLimitPerUser) ?
            this.getTextView(locString('consumedOfferLimit'))
            : !this.activity.isUserSConsumable && !this.activity.isUserOConsumable ?
            this.getTextView(consumeMessage)
            : null
          : null
        }
        {!this.activity.isUserConsumable && this.activity.onlyBirthday ?
          this.getTextView(locString('consumableOnBirthday'))
          : null
        }
      </View>
    );
  }

  getVoucherCodeView(imageUrl, qrData, code, pin, pinText, title, message = null, canCopy = true) {
    const {classes, isXS} = this.props;
    const imageSize = this.props.width - 96;
    const qrSize = isXS ? 180 : 200;
    return (
      <View className={classes.viewColumnFullWidth}>
        <View className={classes.viewColumnFullWidth} style={{minWidth: isXS ? 260 : 320, margin: SpaceXSmall, marginTop: 0, marginBottom: this.activity.isUserSConsumable ? 20 : 10, borderRadius: RadiusView, borderWidth: 2, borderColor: ColorTitle, borderStyle: 'dashed', padding: SpaceXSmall, paddingLeft: SpaceNormal, paddingRight: SpaceNormal, alignItems: 'center', backgroundColor: ColorBackground}}>
          <AppTextWrapper style={{fontSize: FontSizeNormal, fontWeight: FontWeightRegular, color: ColorTitle, marginBottom: SpaceXSmall}}>
            {title}
          </AppTextWrapper>
          {qrData ?
            <View className={classes.viewColumn} style={{marginTop: SpaceXSmall, marginBottom: SpaceSmall}}>
              <div style={{height: "auto", maxWidth: qrSize, width: "100%"}}>
                <QRCode
                  id={'QRCodeShare'}
                  size={qrSize}
                  style={{height: "auto", maxWidth: "100%", width: "100%"}}
                  value={qrData}
                  viewBox={`0 0 ${qrSize} ${qrSize}`}
                  level={'M'}
                />
              </div>
            </View>
            : null
          }
          {imageUrl ?
            <View style={{
              width: imageSize,
              marginTop: SpaceXSmall,
              marginBottom: SpaceSmall}}>
              <TouchableOpacity onClick={() => {
                // ImageScreen.navigateTo(this.props.navigation,[imageUrl])
              }}>
                <AppImage
                  style={{width: imageSize, height: imageSize, backgroundColor: ColorWhite, borderColor: ColorWhite, borderWidth: 1, borderRadius: RadiusViewList}}
                  imageUrl={imageUrl}
                />
              </TouchableOpacity>
            </View>
            : null
          }
          {code ?
            <View style={{flexDirection: 'row'}}>
              <AppTextWrapper variant={'body1'} wrapperStyle={{minWidth: 54}} style={{fontWeight: FontWeightRegular, color: ColorTitle}}>
                {locString('code')}
              </AppTextWrapper>
              <Space verticalSpace={1} />
              <AppTextWrapper variant={'body1'} wrapperStyle={{maxWidth: this.props.width - 124}} style={{fontWeight: FontWeightMedium, color: ColorTitle}}>
                {code}
              </AppTextWrapper>
              {canCopy ?
                <Space verticalSpace={1.5} />
                : null
              }
              {canCopy ?
                <IconButton
                  size={"small"}
                  onClick={() => {
                    navigator.clipboard.writeText(code);
                    this.showToast(locString('voucherCodeCopied'));
                  }}
                  style={{margin: -4}}>
                  <AppIcon icon={IconCopy} color={ColorSubTitle} />
                </IconButton>
                : null
              }
            </View>
            : null
          }
          {pin ?
            <View style={{flexDirection: 'row'}}>
              <AppTextWrapper variant={'body1'} wrapperStyle={{minWidth: 54}} style={{fontSize: FontSizeNormal, fontWeight: FontWeightRegular, color: ColorTitle}}>
                {pinText}
              </AppTextWrapper>
              <Space verticalSpace={1.5} />
              <AppTextWrapper variant={'body1'} wrapperStyle={{maxWidth: this.props.width - 124}} style={{fontSize: FontSizeNormal, fontWeight: FontWeightMedium, color: ColorTitle}}>
                {pin}
              </AppTextWrapper>
              {canCopy ?
                <Space verticalSpace={1.5} />
                : null
              }
              {canCopy ?
                <IconButton
                  size={"small"}
                  onClick={() => {
                    navigator.clipboard.writeText(pin);
                    this.showToast(locString('voucherPinCopied'));
                  }}
                  style={{margin: -4}}>
                  <AppIcon icon={IconCopy} color={ColorSubTitle} />
                </IconButton>
                : null
              }
            </View>
            : null
          }
        </View>
        {message ?
          <AppTextWrapper variant={'body2'} style={{fontWeight: FontWeightRegular, color: ColorSubTitle, marginTop: -8, marginBottom: 2, textAlign: 'center'}}>
            {message}
          </AppTextWrapper>
          : null
        }
      </View>
    );
  }

  getCampaignGameCollectStarActionView() {
    // const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt);
    // const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt);
    // const canAction = startDateDiff < 0 && endDateDiff > 0 && this.activity.state == STATE_ENABLED;
    // const canActionEff = this.activity.isUserActionable;
    //
    // let validityText = null;
    // let validityTextFontSize = FontSizeSmall;
    // let validityTextFontColor = ColorSubTitle;
    // if (canAction && !canActionEff && this.activity.userActionAt && this.activity.userActionAt && this.activity.userConsumedCount > 0) {
    //     const minutesPassed = -(DateTimeHelper.getSecondsDiffFromNow(this.activity.userActionAt) / 60);
    //     const resetAfterMinutes = this.activity.userConsumedCount - minutesPassed;
    //     if (resetAfterMinutes > 0) {
    //         validityText = locString('backAgainToCollectMore', {value: DateTimeHelper.getGameRecurIn(DateTimeHelper.getDateWithAddingMinutesFromNow(resetAfterMinutes))});
    //         validityTextFontSize = FontSizeNormal;
    //         validityTextFontColor = ColorOrange;
    //     }
    // }

    const isEnded = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) <= 0;
    const minutesToEnd = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) / 60;
    let resetAfterMinutes = 0;
    if (this.activity.userValueText > 0 && !isEnded && this.activity.userActionAt && this.activity.userConsumedCount > 0) {
      const minutesPassed = -(DateTimeHelper.getSecondsDiffFromNow(this.activity.userActionAt) / 60);
      const resetAfter = this.activity.userConsumedCount - minutesPassed;
      if (resetAfter <= minutesToEnd) {
        resetAfterMinutes = resetAfter;
      }
    }

    let showGame = this.activity.isUserActionable || this.activity.noActionMessage;
    let rewardsWonView = null;
    let actionDisabledMessage = null;
    if (!this.activity.isUserActionable) {
      if (this.activity.userWon) {
        rewardsWonView = this.getRewardsWonView();
        showGame = false;
      } else if (this.activity.userWinEligible) {
        actionDisabledMessage = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
        showGame = true;
      } else if (this.activity.userNotWon) {
        actionDisabledMessage = locString('notWinningMessage');
        showGame = true;
      } else if (!this.activity.noRewards && (this.activity.winGCount >= this.activity.winGLimit || this.activity.answeredCount >= this.activity.winLimit)) {
        actionDisabledMessage = locString('gameWinLimitComplete');
      } else if (this.activity.userValueText > 0) {
        if (resetAfterMinutes > 0) {
          actionDisabledMessage = locString('backAgainToCollectMore', {value: DateTimeHelper.getGameRecurIn(DateTimeHelper.getDateWithAddingMinutesFromNow(resetAfterMinutes))});
        } else if (this.activity.winnersAt) {
          if (this.activity.winnersBy === 1) {
            if (this.activity.userValueText >= this.activity.winnersByValue) {
              actionDisabledMessage = locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
            } else {
              actionDisabledMessage = locString('notWinningMessage');
            }
          } else {
            actionDisabledMessage = locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
          }
        }
        showGame = true;
      } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) > 0) {
        actionDisabledMessage = DateTimeHelper.getValidity(this.activity.startAt, 'campaign.startIn');
        showGame = true;
      } else if (isEnded && !this.activity.recurAt) {
        actionDisabledMessage = locString('campaignIsEnded');
      }
    }

    let collectedValue = this.activity.userValueText > 0 ? parseInt(this.activity.userValueText) : 0;
    if (this.flippedValues && this.flippedValues.length > 0) {
      this.flippedValues.forEach((value) => {
        collectedValue += value.value1;
      });
    }

    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {showGame ?
          <View>
            {/*<FlipTileGameView*/}
            {/*  ref={this.handleFlipRef}*/}
            {/*  noActionMode={this.props.noActionMode || this.props.readOnly}*/}
            {/*  onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}*/}
            {/*  mute={this.state.mute}*/}
            {/*  classes={this.props.classes}*/}
            {/*  contentWidth={this.props.width}*/}
            {/*  contentHeight={this.contentHeight}*/}
            {/*  uiConfigs={this.getUIConfigs()}*/}
            {/*  name={locString('gameCollectStar')}*/}
            {/*  disabled={!this.activity.isUserActionable}*/}
            {/*  cardIcon={this.activity.imageUrl1 ? null : IconStar}*/}
            {/*  items={this.activity.slotValues}*/}
            {/*  cardImage={this.activity.imageUrl1 ? {uri: this.activity.imageUrl1} : null}*/}
            {/*  rows={this.activity.gameRows}*/}
            {/*  columns={this.activity.gameColumns}*/}
            {/*  gameTime={this.activity.gameTime}*/}
            {/*  gameType={this.activity.type}*/}
            {/*  gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}*/}
            {/*  flipAllOnWin={true}*/}
            {/*  gameValueE={this.activity.gameValue}*/}
            {/*  flipsNeeded={this.activity.flipsNeeded}*/}
            {/*  collectedValue={collectedValue}*/}
            {/*  onFlipped={(values) => {*/}
            {/*    this.flippedValues = values;*/}
            {/*    this.reloadView();*/}
            {/*  }}*/}
            {/*  onWin={(gameEndValue) => {*/}
            {/*    // this.isGameOver = true;*/}
            {/*    this.gameEndValue = gameEndValue;*/}
            {/*    setTimeout(() => {*/}
            {/*      this.makeApiForFlipGameOver();*/}
            {/*    }, 200);*/}
            {/*  }}*/}
            {/*  onLose={() => {*/}
            {/*    this.isGameOver = true;*/}
            {/*    this.gameEndValue = null;*/}
            {/*    setTimeout(() => {*/}
            {/*      this.makeApiForFlipGameOver();*/}
            {/*    }, 200);*/}
            {/*    this.reloadView();*/}
            {/*  }}*/}
            {/*/>*/}
            {/*{spinsLeftText ? this.getTextView(spinsLeftText) : null}*/}
            {/*{flippedPoints > 0 ?*/}
            {/*    <View style={{flexDirection: 'row', alignItems: 'center', alignSelf: 'center', marginTop: 6, marginBottom: SpaceNormal}}>*/}
            {/*        {this.activity.imageUrl1 ?*/}
            {/*            <AppImage imageUrl={this.activity.imageUrl1} style={{width: 22, height: 22}}/>*/}
            {/*            : <AppIcon icon={IconStar} color={ColorTheme} />*/}
            {/*        }*/}
            {/*        <AppText style={{*/}
            {/*            marginLeft: SpaceXSmall,*/}
            {/*            color: ColorTheme,*/}
            {/*            fontSize: FontSizeNormal,*/}
            {/*            fontWeight: FontWeightMedium,*/}
            {/*            textAlign: 'center'}}>*/}
            {/*            {flippedPoints}*/}
            {/*        </AppText>*/}
            {/*    </View>*/}
            {/*    : null*/}
            {/*}*/}
            {/*{validityText ? this.getTextView(validityText) : null}*/}
          </View>
          : null
        }
        {rewardsWonView}
        {this.getNoActionMessageViewEx()}
        {this.getTextView(actionDisabledMessage)}
        {this.getGameRecurView()}
        {this.getResetActionView()}
        {this.getGameStatusView()}
      </View>
    );
  }

  getCampaignGameSlidesActionView(gameOtherInfo) {
    const {classes, isLTR, isXS, inPreview, width, height, simulation} = this.props;
    const uiConfigs = this.getUIConfigs();
    let gameStatusView = null;
    if (!this.activity.isUserActionable) {
      gameStatusView = this.getGameActionOtherView(gameOtherInfo);
    }
    // const styleBlur = !hideGameStatus ? {filter: 'blur(3px)'} : null;
    return (
      <div className={classes.absoluteFillCenter} style={{backgroundColor: ColorBlack}}>
        <ActivitySlides
          ref={this.handleRefSlides}
          isLTR={isLTR}
          isXS={isXS}
          width={width}
          height={height}
          items={this.activity.subPosts}
          uiConfigs={uiConfigs}
          simulation={simulation}
          canAction={gameStatusView === null}
          onDone={this.onSlidesDone}
        />
        {gameStatusView != null ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {gameStatusView}
          </div>
          : null
        }
        {!simulation && !inPreview ?
          <div style={{position: 'absolute', top: isXS ? 4 : 8, left: 6, right: 6}}>
            <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <Paper style={{borderRadius: 22, backgroundColor: colorWithAlpha(uiConfigs.themeColor, 0.5), width: 44, height: 44, zIndex: zIndex}}>
                <NavBackActionView color={uiConfigs.titleColor} isLTR={isLTR} onClick={this.onBackClicked}/>
              </Paper>
              <div className={classes.flex1}/>
              {this.activity.type === constants.activity.types.SLIDES ?
                <Paper style={{borderRadius: 22, backgroundColor: colorWithAlpha(uiConfigs.themeColor, 0.5), width: 44, height: 44, zIndex: zIndex}}>
                  <IconButton onClick={this.onShareClicked} className={classes.navActionImage} style={{width: 44, height: 44}}>
                    <AppIcon icon={IconShare} color={uiConfigs.titleColor} style={{width: 22, height: 22}}/>
                  </IconButton>
                </Paper>
                : null
              }
            </View>
          </div>
          : null
        }
      </div>
    );
  }

  handleRefSlides = (ref) => {
    this.refSlides = ref;
  }

  onSlidesDone = () => {
    this.gameEndValue = {value: 0};
    this.makeApiForFlipGameOver();
    this.reloadView();
  }

  getCampaignGameSlotActionView(gameOtherInfo) {
    let startAtEndValues = null;
    if ((this.activity.userWinEligible || this.activity.userNotWon) && this.activity.userValueText) {
      startAtEndValues = [];
      for (let i = 0; i < this.activity.gameColumns; i++) {
        startAtEndValues.push({id: parseInt(this.activity.userValueText)});
      }
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View className={this.props.classes.actionView}>
        {/*{showGame ?*/}
          <View style={{marginBottom: 8, ...styleBlur}}>
            <JackpotGameView
              ref={this.handleSlotRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              preview={this.props.inPreview}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              items={this.activity.slotValues}
              rows={3}
              columns={this.activity.gameColumns}
              startAt={startAtEndValues}
              processWin={true}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameWinAudioUrl={this.activity.gameWinAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              spinsLeft={Math.max(0, this.activity.consumeLimitPerUser - this.activity.userConsumedCount)}
              spinsCount={this.activity.consumeLimitPerUser}
              canSpin={this.activity.isUserActionable}
              onImageClicked={this.onImageFSClicked}
              onSpinStarted={this.onGameSpinStarted}
              onSpinStopped={this.onGameSpinStopped}
            />
          </View>
        {/*  : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo)}
          </div>
          : null
        }
      </View>
    );
  }

  onGameSpinStarted = (selectedSlots) => {
    this.makeApiForSpin(selectedSlots);
  };

  getCampaignGameRouletteActionView(gameOtherInfo) {
    let startAtEndValues = null;
    if ((this.activity.userWinEligible || this.activity.userNotWon) && this.activity.userValueText) {
      startAtEndValues = [];
      for (let i = 0; i < this.activity.gameColumns; i++) {
        startAtEndValues.push({id: parseInt(this.activity.userValueText)});
      }
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{showGame ?*/}
          <View style={{marginBottom: 8, ...styleBlur}}>
            <RouletteGameView
              ref={this.handleSlotRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              mute={this.state.mute}
              preview={this.props.inPreview}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              isLTR={this.props.isLTR}
              items={this.activity.slotValues}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              startAt={startAtEndValues}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              gameWinAudioUrl={this.activity.gameWinAudioLocalUrl}
              canSpin={this.activity.isUserActionable}
              spinsLeft={Math.max(0, this.activity.consumeLimitPerUser - this.activity.userConsumedCount)}
              spinsCount={this.activity.consumeLimitPerUser}
              autoSimulation={this.props.autoSimulation}
              onImageClicked={this.onImageFSClicked}
              onSpinStarted={this.onGameSpinStarted}
              onSpinStopped={this.onGameSpinStopped}
            />
          </View>
        {/*  : null*/}
        {/*}*/}
        {/*{rewardsWonView}*/}
        {/*{this.getNoActionMessageViewEx()}*/}
        {/*{this.getTextView(actionDisabledMessage)}*/}
        {/*{this.getGameRecurView()}*/}
        {/*{this.getResetActionView()}*/}
        {/*{this.getGameStatusView()}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo)}
          </div>
          : null
        }
      </View>
    );
  }

  handleSlotRef = (ref) => {
    this.refJackpotGameView = ref
  }

  getCampaignGameGreedySpinNBettingPicActionView(gameOtherInfo) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();

    let scoreView = null;
    if (gameOtherInfo.showScore) {
      const score = this.activity.userValueText ? parseInt(this.activity.userValueText) : 0;
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          <TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.score'} values={{value: score}}/></TextView>
        </div>
      )
    }

    const collectedValue = this.activity.userValueText > 0 ? this.activity.userValueText : 0;
    const spinsLeft = Math.max(0, this.activity.consumeLimitPerUser - this.activity.userConsumedCount);
    // if (showGame && spinsLeft == 0 && showNoSpins) {
    //   if (actionDisabledMessage) {
    //     actionDisabledMessage = locString('noSpinsLeft', null, this.context.intl) +"\n"+ actionDisabledMessage;
    //   } else {
    //     actionDisabledMessage = locString('noSpinsLeft');
    //   }
    // }

    let slotView = null;
    if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN) {
      slotView = (
        <GameGreedySpinView
          ref={this.handleSlotRef}
          disableAudio={this.props.disableAudio}
          noActionMode={this.props.noActionMode || this.props.readOnly}
          onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
          mute={this.state.mute}
          preview={this.props.inPreview}
          classes={this.props.classes}
          contentWidth={this.props.width}
          contentHeight={this.contentHeight}
          uiConfigs={this.getUIConfigs()}
          isLTR={this.props.isLTR}
          items={this.activity.slotValues}
          rows={this.activity.gameRows}
          columns={this.activity.gameColumns}
          gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
          gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
          gameWinAudioUrl={this.activity.gameWinAudioLocalUrl}
          hideSpin={!this.activity.isUserActionable}
          canSpin={this.activity.isUserActionable}
          spinsLeft={spinsLeft}
          spinsCount={this.activity.consumeLimitPerUser}
          collectedValue={collectedValue}
          onImageClicked={this.onImageFSClicked}
          onSpinStarted={this.onGameSpinStarted}
          onSpinStopped={this.onGameSpinStopped}
        />
      );
    } else if (this.activity.type === ACTIVITY_TYPE_BETTING_PIC) {
      slotView = (
        <GameBettingPicView
          ref={this.handleSlotRef}
          disableAudio={this.props.disableAudio}
          noActionMode={this.props.noActionMode || this.props.readOnly}
          onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
          mute={this.state.mute}
          preview={this.props.inPreview}
          classes={this.props.classes}
          contentWidth={this.props.width}
          contentHeight={this.contentHeight}
          uiConfigs={this.getUIConfigs()}
          isLTR={this.props.isLTR}
          items={this.activity.slotValues}
          rows={this.activity.gameRows}
          columns={this.activity.gameColumns}
          gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
          gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
          gameWinAudioUrl={this.activity.gameWinAudioLocalUrl}
          hideSpin={!this.activity.isUserActionable}
          canSpin={this.activity.isUserActionable}
          spinsLeft={spinsLeft}
          spinsCount={this.activity.consumeLimitPerUser}
          collectedValue={collectedValue}
          onImageClicked={this.onImageFSClicked}
          onSpinStarted={this.onGameSpinStarted}
          onSpinStopped={this.onGameSpinStopped}
        />
      );
    }
    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{showGame ?*/}
          <View style={styleBlur}>
            {slotView}
          </View>
        {/*  : null*/}
        {/*}*/}
        {/*{rewardsWonView}*/}
        {/*{this.getNoActionMessageViewEx()}*/}
        {/*{this.getTextView(actionDisabledMessage)}*/}
        {/*{this.getGameRecurView()}*/}
        {/*{this.getResetActionView()}*/}
        {/*{this.getGameStatusView()}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, scoreView)}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignGameSpinDiscoverBrandRaceActionView(gameOtherInfo) {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    if (this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER && !this.activity.isUserActionable && this.activity.userWon) {
      // const imageSize = 200;
      // const viewImageDiscovered = (
      //   <View style={{alignItems: 'center'}}>
      //     <View style={{height: imageSize, width: imageSize, overflow: 'hidden', borderRadius: RadiusView, marginBottom: 20}}>
      //       <TouchableOpacity style={{flex: 1}} onClick={() => {
      //         this.onImageFSClicked(this.activity.imageUrl2);
      //       }}>
      //         <View style={{width: imageSize, height: imageSize}}>
      //           <AppImage
      //             style={{width: imageSize, height: imageSize, borderRadius: RadiusView}}
      //             imageUrl={this.activity.imageUrl2}
      //           />
      //         </View>
      //       </TouchableOpacity>
      //     </View>
      //   </View>
      // );
      // gameOtherInfo.rewardsWonView = this.getRewardsWonView(this.activity, viewImageDiscovered, imageSize);
    }
    if (this.activity.type === ACTIVITY_TYPE_BRAND_RACE && gameOtherInfo.gamePlayTriesOver) {
      this.activity.slotValues.forEach((slot) => {
        if (slot.value2 >= this.activity.gameRows) {
          // gameOtherInfo.actionDisabledMessage = locString('opponentWonMessage');
        }
      });
    }
    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View className={this.props.classes.actionView}>
        {/*{gameOtherInfo.showGame ?*/}
          <View style={styleBlur}>
            <GameSpinDiscoverView
              ref={this.handleSlotRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              mute={this.state.mute}
              preview={this.props.inPreview}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              isLTR={this.props.isLTR}
              items={this.activity.slotValues}
              gameType={this.activity.type}
              value={this.activity.userValueText}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              sColumns={this.activity.gameSColumns}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              gameWinAudioUrl={this.activity.gameWinAudioLocalUrl}
              cardImage={this.activity.imageUrl1}
              cardHiddenImage={this.activity.imageUrl2}
              // hideSpin={!this.activity.isUserActionable}
              canSpin={this.activity.isUserActionable}
              spinsLeft={Math.max(0, this.activity.consumeLimitPerUser - this.activity.userConsumedCount)}
              spinsCount={this.activity.consumeLimitPerUser}
              onImageClicked={this.onImageFSClicked}
              onSpinStarted={this.onGameSpinStarted}
              onSpinStopped={this.onGameSpinStopped}
            />
          </View>
        {/*  : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo)}
          </div>
          : null
        }
      </View>
    );
  }

  onGameSpinStopped = () => {
    delete(this.activityUpdated.endSlotValues);
    const onDialogDismissed = () => {
      this.activity = this.activityUpdated;
      this.updateAndReload();
    };
    const isWin = this.activityUpdated.userWon;
    const isWinEligible = this.activityUpdated.userWinEligible;
    if (isWin) {
      onDialogDismissed();
      // this.showSimpleOverlayView(locString('congratulations'), null, this.getRewardsWonOverlayContentView(this.activityUpdated), true, null, onDialogDismissed);
    } else if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
      let subTitle = null;
      if (isWinEligible) {
        subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
        this.playGameNeutralAudioInline();
      }
      this.showSimpleOverlayView({
        icon: IconGifts,
        iconColor: this.getUIConfigs().messageBorderColor,
        title: locString('earnedPointsTitle'),
        subTitle: subTitle,
        positiveActionText: locString('close'),
        subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
        onDisplayed: onDialogDismissed
      });
    } else {
      // if (isWinEligible) {
      //   this.playGameNeutralAudioInline();
      //   this.showSimpleOverlayView({
      //     icon: IconSuccess,
      //     iconColor: this.getUIConfigs().messageBorderColor,
      //     title: locString('earnedPointsTitle'),
      //     subTitle: locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDate(this.activity.winnersAt)}, this.context.intl),
      //     positiveActionText: locString('close'),
      //     onDisplayed: onDialogDismissed
      //   });
      // } else {
      //   onDialogDismissed();
      // }
      if (isWinEligible) {
        this.playGameNeutralAudioInline();
        if (!this.props.inPreview) {
          this.showToast(locString('userEligibleToWin'));
        }
      }
      onDialogDismissed();
    }
  };

  getCampaignGameFlipCardActionView(gameOtherInfo) {
    let name = null;
    if (this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN) {
      name = locString('gameFindHidden');
    } else if (this.activity.type === ACTIVITY_TYPE_MATCHING_PIC) {
      name = locString('gameMatchPair');
    } else {
      name = locString('gameFlipCard');
    }
    const hideGameStatus = this.activity.isUserActionable;
    let gameStatusView = null
    if (!hideGameStatus) {
      gameStatusView = this.getGameActionOtherView(gameOtherInfo);
    }
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{showGame ?*/}
          <View style={styleBlur}>
            <FlipTileGameView
              ref={this.handleFlipRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              simulation={this.props.simulation}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              isLTR={this.props.isLTR}
              preview={this.props.inPreview}
              type={this.activity.type}
              name={name}
              disabled={!this.activity.isUserActionable}
              cardImage={this.activity.imageUrl1}
              items={this.activity.slotValues}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              gameTime={this.activity.gameTime}
              gameType={this.activity.type}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              gameValueE={this.activity.gameValue}
              flipsNeeded={this.activity.flipsNeeded}
              deadCount={this.activity.deadCount}
              onStart={this.handleFlipStart}
              onWin={this.handleFlipWin}
              onLose={this.handleFlipLose}
            />
            {/*{this.getTextView(spinsLeftText)}*/}
          </View>
        {/*  : null*/}
        {/*}*/}
        {gameStatusView != null ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {gameStatusView}
          </div>
          : null
        }
      </View>
    );
  }

  handleFlipRef = (ref) => {
    this.refFlipTileGameView = ref;
  }
  handleFlipStart = () => {
    const _this = this;
    setTimeout(() => {
      _this.makeApiForFlipGameStart();
    });
  };
  handleFlipWin = (gameEndValue) => {
    // this.isGameOver = true;
    this.gameEndValue = gameEndValue;
    const _this = this;
    setTimeout(() => {
      _this.makeApiForFlipGameOver();
    }, 200);
  };
  handleFlipLose = (gameEndValue) => {
    this.isGameOver = true;
    this.gameEndValue = gameEndValue;
    const _this = this;
    setTimeout(() => {
      _this.makeApiForFlipGameOver();
    }, 200);
    this.reloadView();
  }

  getCampaignGameMatchThreeActionView(gameOtherInfo) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const value = this.activity.userValueText ? parseInt(this.activity.userValueText) : 0;
    let scoreView = null;
    if (gameOtherInfo.showScore && !this.props.simulation) {
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          <TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.score'} values={{value: value}}/></TextView>
        </div>
      )
    }

    const hideGameStatus = this.activity.isUserActionable;
    let gameStatusView = null
    if (!hideGameStatus) {
      gameStatusView = this.getGameActionOtherView(gameOtherInfo, scoreView);
    }

    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{showGame ?*/}
          <View style={styleBlur}>
            <GameMatchThreeView
              ref={this.handleFlipRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              simulation={this.props.simulation}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              isLTR={this.props.isLTR}
              contentY={this.contentY}
              items={this.activity.slotValues}
              disabled={!this.activity.isUserActionable}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              gameTime={this.activity.gameTime}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              flipsNeeded={this.activity.flipsNeeded}
              value={value}
              winValue={this.activity.winnersByValue}
              won={this.activity.userWon || this.activity.userWinEligible}
              onStart={() => {
                this.disableBodyScroll();
                setTimeout(() => {
                  this.makeApiForFlipGameStart();
                });
              }}
              onEnd={(gameEndValue) => {
                this.enableBodyScroll();
                this.gameEndValue = gameEndValue;
                setTimeout(() => {
                  this.makeApiForFlipGameOver();
                });
              }}
            />
          </View>
        {/*  : null*/}
        {/*}*/}
        {gameStatusView != null ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {gameStatusView}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignGameWhacAMoleActionView(gameOtherInfo) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const value = this.activity.userValueText ? parseInt(this.activity.userValueText) : 0;
    const winValue = this.activity.winnersByValue;
    let scoreView = null;
    if (gameOtherInfo.showScore) {
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          <TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.score'} values={{value: value}}/></TextView>
        </div>
      )
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{gameOtherInfo.showGame ?*/}
          <View style={styleBlur}>
            <GameWhacAMoleView
              ref={this.handleFlipRef}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              simulation={this.props.simulation}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              isLTR={this.props.isLTR}
              contentY={this.contentY}
              items={this.activity.slotValues}
              disabled={!this.activity.isUserActionable}
              hideAction={!this.props.inPreview && this.activity.isUserResetable}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              // placeholderImageUrl={this.activity.imageUrl1}
              gameTime={this.activity.gameTime}
              moleAppearTime={this.activity.gameEasy}
              moleAppearExtraMaxTime={this.activity.gameEasy1}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
              flipsNeeded={this.activity.flipsNeeded}
              value={value}
              winValue={winValue}
              won={this.activity.userWon || this.activity.userWinEligible}
              onImageClicked={this.onImageFSClicked}
              onStart={() => {
                setTimeout(() => {
                  this.makeApiForFlipGameStart();
                });
              }}
              onEnd={(gameEndValue) => {
                this.gameEndValue = gameEndValue;
                setTimeout(() => {
                  this.makeApiForFlipGameOver();
                });
              }}
            />
          </View>
        {/*  : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, scoreView)}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignGameTicTacToeActionView(gameOtherInfo) {
    const {classes, userImageUrl} = this.props;
    const uiConfigs = this.getUIConfigs();

    let userWonRounds = 0;
    if (this.activity.userValueText && (this.activity.userValueText < 0 || this.activity.userWinEligible || this.activity.userNotWon)) {
      userWonRounds = Math.abs(this.activity.userValueText);
    }
    const botWonRounds = this.activity.userClickedCount;
    const roundsPlayed = this.activity.userConsumedCount;
    const drawRounds = roundsPlayed - userWonRounds - botWonRounds;
    const roundsToWin = Math.floor((this.activity.consumeLimitPerUser - drawRounds) / 2) + 1;
    const isBotWon = botWonRounds >= roundsToWin;

    const userLost = !this.activity.userWon && !this.activity.userWinEligible && (this.activity.userConsumedCount >= this.activity.consumeLimitPerUser || isBotWon);
    const userLostMessageId = userLost ? isBotWon ? 'youLost' : 'notWinningMessage' : null ;

    const isSocketApplicable = this.isSocketApplicable();
    const showSocketInfo = this.isSocketApplicable() && (this.state.socketState === SOCKET_STATE_CONNECTING
      || this.state.socketState === SOCKET_STATE_DISCONNECTING
      || this.state.socketState === SOCKET_STATE_EMITTING
      || this.state.socketState === SOCKET_STATE_ERROR);
    const showSocketLoading = this.state.socketState === SOCKET_STATE_CONNECTING
      || this.state.socketState === SOCKET_STATE_DISCONNECTING;
    const showSocketError = this.state.socketState === SOCKET_STATE_ERROR;
    const showSocketDataProcessing = this.state.socketState === SOCKET_STATE_EMITTING;

    let scoreView = null;
    if (gameOtherInfo.showScore) {
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          <TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.scoreRounds'} values={{value1: userWonRounds, value2: botWonRounds}}/></TextView>
        </div>
      )
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 300, justifyContent: 'center'}}>
        {/*{gameOtherInfo.showGame ?*/}
          <View style={{position: 'relative', ...styleBlur}}>
            <TicTacToeGameView
              ref={this.handleFlipRef}
              autoSimulation={this.props.autoSimulation}
              disableAudio={this.props.disableAudio}
              fetchAction={isSocketApplicable ? this.fetchSocketResponse : null}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              simulation={this.props.simulation}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              isLTR={this.props.isLTR}
              uiConfigs={uiConfigs}
              disabled={!this.activity.isUserActionable}
              cardImage={this.activity.imageUrl1}
              items={this.activity.slotValues}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              rounds={this.activity.consumeLimitPerUser}
              roundsPlayed={roundsPlayed}
              roundsToWin={roundsToWin}
              userWonRounds={userWonRounds}
              aiWonRounds={botWonRounds}
              gameTime={this.activity.gameTime}
              gameType={this.activity.type}
              easy={this.activity.gameEasy}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              onImageClicked={this.onImageFSClicked}
              onStart={() => {
                setTimeout(() => {
                  this.makeApiForFlipGameStart();
                });
              }}
              onEnd={(gameEndValue) => {
                this.gameEndValue = gameEndValue;
                setTimeout(() => {
                  this.makeApiForFlipGameOver();
                });
              }}
            />
            {userLostMessageId ? this.getTextView(locString(userLostMessageId)) : null}
            {showSocketInfo ?
              <View style={{position: 'absolute', top: 114 * uiConfigs.sizeFactor, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {showSocketLoading ?
                  <CircularProgress size={uiConfigs.fontSize * 2} style={{color: ColorWhite}} />
                  : null
                }
                {showSocketError ?
                  <View className={this.props.classes.viewColumn}>
                    <View style={{padding: 4, paddingLeft: 12, paddingRight: 12, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(ColorBlack, 0.4), borderRadius: 20}}>
                      <TextView fontSizeN={uiConfigs.fontSize} variant={'body2'} color={ColorWhite}>{this.state.socketError}</TextView>
                    </View>
                    <Space horizontalSpace={1}/>
                    <View className={this.props.classes.viewRow} style={{justifyContent: 'center'}}>
                      <Button color={'primary'} size={uiConfigs.sizeFactor >= 1.1 ? 'medium' : 'small'} variant={'contained'} onClick={this.onSocketRetryClicked}><FormattedMessage id={'generic.retry'} /></Button>
                    </View>
                  </View>
                  : null
                }
              </View>
              : null
            }
          </View>
        {/*  : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, scoreView)}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignGamePokerActionView(gameOtherInfo) {
    const {classes, userImageUrl} = this.props;
    const uiConfigs = this.getUIConfigs();

    let roundsToWin = parseInt(this.activity.consumeLimitPerUser/2) + 1;
    let userWonRounds = 0;
    if (this.activity.userWon) {
      userWonRounds = roundsToWin;
    } else if (this.activity.userValueText && (this.activity.userValueText < 0 || this.activity.userWinEligible || this.activity.userNotWon)) {
      userWonRounds = Math.abs(this.activity.userValueText);
    }
    const aiWonRounds = Math.max(0, this.activity.userConsumedCount - userWonRounds);
    const effUserImageUrl = userImageUrl !== this.activity.business.imageUrl ? userImageUrl : require('src/images/img_user_dummy.png');
    const roundsPlayed = this.activity.userConsumedCount + (this.activity.isUserActionable ? 1 : 0);

    let scoreView = null;
    if (gameOtherInfo.showScore) {
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          <TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.scoreRounds'} values={{value1: userWonRounds, value2: aiWonRounds}}/></TextView>
        </div>
      )
    }

    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 300, justifyContent: 'center'}}>
        {/*{gameOtherInfo.showGame ?*/}
          <View style={styleBlur}>
            <GamePokerView
              ref={this.handleFlipRef}
              autoSimulation={this.props.autoSimulation}
              disableAudio={this.props.disableAudio}
              noActionMode={this.props.noActionMode || this.props.readOnly}
              onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
              fetchAction={!this.props.inPreview ? this.makePreActionInActivity : null}
              simulation={this.props.simulation}
              mute={this.state.mute}
              classes={this.props.classes}
              contentWidth={this.props.width}
              contentHeight={this.contentHeight}
              uiConfigs={this.getUIConfigs()}
              disabled={!this.activity.isUserActionable}
              userImageUrl={effUserImageUrl}
              aiImageUrl={this.activity.business.imageUrl}
              cardImageUrl={this.activity.imageUrl1}
              items={this.activity.slotValues}
              rows={this.activity.gameRows}
              columns={this.activity.gameColumns}
              rounds={this.activity.consumeLimitPerUser}
              roundsPlayed={roundsPlayed}
              roundsToWin={roundsToWin}
              userWonRounds={userWonRounds}
              aiWonRounds={aiWonRounds}
              gameTime={this.activity.gameTime}
              gameType={this.activity.type}
              easy={this.activity.gameEasy}
              gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
              onImageClicked={this.onImageFSClicked}
              onStart={() => {
                setTimeout(() => {
                  this.makeApiForFlipGameStart();
                });
              }}
              onEnd={(gameEndValue) => {
                this.gameEndValue = gameEndValue;
                setTimeout(() => {
                  this.makeApiForFlipGameOver();
                });
              }}
            />
          </View>
        {/*   : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo, scoreView)}
          </div>
          : null
        }
      </View>
    );
  }

  getCampaignGamePuzzleActionView(gameOtherInfo) {
    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus ? {filter: 'blur(4px)', opacity: 0.8} : null;
    return (
      <View style={{minHeight: 200, justifyContent: 'center'}}>
        {/*{showGame ?*/}
          <View style={styleBlur}>
            {this.activity.type === ACTIVITY_TYPE_PUZZLE ?
              <GamePuzzleTapSelectView
                ref={this.handleFlipRef}
                disableAudio={this.props.disableAudio}
                noActionMode={this.props.noActionMode || this.props.readOnly}
                onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
                simulation={this.props.simulation}
                mute={this.state.mute}
                classes={this.props.classes}
                contentWidth={this.props.width}
                contentHeight={this.contentHeight}
                uiConfigs={this.getUIConfigs()}
                isLTR={this.props.isLTR}
                puzzleImage={this.activity.imageUrl1}
                disabled={!this.activity.isUserActionable}
                rows={this.activity.gameRows}
                columns={this.activity.gameColumns}
                gameTime={this.activity.gameTime}
                gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
                gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
                flipsNeeded={this.activity.flipsNeeded}
                won={this.activity.userWon || this.activity.userWinEligible}
                onImageClicked={this.onImageFSClicked}
                onStart={this.handlePuzzleStart}
                onEnd={this.handlePuzzleEnd}
              />
              : <GamePuzzleSlideView
                ref={this.handleFlipRef}
                disableAudio={this.props.disableAudio}
                noActionMode={this.props.noActionMode || this.props.readOnly}
                onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
                simulation={this.props.simulation}
                mute={this.state.mute}
                classes={this.props.classes}
                contentWidth={this.props.width}
                contentHeight={this.contentHeight}
                uiConfigs={this.getUIConfigs()}
                isLTR={this.props.isLTR}
                puzzleImage={this.activity.imageUrl1}
                disabled={!this.activity.isUserActionable}
                rows={this.activity.gameRows}
                columns={this.activity.gameColumns}
                gameTime={this.activity.gameTime}
                gamePlayAudioUrl={this.activity.gamePlayAudioLocalUrl}
                gameLoseAudioUrl={this.activity.gameLoseAudioLocalUrl}
                flipsNeeded={this.activity.flipsNeeded}
                won={this.activity.userWon || this.activity.userWinEligible}
                onImageClicked={this.onImageFSClicked}
                onStart={this.handlePuzzleStart}
                onEnd={this.handlePuzzleEnd}
              />
            }
          </View>
        {/*  : null*/}
        {/*}*/}
        {!hideGameStatus ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.getGameActionOtherView(gameOtherInfo)}
          </div>
          : null
        }
      </View>
    );
  }

  handlePuzzleStart = () => {
    let timeoutRef = setTimeout(() => {
      this.makeApiForFlipGameStart();
      clearTimeout(timeoutRef);
      timeoutRef = null;
    });
  }

  handlePuzzleEnd = (gameEndValue) => {
    this.gameEndValue = gameEndValue;
    let timeoutRef = setTimeout(() => {
      this.makeApiForFlipGameOver();
      clearTimeout(timeoutRef);
      timeoutRef = null;
    });
  }

  getCampaignGameGuessActionView(gameOtherInfo) {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    const sizeVFactor = uiConfigs.sizeVFactor;

    let showInline = true;
    if (this.activity.userWon || this.props.isGuestUser) {
      showInline = false;
    }
    gameOtherInfo.showInline = showInline;
    // const showQuestion = !this.activity.userWon;
    const showQuestion = true;
    let isUserActionable = this.activity.isUserActionable || this.activity.isUserActionableA;
    const questionItems = this.activity.qOptions ? this.activity.qOptions : [];
    const imageUrl = this.activity.imageUrl2;

    const effWidth = this.props.width;
    const optionInRow = 1;
    const hideGameStatus = this.activity.isUserActionable;
    const styleBlur = !hideGameStatus && !showInline ? {filter: 'blur(4px)', opacity: 0.8} : null;
    let otherView = null;
    if (!hideGameStatus) {
      otherView = this.getGameActionOtherView(gameOtherInfo);
    }
    return (
      <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
        <View style={{flex: 1, maxWidth: effWidth, paddingLeft: 8 * sizeFactor, paddingRight: 8 * sizeFactor}}>
          {/*{showQuestion ?*/}
            <View style={{position: 'relative', ...styleBlur}}>
              <ImageBackground source={uiConfigs.gameBgImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, width: '100%', height: '100%'}}>
                <View style={{padding: 6 * sizeFactor, position: 'relative'}}>
                  {imageUrl ?
                    <View style={{width: '100%', alignSelf: 'center', marginBottom: 4 * sizeFactor}}>
                      <ImageBackground source={uiConfigs.mediaBgImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />
                      <View style={{padding: 4 * sizeFactor, overflow: 'hidden'}}>
                        <TouchableOpacity
                          onClick={() => {
                            this.onImageFSClicked(imageUrl);
                          }}>
                          <AppImage
                            resizeMode={'contain'}
                            style={{width: '100%', aspectRatio: 16/9, borderRadius: 12, maxHeight: this.props.width/16*9}}
                            imageUrl={imageUrl}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                    : null
                  }
                  <AppText
                    fontSizeN={uiConfigs.fontSize}
                    onLinkClick={this.onTextLinkClicked}
                    style={{
                      color: 'rgb(85,65,45)',
                      fontWeight: FontWeightMedium,
                      textAlign: 'center',
                      margin: 4 * sizeFactor,
                      marginTop: (imageUrl ? 0 : 6) * sizeFactor,
                      marginBottom: (imageUrl ? 12 : 4) * sizeFactor,
                    }}>
                    {this.activity.qTitle}
                  </AppText>
                </View>
              </ImageBackground>
            </View>
          {/*  : null*/}
          {/*}*/}
          {otherView == null || isUserActionable ?
            <View style={{marginTop: 8 * sizeVFactor, marginBottom: 24 * sizeVFactor, flexDirection: 'row', flexWrap: 'wrap', ...styleBlur}}>
              {questionItems.map((item, index) => {
                return (
                  <View style={{width: Math.floor((effWidth - (16 + 6 * (optionInRow - 1)) * sizeFactor) / optionInRow) - 1, marginRight: optionInRow === 1 ? 0 : (index % optionInRow === 0 ? 6 * sizeFactor : 0), marginTop: 2 * sizeFactor}}>
                    <QuestionOptionItem
                      uiConfigs={uiConfigs}
                      bgImage={uiConfigs.cardBgImage}
                      selectorColor={uiConfigs.gameValueTextColor}
                      titleColor={uiConfigs.gameValueTextColor}
                      id={index}
                      disabled={!isUserActionable}
                      onClick={this.onGuessItemClicked}
                      name={item.name}
                      selected={this.selectedOptionIndexes.has(item.id)}/>
                  </View>
                );
              })}
            </View>
            : null
          }
          {otherView != null ? showInline ? otherView :
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
              {otherView}
            </div>
            : null
          }
        </View>
      </View>
    );
  }

  processCampaignLikeUserAction() {
    if (this.activity.likeeUser && this.activity.isUserActionable) {
      const uiConfigs = this.getUIConfigs();
      const onProceedActionClicked = () => {
        this.dismissSimpleOverlayNHandleCallback(() => {
          this.showSimpleOverlayView({
            title: locString('likeUserPrompt', {value1: this.getGameValuePlaceholder()}),
            subTitle: locString('likeUserMessage', {value1: this.getGameValuePlaceholder()}),
            positiveActionText: locString('yes'),
            negativeActionText: locString('no'),
            onPositiveClicked: () => {
              this.makeApiToLikeUser(this.activity.likeeUser.id);
            },
            hideActionsSeparator: true,
            showInCenter: true,
            topSubView: this.activity.imageUrl1 ? (
              <View style={{backgroundColor: uiConfigs.messageBgColor, width: 90, height: 90, borderRadius: 45, padding: 2, alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: -45, marginBottom: -8}}>
                <AppImage imageUrl={this.activity.imageUrl1} style={{width: 86, height: 86, borderRadius: 43}} />
              </View>
            ) : null
          });
        });
      };
      const subView = (
        <View>
          <View style={{marginTop: 8}}>
            <TouchableOpacity
              onClick={onProceedActionClicked}
              disabled={!this.activity.isUserActionable}>
              <ImageBackground
                source={uiConfigs.playBgImage}
                resizeMode={'fill'}
                style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />
              <View style={{flexDirection: 'row', padding: 12, marginBottom: 8, alignItems: 'center', justifyContent: 'center'}}>
                {this.activity.imageUrl1 ?
                  <View style={{backgroundColor: '#2A9CEA', alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                    <AppImage imageUrl={this.activity.imageUrl1} style={{width: 56, height: 56, borderRadius: 28}}/>
                  </View>
                  : null
                }
                <View style={{marginLeft: 12, marginRight: 12, alignItems: 'center', maxWidth: this.props.width - 230}}>
                  <AppText style={{textAlign: 'center', fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: ColorWhite}}>
                    {locString('giveOne')}
                  </AppText>
                  <AppText style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: ColorWhite, marginTop: 4}}>
                    {this.getGameValuePlaceholder()}
                  </AppText>
                  <AppText numberOfLines={2} style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: ColorWhite, marginTop: 2}}>
                    {locString('likeToUserValue', {value: this.activity.likeeUser.name})}
                  </AppText>
                </View>
                <View style={{backgroundColor: '#2A9CEA', alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                  <AppImage imageUrl={this.activity.likeeUser.imageUrl} style={{width: 56, height: 56, borderRadius: 28}}/>
                </View>
              </View>
            </TouchableOpacity>
          </View>
          {!this.activity.isUserActionable && this.activity.noActionMessage ? this.getNoActionMessageView() : null}
          <View style={{marginTop: 16, alignItems: 'center'}}>
            {this.getImageActionButton(this.dismissSimpleOverlayNHandleCallback, locString('cancel'), 200, uiConfigs.otherActionNImage)}
          </View>
        </View>
      );
      this.showSimpleOverlayView({
        title: locString('getLikeRequestValue', {value: this.getGameValuePlaceholder()}),
        hideActions: true,
        showInCenter: true,
        subView: subView
      });
    } else if (this.props.navigation.state.params.viaLink && this.activity.likedUser) {
      const uiConfigs = this.getUIConfigs();
      this.showSimpleOverlayView({
        title: locString('great', {value1: this.getGameValuePlaceholder()}),
        hideActionsSeparator: true,
        showInCenter: true,
        subView: (
          <View>
            <View style={{backgroundColor: ColorWhite, alignItems: 'center', justifyContent: 'center', padding: 16, marginBottom: 8, marginTop: 8, marginLeft: -16, marginRight: -16}}>
              <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                {this.activity.imageUrl1 ?
                  <View style={{backgroundColor: uiConfigs.borderColor, alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                    <AppImage imageUrl={this.activity.imageUrl1} style={{width: 56, height: 56, borderRadius: 28}}/>
                  </View>
                  : null
                }
                <View style={{marginLeft: 12, marginRight: 12, alignItems: 'center', maxWidth: this.props.width - 208}}>
                  <AppText style={{textAlign: 'center', fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor}}>
                    {locString('youAlreadyGave')}
                  </AppText>
                  <AppText style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginTop: 4}}>
                    {this.getGameValuePlaceholder()}
                  </AppText>
                  <AppText numberOfLines={2} style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginTop: 2}}>
                    {locString('likeToUserValue', {value: this.activity.likedUser.name})}
                  </AppText>
                </View>
                <View style={{backgroundColor: uiConfigs.borderColor, alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                  <AppImage imageUrl={this.activity.likedUser.imageUrl} style={{width: 56, height: 56, borderRadius: 28}}/>
                </View>
              </View>
            </View>
          </View>
        )
      });
    }
  }

  getCampaignGameShareNGetActionView() {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;

    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt);
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt);
    let canAction = startDateDiff < 0 && endDateDiff > 0 && this.activity.state === STATE_ENABLED;
    const showCollectedValues = startDateDiff < 0 && !this.activity.isCodeNeeded;
    const topUsersPresent = this.activity.topUsers && this.activity.topUsers.length > 0;

    let rewardsWonView = null;
    let actionDisabledMessage = null;
    if (this.activity.userWon) {
      rewardsWonView = this.getRewardsWonView();
      if (this.activity.userConsumedCount > 0) {
        rewardsWonView = (
          <View>
            {rewardsWonView}
            <AppText style={{
              textAlign: 'center',
              color: ColorTheme,
              fontSize: FontSizeNormal,
              fontWeight: FontWeightMedium,
              marginTop: 4,
              marginBottom: 4
            }}>{locString('rewardToLikeOthers', {value1: this.getGameValuePlaceholder()})}</AppText>
          </View>
        );
      }
      if (rewardsWonView) {
        canAction = false;
      }
    } else if (this.activity.isCodeNeeded) {
      if (this.activity.userValueText > 0) {
        actionDisabledMessage = locString('notWinningMessage');
      } else if (!this.activity.recurAt) {
        actionDisabledMessage = locString('campaignIsEnded');
      }
    } else if (this.activity.userValueText > 0 && this.activity.winnersAt) {
      if (this.activity.winnersBy === 1) {
        if (this.activity.userValueText >= this.activity.winnersByValue) {
          actionDisabledMessage = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
        }
      } else {
        actionDisabledMessage = locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
      }
    } else if (startDateDiff > 0) {
      actionDisabledMessage = DateTimeHelper.getValidity(this.activity.startAt, 'campaign.startIn');
    } else if (endDateDiff <= 0 && !this.activity.recurAt) {
      actionDisabledMessage = locString('campaignIsEnded');
    }

    const menuItem = (imageModel, title, onClick) => {
      return (
        <View style={{minWidth: 140, paddingLeft: 16, paddingRight: 16}}>
          <TouchableOpacity onClick={onClick}>
            <View style={{alignItems: 'center'}}>
              <View style={{backgroundColor: uiConfigs.borderColor, width: 70, height: 70, borderRadius: RadiusView, padding: 2, alignItems: 'center', justifyContent: 'center'}}>
                {imageModel.url ? <AppImage imageUrl={imageModel.url} style={{width: 66, height: 66, borderRadius: RadiusView}} /> : null}
                {imageModel.res ? <AppImage source={imageModel.res} resizeMode={'fill'} style={{width: 50, height: 50}} /> : null}
              </View>
              <AppText style={{textAlign: 'center', color: uiConfigs.subTitleColor, fontSize: FontSizeSmall, fontWeight: FontWeightMedium, marginTop: 4}}>
                {title}
              </AppText>
            </View>
          </TouchableOpacity>
        </View>
      );
    };

    return (
      <View>
        {/*<View style={[styles.viewCard, {flexDirection: 'row', paddingLeft: 12, paddingRight: 12}]}>*/}
        <View style={{flexDirection: 'row', paddingLeft: 12, paddingRight: 12}}>
          {this.activity.imageUrl1 ?
            <TouchableOpacity onClick={() => {
              // ImageScreen.navigateTo(this.props.navigation, [this.activity.imageUrl1])
            }}>
              <View style={{backgroundColor: uiConfigs.borderColor, width: 100, height: 100, borderRadius: 50, alignSelf: 'center', padding: 2, marginRight: 12}}>
                <AppImage imageUrl={this.activity.imageUrl1} style={{width: 96, height: 96, borderRadius: 48}}/>
              </View>
            </TouchableOpacity>
            : null
          }
          <View style={{flex: 1}}>
            <AppTextWrapper
              style={{
                color: uiConfigs.titleColor,
                fontSize: FontSizeNormal,
                fontWeight: FontWeightMedium,
              }}>
              {locString('collectValue', {value: this.getGameValuePlaceholder()})}
            </AppTextWrapper>
            <AppTextWrapper
              style={{
                color: uiConfigs.subTitleColor,
                fontSize: FontSizeSmall,
                fontWeight: FontWeightRegular,
                marginTop: 8,
              }}>
              {ActivityHelper.getGameCollectValueMessage(this.activity)}
            </AppTextWrapper>
            {this.getDurationView()}
          </View>
        </View>
        <View style={{backgroundColor: ColorWhite}}>
          <View style={{height: 20, borderBottomStartRadius: RadiusViewCard, borderBottomEndRadius: RadiusViewCard, backgroundColor: uiConfigs.safeAreaColor, marginBottom: 20}}/>
          {canAction ?
            <View style={{height: 120 * sizeFactor, marginLeft: 16, marginRight: 16}}>
              <TouchableOpacity style={{flex: 1}} onClick={this.onShareClicked}>
                <ImageBackground
                  source={uiConfigs.playBgImage}
                  resizeMode={'fill'}
                  style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />
                <View style={{flex: 1, flexDirection: 'row', padding: 16, alignItems: 'center', justifyContent: 'center'}}>
                  <ImageBackground
                    source={uiConfigs.playImage}
                    resizeMode={'fill'}
                    style={{width: 80, height: 80}} />
                  <View style={{marginLeft: this.activity.imageUrl1 ? 16 : 32, marginRight: 24, marginBottom: 6, alignItems: 'center'}}>
                    <AppTextWrapper style={{textAlign: 'center', fontSize: FontSizeXLarge, fontWeight: FontWeightMedium, color: ColorWhite}}>{locString('shareNGet')}</AppTextWrapper>
                    <AppTextWrapper style={{textAlign: 'center', fontSize: FontSizeXLarge, fontWeight: FontWeightMedium, color: ColorWhite, marginTop: 6}}>{this.getGameValuePlaceholder()}</AppTextWrapper>
                  </View>
                  {this.activity.imageUrl1 ?
                    <View style={{backgroundColor: '#2A9CEA', width: 66, height: 66, borderRadius: 33, alignSelf: 'center', padding: 2, marginBottom: 6, marginRight: 6}}>
                      <AppImage imageUrl={this.activity.imageUrl1} style={{width: 62, height: 62, borderRadius: 31}}/>
                    </View>
                    : null
                  }
                </View>
              </TouchableOpacity>
            </View>
            : null
          }
          {showCollectedValues ?
            // <View style={[styles.viewCard, {flexDirection: 'row', alignItems: 'center', paddingTop: 6, paddingBottom: 6, marginLeft: 24, marginRight: 24, marginBottom: 8, marginTop: 8}]}>
            <View style={{flexDirection: 'row', alignItems: 'center', paddingTop: 6, paddingBottom: 6, marginLeft: 24, marginRight: 24, marginBottom: 8, marginTop: 8}}>
              <AppTextWrapper
                wrapperStyle={{flex: 1}}
                style={{
                  color: uiConfigs.titleColor,
                  fontSize: FontSizeNormal,
                  fontWeight: FontWeightMedium,
                }}>
                {locString('yourCollectionValue', {value: this.getGameValuePlaceholder()})}
              </AppTextWrapper>
              <View style={{padding: 12, paddingTop: 6, paddingBottom: 6, backgroundColor: uiConfigs.borderColor, borderRadius: RadiusViewCard, flexDirection: 'row', alignItems: 'center'}}>
                {this.activity.imageUrl1 ?
                  <AppImage imageUrl={this.activity.imageUrl1} style={{width: 28, height: 28, borderRadius: RadiusView, marginRight: 8}}/>
                  : null
                }
                <AppTextWrapper
                  style={{
                    color: uiConfigs.subTitleColor,
                    fontSize: FontSizeNormal,
                    fontWeight: FontWeightMedium,
                  }}>
                  {this.activity.userValueText > 0 ? this.activity.userValueText : 0}
                </AppTextWrapper>
              </View>
            </View>
            : null
          }
          {rewardsWonView}
          {this.getNoActionMessageViewEx()}
          {this.getTextView(actionDisabledMessage)}
          {this.getGameRecurView()}
          {this.getResetActionView()}
          {this.getGameStatusView()}
          <View style={{height: 20, borderTopStartRadius: RadiusViewCard, borderTopEndRadius: RadiusViewCard, backgroundColor: uiConfigs.safeAreaColor, marginTop: 20}}/>
        </View>
        <View style={{flex: 1, padding: SpaceNormal, paddingTop: 0, borderTopStartRadius: SpaceNormal, borderTopEndRadius: SpaceNormal}}>
          {this.getBusinessView()}
          {this.getBottomOtherActionsView()}
        </View>
        {/*<View style={[styles.viewCard, {flexDirection: 'row', justifyContent: 'center'}]}>*/}
        {/*    {menuItem({url: this.activity.business.imageUrl}, this.activity.business.name, this.onBusinessClicked)}*/}
        {/*    {topUsersPresent ? menuItem({res: uiConfigs.toppersImage}, locString('topCollectorsMulti'), this.onWinEligibleMenuClicked) : null}*/}
        {/*    {this.activity.isCodeNeeded ? menuItem({res: require('src/images/activity/0-img_winner.png')}, locString('winners'), this.onWinnerMenuClicked) : null}*/}
        {/*</View>*/}
      </View>
    );
  }

  getCampaignEventActionView() {
    let actionText = null;
    let actionColor = ColorSecondary;
    if (this.activity.isUserActionable || this.activity.noActionMessage) {
      actionText = locString('participate');
    } else if (this.activity.userClickedCount > 0) {
      actionColor = ColorSubTitle;
      if (this.activity.userValue2 > 0) {
        actionText = locString('youHaveParticipatedViewOffer');
      }
      // else {
      //     actionText = locString('youHaveParticipated');
      // }
    }
    // else if (this.activity.clickedCount >= this.activity.clickLimit) {
    //     actionColor = ColorOtherTitle;
    //     actionText = locString('completelyReserved');
    // }

    let actionDisabledMessage = null;
    if (!this.activity.isUserActionable) {
      if (this.activity.userClickedCount > 0) {
        if (!this.activity.userValue2) {
          actionDisabledMessage = locString('youHaveParticipated');
        }
      } else {
        if (this.activity.clickedCount >= this.activity.clickLimit) {
          actionDisabledMessage = locString('completelyReserved');
        } else if (DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) <= 0) {
          actionDisabledMessage = locString('campaignIsEnded');
        }
      }
    }
    const actionOnPress = () => {
      if (this.activity.isUserActionable) {
        this.showSimpleOverlayView({
          icon: IconQuestion,
          iconColor: ColorOrange,
          title: locString('participatingEvent'),
          subTitle: locString('participatingEventMessage'),
          positiveActionText: locString('yes'),
          negativeActionText: locString('no'),
          onPositiveClicked: () => {
            this.playGamePlayAudioInline();
            this.makeApiToParticipate();
          }
        });
      } else if (this.activity.userClickedCount > 0) {
        if (this.activity.userValue2 > 0) {
          this.onViewOfferClicked();
        } else {
          if (!this.props.inPreview) {
            this.showToast(locString('youHaveParticipated'));
          }
        }
      }
    };
    return (
      <View /*style={styles.viewActionWrapper}*/>
        {actionText ?
          <View style={{flex: 1, margin: SpaceXSmall}}>
            <Button
              disabled={!this.activity.isUserActionable && this.activity.userClickedCount === 0}
              style={{borderRadius: HeightElementMinimum / 2}}
              titleMaxLines={3}
              onClick={actionOnPress}
              titleColor={ColorWhite}
              color={actionColor}
            >{actionText}</Button>
          </View>
          : null
        }
        {this.getNoActionMessageViewEx()}
        {this.getTextView(actionDisabledMessage)}
      </View>
    );
  }

  getCampaignSmartAdActionView() {
    return (
      <View /*style={[styles.viewActionWrapper]}*/>
        {this.activity.isUserActionable || this.activity.link ?
          <Button
            onClick={() => {
              if (this.activity.isUserActionable) {
                this.makeApiForClick();
              } else {
                this.onLinkClicked();
              }
            }}
            color={ColorSecondary}
            titleColor={ColorWhite}
            style={{margin: SpaceXSmall, borderRadius: HeightElementMinimum/2}}
          >{this.activity.linkText ? this.activity.linkText : locString('clickHere')}</Button>
          : null
        }
      </View>
    );
  }

  getExternalGameActionView(height, gameOtherInfo) {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();

    if (!this.gameOptions) {
      let images = null;
      if (this.activity.slotValues && this.activity.slotValues.length > 0) {
        images = [];
        this.activity.slotValues.forEach((slotValue) => {
          if (slotValue.imageUrl) {
            images.push({number: slotValue.number, url: slotValue.imageUrl});
          }
        });
      }
      let audios = null;
      if (this.activity.bgAudioUrl) {
        audios = [{number: 0, url: this.activity.bgAudioUrl}];
      }
      this.gameOptions = {
        scale: window.appScale,
        isRotated: this.props.isRotated,
        simulation: this.props.simulation,
        width: this.props.width,
        height: height,
        // images: images,
        // audios: audios,
        canPlay: this.activity.isUserActionable,
        mute: this.state.mute,
        locale: this.props.locale,
        themeColor: this.activity.themeColor || this.activity.gameInfo.themeColor,
        name: this.activity.gameInfo.name,
        images: images,
        audios: audios,
      }
      if (!this.activity.gameInfo.gameUrl) {
        this.gameOptions.scoreToWin = this.activity.winnersByValue;
        this.gameOptions.gameTime = this.activity.gameTime;
        this.gameOptions.tryCount = this.activity.gameInfo.tryCount;
        this.gameOptions.onStart = this.onExternalGameStart;
        this.gameOptions.onEnd = this.onExternalGameEnd;
        if (this.props.inPreview && this.activity.gameInfo.id === 5) {
          this.gameOptions.gameTime = 40 * 1000;
        }
      }
    }

    let scoreView = null;
    if (gameOtherInfo.showScore) {
      const score = this.activity.userValueText ? parseInt(this.activity.userValueText) : 0;
      scoreView = (
        <div className={classes.viewColumnFullWidth} style={{marginBottom: 24}}>
          {/*<TextView fontSizeN={uiConfigs.fontSize} variant={'h6'} color={ColorWhite} fontWeight={FontWeightMedium}><FormattedMessage id={'gameOver'}/></TextView>*/}
          {this.activity.gameInfo.resultType === 2 ? <TextView fontSizeN={uiConfigs.fontSize} variant={'h5'} color={uiConfigs.titleColor} fontWeight={FontWeightBold} style={{marginTop: 16}}><FormattedMessage id={'game.score'} values={{value: score}}/></TextView> : null}
        </div>
      )
    }
    const hideGameStatus = this.activity.isUserActionable;
    let gameStatusView = null;
    if (!this.activity.isUserActionable) {
      gameStatusView = this.getGameActionOtherView(gameOtherInfo, scoreView);
    }
    const styleBlur = !hideGameStatus ? {filter: 'blur(3px)'} : null;
    return (
      <div style={{width: '100%', height: '100%', minHeight: height, backgroundColor: uiConfigs.bgColor}}>
        <View style={{width: '100%', height: '100%', minHeight: height, ...styleBlur}}>
          {this.activity.gameInfo.gameUrl ?
            <React.Fragment>
              <iframe
                key={''+ this.iframeLoadCount}
                ref={this.refHandlerIframeGameView}
                id={'iframeGame'}
                width={this.props.width}
                height={height}
                src={this.activity.gameInfo.gameUrl}
                style={{display: 'flex', flex: 1, width: '100%', border: 'none', overflow: 'hidden', margin: 0}}
                onLoad={this.onIframeLoad}
              />
              {!this.state.onIframeLoaded ?
                <Skeleton animation={'wave'} variant={'rect'} style={{position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', backgroundColor: uiConfigs.bgColor}}/>
                : null
              }
            </React.Fragment>
            :
            <ExternalGameComponentView
              width={this.props.width}
              height={height}
              gameOptions={this.gameOptions}
              refHandler={this.refExGame}
              gameId={this.activity.gameInfo.id}/>
          }
        </View>
        {(!this.activity.isUserActionable && gameStatusView != null) || this.isGameDataUpdating ?
          <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', paddingTop: 20, backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {this.isGameDataUpdating ? <div className={classes.flexColumn} style={{justifyContent: 'center'}}><CircularProgress style={{color: uiConfigs.accentColor}}/></div> : gameStatusView}
          </div>
          : null
        }
      </div>
    );
  }

  onIframeLoad = () => {
    logDebug('iframeLoaded');
    window.removeEventListener('message', this.onMessage);
    window.addEventListener('message', this.onMessage);
    this.setState({mute: 1});

    // this.postMessage({
    //   type: 'RAB7_GAME_DATA',
    //   metadata: this.gameOptions,
    // });
  }

  refHandlerExternalGameView = (ref) => {this.refExGame.current = ref};

  refHandlerIframeGameView = (ref) => {this.refIframeGame = ref};

  postMessage = (data) => {
    this.refIframeGame.contentWindow.postMessage(data, '*');
  };

  onMessage = (event) => {
    const data = event.data;
    if (data.type === 'RAB7_GAME_LOAD') {
      this.setState({mute: 1});
      this.onExternalGameInit(data.metadata);
      if (this.props.gameValidationCallbacks && this.props.gameValidationCallbacks.onLoad) {
        this.props.gameValidationCallbacks.onLoad(data.metadata, this.onMuteToggle);
      }
    } else if (data.type === 'RAB7_GAME_START') {
      this.onExternalGameStart();
      if (this.props.gameValidationCallbacks && this.props.gameValidationCallbacks.onStart) {
        this.props.gameValidationCallbacks.onStart();
      }
    } else if (data.type === 'RAB7_GAME_END') {
      this.onExternalGameEnd(data.metadata.winScore);
      if (this.props.gameValidationCallbacks && this.props.gameValidationCallbacks.onEnd) {
        this.props.gameValidationCallbacks.onEnd(data.metadata.winScore);
      }
    }
  };

  onExternalGameInit = (gameInfo) => {
    this.setState({onIframeLoaded: true});
    console.log('EX_GAME_INFO', gameInfo);

    this.postMessage({
      type: 'RAB7_GAME_DATA',
      metadata: this.gameOptions,
    });
  }

  onExternalGameStart = () => {
    this.makeApiForExternalGameStart();
  }

  onExternalGameEnd = (score) => {
    const gameEndValue = {value: score};
    if (this.activity.gameInfo.resultType === 1) {
      gameEndValue.isWin = score > 0;
    }
    this.makeApiForExternalGameOver(gameEndValue);
    this.reloadView();
  }

  restartExternalGame = () => {
    if (this.refExGame && this.refExGame.current) {
      this.gameOptions.canPlay = this.activity.isUserActionable;
      this.refExGame.current.restart(this.gameOptions);
    } else if (this.refIframeGame) {
      // this.postMessage({
      //   type: 'RAB7_GAME_RESTART',
      //   metadata: this.gameOptions
      // });
      this.iframeLoadCount++;
      this.reloadView();
    }
  };

  simulateExternalGame = () => {
    if (this.refExGame.current) {
      this.refExGame.current.simulate();
    } else if (this.refIframeGame) {
      this.postMessage({
        type: 'RAB7_GAME_SIMULATE',
      });
    }
  };

  toggleExternalGameMute = () => {
    if (this.refExGame.current) {
      this.refExGame.current.mute(this.state.mute);
    } else if (this.refIframeGame) {
      this.postMessage({
        type: 'RAB7_GAME_TOGGLE_MUTE',
        metadata: {
          mute: this.state.mute
        }
      });
    }
  };

  // endregion

  getLikeUserViewHorizontal(user) {
    const imageSize = 40;
    const likeCountText = ValueHelper.getDisplayValue(user.likesCount);
    let likeText = null;
    if (user.likesCount == 1) {
      if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
        likeText = locString('starWithValue', {value: likeCountText, value1: this.getGameValuePlaceholder()});
      } else {
        likeText = locString('cLikeWithValue', {value: likeCountText, value1: this.getGameValuePlaceholder()});
      }
    } else {
      if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
        likeText = locString('starsWithValue', {value: likeCountText, value1: this.getGameValuePlaceholder()});
      } else {
        likeText = locString('cLikesWithValue', {value: likeCountText, value1: this.getGameValuePlaceholder()});
      }
    }
    return (
      <View style={{flex: 1, flexDirection: 'row', margin: SpaceXSmall}}>
        <View style={{
          width: imageSize,
          marginRight: SpaceXSmall}}>
          <AppImage
            style={{width: imageSize, height: imageSize, borderColor: ColorOtherTitle, borderRadius: imageSize/2}}
            imageUrl={user.imageUrl}
          />
        </View>
        <View style={{flex: 1}}>
          <AppTextWrapper
            numberOfLines={1}
            style={{
              fontSize: FontSizeNormal,
              fontWeight: FontWeightRegular,
              color: ColorTitle,
            }}>{user.name}
          </AppTextWrapper>
          {user.username ?
            <AppTextWrapper
              numberOfLines={1}
              style={{
                fontSize: FontSizeSmall,
                fontWeight: FontWeightRegular,
                color: ColorSubTitle,
              }}>{"@" + user.username}
            </AppTextWrapper>
            : null
          }
          {user.likesCount ?
            <AppTextWrapper
              numberOfLines={1}
              style={{
                fontSize: FontSizeSmall,
                fontWeight: FontWeightMedium,
                color: ColorSubTitle,
                marginTop: 2
              }}>{likeText}
            </AppTextWrapper>
            : null
          }
        </View>
      </View>
    );
  }

  getLikeUserViewVerticalWithAction(user) {
    const uiConfigs = this.getUIConfigs();
    const imageSize = 48;
    const likeCountText = ValueHelper.getDisplayValue(user.value);
    let likeText = locString('starWithValue', {value: likeCountText, value1: this.getGameValuePlaceholder()});
    return (
      <View key={''+ user.id} style={{marginTop: 6, padding: 6, borderRadius: RadiusView}}>
        <View style={{flexDirection: 'row', alignItems: 'center'}}>
          <View style={{
            width: imageSize,
            marginRight: SpaceXSmall}}>
            <AppImage
              style={{width: imageSize, height: imageSize, borderColor: ColorOtherTitle, borderRadius: imageSize/2}}
              imageUrl={user.imageUrl}
            />
          </View>
          <View style={{flex: 1}}>
            <AppTextWrapper
              numberOfLines={2}
              style={{
                fontSize: FontSizeNormal,
                fontWeight: FontWeightRegular,
                color: uiConfigs.titleColor,
              }}>{user.name}
            </AppTextWrapper>
            {/*{user.username ?*/}
            {/*    <AppTextWrapper*/}
            {/*        numberOfLines={1}*/}
            {/*        style={{*/}
            {/*            fontSize: FontSizeSmall,*/}
            {/*            fontWeight: FontWeightRegular,*/}
            {/*            color: uiConfigs.subTitleColor,*/}
            {/*        }}>{"@" + user.username}*/}
            {/*    </AppTextWrapper>*/}
            {/*    : null*/}
            {/*}*/}
            <AppTextWrapper
              numberOfLines={1}
              style={{
                fontSize: FontSizeSmall,
                fontWeight: FontWeightMedium,
                color: uiConfigs.subTitleColor,
                marginTop: 2
              }}>{likeText}
            </AppTextWrapper>
          </View>
        </View>
      </View>
    );
  }

  getGameActionOtherView(gameOtherInfo, topView = null, bottomView = null) {
    const showQuestion = this.activity.inQuestion && this.activity.inQuestion.isUserActionable;
    if (showQuestion) {
      return null;
    }
    if (this.props.autoSimulation) {
      return null;
    }

    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const showInline = gameOtherInfo.showInline;
    const spaceTop = gameOtherInfo.paddingTop || showInline ? 12 * uiConfigs.sizeFactor : 20 * uiConfigs.sizeFactor;
    // const padding = showInline ? 0 : 16;
    const padding = 8 * uiConfigs.sizeFactor;

    let subView = null;
    if (this.props.gameValidationCallbacks) {
      subView = (
        <View className={classes.viewColumnFullWidth}>
          {this.getResetActionView()}
        </View>
      );
    } else {
      let rewardsWonView = null;
      let resetActionView = null;
      if (!this.props.autoSimulation) {
        rewardsWonView = gameOtherInfo.rewardsWonView;
        resetActionView = this.getResetActionView();
      }
      const noActionMessage = this.getNoActionMessageViewEx();
      const actionDisabledView = this.getTextView(gameOtherInfo.actionDisabledMessage);
      const statusView = this.getGameStatusView(gameOtherInfo);
      const recurView = this.getGameRecurView();

      if (rewardsWonView || resetActionView || noActionMessage
        || actionDisabledView || statusView || recurView) {
        subView = (
          <View className={classes.viewColumnFullWidth}>
            {rewardsWonView}
            {noActionMessage}
            {actionDisabledView}
            {statusView}
            {recurView}
            {resetActionView}
          </View>
        );
      }
    }
    if (!topView && !subView && !bottomView) {
      return null;
    }

    return (
      <ScrollView style={{width: '100%', flex: 1, alignItems: 'center', padding: 12 * uiConfigs.sizeFactor, paddingTop: spaceTop}}>
        <div className={classes.viewColumnFullWidth} style={{minHeight: showInline ? 0 : 300, justifyContent: 'center'}}>
          <Paper className={classes.viewColumnFullWidth} style={{padding: padding, borderRadius: BORDER_RADIUS, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColor, 0.9) +','+ colorWithAlpha(uiConfigs.themeColorDark, 0.9) +')'}}>
            {topView}
            {subView}
            {bottomView}
          </Paper>
        </div>
      </ScrollView>
    );
  }

  getTextView(title, numberOfLines = 0) {
    if (!title) {
      return null;
    }
    return (
      <GetTextView isXS={this.props.isXS} numberOfLines={numberOfLines} title={title} uiConfigs={this.getUIConfigs()}/>
    );
  }

  getGameRecurView() {
    if (!this.activity.noActionMessage && this.activity.recurAt) {
      return this.getTextView(locString('gameRecurAgain', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.recurAt)}));
    }
    return null;
  }

  getNoActionMessageView() {
    if (this.activity.noActionMessage) {
      return (
        <GetNoActionMessageView
          noActionMessage={this.activity.noActionMessage}
          showCollectMorePoints={this.activity.showCollectMorePoints}
          onCollectMoreClicked={this.onCollectMoreClicked}
        />
      );
    }
    return null;
  }

  getNoActionMessageViewEx() {
    if (!this.activity.isUserActionable && this.activity.noActionMessage) {
      const onClick = () => {/*FunInnerScreen.navigateToCollectMore(this.props.navigation, this.activity.cBusinessId)*/};
      return (
        <View style={{alignItems: 'center'}}>
          {this.getTextView(this.activity.noActionMessage)}
          {this.activity.showCollectMorePoints ?
            this.getUIConfigs().otherActionImage ?
              this.getImageActionButton(onClick, locString('collectMorePoints'), 250)
              : <Button
                onClick={onClick}
                style={{borderRadius: HeightElementMinimum / 2, paddingLeft: 20, paddingRight: 20}}
                color={ColorGreen}
                titleColor={ColorWhite}
              >{locString('collectMorePoints')}</Button>
            : null
          }
        </View>
      );
    }
    return null;
  }

  getResetActionView() {
    if (!this.activity.isUserResetable || (this.activity.inQuestion && this.activity.inQuestion.isUserActionable)) {
      return null;
    }
    let buttonTextKey = null;
    if (this.props.inPreview) {
      buttonTextKey = this.props.gameValidationCallbacks ? 'playAgain' : 'activity.resetPreview';
    } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
      buttonTextKey = 'startAgain';
    } else {
      buttonTextKey = 'playAgain';
    }
    const onClick = () => {this.resetGame()};
    return (
      <View style={{alignItems: 'center', marginTop: 12}}>
        {this.getImageActionButton(onClick, locString(buttonTextKey), 200)}
      </View>
    );
  }

  getGameStatusView(gameOtherInfo) {
    const uiConfigs = this.getUIConfigs();
    if (this.props.autoSimulation && this.activity.userWon) {
      return (
        <AppText
          fontSizeN={uiConfigs.fontSize}
          variant={'h6'}
          style={{
            color: uiConfigs.titleColor,
            fontWeight: FontWeightMedium,
            textAlign: 'center',
          }}>
          <FormattedHTMLMessage id={this.props.canPlayInShowcase ? 'screen.diveIn' : 'screen.diveInNoPlay'}/>
        </AppText>
      );
    }

    const isGameOver = gameOtherInfo.gamePlayTriesOver;
    if (!this.activity.isUserActionable
      && DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) < 0
      && !this.activity.isInternal
      && this.activity.type !== constants.activity.types.CHALLENGE) {

      const isGuestUser = this.props.isGuestUser && !this.props.inPreview;
      let winEligible = this.activity.userWinEligible;
      if (isGameOver) {
        if (this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_SURVEY) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_GUESS || this.activity.type === ACTIVITY_TYPE_PREDICTION
          || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE) {
          if (!this.shouldShowRewards() && (this.activity.userAnswer == this.activity.consumeLimitPerUser)) {
            winEligible = true;
          }
        }
      }
      const canPutExplicitShare = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) > 0
        && DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) < 0
        && !this.props.inPreview
        && !this.props.playInShowcase;

      let title = null;
      let subTitle = null;
      let showInQuestion = false;
      let showJoinUsView = false;
      let showShare = false;
      let needContactNumber = false;
      let needName = false;
      let actionText = null;
      let actionClick = null;
      let canGoBackAuto = false;
      if (this.activity.userWon) {
        canGoBackAuto = true;
        if (this.activity.inQuestion && this.activity.inQuestion.isUserActionable) {
          showInQuestion = true;
          if (this.activity.userValue1 === -1 || !this.activity.userValues) {
            title = locString('activity.wonChallengeNoRewardInQuestion');
          } else {
            title = locString('activity.wonChallengeInQuestion');
          }
        } else if (isGuestUser) {
          if (this.activity.userValue1 === -1 || !this.activity.userValues) {
            subTitle = locString('activity.joinGenericNR');
            showJoinUsView = true;
          } else {
            subTitle = locString('activity.wonChallengeMessageNR');
            actionText = locStringA(this.context.intl, 'generic.joinRab7Now');
            actionClick = this.moveToJoinUs;
          }
        } else if (this.activity.needContactNumber) {
          subTitle = locString('activity.needCustomerContactWon');
          actionText = locStringA(this.context.intl, 'proceed');
          actionClick = this.moveToUpdateMobile;
        } else if (this.activity.needName) {
          subTitle = locString('activity.needNameWon');
          actionText = locStringA(this.context.intl, 'proceed');
          actionClick = this.moveToUpdateName;
        } else if (canPutExplicitShare) {
          showShare = true;
        }
      } else if (winEligible) {
        needContactNumber = this.activity.needContactNumber;
        needName = this.activity.needName;
        canGoBackAuto = true;
        title = locStringA(this.context.intl, 'activity.passChallenge');
        if (this.activity.type === constants.activity.types.PREDICTION) {
          if (!this.props.inPreview && this.activity.rightOptionHint) {
            const rightOption = ''+ this.activity.rightOptionHint + (this.activity.rightOptionHintAr ? ','+ this.activity.rightOptionHintAr : '');
            if (this.guessText == rightOption) {
              title = locStringA(this.context.intl, 'activity.userPredictionRight');
            } else {
              title = locStringA(this.context.intl, 'activity.userPredictionWrong');
            }
          } else {
            const canUpdate = !isGuestUser && this.activity.isUserActionableA;
            // title = locStringA(this.context.intl, canUpdate ? 'activity.youHavePredicatedNUpdate' : 'activity.youHavePredicated');
            title = null;
          }
        } else if (this.activity.type === constants.activity.types.GUESS) {
          if (!this.props.inPreview && this.activity.isCodeNeeded && this.activity.rightOptionId) {
            if (this.guessText == this.activity.rightOptionId) {
              title = locStringA(this.context.intl, 'activity.userGuessRight');
            } else {
              title = locStringA(this.context.intl, 'activity.userGuessWrong');
            }
          } else {
            const canUpdate = !isGuestUser && this.activity.isUserActionableA;
            title = locStringA(this.context.intl, canUpdate ? 'activity.youHaveGuessedNUpdate' : 'activity.youHaveGuessed');
          }
        } else if (this.activity.type === constants.activity.types.IDENTIFY_LOCATION) {
          const canUpdate = !isGuestUser && this.activity.isUserActionableA;
          title = locStringA(this.context.intl, canUpdate ? 'activity.locationPickedNUpdate' : 'activity.locationPicked');
        }

        if (this.activity.inQuestion && this.activity.inQuestion.isUserActionable) {
          showInQuestion = true;
          if (!this.activity.noRewards && this.activity.winnersAt) {
            title = locString('activity.winEligibleInQuestion');
          } else {
            title = locString('activity.wonChallengeNoRewardInQuestion');
          }
        } else if (isGuestUser) {
          if (!this.activity.noRewards && this.activity.winnersAt) {
            title = locStringA(this.context.intl, 'activity.passChallengeJoinUs');
            // subTitle = locStringA(this.context.intl, 'activity.passChallengeMessageNR', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)});
            // if (this.activity.type === constants.activity.types.PREDICTION
            //   || this.activity.type === constants.activity.types.GUESS) {
            //   subTitle = locStringA(this.context.intl, 'activity.updateActionRewardMessageNR');
            // }
          } else {
            title = locStringA(this.context.intl, 'activity.joinGenericNR');
            // if (this.activity.isUserActionableA && (
            //   this.activity.type === constants.activity.types.PREDICTION
            //     || this.activity.type === constants.activity.types.GUESS
            //     || this.activity.type === constants.activity.types.IDENTIFY_LOCATION)
            // ) {
            //   subTitle = locStringA(this.context.intl, 'activity.updateActionMessageNR');
            // }
          }
          // actionText = locStringA(this.context.intl, 'generic.joinRab7Now');
          // actionClick = this.moveToJoinUs;
          showJoinUsView = true;
        } else if (this.activity.needContactNumber) {
          subTitle = locStringA(this.context.intl, 'activity.needCustomerContact', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)});
        } else if (this.activity.needName) {
          subTitle = locStringA(this.context.intl, 'activity.needCustomerName', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)});
        } else {
          if (!this.activity.noRewards && this.activity.winnersAt) {
            subTitle = locStringA(this.context.intl, 'activity.eligibleToRaffle', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)});
          } else {
            if (this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
              subTitle = locStringA(this.context.intl, 'youHaveReviewed');
            } else if (this.activity.type === ACTIVITY_TYPE_SURVEY) {
              subTitle = locStringA(this.context.intl, 'surveyCompleted');
            }
          }
          showShare = canPutExplicitShare;
        }
      } else if (this.activity.userNotWon) {
        needName = this.activity.needName;
        canGoBackAuto = true;
        // if (this.activity.rightOptionId) {
        //   if (this.guessText == this.activity.rightOptionId) {
        //     title = locStringA(this.context.intl, 'activity.userGuessRight');
        //   } else {
        //     title = locStringA(this.context.intl, 'activity.userGuessWrong');
        //   }
        // }
        if (this.activity.inQuestion && this.activity.inQuestion.isUserActionable) {
          showInQuestion = true;
          title = locString('activity.wonChallengeNoRewardInQuestion');
        } else if (isGuestUser) {
          subTitle = locStringA(this.context.intl, 'activity.joinGenericNR');
          // actionText = locStringA(this.context.intl, 'generic.joinRab7Now');
          // actionClick = this.moveToJoinUs;
          showJoinUsView = true;
        } else if (this.activity.needName) {
          subTitle = locStringA(this.context.intl, 'activity.gameOverProvideName');
        } else if (canPutExplicitShare) {
          showShare = true;
        }
      } else if (isGameOver) {
        if (!this.activity.isUserResetable) {
          needName = this.activity.needName;
          canGoBackAuto = true;
          title = locStringA(this.context.intl, 'activity.gameOverChallenge');
          if (this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU) {
            title = locStringA(this.context.intl, 'campaign.endedDone');
          } else if (this.activity.type === constants.activity.types.GUESS) {
            if (this.activity.isCodeNeeded && this.activity.rightOptionId) {
              if (this.guessText == this.activity.rightOptionId) {
                title = locString('activity.userGuessRight');
              } else {
                title = locString('activity.userGuessWrong');
              }
            }
          }
          if (DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt) > 0) {
            if (this.activity.inQuestion && this.activity.inQuestion.isUserActionable) {
              showInQuestion = true;
              title = locString('activity.wonChallengeNoRewardInQuestion');
            } else if (isGuestUser) {
              title = locStringA(this.context.intl, 'activity.gameOverChallengeNR');
              subTitle = locStringA(this.context.intl, 'activity.gameOverChallengeMessageNR');
              // actionText = locStringA(this.context.intl, 'generic.joinRab7Now');
              // actionClick = this.moveToJoinUs;
              showJoinUsView = true;
            } else if (this.activity.needName) {
              title = locStringA(this.context.intl, 'activity.gameOverChallengeTitle');
              subTitle = locStringA(this.context.intl, 'activity.gameOverProvideName');
            } else if (this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU) {
              title = null;
            } else if (!this.props.inPreview && !this.props.playInShowcase) {
              title = locStringA(this.context.intl, 'activity.gameOverChallengeTitle');
              subTitle = locStringA(this.context.intl, 'activity.gameOverChallengeMessage');
              actionText = locStringA(this.context.intl, 'activity.share');
              actionClick = this.onShareClicked;
              if (this.timerShowShare) {
                logDebug('DG:S_shareDialogClear');
                clearTimeout(this.timerShowShare);
                this.timerShowShare = null;
              }
            }
          } else if (this.activity.needName) {
            title = locStringA(this.context.intl, 'activity.gameOverChallengeTitle');
            subTitle = locStringA(this.context.intl, 'activity.gameOverProvideName');
          }
        } else if (!gameOtherInfo.actionDisabledMessage) {
          // if (this.activity.needName) {
          //   title = locStringA(this.context.intl, 'activity.gameOverChallengeTitle');
          //   subTitle = locStringA(this.context.intl, 'activity.gameOverProvideNamePlayAgain');
          // } else {
            subTitle = locStringA(this.context.intl, 'activity.gameOverChallengePlayAgain');
          // }
        }
      }
      if (!title && !subTitle && !canGoBackAuto && !showShare) {
        return null;
      }

      if (this.props.autoSimulation) {
        subTitle = null;
        title = <FormattedHTMLMessage id={this.props.canPlayInShowcase ? 'screen.diveIn' : 'screen.diveInNoPlay'}/>
      }

      const {classes} = this.props;
      if (!(title || subTitle || showJoinUsView || showInQuestion || showShare
        || (!this.props.autoSimulation && actionText)
        || (this.props.playInShowcase && !this.props.autoSimulation && canGoBackAuto))) {
        return null;
      }
      let rewardText = null;
      if (showJoinUsView) {
        if (this.activity.type !== constants.activity.types.QUESTIONNAIRE
          && this.activity.slotValues && this.activity.slotValues.length > 0
          && this.activity.slotValues[0].offers && this.activity.slotValues[0].offers.length > 0) {
          rewardText = this.activity.slotValues[0].offers[0].title;
        }
      }
      if (showInQuestion) {
        rewardText = null;
        actionText = null;
        subTitle = null;
        showJoinUsView = null;
        needContactNumber = false;
        needName = false;
        showShare = false;
      }
      return (
        <View className={classes.viewColumn} style={{backgroundColor: tinycolor(ColorBackground).setAlpha(0.9), border: '1px solid '+ ColorBackground, borderRadius: 8, padding: 6, paddingLeft: 10, paddingRight: 10, minHeight: gameOtherInfo.showInline ? 0 : 200, justifyContent: 'center'}}>
          <FullWidthDummyView/>
          {rewardText ?
            <React.Fragment>
              <AppText
                fontSizeN={uiConfigs.fontSize}
                variant={'subtitle1'}
                numberOfLines={2}
                style={{
                  color: ColorTitle,
                  fontWeight: FontWeightMedium,
                  textAlign: 'center',
                }}>{rewardText}
              </AppText>
              <div className={classes.viewColumnFullWidth} style={{justifyContent: 'center'}}>
                <div style={{width: 150, height: 1, margin: 8, backgroundColor: ColorOtherTitle}}/>
              </div>
            </React.Fragment>
            : null
          }
          {title ?
            <AppText
              fontSizeN={uiConfigs.fontSize}
              variant={'subtitle1'}
              style={{
                color: ColorTitle,
                fontWeight: FontWeightBold,
                textAlign: 'center',
                marginBottom: subTitle ? 4 : 0
              }}>{title}
            </AppText>
            : null
          }
          {subTitle ?
            <AppText
              fontSizeN={uiConfigs.fontSize}
              variant={'body1'}
              style={{
                color: ColorSubTitle,
                fontWeight: FontWeightMedium,
                textAlign: 'center'
              }}>{subTitle}
            </AppText>
            : null
          }
          {showInQuestion ?
            this.getCampaignInnerQuestionView(this.activity.inQuestion)
            : null
          }
          {showJoinUsView ?
            <div>
              <JoinNow
                history={this.props.history}
                activityId={this.activity.id}
                activityType={this.activity.type}
                needContactNumber={this.activity.needContactNumber}
                contactNumberHelperTextId={'activity.mobileRequiredNonRegistered'}
                showEnd={this.activity.videoUrl || this.activity.s2ImageUrl}
                uiConfigs={uiConfigs}
                onDone={this.onJoinInlineDone}
                isLTR={this.props.isLTR}
                maxWidth={this.props.width}
                noMinHeight={true}
              />
            </div>
            : needContactNumber ?
              <UpdateMobileInline
                history={this.props.history}
                activityId={this.activity.id}
                activityType={this.activity.type}
                needName={this.activity.needName}
                uiConfigs={uiConfigs}
                onDone={this.onJoinInlineDone}
                isLTR={this.props.isLTR}
                maxWidth={this.props.width}
                noMinHeight={true}
              />
              : needName ?
                <UpdateNameInline
                  history={this.props.history}
                  activityId={this.activity.id}
                  activityType={this.activity.type}
                  uiConfigs={uiConfigs}
                  onDone={this.onJoinInlineDone}
                  isLTR={this.props.isLTR}
                  maxWidth={this.props.width}
                  noMinHeight={true}
                />
                : null
          }
          {!this.props.autoSimulation && actionText ? <div className={classes.viewRow} style={{justifyContent: 'center', marginTop: 12}}>
              <GetActionButton
                size={'large'}
                uiConfigs={uiConfigs}
                onClick={actionClick}
                title={actionText}
              />
              {/*{this.getImageActionButton(actionClick, actionText, 300)}*/}
            </div>
            : null
          }
          {showShare ?
            <React.Fragment>
              <div className={classes.viewColumnFullWidth} style={{justifyContent: 'center'}}>
                <div style={{width: 250, height: 1, margin: 8, marginTop: 24, backgroundColor: ColorOtherTitle}}/>
              </div>
              <AppText
                fontSizeN={uiConfigs.fontSize}
                variant={'subtitle1'}
                style={{
                  color: ColorTitle,
                  fontWeight: FontWeightRegular,
                  textAlign: 'center',
                  marginBottom: 6,
                }}>{locStringA(this.context.intl, 'activity.sharePrompt')}
              </AppText>
              <div className={classes.viewRow} style={{justifyContent: 'center'}}>
                <GetActionButton
                  uiConfigs={uiConfigs}
                  onClick={this.onShareClicked}
                  title={locStringA(this.context.intl, 'activity.share')}
                />
              </div>
            </React.Fragment>
            : null
          }
          {this.props.playInShowcase && !this.props.autoSimulation && canGoBackAuto ?
            this.getAutoCloseView(title || subTitle)
            : null
          }
        </View>
      );
    }
    return null;
  }

  getInternalQuestionView(gameOtherInfo) {
    const isGameOver = gameOtherInfo.gamePlayTriesOver;
    if (!this.activity.isUserActionable
      // && DateTimeHelper.getSecondsDiffFromNow(this.activity.restartAt) < 0
      // && !this.activity.isInternal
      // && this.activity.type !== constants.activity.types.CHALLENGE
    ) {

      let winEligible = this.activity.userWinEligible;
      if (isGameOver) {
        if (this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_SURVEY) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_GUESS || this.activity.type === ACTIVITY_TYPE_PREDICTION
          || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
          winEligible = true;
        } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE) {
          if (!this.shouldShowRewards() && (this.activity.userAnswer == this.activity.consumeLimitPerUser)) {
            winEligible = true;
          }
        }
      }

      let title = null;
      if (this.activity.userWon) {
        if (this.activity.userValue1 === -1 || !this.activity.userValues) {
          title = locString('activity.wonChallengeNoRewardInQuestion');
        } else {
          title = locString('activity.wonChallengeInQuestion');
        }
      } else if (winEligible) {
        if (!this.activity.noRewards && this.activity.winnersAt) {
          title = locString('activity.winEligibleInQuestion');
        } else {
          title = locString('activity.wonChallengeNoRewardInQuestion');
        }
      } else if (this.activity.userNotWon) {
        title = locString('activity.wonChallengeNoRewardInQuestion');
      } else {
        title = locString('activity.wonChallengeNoRewardInQuestion');
      }

      if (!title) {
        return null;
      }

      const showInline = gameOtherInfo.showInline;
      const {classes} = this.props;
      const uiConfigs = this.getUIConfigs();
      const spaceTop = gameOtherInfo.paddingTop || showInline ? 12 * uiConfigs.sizeFactor : 20 * uiConfigs.sizeFactor;
      const padding = 8 * uiConfigs.sizeFactor;
      return (
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <ScrollView style={{width: '100%', flex: 1, alignItems: 'center', padding: 12 * uiConfigs.sizeFactor, paddingTop: spaceTop}}>
            <Paper className={classes.viewColumnFullWidth} style={{padding: padding, paddingBottom: 0, borderRadius: BORDER_RADIUS, background: 'linear-gradient(0deg, '+ colorWithAlpha(uiConfigs.themeColor, 0.9) +','+ colorWithAlpha(uiConfigs.themeColorDark, 0.9) +')'}}>
              <View className={classes.viewColumnFullWidth} style={{paddingTop: 4}}>
                <FullWidthDummyView/>
                <AppText
                  fontSizeN={uiConfigs.fontSize}
                  variant={'h6'}
                  style={{
                    color: uiConfigs.titleColor,
                    fontWeight: FontWeightMedium,
                    textAlign: 'center',
                    marginTop: 4,
                    marginBottom: 20}}>
                  {title}
                </AppText>
                {this.getCampaignInnerQuestionView(this.activity.inQuestion)}
              </View>
            </Paper>
          </ScrollView>
        </div>
      );
    }
    return null;
  }

  getAutoCloseView = (topViewPresent) => {
    if (!this.autoCloseIntervalHandler) {
      this.setState({autoCloseTimer: 10});
      this.autoCloseIntervalHandler = setInterval(() => {
        const autoCloseTimer = Math.max(0, this.state.autoCloseTimer - 1);
        this.setState({autoCloseTimer: autoCloseTimer}, () => {
          if (autoCloseTimer === 0) {
            this.onBackClicked();
          }
        });
      }, 1000);
    }

    const uiConfigs = this.getUIConfigs();
    const autoCloseTimer = this.state.autoCloseTimer;
    return (
      <div className={this.props.classes.viewColumn} style={{marginTop: topViewPresent ? 40 : 0}}>
        <AppText
          fontSizeN={uiConfigs.fontSize}
          variant={'body1'}
          style={{
            color: uiConfigs.subTitleColor,
            fontWeight: FontWeightMedium,
            textAlign: 'center'
          }}>
          <FormattedHTMLMessage id={autoCloseTimer === 1 ? 'showcase.autoClosePlayGameEnd1' : 'showcase.autoClosePlayGameEnd'} values={{value: autoCloseTimer}}/>
        </AppText>
      </div>
    );
  }

  moveToJoinUs = () => {
    // this.props.history.push({
    //   pathname: PathJoin,
    //   search: getRedirectSearch(this.props.history.location)
    // })
    this.onPlayJoinClicked();
  }

  moveToUpdateMobile = () => {
    // this.props.history.push({
    //   pathname: PathJoin,
    //   search: getRedirectSearch(this.props.history.location)
    // })
    this.onUpdateMobileClicked();
  }

  moveToUpdateName = () => {
    // this.props.history.push({
    //   pathname: PathJoin,
    //   search: getRedirectSearch(this.props.history.location)
    // })
    this.onUpdateNameClicked();
  }

  getImageActionButton(onClick, title, width = 200, image = null, disabled = false, isNegative = false) {
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;

    if (image || uiConfigs.otherActionImage) {
      return (
        <GetImageActionButton
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
          onClick={onClick}
          title={title}
          width={width}
          image={image || uiConfigs.otherActionImage}
          disabled={disabled}
        />
      );
    }
    return (
      <GetActionButton
        disabled={disabled}
        isNegative={isNegative}
        uiConfigs={uiConfigs}
        onClick={onClick}
        title={title}
      />
    );
  }

  getTopUsersView() {
    if (this.activity.topUsers && this.activity.topUsers.length > 0) {
      const views = [];
      this.activity.topUsers.forEach((user) => {
        views.push(this.getLikeUserViewVerticalWithAction(user));
      });
      return (
        <View style={{
          marginBottom: SpaceXSmall,
          paddingBottom: 0,
          borderRadius: 2,
        }}>
          <View style={{borderRadius: RadiusView,
            marginTop: SpaceXSmall, marginBottom: SpaceXXSmall, padding: SpaceXSmall, paddingLeft: 0, paddingBottom: 0}}>
            <AppTextWrapper
              numberOfLines={1}
              style={{
                fontSize: FontSizeNormal,
                fontWeight: FontWeightMedium,
                color: ColorTheme,
                marginLeft: SpaceXSmall
              }}>{locString('topStarsCollectors', {value1: this.getGameValuePlaceholder()})}
            </AppTextWrapper>
            <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
              {views}
            </View>
          </View>
        </View>
      );
    }
    return null;
  }

  getJackpotWonView(isDisplayedInAlert = false) {
    const wonPoints = this.activity.userValue1;
    let wonOffers = [];
    let wonGames = [];
    if (this.activity.userValueObjs && this.activity.userValueObjs.length > 0) {
      this.activity.userValueObjs.forEach((item) => {
        if (item.type === ACTIVITY_TYPE_OFFER) {
          wonOffers.push(item);
        } else {
          wonGames.push(item);
        }
      });
    }
    let wonOffersTitle = null;
    let wonOffersView = null;
    if (wonOffers && wonOffers.length > 0) {
      if (wonPoints > 0) {
        wonOffersTitle = locString(wonOffers.length > 1 ? 'youWonEJackpotOffers' : 'youWonEJackpotOffer')
      } else {
        wonOffersTitle = locString(wonOffers.length > 1 ? 'youWonJackpotOffers' : 'youWonJackpotOffer')
      }
      wonOffersView = [];
      wonOffers.forEach((item) => {
        wonOffersView.push(ActivityHelper.getActivityHorizontalView(item, isDisplayedInAlert ? this : null));
      });
    }
    let wonGamesTitle = null;
    let wonGamesView = null;
    if (wonGames && wonGames.length > 0) {
      if (wonPoints > 0 || (wonOffers && wonOffers.length > 0)) {
        wonGamesTitle = locString(wonOffers.length > 1 ? 'youWonEJackpotGames' : 'youWonEJackpotGame')
      } else {
        wonGamesTitle = locString(wonOffers.length > 1 ? 'youWonJackpotGames' : 'youWonJackpotGame')
      }
      wonGamesView = [];
      wonGames.forEach((item) => {
        wonGamesView.push(ActivityHelper.getActivityHorizontalView(item, isDisplayedInAlert ? this : null));
      });
    }
    if (wonPoints > 0 || (wonOffers && wonOffers.length > 0) || (wonGames && wonGames.length > 0)) {
      return (
        <View style={{margin: 0, marginBottom: SpaceSmall}}>
          <AppText style={{textAlign: 'center', color: ColorTheme, fontSize: FontSizeNormal + 1, fontWeight: FontWeightMedium, marginBottom: 2}}>{locString('congratulations')}</AppText>
          {wonPoints ? <AppText style={{textAlign: 'center', color: ColorTheme, fontSize: FontSizeNormal, fontWeight: FontWeightRegular, marginTop: 4}}>{locString('youWonJackpotPoints', {value: wonPoints})}</AppText> : null}
          {wonOffersView ?
            <View style={{minHeight: 30 + wonOffers.length * 36}}>
              <AppText style={{textAlign: 'center', color: ColorTheme, fontSize: FontSizeNormal, fontWeight: FontWeightRegular, marginTop: 4, marginBottom: 4}}>{wonOffersTitle}</AppText>
              {wonOffersView}
            </View>
            : null
          }
          {wonGamesView ?
            <View style={{minHeight: 30 + wonGames.length * 36}}>
              <AppText style={{textAlign: 'center', color: ColorTheme, fontSize: FontSizeNormal, fontWeight: FontWeightRegular, marginTop: 4, marginBottom: 4}}>{wonGamesTitle}</AppText>
              {wonGamesView}
            </View>
            : null
          }
          {!isDisplayedInAlert && this.activity.userWinPostId ?
            <Button
              onClick={() => {
                // ActivityReviewDetailScreen.navigateTo(this.props.navigation, null, this.activity.userWinPostId);
              }}
              elevation={false}
              color={ColorClear}
              titleColor={ColorTheme}
              style={{borderWidth: 1, borderColor: ColorTheme, marginTop: SpaceNormal, marginBottom: -4}}
              titleStyle={{fontWeight: FontWeightMedium}}
            >{locString('viewWinnerPost')}</Button>
            : null
          }
        </View>
      );
    }
    return null;
  }

  getRewardsWonView(activity = null, topView = null, topViewHeight = 0, rewardUnavailableMessage) {
    if (!activity) {
      activity = this.activity;
    }
    return (
      <GetRewardsWonView
        isGuestUser={this.props.isGuestUser}
        topView={topView}
        topViewHeight={topViewHeight}
        uiConfigs={this.getUIConfigs()}
        contentWidth={this.props.width}
        classes={this.props.classes}
        sizeFactor={this.getUIConfigs().sizeFactor}
        activity={activity}
        rewardUnavailableMessage={rewardUnavailableMessage}
        viewMaxHeight={this.getRewardWonViewMaxHeight()}
        onActivityClicked={this.onActivityClicked}
        onImageClicked={this.onImageFSClicked}
      />
    )
  }

  getParticipationWonOverlayContentView(activity, message) {
    return ActivityHelper.getParticipationWonOverlayContentView(this.getUIConfigs(), activity, this.props.width, message, this.dismissSimpleOverlayNHandleCallback, this.onActivityClicked, this.onImageFSClicked);
  }

  getGuideView() {
    const {classes} = this.props;
    const uiConfigs = this.getUIConfigs();
    const sizeFactor = uiConfigs.sizeFactor;
    return ActivityHelper.getGuideView(this.activity, uiConfigs, this.onImageFSClicked, this.onTextLinkClicked, this.context.intl);
  }

  getWalletView() {
    const pointsView = this.getParticipateConditionsView(true);
    if (pointsView != null) {
      return (
        <ScrollView
          style={{marginBottom: -8}}
          contentContainerStyle={{paddingTop: 12, paddingBottom: 12}}>
          <View style={{minHeight: 40, alignItems: 'center'}}>
            {pointsView}
          </View>
        </ScrollView>
      );
    }
    return null;
  }

  getMoreDetailsView(activity) {
    if (!activity) {
      activity = this.activity;
    }
    const showPointsCondition = activity.type === ACTIVITY_TYPE_SHARE_N_LIKE;
    return (
      <GetMoreDetailsView
        classes={this.props.classes}
        uiConfigs={this.getUIConfigs()}
        activity={activity}
        showPointsCondition={showPointsCondition}
        onLinkClick={this.onTextLinkClicked}/>
    );
  }

  getOverlayContentSeparatorView() {
    const uiConfigs = this.getUIConfigs();
    return ActivityHelper.getOverlayContentSeparatorView(uiConfigs);
  }

  static getGuessPlaceholderView(placeholder) {
    return (
      <View style={{alignItems: 'center', paddingTop: SpaceXSmall, paddingBottom: SpaceXSmall}}>
        <AppTextWrapper style={{color: ColorTheme, fontSize: FontSizeSmall, fontWeight: FontWeightMedium, textAlign: 'center'}}>
          {placeholder}
        </AppTextWrapper>
      </View>
    );
  }

  getMediaViewEx(width, borderRadius = RadiusView, spacingH = 16, spacingV = 16, maxHeight = undefined) {
    if (this.videoAsset) {
      // return (
      //   <VideoPlayerScreen
      //     ref={(ref) => this.refVideoView = ref}
      //     videoAsset={this.videoAsset}
      //     maxHeight={maxHeight}
      //     horizontalSpace={spacingH}
      //     verticalSpace={spacingV}
      //     onEnterFullscreenMode={() => this.onEnterFullscreenMode()}
      //     onExitFullscreenMode={() => this.onExitFullscreenMode()}/>
      // );
      return null;
    } else {
      const height = width / 4 * 3;
      return this.getImageView(width, height, borderRadius);
    }
  }

  onEnterFullscreenMode() {
    if (this.refScrollView) {
      this.refScrollView.scrollTo({y: 0});
    }
    super.onEnterFullscreenMode();
  }

  canAnswer() {
    if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
      if (this.activity.isUserActionable) {
        if (this.activity.value2Placeholder) {
          return this.guess2 && this.guess2.trim().length > 0 && this.guess1 && this.guess1.trim().length > 0;
        }
        return this.guess1 && this.guess1.trim().length > 0;
      }
      if (this.activity.isUserActionableA) {
        if (this.activity.value2Placeholder) {
          return this.guess2 !== this.oldGuess2 || this.guess1 !== this.oldGuess1;
        }
        return this.guess1 !== this.oldGuess1;
      }
      return false;
    } else if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
      if (this.activity.isUserActionable) {
        return this.guess2 && this.guess1;
      }
      if (this.activity.isUserActionableA) {
        return this.guess2 != this.oldGuess2 || this.guess1 != this.oldGuess1;
      }
      return false;
    } else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
      if (this.activity.isUserActionable) {
        return this.guessText && this.guessText.trim().length > 0;
      }
      if (this.activity.isUserActionableA) {
        return this.guessText !== this.oldGuessText;
      }
      return false;
    }
    return this.selectedOptionIndexes && this.selectedOptionIndexes.size > 0;
  }

  onLinkClicked() {
    if (this.activity.link) {
      // LinkHelper.open(this.activity.link);
    }
  }

  onActivityClicked = (activity) => {
    if (activity) {
      const invokeMethod = () => {
        history.push({
          pathname: getPathForActivity(activity) +'/'+ activity.id,
          state: {canGoBack: true}
        });
      };
      if (this.state.showOverlay || this.state.showImageFS) {
        this.setState({showOverlay: false, showSimpleOverlay: false, showEnd: false, showImageFS: false}, invokeMethod);
      } else {
        invokeMethod();
      }
    }
  };

  onMuteToggle = () => {
    const mute = !this.state.mute;
    this.setState({mute: mute, userMute: mute}, () => {
      setTimeout(() => {
        if (this.props.inPreview) {
          if (!this.state.mute) {
            this.playGameBgAudio();
          }
        }
        this.toggleExternalGameMute();
      }, 100);
    });
  };

  onCollectMoreClicked = () => {
    history.push({
      pathname: '/funs',
    });
  };

  onEndViewLinkClicked = () => {
    if (this.activity.s2Link) {
      LinkHelper.openLink(this.activity.s2Link);
      this.makeCtaActionsInActivity(ACTIVITY_CTA2_ACTION);
    }
  };

  onSponsorViewLinkClicked = (activity) => {
    if (activity.business.link) {
      // this.makeCtaActionsInActivity(ACTIVITY_CTA1_ACTION);
      LinkHelper.openLink(activity.business.link);
    }
  };

  onTextLinkClicked = (link) => {
    LinkHelper.openLink(link);
  };

  onOrderNowClicked = () => {

  };

  onReviewCampaignClicked = () => {
    // AddChallengeScreen.navigateTo(this.props.navigation, this.activity, null, (activity, post) => {
    //   if (activity && post) {
    //     this.activity = activity;
    //     this.updateAndReload();
    //   }
    // });
  };

  getValidityText() {
    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt);
    if (startDateDiff <= 0) {
      const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activity.endAt);
      if (endDateDiff <= 0) {
        return locString('completed');
      } else {
        return locString('ongoing');
      }
    } else {
      return locString('startingInWithValue', {value: DateTimeHelper.getValidity(this.activity.startAt)});
    }
    return null;
  };

  getDuration(color = ColorOtherTitle) {
    return (
      <AppText style={{
        color: color,
        fontSize: FontSizeSmall - 1,
        fontWeight: FontWeightRegular}}>
        <AppText>{locString('from')}</AppText>
        <AppText>{" "}</AppText>
        <AppText style={{color: color}}>{DateTimeHelper.getDisplayDate(this.activity.startAt)}</AppText>
        <AppText>{"\n"}</AppText>
        <AppText>{locString('to')}</AppText>
        <AppText>{" "}</AppText>
        <AppText style={{color: color}}>{DateTimeHelper.getDisplayDate(this.activity.endAt)}</AppText>
        {this.activity.recurAt ?
          <AppText>
            <AppText>{"\n"}</AppText>
            <AppText>{locString('restartAgainOn')}</AppText>
            <AppText>{" "}</AppText>
            <AppText style={{color: color}}>{DateTimeHelper.getDisplayDate(this.activity.recurAt)}</AppText>
          </AppText>
          : null
        }
      </AppText>
    );
  };

  onTextChanged = (text) => {
    this.reloadView();
  };

  getImageView(imageWidth, imageHeight, borderRadius = RadiusView) {
    if (this.activity.imageUrl) {
      return (
        <TouchableOpacity onClick={this.onImageFSClicked.bind(this, this.activity.imageUrl)}>
          <View style={{
            borderRadius: borderRadius,
            overflow: 'hidden',
            width: '100%',
            height: imageHeight}}>
            <AppImage
              style={{
                width: imageWidth,
                height: imageWidth/4*3,
                maxHeight: 600,
                backgroundColor: ColorBackground}}
              imageUrl={this.activity.imageUrl}
              resizeMode={'cover'}/>
          </View>
        </TouchableOpacity>
      );
    }
    return null;
  }

  getUsersView() {
    let views = null;
    if (this.activity.systemPrize && this.activity.systemPrize.myVotedUsers) {
      views = [];
      this.activity.systemPrize.myVotedUsers.forEach((item) => {
        const view = <View style={{
          flex: 1,
          flexDirection: 'row',
          marginTop: 10}}>
          <View style={{
            width: 40,
            marginRight: 10,
          }}>
            <AppImage
              style={{width: 44, height: 44, borderColor: ColorOtherTitle, borderRadius: 22}}
              imageUrl={item.imageUrl}
            />
          </View>
          <View style={{flex: 1}}>
            <AppText
              numberOfLines={1}
              style={{
                paddingTop: utils.isIos() ? 2 : 0,
                fontSize: FontSizeNormal,
                fontWeight: FontWeightMedium,
                color: ColorTitle,
              }}>{item.name}</AppText>
            <AppText
              numberOfLines={1}
              style={{
                fontSize: FontSizeNormal,
                fontWeight: FontWeightRegular,
                color: ColorSubTitle,
              }}>{"@" + item.username}</AppText>
          </View>
        </View>;
        views.push(view);
      });
    }
    return views;
  }

  isAudioRecording() {
    return this.recordAsset != null /* && this.recordAsset.state === AUDIO_RECORDER_STATE_RECORDING */;
  }

  isAudioRecorded() {
    return this.recordAsset != null;
  }

  getAsset() {
    if (this.activity && this.activity.audioUrl) {
      let audioTitle = null;
      if (this.activity.createdByType === CREATED_TYPE_ME && this.activity.createdById === this.props.userId) {
        audioTitle = locString('audioFromMe');
      } else {
        audioTitle = locString('audioFromUserName', {'0': this.activity.title});
      }
      return this.getAudioAsset(this.activity.audioUrl, this.activity.audioDuration, audioTitle);
    }
    return null;
  };

  onPickImageClicked = () => {
    this.pickPicture(this.onImagePicked, this.imageUri)
  };

  onImagePicked = (image) => {
    this.imageUri = image;
    this.refMultiInputView.setImagePicked(this.imageUri);
  };

  onRecordClicked = () => {
    this.handleRecord((recordAsset) => {
      const oldAsset = this.recordAsset;
      this.recordAsset = recordAsset;
      this.refMultiInputView.setRecordAsset(recordAsset);
      if (!oldAsset || oldAsset.audioPath != this.recordAsset.audioPath || oldAsset.state != this.recordAsset.state) {
        this.reloadView();
      }
    }, (playAsset) => {
      this.refMultiInputView.setRecordPlayAsset(playAsset);
    });
  };

  onRecordClearClicked = () => {
    this.recordAsset = null;
    this.clearRecord();
    this.reloadView();
  };

  onBranchMapIconClicked(item) {
    this.push(NAVIGATION_NAME_MAP, {title: item.name, subTitle: item.address, latitude: item.latitude, longitude: item.longitude});
  }

  onDurationClicked = () => {
    let message = <AppText style={{
      marginTop: 2,
      color: ColorTitle,
      fontSize: FontSizeNormal,
      fontWeight: FontWeightRegular}}>
      <AppText>{locString('startingFrom')}</AppText>
      <AppText>{" "}</AppText>
      <AppText style={{paddingLeft: 4, fontWeight: FontWeightMedium}}>{DateTimeHelper.getDisplayDate(this.activity.startAt)}</AppText>
      <AppText>{"\n"}</AppText>
      <AppText>{locString('validUpto')}</AppText>
      <AppText>{" "}</AppText>
      <AppText style={{paddingLeft: 4, fontWeight: FontWeightMedium}}>{DateTimeHelper.getDisplayDate(this.activity.endAt)}</AppText>
    </AppText>;
    this.push(NAVIGATION_NAME_DETAIL, {
      title: this.activity.title,
      header: locString('duration'),
      message: message
    });
  };

  onDetailsClicked = () => {
    if (this.activity.description) {
      this.push(NAVIGATION_NAME_DETAIL, {
        title: this.activity.title,
        header: locString('details'),
        message: this.activity.description
      });
    } else {
      this.showToast(locString('noMoreDetails'));
    }
  };

  onTncClicked = () => {
    if (this.activity.tnc) {
      this.push(NAVIGATION_NAME_DETAIL, {
        title: this.activity.title,
        header: locString('termsNConditions'),
        message: this.activity.tnc
      });
    } else {
      this.showToast(locString('noTnc'));
    }
  };

  onQuestionnairePreviousClicked = () => {
    if (this.questionnaireNumber > 1) {
      this.questionnaireNumber--;
      this.reloadView();
    }
  };

  onQuestionnaireNextClicked = () => {
    const question = this.activity.questionnaire[this.questionnaireNumber - 1];
    const isChanged = (!this.activity.questionnaireAnswers && this.questionnaireMap[question.id])
      || this.activity.questionnaireAnswers[question.id] !== this.questionnaireMap[question.id]
      || this.activity.questionnaire.length === this.questionnaireNumber;
    if (isChanged) {
      if (this.activity.correction) {
        let message = null;
        if (question.rightOptionHint && question.rightOptionHint.length > 0) {
          message = question.rightOptionHint;
        } else {
          message = this.context.intl.formatMessage({id: 'activity.questionnaireCorrectAnswerPrompt'});
        }
        let showRightOptionHint = false;
        const qOptions = question.qOptions || question.options;
        qOptions.forEach((option) => {
          if (option.id === this.questionnaireMap[question.id] && !option.isRight) {
            showRightOptionHint = true;
          }
        });

        if (showRightOptionHint) {
          this.showSimpleOverlayView({
            title: locString('confirmAnswer'),
            subTitle: message,
            positiveActionText: locString('proceedAnyway'),
            negativeActionText: locString('changeAnswer'),
            onPositiveClicked: () => {
              setTimeout(() => {
                this.onQuestionnaireMakeAction();
              }, 100);
            }
          });
        } else {
          this.onQuestionnaireMakeAction();
        }
      } else {
        this.onQuestionnaireMakeAction();
      }
    } else {
      this.questionnaireNumber++;
      this.reloadView();
    }
  };

  onQuestionnaireMakeAction() {
    if (this.questionnaireNumber === this.activity.consumeLimitPerUser) {
      this.showSimpleOverlayView({
        title: locString(this.activity.type === ACTIVITY_TYPE_SURVEY ? 'completeSurvey' : 'completeQuestionnaire'),
        subTitle: locString(this.activity.type === ACTIVITY_TYPE_SURVEY ? 'completeSurveyMessage' : 'completeQuestionnaireMessage'),
        positiveActionText: locString('yes'),
        negativeActionText: locString('no'),
        onPositiveClicked: () => {
          this.playGameNeutralAudioInline();
          // this.gameAudioPlayer.playNeutralAudio();
          this.makeApiForQuestionnaireAnswer();
        }
      });
    } else {
      this.makeApiForQuestionnaireAnswer();
    }
  }

  onQuestionItemClicked = (activity, index, innerQuestionDisplayedEnd = false) => {
    if (this.props.noActionMode || this.props.readOnly) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    if (activity.isUserActionable) {
      const item = activity.qOptions[index];
      if (this.selectedOptionIndexes.has(item.id)) {
        this.selectedOptionIndexes.clear();
        this.selectedOptionIndexes.delete(item.id);
      } else {
        this.selectedOptionIndexes.clear();
        this.selectedOptionIndexes.add(item.id);

        this.showSimpleOverlayView({
          showInCenter: true,
          title: locString(this.activity.nextId ? 'activity.confirmAnswerNPlay' : 'confirmAnswer'),
          positiveActionText: locString('yes'),
          negativeActionText: locString('no'),
          onPositiveClicked: () => {
            this.onAnswerClicked(activity, innerQuestionDisplayedEnd);
          },
          onNegativeClicked: () => {
            this.selectedOptionIndexes.clear();
            this.selectedOptionIndexes.delete(item.id);
            this.reloadView();
          }
        });
      }
    }
    this.reloadView();
  };

  onGuessItemClicked = (index) => {
    if (this.props.noActionMode || this.props.readOnly) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    if (this.activity.isUserActionable || this.activity.isUserActionableA) {
      const item = this.activity.qOptions[index];
      if (this.selectedOptionIndexes.has(item.id)) {
        this.selectedOptionIndexes.clear();
        this.selectedOptionIndexes.delete(item.id);
        this.guessText = this.oldGuessText;
        if (this.guessText) {
          this.selectedOptionIndexes.add(parseInt(this.guessText));
        }
      } else {
        this.selectedOptionIndexes.clear();
        this.selectedOptionIndexes.add(item.id);

        this.guessText = ''+ item.id;
        if (this.canAnswer()) {
          if (this.activity.correction && this.activity.rightOptionId && !this.selectedOptionIndexes.has(this.activity.rightOptionId)) {
            const message = this.activity.rightOptionHint || this.context.intl.formatMessage({id: 'activity.guessCorrectAnswerPrompt'});
            this.showSimpleOverlayView({
              title: locString('confirmAnswer'),
              subTitle: message,
              positiveActionText: locString('proceedAnyway'),
              negativeActionText: locString('activity.changeGuess'),
              onPositiveClicked: this.onGuessPromptPositiveClicked.bind(this, 100),
              onNegativeClicked: this.onGuessPromptNegativeClicked.bind(this, item)
            });
          } else {
            this.showSimpleOverlayView({
              title: locString('recordGuess'),
              positiveActionText: locString('yes'),
              negativeActionText: locString('no'),
              onPositiveClicked: this.onGuessPromptPositiveClicked,
              onNegativeClicked: this.onGuessPromptNegativeClicked.bind(this, item)
            });
          }
        }
      }
    }
    this.reloadView();
  };

  onGuessPromptPositiveClicked = (delay) => {
    setTimeout(() => {
      this.playGamePlayAudioInline();
      this.makeApiToGuessImage();
    }, delay);
  }

  onGuessPromptNegativeClicked = (item) => {
    this.selectedOptionIndexes.clear();
    this.selectedOptionIndexes.delete(item.id);
    this.guessText = this.oldGuessText;
    if (this.guessText) {
      this.selectedOptionIndexes.add(parseInt(this.guessText));
    }
    this.reloadView();
  }

  onRatingEntered = (rating) => {
    this.rating = rating;
    this.reloadView();
  };

  onRateClicked = () => {
    this.makeApiToRate();
  };

  onVoteStatusClicked = () => {
    this.push(NAVIGATION_NAME_GIFT_ELIGIBLE, {systemPrize: this.activity.systemPrize});
  };

  onShowWinnersClicked = () => {
    this.push(NAVIGATION_NAME_SYSTEM_GIFT_WINNERS, {giftId: this.activity.systemPrize.id});
  };

  onConsumeInStoreClicked = () => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    let message = null;
    if (this.activity.isVoucher) {
      if (this.activity.userAnswer > 0 && this.activity.userValue2 > 0) {
        message = locString('generateVoucherCodeAgainMessagePrompt');
      }
    } else {
      message = locString('promptGenerateOfferCodeMessage');
    }
    const title = this.activity.isVoucher ? locString('generateVoucherCodePrompt') : locString('promptGenerateOfferCode');
    const positiveButton = locString('proceed');

    this.showSimpleOverlayView({
      icon: IconQuestion,
      iconColor: ColorOrange,
      title: title,
      subTitle: message,
      positiveActionText: positiveButton,
      negativeActionText: locString('no'),
      onPositiveClicked: this.onConsumeOfferClicked
    });
  };

  onConsumeInCartClicked = () => {
    // if open from ordering, put in selected branch
    if (this.activity.dp == 23 && (this.branch || this.refBranch)) {
      this.onResultBranchPicked(this.branch ? this.branch : this.refBranch);
      return;
    }
  };

  onResultBranchPicked = (branch, orderType) => {
    setTimeout(() => {
      if (this.activity.productId > 0) {
        // ProductsInOfferScreen.navigateTo(this.props.navigation, branch, this.activity.id, CartStore.getInstance().address, orderType, null, null);
      } else {
        this.addToCartInBranch(branch, orderType);
      }
    });
  };

  addToCartInBranch(branch, orderType = null) {
    this.showLoader(() => {
      const onSuccess = () => {
        this.dismissLoader(() => {
          this.forceAddToCart = false;
          this.showToast(locString('offerAdded'));
          this.reloadView();
          // this.pop();
        });
      };
      const onConflict = (oldBranch) => {
        this.dismissLoader(() => {
          let message;
          if (oldBranch.business.id === branch.business.id) {
            message = locString('replaceCartItemWithinBusinessMessage', {oldBusiness: oldBranch.business.name, oldBranch: oldBranch.name, newBusiness: branch.business.name, newBranch: branch.name});
          } else {
            message = locString('replaceCartItemMessage', {oldBusiness: oldBranch.business.name, newBusiness: branch.business.name});
          }
          this.showAlert(BaseScreen.getImage(ImageTypeConfirmation), locString('replaceCartItem'), message, locString('yes'), locString('no'), () => {
            this.dismissAlert(() => {
              this.forceAddToCart = true;
              this.addToCartInBranch(branch, orderType);
            });
          });
        });
      }
      const onRefresh = (errorType, error, branch, product, offer) => {
        this.dismissLoader(() => {
          if (offer) {
            offer.dp = this.activity.dp;
            this.activity = offer;
          }
          if (branch && this.branch) {
            this.branch = branch;
          }
          this.showAlert(BaseScreen.getImage(errorType), locString('unableToAddToCart'), error, locString('ok'), null, () => {
            this.dismissAlert(() => {
              if (!branch || !offer) {
                this.pop();
              }
            });
          });
        });
      };
      const onFailure = (errorType, error) => {
        this.dismissAlert(() => {
          this.showAlert(BaseScreen.getImage(errorType), locString('unableToAddToCart'), error);
        });
      };

      // CartStore.getInstance().addItem(branch, orderType, null, this.activity.id, 1, null, this.forceAddToCart, onSuccess, onConflict, onRefresh, onFailure);
    });
  }

  onAnswerClicked = (activity, innerQuestionDisplayedEnd) => {
    if (activity.rightOptionId) {
      if (!this.selectedOptionIndexes.has(activity.rightOptionId)) {
        this.showSimpleOverlayView({title: locString('inCorrectedAnswerSelected'), subTitle: activity.rightOptionHint});
        return;
      }
    }
    this.makeApiForAnswer(activity, innerQuestionDisplayedEnd);
  };

  onPredictClicked = () => {
    if (this.props.noActionMode || this.props.readOnly) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    if (this.canAnswer()) {
      this.setState({canEditPrediction: false});
      this.playGamePlayAudioInline();
      this.makeApiForAnswer(this.activity);
    } else if (!this.activity.isUserActionable && this.activity.isUserActionableA) {
      this.setState({canEditPrediction: true});
    }
  };

  onSponsorClicked = () => {
    this.showSponsorView(null, this.activity);
  };

  onBusinessClicked = () => {
    if (this.activity.business.link) {
      // this.makeCtaActionsInActivity(ACTIVITY_CTA1_ACTION);
      LinkHelper.openLink(this.activity.business.link);
    }
  };

  onPrizeClicked = () => {
    this.push(NAVIGATION_NAME_GIFT_DETAIL, {giftId: this.activity.systemPrizeId})
  };

  onRatingsClicked = () => {
    this.push(NAVIGATION_NAME_ACTIVITY_RATINGS, {
      activity: this.activity,
      onResultUpdate: this.onResultCommentsUpdated
    })
  };

  onActivityReviewsClicked = () => {
    // ActivityReviewsScreen.navigateTo(this.props.navigation, this.activity, null, null, null, null, this.onActivityReviewUpdated);
  };

  onActivityReviewUpdated = (activity) => {
    this.activity.commentsCount = activity.commentsCount;
    this.activity.ratersCount = activity.ratersCount;
    this.activity.rating = activity.rating;
    this.activity.userRating = activity.userRating;
    this.activity.userConsumedCount = activity.userConsumedCount;
    this.reloadView();
  };

  onTransferClicked = () => {
    this.showAlert(BaseScreen.getImage(ImageTypeConfirmation), locString('promptTransferOffer'), locString('promptTransferOfferMessage'), locString('transfer'), locString('cancel'), () => {
      this.dismissAlert(() => {
        this.push(NAVIGATION_NAME_TRANSFER_OFFER, {
          activity: this.activity,
          title: locString('transferOffer'),
          onResult: this.onResultTransferCompleted,
        });
      });
    }, () => {
      this.dismissAlert();
    });
  };

  onShareClicked = (event, activity, postId) => {
    if (!activity) {
      activity = this.activity;
    }
    if (isNaN(postId)) {
      postId = null;
    }
    let shareUrl = this.props.inPreview ? activity.shUrl : activity.userShUrl;
    if (postId) {
      shareUrl = activity.postShUrls ? activity.postShUrls[postId] : null;
    }
    if (!shareUrl && !this.props.inPreview) {
      const activityId = activity.type === constants.activity.types.QUESTION && activity.isInternal && activity.nextId ? activity.nextId : activity.id;
      const data = {
        activityId: activityId,
        aid: activity.aid,
        state: ACTIVITY_UPDATE_STATE_SHARE,
        postId: postId
      };
      this.makeActionInActivity(data, true, (response) => {
        activity.shUrl = response.shUrl;
        if (response.userShUrl) {
          activity.userShUrl = response.userShUrl;
        }
        if (response.postShUrl) {
          if (!activity.postShUrls) {
            activity.postShUrls = {};
          }
          activity.postShUrls[postId] = response.postShUrl;
        }
        if (postId) {
          if (activity.postShUrls && activity.postShUrls[postId]) {
            this.onShareClicked(null, activity, postId);
          } else {
            this.showToastError();
          }
        } else {
          if (activity.userShUrl) {
            this.onShareClicked();
          } else {
            this.showToastError();
          }
        }
      }, (error) => {
        this.showToastError(error);
      });
      return;
    }
    const fallback = () => {
      this.showToast(this.context.intl.formatMessage({id: 'common.shareDataCopied'}));
    };
    if (activity.type === ACTIVITY_TYPE_SHARE_N_LIKE) {
      utils.shareNLikeActivity(activity, this.context.intl, shareUrl, fallback);
    } else {
      const shareActivity = activity.type === constants.activity.types.QUESTION && activity.isInternal && activity.next ? activity.next : activity;
      utils.shareActivity(shareActivity, this.context.intl, shareUrl, fallback);
    }
  };

  onAffiliateLinkClicked = () => {
    setTimeout(() => {
      utils.shareAffiliate(this.props.userRab7Number, this.activity.id);
    }, 100);
  };

  onFavouriteClicked = () => {
    this.makeApiToToggleFavourite();
  };

  onHelpClicked = () => {
    LinkHelper.openLink(this.activity.helpUrl);
  };

  onDeleteClicked = () => {
    let title = null;
    let subTitle = null;
    if (this.activity.type == ACTIVITY_TYPE_OFFER || this.activity.type == ACTIVITY_TYPE_DISCOUNT) {
      title = locString('removeOffer');
      subTitle = locString('removeOfferPromptMessage');
    } else {
      title = locString('removeActivity');
      subTitle = locString('removeActivityPromptMessage');
    }
    this.showAlert(BaseScreen.getImage(ImageTypeConfirmation), title, subTitle, locString('remove'), locString('cancel'), () => {
      this.dismissAlert(() => {
        this.makeApiToDelete();
      });
    }, () => {
      this.dismissAlert();
    });
  };

  onReportClicked = (event, activity) => {
    if (!activity) {
      activity = this.activity;
    }
    this.showSimpleOverlayView({
      title: locString('activity.reportCampaign'),
      subTitle: locString('activity.reportMessage'),
      positiveActionText: locString('close'),
      hideActions: true,
      showInCenter: this.shouldShowInCenter(),
      subView: ActivityHelper.getReportView(activity.id, this.getUIConfigs(), 500, this.props.width, (isSuccess) => {
        if (isSuccess) {
          this.showToast(this.context.intl.formatMessage({id: 'reportedMessage'}));
        }
        this.dismissSimpleOverlayNHandleCallback();
      }),
    });
  };

  onPlayJoinClicked = (activity, title, subTitle) => {
    if (!activity) {
      activity = this.activity;
    }
    if (!title) {
      title = locString('login.joinRab7Short');
    }

    const uiConfigs = {
      overlayTitleColor: ColorTitle,
      overlaySubTitleColor: ColorSecondary,
      overlayBgColor: ColorWhite,
      actionBgColor: ColorTheme,
      actionTitleColor: ColorWhite
    }
    const renderContent = () => {
      return (
        <JoinNow
          history={this.props.history}
          activityId={activity.id}
          activityType={activity.type}
          needContactNumber={this.activity.needContactNumber}
          contactNumberHelperTextId={'activity.mobileRequiredNonRegisteredWon'}
          showEnd={this.activity.videoUrl || this.activity.s2ImageUrl}
          uiConfigs={uiConfigs}
          onDone={this.onJoinInlineDialogDone}
          isLTR={this.props.isLTR}
          maxWidth={this.props.width}
          title={title}
          subTitle={subTitle}
          showNegativeAction={true}
        />
      );
    };
    this.showDialog({
      renderContent: renderContent,
      positiveText: null,
      fullScreen: this.props.isXS,
      marginTop: this.props.isXS ? window.appHeight - 600 : 0
    });
  };

  onUpdateMobileClicked = (activity, title, subTitle) => {
    if (!activity) {
      activity = this.activity;
    }
    if (!title) {
      title = locString('activity.updateContactNumber');
    }

    const uiConfigs = {
      overlayTitleColor: ColorTitle,
      overlaySubTitleColor: ColorSecondary,
      overlayBgColor: ColorWhite,
      actionBgColor: ColorTheme,
      actionTitleColor: ColorWhite
    }
    const renderContent = () => {
      return (
        <UpdateMobileInline
          history={this.props.history}
          activityId={activity.id}
          activityType={activity.type}
          needName={this.activity.needName}
          uiConfigs={uiConfigs}
          onDone={this.onJoinInlineDialogDone}
          isLTR={this.props.isLTR}
          maxWidth={this.props.width}
          title={title}
          subTitle={subTitle}
          showNegativeAction={true}
        />
      );
    };
    this.showDialog({
      renderContent: renderContent,
      positiveText: null,
      fullScreen: this.props.isXS,
      marginTop: this.props.isXS ? window.appHeight - 600 : 0
    });
  };

  onUpdateNameClicked = (activity, title, subTitle) => {
    if (!activity) {
      activity = this.activity;
    }
    if (!title) {
      title = locString('activity.updateName');
    }

    const uiConfigs = {
      overlayTitleColor: ColorTitle,
      overlaySubTitleColor: ColorSecondary,
      overlayBgColor: ColorWhite,
      actionBgColor: ColorTheme,
      actionTitleColor: ColorWhite
    }
    const {isLTR, width, history} = this.props;
    const _this = this;
    const renderContent = () => {
      return (
        <UpdateNameInline
          history={history}
          activityId={activity.id}
          activityType={activity.type}
          uiConfigs={uiConfigs}
          onDone={_this.onJoinInlineDialogDone}
          isLTR={isLTR}
          maxWidth={width}
          title={title}
          subTitle={subTitle}
          showNegativeAction={true}
        />
      );
    };
    this.showDialog({
      renderContent: renderContent,
      positiveText: null,
      fullScreen: this.props.isXS,
      marginTop: this.props.isXS ? window.appHeight - 600 : 0
    });
  };

  onJoinInlineDone = (result) => {
    if (result === 1) {
      this.activity.needContactNumber = false;
      this.activity.needName = false;
      this.reloadView();

      this.updateUrlToShowCTAOrShare();
      setTimeout(() => {
        this.props.reloadActivity();
      }, 300);
    }
  }

  onJoinInlineDialogDone = (result) => {
    this.hideDialog();
    this.onJoinInlineDone(result);
  }

  updateUrlToShowCTAOrShare = () => {
    const searchParams = getURLParameters(decodeURIComponent(this.props.history.location.search));
    if (this.activity.showEnd && !this.props.playInShowcase) {
      searchParams['se'] = 1;
    } else {
      searchParams['se'] = 2;
    }
    const search = new URLSearchParams(searchParams).toString();
    const effSearch = search ? '?'+ search : '';
    this.props.history.replace({
      pathname: this.props.history.location.pathname,
      search: effSearch,
      hash: this.props.history.location.hash,
    });
  };

  onBranchExpandCollapseClicked = () => {
    this.showBranches = !this.showBranches;
    this.reloadView();
  };

  onPlayPauseClicked = () => {
    let asset = this.audioPlayerAssets[this.activity.audioUrl];
    if (asset) {
      this.handleAudio(asset, false);
    }
  };

  onViewOfferClicked = () => {
    // NavigationHelper.navigate(this.props.navigation, NAVIGATION_NAME_ACTIVITY_DETAIL, {
    //   activityId: this.activity.userValue2,
    //   dp: this.activity.dp,
    //   aid: this.activity.aid,
    // });
  };

  moveToAd() {
    if (this.canMoveToAd()) {
      // hide this and open ads
      const navigation = this.props.navigation;
      this.pop();
      if (!this.business && !this.transaction && !this.branch && this.activity) {
        this.business = this.activity.business;
      }
      // NavigationHelper.navigate(navigation, NAVIGATION_NAME_ACTIVITY_DETAIL, {
      //   transaction: this.transaction,
      //   branch: this.branch,
      //   business: this.business,
      //   inExperience: this.inExperience,
      //   inProfile: this.inProfile,
      //   inAck: this.inAck,
      //   cType: this.activity.type,
      //   dp: this.activity.dp,
      //   aid: this.activity.aid,
      // });
    }
  }

  canMoveToAd() {
    return this.hasNext;
  }

  onResultCommentsUpdated = (activity) => {
    if (activity) {
      this.activity = activity;
      this.reloadView();
    }
  };

  onResultTransferCompleted = (activity) => {
    if (activity) {
      this.activity = activity;
      this.reloadView();
    }
  };

  onResultUserRequest = (isSuccess, userRequest) => {
    if (isSuccess) {
      setTimeout(() => {
        if (userRequest.state == STATE_USER_REQUEST_COMPLETED) {
          this.activity.consumedCount += 1;
          this.activity.userConsumedCount += 1;
          this.activity.isUserSConsumable = false;
          this.activity.isUserOConsumable = false;
          this.activity.isUserConsumable = false;
          this.activity.isUserReviewable = this.activity.type === ACTIVITY_TYPE_SMART_AD || this.activity.type === ACTIVITY_TYPE_VOTE;

          this.showAlert(require('src/images/activity/0_ic_congratulations.png'), locString('congratulations'), locString('offerConsumedMessage'));
        }
      }, 500);
    }
  };

  onRatingDone(response) {
    this.rating = 0;
    if (response.isRefreshedOnly) {
      delete(response.isRefreshedOnly);
      this.showToastInfo(locString('dataNotLatest'));
      this.activity = response;
      this.updateAndReload();
    } else {
      this.activity = response;
      // const moveToMoreFun = this.activity.type === ACTIVITY_TYPE_OPINION || this.activity.type === ACTIVITY_TYPE_VISITOR_OPINION;
      const moveToMoreFun = false;
      this.updateActivityData().then(() => {
        const onPositiveClicked = () => {
          this.dismissAlert(() => {
            // if (this.canMoveToAd()) {
            //     this.moveToAd();
            // }
            // move to more fun
            if (moveToMoreFun) {
              const navigation = this.props.navigation;
              this.pop();
              /*FunInnerScreen.navigateToMoreFun(navigation, this.activity.cBusinessId);*/
            }
          });
        };
        if (ActivityHelper.isPointsEarned(this.activity)) {
          ActivityHelper.showPointsEarnedAlertView(this, this.getUIConfigs(), this.activity, this.props.width, locString('opinionSuccess'), moveToMoreFun ? locString('moreFunActivities') : locString('ok'), null, this.onActivityClicked, this.onImageFSClicked, onPositiveClicked);
        } else {
          this.showAlert(BaseScreen.getImage(ImageTypeSuccess), locString('opinionSuccess'), null, moveToMoreFun ? locString('moreFunActivities') : locString('ok'), null, onPositiveClicked);
        }
      });
    }
  }

  invokePost() {
    // const navigation = this.props.navigation;
    // this.pop();
    // NavigationHelper.navigate(navigation, NAVIGATION_NAME_POST_DETAIL, {
    //   'postId': this.activity.productId,
    //   'animationEnabled': false
    // });
  }

  invokeReels(animate = true) {
    // const navigation = this.props.navigation;
    // this.pop();
    //
    // let activity = this.activity;
    // if (!activity) {
    //   activity = {
    //     id: this.activityId,
    //     type: this.activityType,
    //     dp: this.displayPlace
    //   };
    // }
    // NavigationHelper.navigate(navigation, ActivityReviewsScreen.getNavigationName(), {
    //   activity: activity,
    //   animationEnabled: animate
    // });
  }

  getVideoAssetForItem(item) {
    // let imageUrl = item.imageUrl;
    // if (item.audioUrl) {
    //   if (!imageUrl) {
    //     imageUrl = AUDIO_POSTER_IMAGE_URL;
    //   }
    //   item.videoUrl = item.audioUrl;
    //   item.videoStreamUrl = item.audioUrl;
    //   item.videoDuration = item.audioDuration;
    //   item.posterUrl = imageUrl;
    //   item.videoTUrl = imageUrl;
    //   item.videoWidth = this.props.width - 2 * SpaceXSmall;
    //   item.videoHeight = 300;
    //   item.isVideoAudioOnly = true;
    //   item.audioUrl = null;
    //   item.audioDuration = 0;
    // } else if (item.videoUrl) {
    //   item.videoTUrl = imageUrl;
    // }
    // return this.getVideoAsset(item, ActivityView.getNavigationName(), ApiHelper.getVideoParams(item));
    return null;
  }

  async updateActivityData() {
    // store slot audios and update the url
    this.activity.gamePlayAudioLocalUrl = this.activity.gamePlayAudioUrl;
    this.activity.gameWinAudioLocalUrl = this.activity.gameWinAudioUrl;
    this.activity.gameLoseAudioLocalUrl = this.activity.gameLoseAudioUrl;
    // this.setupGameBgAudio();

    const uiConfigs = this.getUIConfigs();
    if (this.activity.userDisplayedCount < 1 && !this.props.hideGuideAtFirst && uiConfigs.showGuideAtFirstLaunch && this.isActivitySupported() && !this.props.onPreFunDone) {
      if (this.shouldShowRewards() && !this.props.playInShowcase) {
        this.unmuteGameAudioOnClose = this.activity.bgAudioUrl ? true : false;
        this.onRewardsMenuClicked();
      } else if (this.shouldShowGuide()) {
        this.unmuteGameAudioOnClose = this.activity.bgAudioUrl ? true : false;
        this.onGuideClicked();
      }
      uiConfigs.showGuideAtFirstLaunch = false;
    }

    // this.videoAsset = this.getVideoAssetForItem(this.activity);
    // if (this.videoAsset && this.autoPlayVideo) {
    //   this.autoPlayVideo = false;
      // VideoPlayer.getInstance().play(this.videoAsset);
    // }


    if (this.activity.type === ACTIVITY_TYPE_QUESTION || this.activity.type === ACTIVITY_TYPE_GUESS) {
      if (this.activity.userAnswer > 0) {
        this.selectedOptionIndexes.add(this.activity.userAnswer);
      }
    }

    this.oldGuessText = null;
    if ((this.activity.type === ACTIVITY_TYPE_GUESS
      || this.activity.type === ACTIVITY_TYPE_PREDICTION
      || this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION)
      && this.activity.userValueText) {
      this.oldGuessText = ''+ this.activity.userValueText;
    }
    this.guessText = this.oldGuessText;
    if (this.activity.type === ACTIVITY_TYPE_GUESS && this.guessText) {
      this.selectedOptionIndexes.add(parseInt(this.guessText));
    }
    let guessSplits = null;
    if (this.guessText) {
      guessSplits = this.guessText.split(',');
    }
    this.oldGuess1 = null;
    if (guessSplits && guessSplits.length > 0) {
      this.oldGuess1 = guessSplits[0];
    }
    this.oldGuess2 = null;
    if (guessSplits && guessSplits.length > 1) {
      this.oldGuess2 = guessSplits[1];
    }
    if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
      if (this.oldGuess1) {
        this.oldGuess1 = parseFloat(this.oldGuess1);
      }
      if (this.oldGuess2) {
        this.oldGuess2 = parseFloat(this.oldGuess2);
      }
      if (this.activity.rightOptionHint) {
        this.activity.rightOptionHint = parseFloat(this.activity.rightOptionHint);
      }
      if (this.activity.rightOptionHintAr) {
        this.activity.rightOptionHintAr = parseFloat(this.activity.rightOptionHintAr);
      }
    }
    this.guess1 = this.oldGuess1;
    this.guess2 = this.oldGuess2;

    if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
      if (this.activity.questionnaireAnswers) {
        this.questionnaireMap = utils.clone(this.activity.questionnaireAnswers);
      } else {
        this.questionnaireMap = {};
      }
      if (this.activity.isUserActionable) {
        if (this.activity.userConsumedCount > 0) {
          this.state.questionnaireTimer = parseInt(this.activity.userClickedCount);
          if (this.questionnaireNumber > 0 && this.questionnaireNumber <= Object.keys(this.questionnaireMap).length) {
            this.questionnaireNumber++;
            this.startQuestionnaireTimer();
          }
        }
      } else {
        this.questionnaireNumber = 0;
        this.state.questionnaireTimer = 0;
      }
      if (this.questionnaireNumber === 0) {
        this.popHashHistory(HASH_QUESTIONNAIRE);
      }
    }

    if (this.activity.type === ACTIVITY_TYPE_SHARE_N_LIKE) {
      this.processCampaignLikeUserAction();
    }

    if (!this.props.playInShowcase && !this.props.simulation) {
      if (this.activity.showEnd
        && (!this.activity.inQuestion || !this.activity.inQuestion.isUserActionable)
        && ((!this.props.isGuestUser && !this.activity.needContactNumber) || this.props.inPreview)) {
        this.processGameEndView();
        this.activity.showEnd = false;
      } else if (this.activity.showShare) {
        this.processShareDialog();
      }
    }

    this.setupSocket();

    // process auto simulation
    if (this.props.autoSimulation) {
      if (this.activity.type === constants.activity.types.GAME_ROULETTE
        || this.activity.type === constants.activity.types.JACKPOT
        || this.activity.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || this.activity.type === constants.activity.types.GAME_BRAND_RACE
        || this.activity.type === constants.activity.types.GAME_BETTING_PIC
        || this.activity.type === constants.activity.types.GAME_POKER
        || this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE
        || this.activity.type === constants.activity.types.GAME_FLIP_CARD
        || this.activity.type === constants.activity.types.GAME_MATCH_PAIR
        || this.activity.type === constants.activity.types.GAME_MATCH_THREE
        || this.activity.type === constants.activity.types.GAME_WHAC_A_MOLE
        || this.activity.type === constants.activity.types.GAME_PUZZLE
        || this.activity.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || this.activity.type === constants.activity.types.SLIDES
        || this.activity.type === constants.activity.types.SHOWCASE_MENU
        || this.activity.type === constants.activity.types.EXTERNAL_GAMES) {

        this.activity.consumeLimitPerUser = 4;
        if (this.activity.type === constants.activity.types.GAME_POKER
          || this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
          this.activity.consumeLimitPerUser = 5;
        } else if (this.activity.type === constants.activity.types.GAME_SPIN_N_DISCOVER
          || this.activity.type === constants.activity.types.GAME_BRAND_RACE) {
           if (this.activity.slotValues) {
             this.activity.slotValues.forEach((slotValue) => {
               slotValue.value *= 2;
             });
           }
        } else if (this.activity.type === constants.activity.types.GAME_FLIP_CARD) {
          this.activity.flipsNeeded = 7;
        } else if (this.activity.type === constants.activity.types.GAME_MATCH_THREE
          || this.activity.type === constants.activity.types.GAME_WHAC_A_MOLE) {
          this.activity.gameTime = 40000;
        } else if (this.activity.type === constants.activity.types.GAME_PUZZLE
          || this.activity.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
          this.activity.gameTime = 50000;
        }


        if (this.activity.isUserActionable) {
          const delayToSimulate = (this.activity.type === constants.activity.types.SLIDES || this.activity.type === constants.activity.types.SHOWCASE_MENU) ? 1000 : 3000;
          setTimeout(() => {
            if (this.refJackpotGameView) {
              this.refJackpotGameView.simulatePlay();
            } else if (this.refFlipTileGameView) {
              this.refFlipTileGameView.simulatePlay();
            } else if (this.refSlides) {
              this.refSlides.simulatePlay();
            } else if (this.activity.type === constants.activity.types.EXTERNAL_GAMES) {
              this.simulateExternalGame();
            }
          }, delayToSimulate);
        } else {
          this.timeoutRefAutoSimulationEnd = setTimeout(() => {
            this.props.onAutoSimulationEnd(this.activity.id);
          }, 100);
        }
      }
    }
  }

  processGameEndView() {
    if (!this.showEndViewHandler) {
      this.showEndViewHandler = setTimeout(() => {
        this.showEndViewHandler = null;
        if (this.isHavingFocus) {
          this.showEndView();
          this.processEndViewPending = false;
        } else {
          this.processEndViewPending = true;
        }
      }, this.activity.showEndAfter);
      this.activity.showEndAfter = 0;
    }
  }

  processJoinUsNowView(delay = 2000) {
    if (!this.activity.hideJoinNow
      && !this.props.inPreview
      && this.props.isGuestUser
      && !this.activity.isUserActionable
      && DateTimeHelper.getSecondsDiffFromNow(this.activity.startAt) < 0
      && !this.showDelayViewHandler
      && !this.activity.isInternal
      && this.activity.type !== constants.activity.types.CHALLENGE) {

      this.activity.hideJoinNow = true;
      this.showDelayViewHandler = setTimeout(() => {
        this.showDelayViewHandler = null;
        let messageId = 'activity.gameOverProceedToJoinMessage';
        if (this.activity.userWon) {
          messageId = 'activity.wonProceedToJoinMessage';
        } else if (this.activity.userWinEligible) {
          messageId = 'activity.wonEligibleProceedToJoinMessage';
        } else if (this.activity.type === constants.activity.types.GUESS
          || this.activity.type === constants.activity.types.IDENTIFY_LOCATION
          || this.activity.type === constants.activity.types.PREDICTION
          || this.activity.type === constants.activity.types.VISITOR_OPINION
          || this.activity.type === constants.activity.types.QUESTIONNAIRE
          || this.activity.type === constants.activity.types.SURVEY) {
          messageId = 'activity.gameSubmitProceedToJoinMessage';
        }
        this.showSimpleOverlayView({
          title: locString('activity.joinRab7ForFurther'),
          subTitle: locHtmlString(messageId),
          positiveActionText: locString('login.joinRab7Short'),
          negativeActionText: locString('generic.later'),
          showInCenter: true,
          onPositiveClicked: () => {
            setTimeout(() => {
              this.props.history.push({
                pathname: PathJoin,
                search: getRedirectSearch(this.props.history.location)
              });
            }, 100);
          },
        });
      }, delay);
    }
  }

  onQuestionnaireQuestionOptionSelected = (questionId, optionId) => {
    this.questionnaireMap[questionId] = optionId;
    this.reloadView();
  };

  startPlay = () => {
    if (!this.props.inPreview) {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.pushHashHistory(HASH_QUESTIONNAIRE);
      }
    }
  }

  stopPlay = () => {
    if (!this.props.inPreview) {
      if (this.isPlaying) {
        this.isPlaying = false;
        this.popHashHistory(HASH_QUESTIONNAIRE);
      }
    }
  }

  startQuestionnaire = () => {
    if (this.props.noActionMode || this.props.readOnly) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    this.questionnaireNumber = this.activity.userConsumedCount + 1;
    this.reloadView();
    this.startQuestionnaireTimer();
    this.pushHashHistory(HASH_QUESTIONNAIRE);
  };

  startQuestionnaireTimer() {
    if (this.activity && (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) && this.activity.gameTime > 0) {
      if (!this.intervalHandle) {
        this.playQuestionnaireTimerAudio();
        this.questionnaireStartTime = new Date().getTime();
        this.intervalHandle = setInterval(() => {
          this.updateQuestionnaireTimeElapsed();
        }, 500);
      }
    }
  }

  stopQuestionnaireTimer() {
    if (this.intervalHandle) {
      this.stopQuestionnaireTimerAudio();
      clearInterval(this.intervalHandle);
      this.intervalHandle = null;
      this.updateQuestionnaireTimeElapsed();
    }
  }

  updateQuestionnaireTimeElapsed() {
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.questionnaireStartTime;
    this.questionnaireStartTime = currentTime;
    const timeElapsed = Math.min(this.state.questionnaireTimer + timeDiff, this.activity.gameTime);

    const timeOver = timeElapsed >= this.activity.gameTime;
    if (this.state.questionnaireTimer !== timeElapsed) {
      this.setState({questionnaireTimer: timeElapsed}, () => {
        if (timeOver) {
          this.stopQuestionnaireTimer();
          // Vibration.vibrate(200);
          this.playGameNeutralAudioInline();
          // this.gameAudioPlayer.playNeutralAudio();
          if (!this.props.inPreview) {
            this.showToast(locString('questionnaireTimeOver'))
          }
          setTimeout(() => {
            this.makeApiForQuestionnaireAnswer();
          }, 500);
        }
      });
    }
  }

  getGameBgAudio() {
    let gameAudio = null;
    let fromResources = true;
    if (this.activity && this.activity.type !== constants.activity.types.EXTERNAL_GAMES) {
      if (this.activity.bgAudioUrl) {
        gameAudio = this.activity.bgAudioUrl;
        fromResources = false;
      } else {
        gameAudio = GAME_BG_AUDIO;
        if (this.activity.type === ACTIVITY_TYPE_SLOT) {
          gameAudio = 'game_bg.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN) {
          gameAudio = 'game_bg_1.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_MATCHING_PIC) {
          gameAudio = 'game_bg_2.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN) {
          gameAudio = 'game_bg_3.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_FLIP_CARD) {
          gameAudio = 'game_bg_4.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
          gameAudio = 'game_bg_5.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER) {
          gameAudio = 'game_bg_6.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE) {
          gameAudio = 'game_bg_7.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_QUESTION) {
          gameAudio = 'game_bg_8.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_BETTING_PIC) {
          gameAudio = 'game_bg_9.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
          gameAudio = 'game_bg_10.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
          gameAudio = 'game_bg_11.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_PUZZLE || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE) {
          gameAudio = 'game_bg_12.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_MATCH_THREE) {
          gameAudio = 'game_bg_13.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE) {
          gameAudio = 'game_bg_14.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE) {
          gameAudio = 'game_bg_15.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
          gameAudio = 'game_bg_16.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_BRAND_RACE) {
          gameAudio = 'game_bg_17.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_POKER) {
          gameAudio = 'game_bg_18.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
          gameAudio = 'game_bg_19.m4a';
        } else if (this.activity.type === ACTIVITY_TYPE_SLIDES || this.activity.type === ACTIVITY_TYPE_SHOWCASE_MENU) {
          gameAudio = null;
        }
        gameAudio = gameAudio ? (APP_GAME_AUDIO_URI + gameAudio) : null;
      }
    }
    return {
      gameAudio,
      fromResources
    }
  }

  setupGameBgAudio() {
    if (this.activity) {
      if (!this.gamePlayAudioIdBg) {
        let gameAudio = null;
        let fromResources = true;
        if (this.activity.bgAudioUrl) {
          gameAudio = this.activity.bgAudioUrl;
          fromResources = false;
        } else {
          gameAudio = GAME_BG_AUDIO;
          if (this.activity.type === ACTIVITY_TYPE_SLOT) {
            gameAudio = 'game_bg.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN) {
            gameAudio = 'game_bg_1.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_MATCHING_PIC) {
            gameAudio = 'game_bg_2.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_FIND_HIDDEN) {
            gameAudio = 'game_bg_3.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_FLIP_CARD) {
            gameAudio = 'game_bg_4.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_PREDICTION) {
            gameAudio = 'game_bg_5.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER) {
            gameAudio = 'game_bg_6.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_GAME_ROULETTE) {
            gameAudio = 'game_bg_7.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_QUESTION) {
            gameAudio = 'game_bg_8.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_BETTING_PIC) {
            gameAudio = 'game_bg_9.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_COLLECT_STARS) {
            gameAudio = 'game_bg_10.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_QUESTIONNAIRE || this.activity.type === ACTIVITY_TYPE_SURVEY) {
            gameAudio = 'game_bg_11.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_PUZZLE || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE) {
            gameAudio = 'game_bg_12.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_MATCH_THREE) {
            gameAudio = 'game_bg_13.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE) {
            gameAudio = 'game_bg_14.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE) {
            gameAudio = 'game_bg_15.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
            gameAudio = 'game_bg_16.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_BRAND_RACE) {
            gameAudio = 'game_bg_17.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_POKER) {
            gameAudio = 'game_bg_18.m4a';
          } else if (this.activity.type === ACTIVITY_TYPE_GUESS) {
            gameAudio = 'game_bg_19.m4a';
          }
        }

        this.gameAudioPlayer.load(gameAudio, (assetId) => {
          this.gamePlayAudioIdBg = assetId;
          this.playGameBgAudio();
        }, fromResources, true);
      } else {
        this.playGameBgAudio();
      }
    }
  }

  // releaseGameBgAudio() {
    // if (this.gamePlayAudioIdBg) {
    //   this.gameAudioPlayer.release(this.gamePlayAudioIdBg);
    // }
  // }

  playGameBgAudio() {
    // this.stopGameBgAudio();
    // if (this.activity && this.activity.configs && this.activity.configs.playAudioBg && this.gamePlayAudioIdBg) {
    //   this.gameAudioPlayer.play(this.gamePlayAudioIdBg);
    // }

    if (this.activity && this.activity.configs && this.activity.configs.playAudioBg && this.refBgAudio.current) {
      this.refBgAudio.current.play();
    }
  }

  stopGameBgAudio() {
    // if (this.gamePlayAudioIdBg) {
    //   this.gameAudioPlayer.stop(this.gamePlayAudioIdBg);
    // }

    if (this.refBgAudio.current) {
      this.refBgAudio.current.pause();
    }
  }

  setupQuestionnairePlayAudio() {
    // if (!this.questionnairePlayAudioId) {
    //   const onLoaded = (assetId) => {
    //     this.questionnairePlayAudioId = assetId;
    //     this.playQuestionnairePlayAudio();
    //   };
    //   if (this.activity.gamePlayAudioLocalUrl) {
    //     this.gameAudioPlayer.load(this.activity.gamePlayAudioLocalUrl, onLoaded, false, true);
    //   } else {
    //     this.gameAudioPlayer.load(GAME_TIMER_AUDIO, onLoaded, true, true);
    //   }
    // } else if (this.questionnairePlayAudioId) {
    //   this.playQuestionnairePlayAudio();
    // }
  }

  // releaseQuestionnairePlayAudio() {
    // if (this.questionnairePlayAudioId) {
    //   this.gameAudioPlayer.release(this.questionnairePlayAudioId);
    // }
  // }

  playQuestionnaireTimerAudio() {
    this.stopQuestionnaireTimerAudio();
    if (this.refAudioTimer.current) {
      this.refAudioTimer.current.play();
    }
  }

  stopQuestionnaireTimerAudio() {
    if (this.refAudioTimer.current) {
      this.refAudioTimer.current.pause();
    }
  }

  playGamePlayAudioInline() {
    if (this.refAudioAction.current) {
      this.refAudioAction.current.play();
    }
  }

  playGameWinAudioInline() {
    if (this.refAudioWin.current) {
      this.refAudioWin.current.play();
    }
  }

  playGameNeutralAudioInline() {
    if (this.refAudioNeutral.current) {
      this.refAudioNeutral.current.play();
    }
  }

  makeApiToDelete() {
    this.showLoader(() => {
      ApiTask().delete("ENDPOINT_ACTIVITY/" + this.activity.id, null, (response) => {
        this.dismissLoader(() => {
          this.showToast(locString('deletedSuccessfully'));
          if (this.onResultDelete) {
            this.onResultDelete(this.activity);
          }
          this.pop();
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  makeApiToToggleFavourite() {
    this.showLoader(() => {
      const data = {
        activityId: this.activity.id,
        dp: this.activity.dp,
        aid: this.activity.aid,
        favourite: !this.activity.userFavourite,
      };
      ApiTask().post('ENDPOINT_ACTIVITY_FAVOURITE', data, (response) => {
        this.dismissLoader(() => {
          delete(response.isRefreshedOnly);
          this.activity = response;
          this.updateAndReload();
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showToastError(error.error);
        });
      });
    });
  }

  makeApiForClick() {
    this.showLoader(() => {
      const data = {
        dp: this.activity.dp,
        aid: this.activity.aid,
        state: ACTIVITY_UPDATE_STATE_ACTION,
      };
      ApiTask().post('ENDPOINT_ACTIVITY_STATE' + "/" + this.activity.id, data, (response) => {
        this.dismissLoader(() => {
          if (response.isRefreshedOnly) {
            delete(response.isRefreshedOnly);
            this.showToastInfo(locString('dataNotLatest'));
            this.activity = response;
            this.updateAndReload();
          } else {
            this.activity = response;
            this.updateActivityData().then(() => {
              if (ActivityHelper.isPointsEarned(this.activity)) {
                this.showSimpleOverlayView({
                  icon: IconGifts,
                  iconColor: ColorEarning,
                  title: locString('greatJob'),
                  positiveActionText: locString('ok'),
                  subView: this.getParticipationWonOverlayContentView(this.activity, locString('genericEarnRewardsMessage')),
                  onPositiveClicked: () => {
                    this.onLinkClicked();
                  }
                });
              } else {
                this.onLinkClicked();
              }
            });
          }
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  makeApiToParticipate() {
    this.showLoader(() => {
      const data = {
        dp: this.activity.dp,
        aid: this.activity.aid,
        state: ACTIVITY_UPDATE_STATE_ACTION,
      };
      ApiTask().post('ENDPOINT_ACTIVITY_STATE' + "/" + this.activity.id, data, (response) => {
        this.dismissLoader(() => {
          if (response.isRefreshedOnly) {
            delete(response.isRefreshedOnly);
            this.showToastInfo(locString('dataNotLatest'));
            this.activity = response;
            this.updateAndReload();
          } else {
            this.activityUpdated = response;
            const onDialogDismissed = () => {
              this.activity = this.activityUpdated;
              this.updateAndReload();
            };

            let wonOffer = this.activityUpdated.userValue2 > 0;
            let subTitle = null;
            let subView = null;
            let icon = IconSuccess;
            let iconColor = ColorGreen;
            if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
              icon = IconGifts;
              iconColor = ColorEarning;
              subView = this.getParticipationWonOverlayContentView(this.activityUpdated, locString('participateOfferRewardsMessage'));
            } else {
              subTitle = wonOffer ? locString('participateOfferMessage') : locString('youHaveParticipated');
            }
            this.showSimpleOverlayView({
              icon: icon,
              iconColor: iconColor,
              title: locString('greatJob'),
              subTitle: subTitle,
              positiveActionText: wonOffer ? locString('viewOffer') : locString('ok'),
              negativeActionText: wonOffer ? locString('later') : null,
              subView: subView,
              onDisplayed: onDialogDismissed,
              onPositiveClicked: () => {
                if (wonOffer) {
                  this.onViewOfferClicked();
                }
              }
            });
          }
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  makeApiToGuessImage() {
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      gameEndValue: this.guessText
    };
    this.makeActionInActivity(data, true, (response) => {
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateAndReload();
      } else {
        this.activityUpdated = response;
        const onDialogDismissed = () => {
          this.activity = this.activityUpdated;
          this.updateAndReload();
        };
        if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
          this.showSimpleOverlayView({
            title: locString('guessRecorded'),
            positiveActionText: locString('close'),
            subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
            onDisplayed: onDialogDismissed
          });
        } else {
          if (!this.props.inPreview) {
            this.showToast(locString('guessRecorded'));
          }
          // this.showSimpleOverlayView({title: locString('guessRecorded'), onPositiveClicked: onDialogDismissed});
          onDialogDismissed();
        }
      }
    }, (error) => {
      this.showSimpleOverlayView({title: error});
    });
  }

  makeApiForSpin(gameEndValue = null) {
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      gameEndValue: gameEndValue
    };
    this.makeActionInActivity(data, false, (response) => {
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateActivityData().then(() => {
          if (this.refJackpotGameView) {
            this.refJackpotGameView.reset();
          }
          this.reloadView();
        });
      } else {
        this.activityUpdated = response;
        if (this.refJackpotGameView) {
          const isWin = this.activityUpdated.userWon;
          const isWinEligible = this.activityUpdated.userWinEligible;
          let isSpinComplete = false;
          if (this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN || this.activity.type === ACTIVITY_TYPE_BETTING_PIC || this.activity.type === ACTIVITY_TYPE_SPIN_DISCOVER) {
            isSpinComplete = response.consumeLimitPerUser - response.userConsumedCount <= 0;
          }
          this.refJackpotGameView.stop({
            isWin: isWin,
            isWinEligible: isWinEligible,
            isSpinComplete: isSpinComplete,
            endValues: response.endSlotValues,
            value: response.userValueText,
            items: response.slotValues,
          });
        }
      }
    }, (error) => {
      if (this.refJackpotGameView) {
        this.refJackpotGameView.reset();
      }
      this.showToastError(error);
    });
  }

  resetGame = () => {
    if (!this.activity.userWon
      && (this.activity.type === ACTIVITY_TYPE_MATCH_THREE
        || this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE
        || this.activity.type === ACTIVITY_TYPE_GREEDY_SPIN
        || this.activity.type === ACTIVITY_TYPE_BETTING_PIC)) {
      this.showSimpleOverlayView({
        title: locString('playAgainQ'),
        subTitle: locString('resetCollectedValuesPrompt', null, this.context.intl),
        positiveActionText: locString('yes'),
        negativeActionText: locString('no'),
        onPositiveClicked: () => {
          this.onResetClicked();
        }
      });
    } else {
      this.onResetClicked();
    }
  }

  makeApiForAnswer(activity, innerQuestionDisplayedEnd = false) {
    const data = {
      dp: activity.dp,
      aid: activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      answer: this.selectedOptionIndexes && this.selectedOptionIndexes.size > 0 ? Array.from(this.selectedOptionIndexes) : [1],
      value1: ValueHelper.getEnglishValue(this.guess1),
      value2: ValueHelper.getEnglishValue(this.guess2),
      nextId: this.props.playInShowcase ? this.activity.nextId : null,
      activityId: activity ? activity.id : null,
    };
    let withBlockedLoading = true;
    if (innerQuestionDisplayedEnd) {
      if (this.props.inPreview) {
        data.innerQuestionDisplayedEnd = true;
      }
      // withBlockedLoading = false;
      // this.setState({inQuestionUpdating: true});
    }

    this.makeActionInActivity(data, withBlockedLoading, (response) => {
      let successMessage = locString('activity.answerSuccess');
      if (activity.type === ACTIVITY_TYPE_PREDICTION) {
        successMessage = locString('guessSubmitted');
      } else if (activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
        successMessage = locString('pickedLocationSubmitted');
      }
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateAndReload();
      } else if (this.activity.inQuestion && this.activity.inQuestion.isUserActionable) {
        this.activity.inQuestion.isUserActionable = false;
        // this.setState({inQuestionUpdating: false});
        if (this.props.inPreview) {
          this.activity.isUserActionable = false;
          this.activity.isUserResetable = true;
        }
        this.updateAndReload();
      } else if (activity.type === ACTIVITY_TYPE_QUESTION || activity.type === ACTIVITY_TYPE_PREDICTION) {
        this.activityUpdated = response;
        this.activityNext = response.next;
        const onDialogDismissed = () => {
          if (this.props.onPreFunDone && !this.activityUpdated.showEnd) {
            this.props.onPreFunDone(this.activityNext);
          } else {
            this.activity = this.activityUpdated;
            this.updateAndReload();
          }
        };

        // let topSubView = ActivityHelper.getActionTopSubView(this.activityUpdated, this.props.width, this.dismissSimpleOverlayNHandleCallback);
        let topSubView = null;
        if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
          this.showSimpleOverlayView({
            title: topSubView == null ? locString('greatJob') : null,
            positiveActionText: locString('close'),
            topSubView: topSubView,
            subView: this.getParticipationWonOverlayContentView(this.activityUpdated, successMessage),
            onDisplayed: onDialogDismissed
          });
        } else {
          // this.showSimpleOverlayView({
          //   title: successMessage,
          //   onPositiveClicked: onDialogDismissed
          // });
          this.showToast(successMessage);
          setTimeout(() => {
            onDialogDismissed();
          });
        }
      } else {
        this.activity = response;
        this.updateActivityData().then(() => {
          const onPositiveClicked = () => {
            this.updateAndReload();
          };
          if (ActivityHelper.isPointsEarned(this.activity)) {
            ActivityHelper.showPointsEarnedAlertView(this, this.getUIConfigs(), this.activity, this.props.width, successMessage, locString('ok'), null, this.onActivityClicked, this.onImageFSClicked, onPositiveClicked);
          } else {
            onPositiveClicked();
            // this.showAlert(BaseScreen.getImage(ImageTypeSuccess), successMessage, null, locString('ok'), null, onPositiveClicked);
          }
        });
      }
    }, (error) => {
      this.showSimpleOverlayView({title: error});
    });
  }

  makeApiForIdentifyLocation() {
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      value1: this.guess1,
      value2: this.guess2,
    };
    this.makeActionInActivity(data, true, (response) => {
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateAndReload();
      } else {
        this.activityUpdated = response;
        const onDialogDismissed = () => {
          this.activity = this.activityUpdated;
          this.updateAndReload();
        };
        const isWin = this.activityUpdated.userWon;
        const isWinEligible = this.activityUpdated.userWinEligible;
        if (isWin) {
          this.playGameWinAudioInline();
          onDialogDismissed();
        } else if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
          let subTitle = null;
          if (isWinEligible) {
            subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
            this.playGameNeutralAudioInline();
          }
          this.showSimpleOverlayView({
            icon: IconGifts,
            iconColor: this.getUIConfigs().messageBorderColor,
            title: locString('earnedPointsTitle'),
            subTitle: subTitle,
            positiveActionText: locString('close'),
            subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
            onDisplayed: onDialogDismissed
          });
        } else {
          if (!this.props.inPreview) {
            this.showToast(locString('pickedLocationSubmitted'));
          }
          onDialogDismissed();
        }
      }
    }, (error, errorCode) => {
      if (this.activity.type === ACTIVITY_TYPE_IDENTIFY_LOCATION) {
        this.guess1 = this.oldGuess1;
        this.guess2 = this.oldGuess2;
      }
      this.showSimpleOverlayView({
        icon: IconCross,
        iconColor: this.getUIConfigs().messageBorderColor,
        subTitle: error,
      });
    });
  }

  makeApiForQuestionnaireAnswer() {
    if (this.intervalHandle) {
      this.wasQuestionnaireTimerRunning = true;
      this.stopQuestionnaireTimer();
    }
    if (this.questionnaireNumber === 0 || !this.activity.questionnaire || this.activity.questionnaire.length < (this.questionnaireNumber - 1)) {
      return;
    }
    const questionId = this.activity.questionnaire[this.questionnaireNumber - 1].id;
    const answerId = this.questionnaireMap[questionId];
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      value1: questionId,
      value2: answerId,
      value: this.state.questionnaireTimer,
    };
    this.makeActionInActivity(data, true, (response) => {
      this.wasQuestionnaireTimerRunning = false;
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateAndReload();
      } else {
        this.activityUpdated = response;
        const onDialogDismissed = () => {
          this.activity = this.activityUpdated;
          this.updateAndReload();
        };

        const isWin = this.activityUpdated.userWon;
        const isWinEligible = this.activityUpdated.userWinEligible;
        if (isWin) {
          this.playGameWinAudioInline();
          onDialogDismissed();
        } else if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
          let subTitle = null;
          if (isWinEligible) {
            subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
            this.playGameNeutralAudioInline();
          }
          this.showSimpleOverlayView({
            icon: IconGifts,
            iconColor: this.getUIConfigs().messageBorderColor,
            title: locString('earnedPointsTitle'),
            subTitle: subTitle,
            positiveActionText: locString('close'),
            subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
            onDisplayed: onDialogDismissed
          });
        } else {
          if (isWinEligible) {
            this.playGameNeutralAudioInline();
            // this.showSimpleOverlayView({
            //   icon: IconSuccess,
            //   iconColor: this.getUIConfigs().messageBorderColor,
            //   title: locString('earnedPointsTitle'),
            //   subTitle: locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDate(this.activity.winnersAt)}, this.context.intl),
            //   positiveActionText: locString('close'),
            //   onDisplayed: onDialogDismissed
            // });
            if (!this.props.inPreview) {
              this.showToast(locString('userEligibleToWin'));
            }
            onDialogDismissed();
          } else if (this.activityUpdated.sponsoredFun) {
            const sponsoredFun = this.activityUpdated.sponsoredFun;
            delete(this.activityUpdated.sponsoredFun);

            const uiConfigs = this.getUIConfigs();
            const subView = ActivityHelper.getPointsNFunView(uiConfigs, this.props.width, 0, 0, [sponsoredFun], 4, (callback) => {
              this.dismissSimpleOverlayNHandleCallback(() => {
                onDialogDismissed();
                if (callback) {
                  callback();
                }
              });
            }, this.onActivityClicked, this.onImageFSClicked);
            this.showSimpleOverlayView({
              showInCenter: true,
              title: locString('takeARest'),
              subTitle: locString('takeARestMessage'),
              positiveActionText: locString('continueToQuestions'),
              subView: <View style={{marginBottom: 20}}>{subView}</View>,
              onPositiveClicked: onDialogDismissed
            });
          } else {
            onDialogDismissed();
          }
        }
      }
    }, (error) => {
      this.showSimpleOverlayView({
        title: error,
        onPositiveClicked: () => {
          if (this.wasQuestionnaireTimerRunning) {
            this.wasQuestionnaireTimerRunning = false;
            this.startQuestionnaireTimer();
          }
        }
      });
    });
  }

  makeApiToCollectStars() {
    this.showLoader(() => {
      const data = {
        dp: this.activity.dp,
        aid: this.activity.aid,
        state: ACTIVITY_UPDATE_STATE_ACTION,
      };
      ApiTask().post('ENDPOINT_ACTIVITY_STATE' + "/" + this.activity.id, data, (response) => {
        this.dismissLoader(() => {
          if (response.isRefreshedOnly) {
            delete(response.isRefreshedOnly);
            this.showToastInfo(locString('dataNotLatest'));
            this.activity = response;
            this.updateAndReload();
          } else {
            this.activity = response;
            this.updateActivityData().then(() => {
              const earnStars = this.activity.userAnswer;
              this.activity.userAnswer = 0;
              const starsCollectedMessage = locString(earnStars === 1 ? 'starCollectedMessage' : 'starsCollectedMessage', {value: earnStars, value1: this.getGameValuePlaceholder()});
              const minutesPassed = -(DateTimeHelper.getSecondsDiffFromNow(this.activity.userActionAt)) / 60;
              const resetAfterMinutes = this.activity.userConsumedCount - minutesPassed;
              let message = starsCollectedMessage + '\n\n' + locString('backAgainToCollectMore', {value: DateTimeHelper.getGameRecurIn(DateTimeHelper.getDateWithAddingMinutesFromNow(resetAfterMinutes))}, this.context.intl);

              if (ActivityHelper.isPointsEarned(this.activity)) {
                ActivityHelper.showPointsEarnedAlertView(this, this.getUIConfigs(), this.activity, this.props.width, locString('starsCollected', {value1: this.getGameValuePlaceholder()}, this.context.intl) + "\n" + message, locString('ok'), null, this.onActivityClicked, this.onImageFSClicked);
              } else {
                this.showAlert(BaseScreen.getImage(ImageTypeSuccess), locString('starsCollected', {value1: this.getGameValuePlaceholder()}), message, locString('ok'));
              }
            });
          }
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  makeApiToLikeUser(userId) {
    this.showLoader(() => {
      const data = {
        dp: this.activity.dp,
        aid: this.activity.aid,
        state: ACTIVITY_UPDATE_STATE_ACTION,
        value: userId,
      };
      ApiTask().post('ENDPOINT_ACTIVITY_STATE' + "/" + this.activity.id, data, (response) => {
        this.dismissLoader(() => {
          if (response.isRefreshedOnly) {
            delete(response.isRefreshedOnly);
            this.showToastInfo(locString('dataNotLatest'));
            this.activity = response;
            this.updateAndReload();
          } else {
            this.activityUpdated = response;
            const onDialogDismissed = () => {
              this.activity = this.activityUpdated;
              this.updateAndReload();
            };

            const uiConfigs = this.getUIConfigs();
            let participationWonView = null;
            let onPositiveClicked = onDialogDismissed;
            let onDisplayed = null;
            if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
              participationWonView = this.getParticipationWonOverlayContentView(this.activityUpdated, locString('genericEarnRewardsMessage'));
              onPositiveClicked = null;
              onDisplayed = onDialogDismissed;
            }
            this.showSimpleOverlayView({
              title: locString('greatJob', {value1: this.getGameValuePlaceholder()}),
              onPositiveClicked: onPositiveClicked,
              onDisplayed: onDisplayed,
              hideActionsSeparator: true,
              showInCenter: true,
              subView: (
                <View>
                  <View style={{backgroundColor: ColorWhite, alignItems: 'center', justifyContent: 'center', padding: 16, marginBottom: 16, marginTop: 8, marginLeft: -16, marginRight: -16}}>
                    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                      {this.activity.imageUrl1 ?
                        <View style={{backgroundColor: uiConfigs.borderColor, alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                          <AppImage imageUrl={this.activity.imageUrl1} style={{width: 56, height: 56, borderRadius: 28}}/>
                        </View>
                        : null
                      }
                      <View style={{marginLeft: 12, marginRight: 12, alignItems: 'center', maxWidth: this.props.width - 208}}>
                        <AppText style={{textAlign: 'center', fontSize: FontSizeSmall, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor}}>
                          {locString('youGave')}
                        </AppText>
                        <AppText style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginTop: 4}}>
                          {this.getGameValuePlaceholder()}
                        </AppText>
                        <AppText numberOfLines={2} style={{textAlign: 'center', fontSize: FontSizeLarge, fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginTop: 2}}>
                          {locString('likeToUserValue', {value: this.activity.likeeUser.name})}
                        </AppText>
                      </View>
                      <View style={{backgroundColor: uiConfigs.borderColor, alignSelf: 'center', width: 60, height: 60, borderRadius: 30, padding: 2}}>
                        <AppImage imageUrl={this.activity.likeeUser.imageUrl} style={{width: 56, height: 56, borderRadius: 28}}/>
                      </View>
                    </View>
                  </View>
                  {participationWonView}
                </View>
              )
            });
          }
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  makeApiForFlipGameStart() {
    if (!this.props.inPreview) {
      this.makeApiForFlipGameAction(true);
    }
  }

  makeApiForFlipGameOver(withBlockedLoading = false) {
    this.makeApiForFlipGameAction(false, withBlockedLoading);
  }

  makeApiForFlipGameAction(isStart = false, withBlockedLoading = false) {
    // CipherHelper.getD(this.props.user, this.activity.gameExC, this.gameEndValue, (value) => {
      if (!this.gameEndValue) {
        this.gameEndValue = {};
      }
      if (isStart) {
         this.gameEndValue.startToken = uuidv4();
      } else {
        this.gameEndValue.endToken = this.activity.gameEndToken || 'gameEndToken';
      }
      const data = {
        dp: this.activity.dp,
        aid: this.activity.aid,
        state: ACTIVITY_UPDATE_STATE_ACTION,
        gameEndValue: JSON.stringify(this.gameEndValue),
        // gameEndValueD: value,
        gameExC: this.activity.gameExC,
      };

      if (isStart) {
        this.startPlay();
      }
      this.makeActionInActivity(data, withBlockedLoading, (response) => {
        if (!isStart) {
          this.stopPlay();
        }
        this.isGameOver = false;
        this.gameEndValue = null;
        this.flippedValues = null;
        if (response.isRefreshedOnly) {
          delete(response.isRefreshedOnly);
          this.showToastInfo(locString('dataNotLatest'));
          this.activity = response;
          this.updateActivityData().then(() => {
            if (this.refFlipTileGameView && this.activity.slotValues) {
              if (this.activity.type === ACTIVITY_TYPE_TIC_TAC_TOE
                || this.activity.type === ACTIVITY_TYPE_PUZZLE
                || this.activity.type === ACTIVITY_TYPE_PUZZLE_SLIDE
                || this.activity.type === ACTIVITY_TYPE_MATCH_THREE
                || this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE
                || this.activity.type === ACTIVITY_TYPE_POKER
                || this.activity.gameValue) {
                this.refFlipTileGameView.reset(this.activity.slotValues, this.activity.gameValue, this.activity.flipsNeeded);
              }
            } else if (this.refSlides && this.activity.subPosts) {
              this.refSlides.reset(this.activity.subPosts, 0);
            }
            this.reloadView();
          });
        } else if (isStart) {
          this.activity.gameEndToken = response.gameEndToken;
        } else {
          this.activityUpdated = response;
          const onDialogDismissed = () => {
            this.activity = this.activityUpdated;
            if (this.refFlipTileGameView && this.activity.slotValues) {
              if (this.activity.type === ACTIVITY_TYPE_WHAC_A_MOLE) {
                this.refFlipTileGameView.reset(this.activity.slotValues, {score: this.activity.userValueText});
              } else {
                this.refFlipTileGameView.reset(this.activity.slotValues, this.activity.gameValue, this.activity.flipsNeeded);
              }
            } else if (this.refSlides && this.activity.subPosts && !this.props.simulation) {
              this.refSlides.reset(this.activity.subPosts, 0);
            }
            this.updateAndReload();
          };
          if (this.activityUpdated.type === ACTIVITY_TYPE_COLLECT_STARS) {
            const isWin = this.activityUpdated.userWon;
            const isWinEligible = this.activityUpdated.userWinEligible;
            if (isWin) {
              this.playGameWinAudioInline();
              onDialogDismissed();
            } else if (isWinEligible) {
              const subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
              this.playGameNeutralAudioInline();
              let subView = null;
              if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
                subView = this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage'));
              }
              this.showSimpleOverlayView({
                icon: IconGifts,
                iconColor: this.getUIConfigs().messageBorderColor,
                title: locString('earnedPointsTitle'),
                subTitle: subTitle,
                positiveActionText: locString('close'),
                subView: subView,
                onDisplayed: onDialogDismissed
              });
            } else {
              this.playGameNeutralAudioInline();
              const earnStars = this.activityUpdated.userAnswer;
              this.activityUpdated.userAnswer = 0;
              let message = locString(earnStars === 1 ? 'starCollectedMessage' : 'starsCollectedMessage', {value: earnStars, value1: this.getGameValuePlaceholder()});
              if (this.activityUpdated.userConsumedCount > 0) {
                const minutesPassed = -(DateTimeHelper.getSecondsDiffFromNow(this.activity.userActionAt)) / 60;
                const resetAfterMinutes = this.activityUpdated.userConsumedCount - minutesPassed;
                message += '\n\n' + locString('backAgainToCollectMore', {value: DateTimeHelper.getGameRecurIn(DateTimeHelper.getDateWithAddingMinutesFromNow(resetAfterMinutes))}, this.context.intl);
              }
              if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
                this.showSimpleOverlayView({
                  icon: IconGifts,
                  iconColor: this.getUIConfigs().messageBorderColor,
                  title: locString('starsCollected', {value1: this.getGameValuePlaceholder()}),
                  positiveActionText: locString('close'),
                  subView: this.getParticipationWonOverlayContentView(this.activityUpdated, message),
                  onDisplayed: onDialogDismissed
                });
              } else {
                this.showSimpleOverlayView({
                  icon: IconSuccess,
                  iconColor: this.getUIConfigs().messageBorderColor,
                  title: locString('starsCollected', {value1: this.getGameValuePlaceholder()}),
                  subTitle: message,
                  positiveActionText: locString('close'),
                  onDisplayed: onDialogDismissed
                });
              }
            }
          } else {
            const isWin = this.activityUpdated.userWon;
            const isWinEligible = this.activityUpdated.userWinEligible;
            if (isWin) {
              this.playGameWinAudioInline();
              onDialogDismissed();
            } else if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
              let subTitle = null;
              if (isWinEligible) {
                subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
                this.playGameNeutralAudioInline();
              }
              this.showSimpleOverlayView({
                icon: IconGifts,
                iconColor: this.getUIConfigs().messageBorderColor,
                title: locString('earnedPointsTitle'),
                subTitle: subTitle,
                positiveActionText: locString('close'),
                subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
                onDisplayed: onDialogDismissed
              });
            } else {
              // if (isWinEligible) {
              //   this.playGameNeutralAudioInline();
              //   this.showSimpleOverlayView({
              //     icon: IconSuccess,
              //     iconColor: this.getUIConfigs().messageBorderColor,
              //     title: locString('earnedPointsTitle'),
              //     subTitle: locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDate(this.activity.winnersAt)}, this.context.intl),
              //     positiveActionText: locString('close'),
              //     onDisplayed: onDialogDismissed
              //   });
              // } else {
              //   onDialogDismissed();
              // }
              if (isWinEligible) {
                this.playGameNeutralAudioInline();
                if (!this.props.inPreview) {
                  this.showToast(locString('userEligibleToWin'));
                }
              }
              onDialogDismissed();
            }
          }
        }
      }, (error, errorCode) => {
        if (!isStart) {
          this.stopPlay();
        }
        this.isGameOver = false;
        this.gameEndValue = null;
        this.flippedValues = null;
        const needToReload = errorCode == 422;
        setTimeout(() => {
          this.showSimpleOverlayView({
            // icon: IconCross,
            // iconColor: this.getUIConfigs().messageBorderColor,
            subTitle: error,
            positiveActionText: needToReload ? locString('generic.ok') : locString('generic.retry'),
            negativeActionText: needToReload ? null : locString('generic.cancel'),
            onPositiveClicked: () => {
              if (needToReload) {
                this.makeApiForData();
              } else {
                if (this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
                  this.onSocketGameResponseNonHandled(this.lastSocketData ? this.lastSocketData.gameData : this.processGameRequestForSocket().gameData);
                } else {
                  this.makeApiForFlipGameOver();
                }
              }
            },
            onNegativeClicked: needToReload ? null : () => {
              this.makeApiForData();
            }
          });
        }, 300);
      });
    // });
  }

  makeApiForExternalGameStart() {
    if (!this.props.inPreview) {
      this.makeApiForExternalGameAction(null, true);
    }
  }

  makeApiForExternalGameOver(gameEndValue) {
    if (!this.props.autoSimulation) {
      this.isGameDataUpdating = true;
    }
    this.makeApiForExternalGameAction(gameEndValue, false);
  }

  makeApiForExternalGameAction(gameEndValue, isStart = false) {
    // CipherHelper.getD(this.props.user, this.activity.gameExC, this.gameEndValue, (value) => {
    if (!gameEndValue) {
      gameEndValue = {};
    }
    if (isStart) {
      gameEndValue.startToken = uuidv4();
    } else {
      gameEndValue.endToken = this.activity.gameEndToken || 'gameEndToken';
    }
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION,
      gameEndValue: JSON.stringify(gameEndValue),
      // gameEndValueD: value,
      gameExC: this.activity.gameExC,
    };

    if (isStart) {
      this.startPlay();
    }
    this.makeActionInActivity(data, false, (response) => {
      if (!isStart) {
        this.stopPlay();
      }
      this.isGameDataUpdating = false;
      this.isGameOver = false;
      this.gameEndValue = null;
      this.flippedValues = null;
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateActivityData().then(() => {
          if (!this.props.simulation) {
            this.restartExternalGame();
          }
          this.reloadView();
        });
      } else if (isStart) {
        this.activity.gameEndToken = response.gameEndToken;
      } else {
        this.activityUpdated = response;
        const onDialogDismissed = () => {
          this.activity = this.activityUpdated;
          if (!this.props.simulation) {
            this.restartExternalGame();
          }
          this.updateAndReload();
        };
        const isWin = this.activityUpdated.userWon;
        const isWinEligible = this.activityUpdated.userWinEligible;
        if (isWin) {
          this.playGameWinAudioInline();
          onDialogDismissed();
        } else if (ActivityHelper.isPointsEarned(this.activityUpdated)) {
          let subTitle = null;
          if (isWinEligible) {
            subTitle = locString('userEligibleToWin', null, this.context.intl) +'\n'+ locString('winnersWillBeDeclaredAt', {value: DateTimeHelper.getDisplayDateWOYear(this.activity.winnersAt)}, this.context.intl);
            this.playGameWinAudioInline();
          }
          this.showSimpleOverlayView({
            icon: IconGifts,
            iconColor: this.getUIConfigs().messageBorderColor,
            title: locString('earnedPointsTitle'),
            subTitle: subTitle,
            positiveActionText: locString('close'),
            subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('gameEarnMessage')),
            onDisplayed: onDialogDismissed
          });
        } else {
          if (isWinEligible) {
            this.playGameWinAudioInline();
            if (!this.props.inPreview) {
              this.showToast(locString('userEligibleToWin'));
            }
          }
          onDialogDismissed();
        }
      }
    }, (error, errorCode) => {
      this.isGameOver = false;
      this.gameEndValue = null;
      this.flippedValues = null;
      const needToReload = errorCode == 422;
      setTimeout(() => {
        this.showSimpleOverlayView({
          subTitle: error,
          positiveActionText: needToReload ? locString('generic.ok') : locString('generic.retry'),
          negativeActionText: needToReload ? null : locString('generic.cancel'),
          onPositiveClicked: () => {
            if (needToReload) {
              if (!isStart) {
                this.stopPlay();
              }
              this.makeApiForData();
            } else {
              this.makeApiForExternalGameOver(gameEndValue);
            }
          },
          onNegativeClicked: needToReload ? null : () => {
            if (!isStart) {
              this.stopPlay();
            }
            this.makeApiForData();
          }
        });
      }, 300);
    });
  }

  makeApiToRate() {
    let data = null;

    const recordAsset = this.refMultiInputView.recordAsset;
    const image = this.refMultiInputView.image;
    let audioPath = null;
    if (recordAsset /* && recordAsset.state === AUDIO_RECORDER_STATE_RECORDED && recordAsset.audioPath */) {
      audioPath = recordAsset.audioPath;
    }

    if (audioPath || image) {
      data = new FormData();
      if (image) {
        data.append('imageFile', {
          name: 'photo.png',
          uri: image,
          type: 'image/png'
        });
      }
      if (audioPath) {
        data.append('audioFile', {
          name: 'record.m4a',
          uri: audioPath,
          type: 'audio/m4a'
        });
      }
      if (this.refMultiInputView.message) {
        data.append("title", this.refMultiInputView.message);
      }
      data.append("rating", this.rating);
      data.append("state", ACTIVITY_UPDATE_STATE_RATE);
      data.append("isCompleteReview", 1);
      if (this.activity.dp) {
        data.append("dp", this.activity.dp);
      }
      if (this.activity.aid) {
        data.append("aid", this.activity.aid);
      }
    } else {
      data = {
        aid: this.activity.aid,
        title: this.refMultiInputView.message,
        state: ACTIVITY_UPDATE_STATE_RATE,
        rating: this.rating,
        isCompleteReview: this.refMultiInputView.message != null,
      };
    }

    this.showLoader(() => {
      ApiTask().post('ENDPOINT_ACTIVITY_STATE' + "/" + this.activity.id, data, (response) => {
        this.dismissLoader(() => {
          this.onRatingDone(response);
        });
      }, (errorType, error) => {
        this.dismissLoader(() => {
          this.showAlert(BaseScreen.getImage(errorType), error);
        });
      });
    });
  }

  onBackClicked = () => {
    if (this.questionnaireNumber || this.isPlaying) {
      this.pushHashHistory(HASH_QUESTIONNAIRE);
      let title = null;
      let subTitle = null;
      if (this.questionnaireNumber) {
        title = this.activity.type === ACTIVITY_TYPE_SURVEY ? locString('exitSurvey') : locString('exitQuestionnaire');
        subTitle = this.activity.type === ACTIVITY_TYPE_SURVEY ? locString('exitSurveyMessage') : locString('exitQuestionnaireMessage');
      } else {
        title = locString('activity.exitPlay');
        subTitle = locString('activity.exitPlayMessage');
      }
      this.showSimpleOverlayView({
        title: title,
        subTitle: subTitle,
        positiveActionText: locString('exit'),
        negativeActionText: locString('no'),
        onPositiveClicked: () => {
          if (this.questionnaireNumber) {
            this.stopQuestionnaireTimer();
            setTimeout(() => {
              this.questionnaireNumber = 0;
              this.questionnaireMap = {};
              this.updateAndReload();
            }, 100);
          } else {
            setTimeout(() => {
              this.stopPlay();
              setTimeout(() => {
                this.moveToBack();
              }, 100);
            }, 100);
          }
        },
      });
      return true;
    }
    return this.moveToBack();
  };

  moveToBack = (event) => {
    if (!this.props.inPreview) {
      if (event) {
        event.target.blur();
      }
      if (this.props.onBackClicked) {
        this.props.onBackClicked();
      }
    }
  };

  onActivityUpdated = (activity) => {
    if (activity) {
      this.activity = activity;
    }
  };

  onClickMore = (event) => {
    this.openMenu(event.target);
  }

  onConsumeOfferClicked = () => {
    const data = {
      dp: this.activity.dp,
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_ACTION
    };
    this.makeActionInActivity(data, true, (response) => {
      if (response.isRefreshedOnly) {
        delete(response.isRefreshedOnly);
        this.showToastInfo(locString('dataNotLatest'));
        this.activity = response;
        this.updateAndReload();
      } else {
        if (this.activity.isVoucher) {
          this.activity = response;
          this.updateActivityData().then(() => {
            if (ActivityHelper.isPointsEarned(this.activity)) {
              this.showSimpleOverlayView({
                icon: IconGifts,
                iconColor: ColorEarning,
                title: locString('greatJob'),
                positiveActionText: locString('ok'),
                subView: this.getParticipationWonOverlayContentView(this.activityUpdated, locString('voucherCodeGenerated', null, this.context.intl) +'\n\n'+ locString('voucherEarnMessage', null, this.context.intl)),
              });
            } else {
              this.showToast(locString('voucherCodeGenerated'));
            }
            this.reloadView();
          });
        } else {
          this.activity = response;
          this.showToast(locString('offerCodeGenerated'));
          this.updateAndReload();
        }
      }
    }, (error) => {
      this.showToastError(error);
    });
  };

  onResetClicked() {
    const data = {
      aid: this.activity.aid,
      state: ACTIVITY_UPDATE_STATE_RESET,
    };
    this.makeActionInActivity(data, true, (response) => {
      this.activity = response;
      this.updateAndReload();
      if (this.activity.type === constants.activity.types.GAME_POKER
        || this.activity.type === constants.activity.types.GAME_TIC_TAC_TOE
        || this.activity.type === constants.activity.types.GAME_WHAC_A_MOLE) {
        if (this.refFlipTileGameView) {
          this.refFlipTileGameView.reset(this.activity.slotValues);
        }
      }
    }, (error) => {
      this.showToastError(error);
    });
  }

  processPreviewGameReset() {
    const newActivity = cloneDeep(this.activity);
    newActivity.userConsumedCount = 0;
    newActivity.isUserResetable = false;
    newActivity.isUserActionable = true;
    newActivity.isUserActionableA = false;
    newActivity.userRating = 0;
    newActivity.userWon = false;
    newActivity.userWinEligible = false;
    newActivity.userNotWon = false;
    newActivity.userValueText = null;
    if (newActivity.slotValues) {
      newActivity.slotValues.forEach((slotValue) => {
        slotValue.value2 = 0;
      })
    }
    newActivity.userAnswer = 0;
    this.guess1 = null;
    this.guess2 = null;
    this.guessText = null;
    this.processPreviewGameResetForQuestionNGuessNPrediction(newActivity);
    this.processPreviewGameResetForQuestionnaire(newActivity);
    if (newActivity.previewInQuestion) {
      newActivity.previewInQuestion.isUserActionable = true;
    }

    if (newActivity.type === ACTIVITY_TYPE_PUZZLE || newActivity.type === ACTIVITY_TYPE_PUZZLE_SLIDE) {
      if (this.refFlipTileGameView) {
        this.refFlipTileGameView.resetForPreview(newActivity.slotValues);
      }
    } else if (newActivity.type === ACTIVITY_TYPE_SLIDES || newActivity.type === ACTIVITY_TYPE_SHOWCASE_MENU) {
      if (this.refSlides) {
        this.refSlides.resetForPreview(newActivity.subPosts, 0);
      }
    }
    if (this.props.gameValidationCallbacks && this.props.gameValidationCallbacks.onRestart) {
      this.props.gameValidationCallbacks.onRestart();
    }
    return newActivity;
  }

  processPreviewGameResetForQuestionNGuessNPrediction(newActivity) {
    newActivity.userAnswer = 0;
    newActivity.userValueText = null;
    newActivity.userConsumedCount = 0;
    newActivity.isUserResetable = false;
    newActivity.isUserActionable = true;
    if (this.selectedOptionIndexes) {
      this.selectedOptionIndexes.clear();
    }
  }

  processPreviewGameResetForQuestionnaire(newActivity) {
    newActivity.userAnswer = 0;
    newActivity.questionnaireAnswers = null;
    newActivity.isUserResetable = false;
    newActivity.isUserActionable = true;
    newActivity.userClickedCount = 0;
  }

  processPreviewGameAction(data) {
    const oldIsUserActionableA = this.activity.isUserActionableA;
    const newActivity = cloneDeep(this.activity);
    if (newActivity && newActivity.previewInQuestion && newActivity.previewInQuestion.isUserActionable) {
      this.selectedOptionIndexes.clear();
      newActivity.previewInQuestion.isUserActionable = false;
      return newActivity;
    }
    if (newActivity && data.innerQuestionDisplayedEnd && newActivity.inQuestion && newActivity.inQuestion.isUserActionable) {
      this.selectedOptionIndexes.clear();
      newActivity.inQuestion.isUserActionable = false;
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
      return newActivity;
    }
    if (newActivity.type === constants.activity.types.JACKPOT
      || newActivity.type === constants.activity.types.GAME_ROULETTE
      || newActivity.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || newActivity.type === constants.activity.types.GAME_BRAND_RACE
      || newActivity.type === constants.activity.types.GAME_BETTING_PIC) {
      newActivity.userConsumedCount++;

      let gameColumns = newActivity.gameColumns;
      if (newActivity.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || newActivity.type === constants.activity.types.GAME_BRAND_RACE) {
        gameColumns = newActivity.gameSColumns;
      }
      let randomCount = gameColumns;
      if (newActivity.type === constants.activity.types.GAME_BETTING_PIC) {
        randomCount = newActivity.gameColumns * newActivity.gameRows;
      }

      const randoms = [];
      for (let i = 0; i < randomCount; i++) {
        let random = 0;
        if (newActivity.type === constants.activity.types.GAME_SPIN_N_DISCOVER
          || newActivity.type === constants.activity.types.GAME_BRAND_RACE) {
          const shouldHaveKey = Math.random() <= 0.5;
          if (shouldHaveKey) {
            random = 0;
          } else {
            random = Math.floor(Math.random() * newActivity.slotValues.length);
          }
        } else {
          random = Math.floor(Math.random() * newActivity.slotValues.length);
        }
        randoms.push(random);
      }
      let endSlotValues = null;
      if (newActivity.type === constants.activity.types.GAME_GREEDY_SPIN
        || newActivity.type === constants.activity.types.GAME_BETTING_PIC) {
        let effEndSlotValues = [];
        for (let row = 0; row < newActivity.gameRows; row++) {
          let slotValues = [];
          for (let column = 0; column < newActivity.gameColumns; column++) {
            const random = randoms[row * newActivity.gameColumns + column];
            slotValues.push(newActivity.slotValues[random]);
          }
          effEndSlotValues.push(slotValues);
        }
        endSlotValues = effEndSlotValues;
      } else {
        endSlotValues = [];
        randoms.forEach((random) => {
          endSlotValues.push(newActivity.slotValues[random]);
        });
      }
      newActivity.endSlotValues = endSlotValues;

      if (newActivity.type === constants.activity.types.JACKPOT) {
        let isWin = true;
        randoms.forEach((random) => {
          if (random > 0) {
            isWin = false;
          }
        });
        if (isWin) {
          newActivity.userWon = true;
        }
      } else if (newActivity.type === constants.activity.types.GAME_ROULETTE) {
        let gameEndValue = data.gameEndValue;
        let isWin = true;
        for (let i = 0; i < randoms.length; i++) {
          if (gameEndValue[i] !== newActivity.slotValues[randoms[i]].id) {
            isWin = false;
            break;
          }
        }
        if (isWin) {
          newActivity.userWon = true;
        }
      } else if (newActivity.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
        let collectedValue = newActivity.userValueText ? parseInt(newActivity.userValueText) : 0;
        randoms.forEach((random) => {
          const slot = newActivity.slotValues[random];
          if (slot.number === 0) {
            collectedValue += (this.props.autoSimulation ? 2 : 1);
          } else if (slot.number < 0) {
            collectedValue -= 1;
          }
        });
        collectedValue = Math.max(0, collectedValue);
        newActivity.userValueText = collectedValue;
        const isWin = collectedValue >= newActivity.gameRows * newActivity.gameColumns;
        if (isWin) {
          newActivity.userWon = true;
        }
      } else if (newActivity.type === constants.activity.types.GAME_BRAND_RACE) {
        const score = {};
        for (let i = 0; i < newActivity.gameColumns; i++) {
          const slot = newActivity.slotValues[i];
          score[slot.number] = 0;
        }
        if (newActivity.userValueText && newActivity.userValueText.length > 0) {
          const oldScores = newActivity.userValueText.split(',');
          if (oldScores && oldScores.length > 0) {
            oldScores.forEach((oldScore) => {
              const oldScoreKV = oldScore.split(':');
              score[oldScoreKV[0]] = parseInt(oldScoreKV[1]);
            });
          }
        }

        let reduceCount = 0;
        randoms.forEach((random) => {
          const slot = newActivity.slotValues[random];
          if (slot.number < 0) {
            reduceCount++;
          } else {
            score[slot.number] = score[slot.number] + (this.props.autoSimulation ? 2 : 1);
          }
        });
        if (reduceCount > 0) {
          for (let i = 0; i < newActivity.gameColumns; i++) {
            const slot = newActivity.slotValues[i];
            if (slot.number >= 0) {
              score[slot.number] = Math.max(0, score[slot.number] - reduceCount);
            }
          }
        }
        let userValueTextChange = ',';
        for (let i = 0; i < newActivity.gameColumns; i++) {
          const slot = newActivity.slotValues[i];
          if (slot.number >= 0) {
            const scoreVal = score[slot.number];
            slot.value2 = scoreVal;
            userValueTextChange += `${slot.number}:${scoreVal},`;

            if (scoreVal >= newActivity.gameRows) {
              if (slot.number === 0) {
                newActivity.userWon = true;
                newActivity.userValue1 = -1;
              } else {
                newActivity.userNotWon = true;
              }
            }
          }
        }
        newActivity.userValueText = userValueTextChange;
      } else if (newActivity.type === constants.activity.types.GAME_BETTING_PIC) {
        let collectedValue = 0;
        for (let row = 0; row < newActivity.gameRows; row++) {
          let lCollectedValue = 0;
          let firstRandom = null;
          let count = 0;
          for (let column = 0; column < newActivity.gameColumns; column++) {
            const random = randoms[row * newActivity.gameColumns + column];
            const slot = newActivity.slotValues[random];
            if (random === firstRandom) {
              count++;
            }

            let columnWeight = 1;
            if (newActivity.type === constants.activity.types.GAME_BETTING_PIC) {
              columnWeight = [1, 2, 5, 10, 20, 50, 100][column];
            }
            const slotValue1 = slot.value1 * columnWeight;
            if (slotValue1) {
              lCollectedValue += slotValue1;
              if (slotValue1 > 0 && !firstRandom) {
                firstRandom = random;
              }
            }
          }
          // if (count === newActivity.gameColumns) {
          //   lCollectedValue *= 10; // 10 times
          // }
          collectedValue += lCollectedValue;
        }
        const oldValue = newActivity.userValueText ? parseInt(newActivity.userValueText) : 0;
        collectedValue = Math.max(0, collectedValue + oldValue);
        newActivity.userValueText = collectedValue;
        if (newActivity.userConsumedCount === newActivity.consumeLimitPerUser && newActivity.userValueText > 0) {
          newActivity.userWinEligible = true;
        }
      }

      if (newActivity.userWon) {
        newActivity.userConsumedCount = newActivity.consumeLimitPerUser;
        newActivity.userValue1 = -1;
      }
      if (newActivity.userNotWon) {
        newActivity.userConsumedCount = newActivity.consumeLimitPerUser;
        newActivity.userValue1 = -1;
      }
      if (newActivity.userConsumedCount === newActivity.consumeLimitPerUser) {
        newActivity.isUserActionable = false;
        newActivity.isUserResetable = true;
        newActivity.userAnswer = 0;
      }
    }

    else if (newActivity.type === constants.activity.types.GAME_POKER
      || newActivity.type === constants.activity.types.GAME_TIC_TAC_TOE) {
      let userValueText = newActivity.userValueText;
      if (!userValueText) {
        userValueText = 0;
      }
      userValueText = parseInt(userValueText);
      const gameEndValue = JSON.parse(data.gameEndValue);

      let isGameEnded = false;
      const isWin = gameEndValue.isWin;
      let isLose = gameEndValue.isLose;
      // consider draw as lose in auto simulation
      if (!isWin && !isLose && this.props.autoSimulation) {
        isLose = true;
      }
      if (isWin || isLose) {
        // let updatedUserValueText = null;
        let winMark = parseInt(newActivity.consumeLimitPerUser/2) + 1;
        let userWonRounds = Math.abs(userValueText);
        let botWonRounds = newActivity.userConsumedCount - userWonRounds;
        if (isWin) {
          userWonRounds++;
        } else {
          botWonRounds++;
        }
        if (userWonRounds >= winMark || botWonRounds >= winMark) {
          isGameEnded = true;
        }
        newActivity.userValueText = -userWonRounds;
        newActivity.userConsumedCount++;
        if (newActivity.userConsumedCount >= newActivity.consumeLimitPerUser || isGameEnded) {
          if (isWin) {
            newActivity.userWon = true;
            newActivity.userValue1 = -1;
          } else {
            newActivity.userNotWon = true;
          }
          newActivity.isUserActionable = false;
          newActivity.isUserResetable = true;
        }
      }
    }

    else if (newActivity.type === constants.activity.types.GAME_FLIP_CARD
      || newActivity.type === constants.activity.types.GAME_MATCH_PAIR
      || newActivity.type === constants.activity.types.GAME_PUZZLE
      || newActivity.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      const gameEndValue = JSON.parse(data.gameEndValue);
      const isWin = gameEndValue.isWin;
      newActivity.userConsumedCount++;
      if (isWin) {
        newActivity.userValueText = 1;
        newActivity.userWinEligible = true;
      } else {
        newActivity.userNotWon = true;
      }
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }

    else if ((newActivity.type === constants.activity.types.SLIDES || newActivity.type === constants.activity.types.SHOWCASE_MENU) && this.props.simulation) {
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = false;
    }

    else if (newActivity.type === constants.activity.types.GAME_WHAC_A_MOLE
      || newActivity.type === constants.activity.types.GAME_MATCH_THREE) {
      const gameEndValue = JSON.parse(data.gameEndValue);
      const value = gameEndValue.value;
      const isWin = newActivity.winnersBy === 1 && value >= newActivity.winnersByValue;
      newActivity.userConsumedCount++;
      newActivity.userValueText = value;
      if (isWin) {
        newActivity.userWinEligible = true;
      } else {
        newActivity.userNotWon = true;
      }
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }

    else if (newActivity.type === constants.activity.types.EXTERNAL_GAMES) {
      const gameEndValue = JSON.parse(data.gameEndValue);
      const value = gameEndValue.value;
      const isWin = newActivity.winnersBy === 1 && value >= newActivity.winnersByValue;
      newActivity.userConsumedCount++;
      newActivity.userValueText = value;
      if (isWin) {
        newActivity.userWinEligible = true;
      } else {
        newActivity.userNotWon = true;
      }
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }

    else if (newActivity.type === constants.activity.types.QUESTION) {
      newActivity.userAnswer = data.answer[0];
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }
    else if (newActivity.type === constants.activity.types.GUESS) {
      newActivity.userValueText = data.gameEndValue;
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }
    else if (newActivity.type === constants.activity.types.PREDICTION || newActivity.type === constants.activity.types.IDENTIFY_LOCATION) {
      newActivity.userValueText = ''+ data.value1 + (data.value2 ? ','+ data.value2 : '');
      newActivity.isUserActionable = false;
      newActivity.isUserActionableA = true;
      newActivity.isUserResetable = true;
    }
    else if (newActivity.type === constants.activity.types.QUESTIONNAIRE || newActivity.type === constants.activity.types.SURVEY) {
      if (!newActivity.questionnaireAnswers) {
        newActivity.questionnaireAnswers = {};
      }
      newActivity.questionnaireAnswers[data.value1] = data.value2;
      const attemptedQuestionsCount = Object.keys(newActivity.questionnaireAnswers).length;
      const isTimeOver = newActivity.gameTime > 0 && data.value >= newActivity.gameTime;
      const isGameEnded = attemptedQuestionsCount >= newActivity.consumeLimitPerUser || isTimeOver;
      newActivity.userClickedCount = data.value;
      newActivity.userConsumedCount = attemptedQuestionsCount;
      if (isGameEnded) {
        // process correct answers here
        newActivity.isUserActionable = false;
        newActivity.isUserResetable = true;
        let correctAnswers = 0;
        newActivity.questionnaire.forEach((question) => {
          const qOptions = question.qOptions || question.options;
          if (qOptions) {
            for (let i = 0; i < qOptions.length; i++) {
              const option = qOptions[i];
              if (option.id === newActivity.questionnaireAnswers[question.id]) {
                if (option.isRight) {
                  correctAnswers++;
                }
                break;
              }
            }
          }
        });
        newActivity.userAnswer = correctAnswers;
        newActivity.userWinEligible = newActivity.winnersBy === 1 && correctAnswers >= newActivity.winnersByValue;
      }
    }
    else if (newActivity.type === constants.activity.types.VISITOR_OPINION) {
      newActivity.userRating = data.rating;
      newActivity.isUserActionable = false;
      newActivity.isUserResetable = true;
    }

    if ((!newActivity.isUserActionable || newActivity.type === constants.activity.types.SLIDES) && (newActivity.videoUrl || newActivity.s2ImageUrl || newActivity.s2Link)) {
      newActivity.showEnd = true;
      newActivity.showEndAfter = 1000;
    }
    if (this.props.autoSimulation) {
      newActivity.isUserResetable = false;
    }
    // show question
    if (newActivity.isUserResetable && !oldIsUserActionableA && !data.innerQuestionDisplayedEnd && newActivity.inQuestion) {
      newActivity.inQuestion.isUserActionable = true;
    }
    return newActivity;
  }

  makeActionInActivity(data, withBlockedLoading, onSuccess, onFailure) {
    if (this.props.inPreview) {
      let delay = 500;
      if (data.state === ACTIVITY_UPDATE_STATE_RESET) {
        delay = 100;
      }

      setTimeout(() => {
        if (data.state === ACTIVITY_UPDATE_STATE_RESET) {
          onSuccess(this.processPreviewGameReset());
          return;
        }
        onSuccess(this.processPreviewGameAction(data));
      }, delay);

    } else {
      if (withBlockedLoading) {
        this.setState({isBlockedLoading: true});
      }
      data.scId = this.props.showcaseId;
      const activityId = data.activityId || this.activity.id;
      this.props.makeActionInActivity(activityId, data, false).then((response) => {
        if (withBlockedLoading) {
          this.setState({isBlockedLoading: false});
        }
        logDebug('DG:S_showShareSet1');
        response.data.showShare = true;
        onSuccess(response.data);
      }).catch((response) => {
        if (withBlockedLoading) {
          this.setState({isBlockedLoading: false});
        }

        let error = null;
        let errorCode = null;
        if (response.data && response.data.error) {
          error = response.data.error;
          errorCode = response.data.errorCode;
        } else if (response.error === 'NETWORK_ERROR') {
          error = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
        } else {
          error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
        }
        onFailure(error, errorCode);
      });
    }
  }

  makePreActionInActivity = (data, onSuccess, onFailure) => {
    data.userId = this.props.userId;
    data.activityId = this.activity.id;
    data.activityType = this.activity.type;
    data.scId = this.props.showcaseId;
    this.props.makePreActionInActivity(data, false).then((response) => {
      onSuccess(response.data.gameData);
    }).catch((response) => {
      onFailure();

      let error = null;
      if (response.data && response.data.error) {
        error = response.data.error;
      } else if (response.error === 'NETWORK_ERROR') {
        error = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
      } else {
        error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.showToastError(error);
    });
  }

  makeCtaActionsInActivity = (action) => {
    if (this.props.inPreview) {
      return;
    }

    const data = {};
    data.userId = this.props.userId;
    data.activityId = this.activity.id;
    data.activityType = this.activity.type;
    data.state = action;
    data.scId = this.props.showcaseId;
    this.props.makeActionInActivity(this.activity.id, data, false).then((response) => {
    }).catch((response) => {
    });
  }

  makeApiForData() {
    this.props.fetchActivity(this.activity.id, this.props.showcaseId).then((data) => {
      this.updateActivity(data.data);
    });
  }

  updateActivity(activity) {
    // this.oldActivity = activity;
    this.activity = cloneDeep(activity);
    this.activityType = this.activity.type;
    this.updateAndReload();
  }

}

ActivityView.propTypes = {
  activity: PropTypes.object.isRequired,
  isLTR: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  inPreview: PropTypes.bool,

  makeActionInActivity: PropTypes.func,

  classes: PropTypes.object,
  history: PropTypes.object,
  fetchActivity: PropTypes.func,
};

ActivityView.contextTypes = {
  intl:PropTypes.object.isRequired
}

export default withMultipleStyles(baseStyles, useStyles)(ActivityView);
